/**
 * O*NET Career Database for PathFinder
 * Auto-generated from O*NET 30.1 Database
 * Generated: 2026-06-02T17:30:56.611463
 * 
 * Source: U.S. Department of Labor, Employment and Training Administration
 * License: Creative Commons Attribution 4.0 International (CC BY 4.0)
 * 
 * Total careers: 637
 */

import { ExpandedCareer } from '../types/expandedCareerTypes';

export const ONET_CAREERS: ExpandedCareer[] = [
  {
    "id": "bill_and_account_collectors",
    "onet_code": "43-3011.00",
    "title": "Bill and Account Collectors",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Social Perceptiveness",
      "Persuasion",
      "Negotiation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "hands_on",
      "analytical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-4041.00",
      "13-2081.00",
      "43-4051.00"
    ],
    "training_paths": [],
    "description": "Locate and notify customers of delinquent accounts by mail, telephone, or personal visit to solicit payment. Duties include receiving payment and posting amount to customer's account, preparing statements to credit department if customer fails to respond, initiating repossession proceedings or service disconnection, and keeping records of collection and status of accounts.",
    "dailyActivities": [
      "Record information about financial status of customers and status of collection efforts.",
      "Locate and notify customers of delinquent accounts by mail, telephone, or personal visits to solicit payment.",
      "Locate and monitor overdue accounts, using computers and a variety of automated systems.",
      "Arrange for debt repayment or establish repayment schedules, based on customers' financial situations.",
      "Advise customers of necessary actions and strategies for debt repayment.",
      "Answer customer questions regarding problems with their accounts."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "billing_and_posting_clerks",
    "onet_code": "43-3021.00",
    "title": "Billing and Posting Clerks",
    "category": "Administrative",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "problem_solving",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 31455,
      "entry_max": 41940,
      "mid_min": 41940,
      "mid_max": 54522
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-3031.00",
      "43-4051.00",
      "43-9041.00"
    ],
    "training_paths": [],
    "description": "Compile, compute, and record billing, accounting, statistical, and other numerical data for billing purposes. Prepare billing invoices for services rendered or for delivery or shipment of goods.",
    "dailyActivities": [
      "Verify accuracy of billing data and revise any errors.",
      "Resolve discrepancies in accounting records.",
      "Prepare itemized statements, bills, or invoices and record amounts due for items purchased or services rendered.",
      "Operate typing, adding, calculating, or billing machines.",
      "Post stop-payment notices to prevent payment of protested checks.",
      "Verify signatures and required information on checks."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "bookkeeping_accounting_and_auditing_clerks",
    "onet_code": "43-3031.00",
    "title": "Bookkeeping, Accounting, and Auditing Clerks",
    "category": "Administrative",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "technical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 31455,
      "entry_max": 41940,
      "mid_min": 41940,
      "mid_max": 54522
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-3021.00",
      "43-3051.00",
      "43-4011.00"
    ],
    "training_paths": [],
    "description": "Compute, classify, and record numerical data to keep financial records complete. Perform any combination of routine calculating, posting, and verifying duties to obtain primary financial data for use in maintaining accounting records. May also check the accuracy of figures, calculations, and postings pertaining to business transactions recorded by other workers.",
    "dailyActivities": [
      "Operate computers programmed with accounting software to record, store, and analyze information.",
      "Check figures, postings, and documents for correct entry, mathematical accuracy, and proper codes.",
      "Comply with federal, state, and company policies, procedures, and regulations.",
      "Operate 10-key calculators, typewriters, and copy machines to perform calculations and produce documents.",
      "Receive, record, and bank cash, checks, and vouchers.",
      "Code documents according to company procedures."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "brokerage_clerks",
    "onet_code": "43-4011.00",
    "title": "Brokerage Clerks",
    "category": "Administrative",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31455,
      "entry_max": 41940,
      "mid_min": 41940,
      "mid_max": 54522
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "41-3031.00",
      "43-4141.00",
      "43-3031.00"
    ],
    "training_paths": [],
    "description": "Perform duties related to the purchase, sale, or holding of securities. Duties include writing orders for stock purchases or sales, computing transfer taxes, verifying stock transactions, accepting and delivering securities, tracking stock price fluctuations, computing equity, distributing dividends, and keeping records of daily transactions and holdings.",
    "dailyActivities": [
      "Correspond with customers and confer with coworkers to answer inquiries, discuss market fluctuations, or resolve account problems.",
      "Document security transactions, such as purchases, sales, conversions, redemptions, or payments, using computers, accounting ledgers, or certificate records.",
      "File, type, or operate standard office machines.",
      "Perform clerical tasks, such as answering phones or distributing mail.",
      "Prepare forms, such as receipts, withdrawal orders, transmittal papers, or transfer confirmations, based on transaction requests from stockholders.",
      "Schedule and coordinate transfer and delivery of security certificates between companies, departments, and customers."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "cargo_and_freight_agents",
    "onet_code": "43-5011.00",
    "title": "Cargo and Freight Agents",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Social Perceptiveness",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [
        "lifting",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-5011.01",
      "43-5071.00",
      "13-1041.08"
    ],
    "training_paths": [],
    "description": "Expedite and route movement of incoming and outgoing cargo and freight shipments in airline, train, and trucking terminals and shipping docks. Take orders from customers and arrange pickup of freight and cargo for delivery to loading platform. Prepare and examine bills of lading to determine shipping charges and tariffs.",
    "dailyActivities": [
      "Negotiate and arrange transport of goods with shipping or freight companies.",
      "Determine method of shipment and prepare bills of lading, invoices, and other shipping documents.",
      "Track delivery progress of shipments.",
      "Advise clients on transportation and payment methods.",
      "Estimate freight or postal rates and record shipment costs and weights.",
      "Keep records of all goods shipped, received, and stored."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "communications_equipment_operators_all_other",
    "onet_code": "43-2099.00",
    "title": "Communications Equipment Operators, All Other",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "administrative"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All communications equipment operators not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "correspondence_clerks",
    "onet_code": "43-4021.00",
    "title": "Correspondence Clerks",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Service Orientation",
      "Judgment and Decision Making"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-9061.00",
      "43-4071.00",
      "43-6014.00"
    ],
    "training_paths": [],
    "description": "Compose letters or electronic correspondence in reply to requests for merchandise, damage claims, credit and other information, delinquent accounts, incorrect billings, or unsatisfactory services. Duties may include gathering data to formulate reply and preparing correspondence.",
    "dailyActivities": [
      "Maintain files and control records to show correspondence activities.",
      "Read incoming correspondence to ascertain nature of writers' concerns and to determine disposition of correspondence.",
      "Gather records pertinent to specific problems, review them for completeness and accuracy, and attach records to correspondence as necessary.",
      "Prepare documents and correspondence, such as damage claims, credit and billing inquiries, invoices, and service complaints.",
      "Compile data from records to prepare periodic reports.",
      "Compose letters in reply to correspondence concerning such items as requests for merchandise, damage claims, credit information requests, delinquent accounts, incorrect billing, or unsatisfactory service."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "couriers_and_messengers",
    "onet_code": "43-5021.00",
    "title": "Couriers and Messengers",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Information Ordering",
      "Control Precision"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [
        "lifting",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-5052.00",
      "53-3033.00",
      "43-9051.00"
    ],
    "training_paths": [],
    "description": "Pick up and deliver messages, documents, packages, and other items between offices or departments within an establishment or directly to other business concerns, traveling by foot, bicycle, motorcycle, automobile, or public conveyance.",
    "dailyActivities": [
      "Deliver and pick up medical records, lab specimens, and medications to and from hospitals and other medical facilities.",
      "Obtain signatures and payments, or arrange for recipients to make payments.",
      "Record information, such as items received and delivered and recipients' responses to messages.",
      "Receive messages or materials to be delivered, and information on recipients, such as names, addresses, telephone numbers, and delivery instructions, communicated via telephone, two-way radio, or in person.",
      "Load vehicles with listed goods, ensuring goods are loaded correctly and taking precautions with hazardous goods.",
      "Walk, ride bicycles, drive vehicles, or use public conveyances to reach destinations to deliver messages or materials."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "court_municipal_and_license_clerks",
    "onet_code": "43-4031.00",
    "title": "Court, Municipal, and License Clerks",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Coordination",
      "Service Orientation",
      "Time Management"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Deductive Reasoning"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-6012.00",
      "13-1041.00",
      "43-9061.00"
    ],
    "training_paths": [],
    "description": "Perform clerical duties for courts of law, municipalities, or governmental licensing agencies and bureaus. May prepare docket of cases to be called; secure information for judges and court; prepare draft agendas or bylaws for town or city council; answer official correspondence; keep fiscal records and accounts; issue licenses or permits; and record data, administer tests, or collect fees.",
    "dailyActivities": [
      "Evaluate information on applications to verify completeness and accuracy and to determine whether applicants are qualified to obtain desired licenses.",
      "Perform administrative tasks, such as answering telephone calls, filing court documents, or maintaining office supplies or equipment.",
      "Verify the authenticity of documents, such as foreign identification or immigration documents.",
      "Record and edit the minutes of meetings and distribute to appropriate officials or staff members.",
      "Question applicants to obtain required information, such as name, address, or age, and record data on prescribed forms.",
      "Issue public notification of all official activities or meetings."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "credit_authorizers_checkers_and_clerks",
    "onet_code": "43-4041.00",
    "title": "Credit Authorizers, Checkers, and Clerks",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Social Perceptiveness",
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "13-2041.00",
      "43-4131.00",
      "13-2072.00"
    ],
    "training_paths": [],
    "description": "Authorize credit charges against customers' accounts. Investigate history and credit standing of individuals or business establishments applying for credit. May interview applicants to obtain personal and financial data, determine credit worthiness, process applications, and notify customers of acceptance or rejection of credit.",
    "dailyActivities": [
      "Keep records of customers' charges and payments.",
      "Compile and analyze credit information gathered by investigation.",
      "Obtain information about potential creditors from banks, credit bureaus, and other credit services, and provide reciprocal information if requested.",
      "Interview credit applicants by telephone or in person to obtain personal and financial data needed to complete credit report.",
      "Evaluate customers' computerized credit records and payment histories to decide whether to approve new credit, based on predetermined standards.",
      "File sales slips in customers' ledgers for billing purposes."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "customer_service_representatives",
    "onet_code": "43-4051.00",
    "title": "Customer Service Representatives",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Social Perceptiveness",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "41-3091.00",
      "41-9041.00",
      "43-9041.00"
    ],
    "training_paths": [],
    "description": "Interact with customers to provide basic or scripted information in response to routine inquiries about products and services. May handle and resolve general complaints. Excludes individuals whose duties are primarily installation, sales, repair, and technical support.",
    "dailyActivities": [
      "Confer with customers by telephone or in person to provide information about products or services, take or enter orders, cancel accounts, or obtain details of complaints.",
      "Keep records of customer interactions or transactions, recording details of inquiries, complaints, or comments, as well as actions taken.",
      "Check to ensure that appropriate changes were made to resolve customers' problems.",
      "Contact customers to respond to inquiries or to notify them of claim investigation results or any planned adjustments.",
      "Determine charges for services requested, collect deposits or payments, or arrange for billing.",
      "Complete contract forms, prepare change of address records, or issue service discontinuance orders, using computers."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "data_entry_keyers",
    "onet_code": "43-9021.00",
    "title": "Data Entry Keyers",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Information Ordering",
      "Category Flexibility"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-4071.00",
      "43-9022.00",
      "43-9071.00"
    ],
    "training_paths": [],
    "description": "Operate data entry device, such as keyboard or photo composing perforator. Duties may include verifying data and preparing materials for printing.",
    "dailyActivities": [
      "Locate and correct data entry errors, or report them to supervisors.",
      "Compile, sort, and verify the accuracy of data before it is entered.",
      "Compare data with source documents, or re-enter data in verification format to detect errors.",
      "Store completed documents in appropriate locations.",
      "Select materials needed to complete work assignments.",
      "Read source documents such as canceled checks, sales reports, or bills, and enter data in specific data fields or onto tapes or disks for subsequent entry, using keyboards or scanners."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "desktop_publishers",
    "onet_code": "43-9031.00",
    "title": "Desktop Publishers",
    "category": "Administrative",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31455,
      "entry_max": 41940,
      "mid_min": 41940,
      "mid_max": 54522
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-5111.00",
      "27-1024.00",
      "43-9081.00"
    ],
    "training_paths": [],
    "description": "Format typescript and graphic elements using computer software to produce publication-ready material.",
    "dailyActivities": [
      "Operate desktop publishing software and equipment to design, lay out, and produce camera-ready copy.",
      "Position text and art elements from a variety of databases in a visually appealing way to design print or web pages, using knowledge of type styles and size and layout patterns.",
      "Check preliminary and final proofs for errors and make necessary corrections.",
      "View monitors for visual representation of work in progress and for instructions and feedback throughout process, making modifications as necessary.",
      "Enter text into computer keyboard and select the size and style of type, column width, and appropriate spacing for printed materials.",
      "Prepare sample layouts for approval, using computer software."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "dispatchers_except_police_fire_and_ambulance",
    "onet_code": "43-5032.00",
    "title": "Dispatchers, Except Police, Fire, and Ambulance",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Social Perceptiveness",
      "Coordination",
      "Complex Problem Solving"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-1044.00",
      "53-1043.00",
      "43-5031.00"
    ],
    "training_paths": [],
    "description": "Schedule and dispatch workers, work crews, equipment, or service vehicles for conveyance of materials, freight, or passengers, or for normal installation, service, or emergency repairs rendered outside the place of business. Duties may include using radio, telephone, or computer to transmit assignments and compiling statistics and reports on work progress.",
    "dailyActivities": [
      "Schedule or dispatch workers, work crews, equipment, or service vehicles to appropriate locations, according to customer requests, specifications, or needs, using radios or telephones.",
      "Prepare daily work and run schedules.",
      "Confer with customers or supervising personnel to address questions, problems, or requests for service or equipment.",
      "Relay work orders, messages, or information to or from work crews, supervisors, or field inspectors, using telephones or two-way radios.",
      "Receive or prepare work orders.",
      "Record and maintain files or records of customer requests, work or services performed, charges, expenses, inventory, or other dispatch information."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "eligibility_interviewers_government_programs",
    "onet_code": "43-4061.00",
    "title": "Eligibility Interviewers, Government Programs",
    "category": "Administrative",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31455,
      "entry_max": 41940,
      "mid_min": 41940,
      "mid_max": 54522
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-4161.00",
      "13-1071.00",
      "43-4111.00"
    ],
    "training_paths": [],
    "description": "Determine eligibility of persons applying to receive assistance from government programs and agency resources, such as welfare, unemployment benefits, social security, and public housing.",
    "dailyActivities": [
      "Compute and authorize amounts of assistance for programs, such as grants, monetary payments, and food stamps.",
      "Keep records of assigned cases, and prepare required reports.",
      "Compile, record, and evaluate personal and financial data to verify completeness and accuracy, and to determine eligibility status.",
      "Interview and investigate applicants for public assistance to gather information pertinent to their applications.",
      "Interview benefits recipients at specified intervals to certify their eligibility for continuing benefits.",
      "Interpret and explain information such as eligibility requirements, application details, payment methods, and applicants' legal rights."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "executive_secretaries_and_executive_administrative_assistants",
    "onet_code": "43-6011.00",
    "title": "Executive Secretaries and Executive Administrative Assistants",
    "category": "Administrative",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31455,
      "entry_max": 41940,
      "mid_min": 41940,
      "mid_max": 54522
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-6014.00",
      "11-3012.00",
      "43-6012.00"
    ],
    "training_paths": [],
    "description": "Provide high-level administrative support by conducting research, preparing statistical reports, and handling information requests, as well as performing routine administrative functions such as preparing correspondence, receiving visitors, arranging conference calls, and scheduling meetings. May also train and supervise lower-level clerical staff.",
    "dailyActivities": [
      "Manage and maintain executives' schedules.",
      "Make travel arrangements for executives.",
      "Prepare invoices, reports, memos, letters, financial statements, and other documents, using word processing, spreadsheet, database, or presentation software.",
      "Coordinate and direct office services, such as records, departmental finances, budget preparation, personnel issues, and housekeeping, to aid executives.",
      "Answer phone calls and direct calls to appropriate parties or take messages.",
      "Prepare responses to correspondence containing routine inquiries."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "file_clerks",
    "onet_code": "43-4071.00",
    "title": "File Clerks",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-9021.00",
      "29-2072.00",
      "43-9061.00"
    ],
    "training_paths": [],
    "description": "File correspondence, cards, invoices, receipts, and other records in alphabetical or numerical order or according to the filing system used. Locate and remove material from file when requested.",
    "dailyActivities": [
      "Perform general office activities, such as typing, answering telephones, operating office machines, processing mail, or securing confidential materials.",
      "Keep records of materials filed or removed, using logbooks or computers and generate computerized reports.",
      "Gather materials to be filed from departments or employees.",
      "Find, retrieve, and make copies of information from files in response to requests and deliver information to authorized users.",
      "Add new material to file records or create new records as necessary.",
      "Sort or classify information according to guidelines, such as content, purpose, user criteria, or chronological, alphabetical, or numerical order."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "financial_clerks_all_other",
    "onet_code": "43-3099.00",
    "title": "Financial Clerks, All Other",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "administrative"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All financial clerks not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "first_line_supervisors_of_office_and_administrative_support_workers",
    "onet_code": "43-1011.00",
    "title": "First-Line Supervisors of Office and Administrative Support Workers",
    "category": "Administrative",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31455,
      "entry_max": 41940,
      "mid_min": 41940,
      "mid_max": 54522
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "41-1012.00",
      "49-1011.00",
      "53-1044.00"
    ],
    "training_paths": [],
    "description": "Directly supervise and coordinate the activities of clerical and administrative support workers.",
    "dailyActivities": [
      "Supervise the work of office, administrative, or customer service employees to ensure adherence to quality standards, deadlines, and proper procedures, correcting errors or problems.",
      "Resolve customer complaints or answer customers' questions regarding policies and procedures.",
      "Provide employees with guidance in handling difficult or complex problems or in resolving escalated complaints or disputes.",
      "Review records or reports pertaining to activities such as production, payroll, or shipping to verify details, monitor work activities, or evaluate performance.",
      "Discuss job performance problems with employees to identify causes and issues and to work on resolving problems.",
      "Prepare and issue work schedules, deadlines, and duty assignments for office or administrative staff."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "freight_forwarders",
    "onet_code": "43-5011.01",
    "title": "Freight Forwarders",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [
        "lifting",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-5011.00",
      "13-1041.08",
      "43-5071.00"
    ],
    "training_paths": [],
    "description": "Research rates, routings, or modes of transport for shipment of products. Maintain awareness of regulations affecting the international movement of cargo. Make arrangements for additional services, such as storage or inland transportation.",
    "dailyActivities": [
      "Negotiate shipping rates with freight carriers.",
      "Arrange for special transport of sensitive cargoes, such as livestock, food, or medical supplies.",
      "Arrange for applicable duties, taxes, or paperwork for customs clearance.",
      "Inform clients of factors such as shipping options, timelines, transfers, or regulations affecting shipments.",
      "Prepare shipping documentation, such as bills of lading, packing lists, dock receipts, or certificates of origin.",
      "Complete customs paperwork."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "gambling_cage_workers",
    "onet_code": "43-3041.00",
    "title": "Gambling Cage Workers",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Social Perceptiveness",
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "41-2012.00",
      "11-9071.00",
      "39-3012.00"
    ],
    "training_paths": [],
    "description": "In a gambling establishment, conduct financial transactions for patrons. Accept patron's credit application and verify credit references to provide check-cashing authorization or to establish house credit accounts. May reconcile daily summaries of transactions to balance books. May sell gambling chips, tokens, or tickets to patrons, or to other workers for resale to patrons. May convert gambling chips, tokens, or tickets to currency upon patron's request. May use a cash register or computer to record transaction.",
    "dailyActivities": [
      "Maintain confidentiality of customers' transactions.",
      "Follow all gaming regulations.",
      "Maintain cage security.",
      "Cash checks and process credit card advances for patrons.",
      "Supply currency, coins, chips, or gaming checks to other departments as needed.",
      "Convert gaming checks, coupons, tokens, or coins to currency for gaming patrons."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "hotel_motel_and_resort_desk_clerks",
    "onet_code": "43-4081.00",
    "title": "Hotel, Motel, and Resort Desk Clerks",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Social Perceptiveness",
      "Coordination",
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "11-9081.00",
      "39-6012.00",
      "43-4171.00"
    ],
    "training_paths": [],
    "description": "Accommodate hotel, motel, and resort patrons by registering and assigning rooms to guests, issuing room keys or cards, transmitting and receiving messages, keeping records of occupied rooms and guests' accounts, making and confirming reservations, and presenting statements to and collecting payments from departing guests.",
    "dailyActivities": [
      "Greet, register, and assign rooms to guests of hotels or motels.",
      "Contact housekeeping or maintenance staff when guests report problems.",
      "Issue room keys and escort instructions to bellhops.",
      "Make and confirm reservations.",
      "Verify customers' credit, and establish how the customer will pay for the accommodation.",
      "Keep records of room availability and guests' accounts, manually or using computers."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "human_resources_assistants_except_payroll_and_timekeeping",
    "onet_code": "43-4161.00",
    "title": "Human Resources Assistants, Except Payroll and Timekeeping",
    "category": "Administrative",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31455,
      "entry_max": 41940,
      "mid_min": 41940,
      "mid_max": 54522
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "13-1071.00",
      "11-3121.00",
      "43-4061.00"
    ],
    "training_paths": [],
    "description": "Compile and keep personnel records. Record data for each employee, such as address, weekly earnings, absences, amount of sales or production, supervisory reports, and date of and reason for termination. May prepare reports for employment records, file employment records, or search employee files and furnish information to authorized persons.",
    "dailyActivities": [
      "Process, verify, and maintain personnel related documentation, including staffing, recruitment, training, grievances, performance evaluations, classifications, and employee leaves of absence.",
      "Record data for each employee, including such information as addresses, weekly earnings, absences, amount of sales or production, supervisory reports on performance, and dates of and reasons for terminations.",
      "Explain company personnel policies, benefits, and procedures to employees or job applicants.",
      "Provide assistance in administering employee benefit programs and worker's compensation plans.",
      "Answer questions regarding examinations, eligibility, salaries, benefits, and other pertinent information.",
      "Prepare and set up for new employee orientations."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "information_and_record_clerks_all_other",
    "onet_code": "43-4199.00",
    "title": "Information and Record Clerks, All Other",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "administrative"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All information and record clerks not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "insurance_claims_and_policy_processing_clerks",
    "onet_code": "43-9041.00",
    "title": "Insurance Claims and Policy Processing Clerks",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Service Orientation",
      "Time Management"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Information Ordering"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-4051.00",
      "43-4041.00",
      "43-4061.00"
    ],
    "training_paths": [],
    "description": "Process new insurance policies, modifications to existing policies, and claims forms. Obtain information from policyholders to verify the accuracy and completeness of information on claims forms, applications and related documents, and company records. Update existing policies and company records to reflect changes requested by policyholders and insurance company representatives.",
    "dailyActivities": [
      "Prepare insurance claim forms or related documents, and review them for completeness.",
      "Calculate amount of claim.",
      "Post or attach information to claim file.",
      "Transmit claims for payment or further investigation.",
      "Contact insured or other involved persons to obtain missing information.",
      "Review insurance policy to determine coverage."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "interviewers_except_eligibility_and_loan",
    "onet_code": "43-4111.00",
    "title": "Interviewers, Except Eligibility and Loan",
    "category": "Administrative",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31455,
      "entry_max": 41940,
      "mid_min": 41940,
      "mid_max": 54522
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-4061.00",
      "29-2099.08",
      "43-9061.00"
    ],
    "training_paths": [],
    "description": "Interview persons by telephone, mail, in person, or by other means for the purpose of completing forms, applications, or questionnaires. Ask specific questions, record answers, and assist persons with completing form. May sort, classify, and file forms.",
    "dailyActivities": [
      "Ask questions in accordance with instructions to obtain various specified information, such as person's name, address, age, religious preference, or state of residency.",
      "Identify and report problems in obtaining valid data.",
      "Ensure payment for services by verifying benefits with the person's insurance provider or working out financing options.",
      "Perform office duties, such as telemarketing or customer service inquiries, maintaining staff records, billing patients, or receiving payments.",
      "Review data obtained from interview for completeness and accuracy.",
      "Compile, record, and code results or data from interview or survey, using computer or specified form."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "legal_secretaries_and_administrative_assistants",
    "onet_code": "43-6012.00",
    "title": "Legal Secretaries and Administrative Assistants",
    "category": "Administrative",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Social Perceptiveness",
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31455,
      "entry_max": 41940,
      "mid_min": 41940,
      "mid_max": 54522
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "23-2011.00",
      "43-6014.00",
      "43-4031.00"
    ],
    "training_paths": [],
    "description": "Perform secretarial duties using legal terminology, procedures, and documents. Prepare legal papers and correspondence, such as summonses, complaints, motions, and subpoenas. May also assist with legal research.",
    "dailyActivities": [
      "Organize and maintain law libraries, documents, and case files.",
      "Mail, fax, or arrange for delivery of legal correspondence to clients, witnesses, and court officials.",
      "Prepare and distribute invoices to bill clients or pay account expenses.",
      "Prepare, proofread, or process legal documents, such as summonses, subpoenas, complaints, appeals, motions, or pretrial agreements.",
      "Make photocopies of correspondence, documents, and other printed matter.",
      "Assist attorneys in collecting information such as employment, medical, and other records."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "library_assistants_clerical",
    "onet_code": "43-4121.00",
    "title": "Library Assistants, Clerical",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Information Ordering"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "hands_on",
      "physical",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "25-4031.00",
      "43-4071.00",
      "43-9061.00"
    ],
    "training_paths": [],
    "description": "Compile records, and sort, shelve, issue, and receive library materials such as books, electronic media, pictures, cards, slides and microfilm. Locate library materials for loan and replace material in shelving area, stacks, or files according to identification number and title. Register patrons to permit them to borrow books, periodicals, and other library materials.",
    "dailyActivities": [
      "Sort books, publications, and other items according to established procedure and return them to shelves, files, or other designated storage areas.",
      "Open and close library during specified hours and secure library equipment, such as computers and audio-visual equipment.",
      "Locate library materials for patrons, including books, periodicals, tape cassettes, Braille volumes, and pictures.",
      "Enter and update patrons' records on computers.",
      "Answer routine inquiries and refer patrons in need of professional assistance to librarians.",
      "Manage reserve materials by placing items on reserve for library patrons, checking items in and out of library, and removing out-of-date items."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "loan_interviewers_and_clerks",
    "onet_code": "43-4131.00",
    "title": "Loan Interviewers and Clerks",
    "category": "Administrative",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31455,
      "entry_max": 41940,
      "mid_min": 41940,
      "mid_max": 54522
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "13-2072.00",
      "43-4041.00",
      "13-2041.00"
    ],
    "training_paths": [],
    "description": "Interview loan applicants to elicit information; investigate applicants' backgrounds and verify references; prepare loan request papers; and forward findings, reports, and documents to appraisal department. Review loan papers to ensure completeness, and complete transactions between loan establishment, borrowers, and sellers upon approval of loan.",
    "dailyActivities": [
      "Verify and examine information and accuracy of loan application and closing documents.",
      "Assemble and compile documents for loan closings, such as title abstracts, insurance forms, loan forms, and tax receipts.",
      "Record applications for loan and credit, loan information, and disbursements of funds, using computers.",
      "Submit loan applications with recommendation for underwriting approval.",
      "Contact customers by mail, telephone, or in person concerning acceptance or rejection of applications.",
      "File and maintain loan records."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "mail_clerks_and_mail_machine_operators_except_postal_service",
    "onet_code": "43-9051.00",
    "title": "Mail Clerks and Mail Machine Operators, Except Postal Service",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Manual Dexterity"
    ],
    "keywords": [
      "administrative",
      "hands_on",
      "physical",
      "customer_service"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-5051.00",
      "43-5053.00",
      "43-5071.00"
    ],
    "training_paths": [],
    "description": "Prepare incoming and outgoing mail for distribution. Time-stamp, open, read, sort, and route incoming mail; and address, seal, stamp, fold, stuff, and affix postage to outgoing mail or packages. Duties may also include keeping necessary records and completed forms.",
    "dailyActivities": [
      "Wrap packages or bundles by hand, or by using tying machines.",
      "Verify that items are addressed correctly, marked with the proper postage, and in suitable condition for processing.",
      "Remove containers of sorted mail or parcels and transfer them to designated areas according to established procedures.",
      "Sort and route incoming mail, and collect outgoing mail, using carts as necessary.",
      "Affix postage to packages or letters by hand, or stamp materials, using postage meters.",
      "Determine manner in which mail is to be sent, and prepare it for delivery to mailing facilities."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "medical_secretaries_and_administrative_assistants",
    "onet_code": "43-6013.00",
    "title": "Medical Secretaries and Administrative Assistants",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Social Perceptiveness",
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Deductive Reasoning"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-4171.00",
      "29-2072.00",
      "43-6014.00"
    ],
    "training_paths": [],
    "description": "Perform secretarial duties using specific knowledge of medical terminology and hospital, clinic, or laboratory procedures. Duties may include scheduling appointments, billing patients, and compiling and recording medical charts, reports, and correspondence.",
    "dailyActivities": [
      "Answer telephones and direct calls to appropriate staff.",
      "Schedule and confirm patient diagnostic appointments, surgeries, or medical consultations.",
      "Complete insurance or other claim forms.",
      "Greet visitors, ascertain purpose of visit, and direct them to appropriate staff.",
      "Transmit correspondence or medical records by mail, e-mail, or fax.",
      "Maintain medical records, technical library, or correspondence files."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "meter_readers_utilities",
    "onet_code": "43-5041.00",
    "title": "Meter Readers, Utilities",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Speaking"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Trunk Strength",
      "Extent Flexibility"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "hands_on",
      "physical",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [
        "lifting",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-9012.00",
      "49-2095.00",
      "51-8012.00"
    ],
    "training_paths": [],
    "description": "Read meter and record consumption of electricity, gas, water, or steam.",
    "dailyActivities": [
      "Read electric, gas, water, or steam consumption meters and enter data in route books or hand-held computers.",
      "Upload into office computers all information collected on hand-held computers during meter rounds, or return route books or hand-held computers to business offices so that data can be compiled.",
      "Walk or drive vehicles along established routes to take readings of meter dials.",
      "Inspect meters for unauthorized connections, defects, and damage, such as broken seals.",
      "Verify readings in cases where consumption appears to be abnormal, and record possible reasons for fluctuations.",
      "Report to service departments any problems, such as meter irregularities, damaged equipment, or impediments to meter access, including dogs."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "new_accounts_clerks",
    "onet_code": "43-4141.00",
    "title": "New Accounts Clerks",
    "category": "Administrative",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Deductive Reasoning"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31455,
      "entry_max": 41940,
      "mid_min": 41940,
      "mid_max": 54522
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-3071.00",
      "43-4011.00",
      "41-3091.00"
    ],
    "training_paths": [],
    "description": "Interview persons desiring to open accounts in financial institutions. Explain account services available to prospective customers and assist them in preparing applications.",
    "dailyActivities": [
      "Perform teller duties as required.",
      "Compile information about new accounts, enter account information into computers, and file related forms or other documents.",
      "Collect and record customer deposits and fees and issue receipts, using computers.",
      "Inform customers of procedures for applying for services, such as ATM cards, direct deposit of checks, and certificates of deposit.",
      "Answer customers' questions and explain available services, such as deposit accounts, bonds, and securities.",
      "Interview customers to obtain information needed for opening accounts or renting safe-deposit boxes."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "office_clerks_general",
    "onet_code": "43-9061.00",
    "title": "Office Clerks, General",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Social Perceptiveness",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Information Ordering"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-6014.00",
      "43-4071.00",
      "43-4171.00"
    ],
    "training_paths": [],
    "description": "Perform duties too varied and diverse to be classified in any specific office clerical occupation, requiring knowledge of office systems and procedures. Clerical duties may be assigned in accordance with the office procedures of individual establishments and may include a combination of answering telephones, bookkeeping, typing or word processing, office machine operation, and filing.",
    "dailyActivities": [
      "Operate office machines, such as photocopiers and scanners, facsimile machines, voice mail systems, and personal computers.",
      "Answer telephones, direct calls, and take messages.",
      "Communicate with customers, employees, and other individuals to answer questions, disseminate or explain information, take orders, and address complaints.",
      "Maintain and update filing, inventory, mailing, and database systems, either manually or using a computer.",
      "Compile, copy, sort, and file records of office activities, business transactions, and other activities.",
      "Review files, records, and other documents to obtain information to respond to requests."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "office_machine_operators_except_computer",
    "onet_code": "43-9071.00",
    "title": "Office Machine Operators, Except Computer",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Speaking",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Near Vision"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "hands_on",
      "physical",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-5111.00",
      "51-5112.00",
      "43-9021.00"
    ],
    "training_paths": [],
    "description": "Operate one or more of a variety of office machines, such as photocopying, photographic, and duplicating machines, or other office machines.",
    "dailyActivities": [
      "Read job orders to determine the type of work to be done, the quantities to be produced, and the materials needed.",
      "Deliver completed work.",
      "Place original copies in feed trays, feed originals into feed rolls, or position originals on tables beneath camera lenses.",
      "Sort, assemble, and proof completed work.",
      "Operate office machines such as high speed business photocopiers, readers, scanners, addressing machines, stencil-cutting machines, microfilm readers or printers, folding and inserting machines, bursters, and binder machines.",
      "Complete records of production, including work volumes and outputs, materials used, and any backlogs."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "office_and_administrative_support_workers_all_other",
    "onet_code": "43-9199.00",
    "title": "Office and Administrative Support Workers, All Other",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "administrative"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All office and administrative support workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "order_clerks",
    "onet_code": "43-4151.00",
    "title": "Order Clerks",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-5071.00",
      "43-5051.00",
      "41-3091.00"
    ],
    "training_paths": [],
    "description": "Receive and process incoming orders for materials, merchandise, classified ads, or services such as repairs, installations, or rental of facilities. Generally receives orders via mail, phone, fax, or other electronic means. Duties include informing customers of receipt, prices, shipping dates, and delays; preparing contracts; and handling complaints.",
    "dailyActivities": [
      "Review orders for completeness according to reporting procedures and forward incomplete orders for further processing.",
      "Obtain customers' names, addresses, and billing information, product numbers, and specifications of items to be purchased, and enter this information on order forms.",
      "Recommend merchandise or services that will meet customers' needs.",
      "Inspect outgoing work for compliance with customers' specifications.",
      "Receive and respond to customer complaints.",
      "Check inventory records to determine availability of requested merchandise."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "payroll_and_timekeeping_clerks",
    "onet_code": "43-3051.00",
    "title": "Payroll and Timekeeping Clerks",
    "category": "Administrative",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Monitoring",
      "Complex Problem Solving"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 31455,
      "entry_max": 41940,
      "mid_min": 41940,
      "mid_max": 54522
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-4161.00",
      "43-3031.00",
      "43-1011.00"
    ],
    "training_paths": [],
    "description": "Compile and record employee time and payroll data. May compute employees' time worked, production, and commission. May compute and post wages and deductions, or prepare paychecks.",
    "dailyActivities": [
      "Verify attendance, hours worked, and pay adjustments, and post information onto designated records.",
      "Process and issue employee paychecks and statements of earnings and deductions.",
      "Compute wages and deductions, and enter data into computers.",
      "Process paperwork for new employees and enter employee information into the payroll system.",
      "Prepare and balance period-end reports, and reconcile issued payrolls to bank statements.",
      "Review time sheets, work charts, wage computation, and other information to detect and reconcile payroll discrepancies."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "postal_service_clerks",
    "onet_code": "43-5051.00",
    "title": "Postal Service Clerks",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Deductive Reasoning",
      "Inductive Reasoning"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-5052.00",
      "43-9051.00",
      "43-5071.00"
    ],
    "training_paths": [],
    "description": "Perform any combination of tasks in a United States Postal Service (USPS) post office, such as receive letters and parcels; sell postage and revenue stamps, postal cards, and stamped envelopes; fill out and sell money orders; place mail in pigeon holes of mail rack or in bags; and examine mail for correct postage. Includes postal service clerks employed by USPS contractors.",
    "dailyActivities": [
      "Weigh letters and parcels, compute mailing costs based on type, weight, and destination, and affix correct postage.",
      "Check mail to ensure correct postage and that packages and letters are in proper condition for mailing.",
      "Sort incoming and outgoing mail, according to type and destination, by hand or by operating electronic mail-sorting and scanning devices.",
      "Obtain signatures from recipients of registered or special delivery mail.",
      "Answer questions regarding mail regulations and procedures, postage rates, and post office boxes.",
      "Transport mail from one work station to another."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "postal_service_mail_carriers",
    "onet_code": "43-5052.00",
    "title": "Postal Service Mail Carriers",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Category Flexibility",
      "Manual Dexterity"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "hands_on",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [
        "lifting",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-5051.00",
      "43-5021.00",
      "43-9051.00"
    ],
    "training_paths": [],
    "description": "Sort and deliver mail for the United States Postal Service (USPS). Deliver mail on established route by vehicle or on foot. Includes postal service mail carriers employed by USPS contractors.",
    "dailyActivities": [
      "Scan labels on letters or parcels to confirm receipt.",
      "Obtain signed receipts for registered, certified, and insured mail, collect associated charges, and complete any necessary paperwork.",
      "Return to the post office with mail collected from homes, businesses, and public mailboxes.",
      "Sort mail for delivery, arranging it in delivery sequence.",
      "Deliver mail to residences and business establishments along specified routes by walking or driving, using a combination of satchels, carts, cars, and small trucks.",
      "Meet schedules for the collection and return of mail."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "postal_service_mail_sorters_processors_and_processing_machine_operators",
    "onet_code": "43-5053.00",
    "title": "Postal Service Mail Sorters, Processors, and Processing Machine Operators",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Manual Dexterity",
      "Finger Dexterity",
      "Multilimb Coordination"
    ],
    "keywords": [
      "administrative",
      "hands_on",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-9051.00",
      "43-5071.00",
      "43-5051.00"
    ],
    "training_paths": [],
    "description": "Prepare incoming and outgoing mail for distribution for the United States Postal Service (USPS). Examine, sort, and route mail. Load, operate, and occasionally adjust and repair mail processing, sorting, and canceling machinery. Keep records of shipments, pouches, and sacks, and perform other duties related to mail handling within the postal service. Includes postal service mail sorters and processors employed by USPS contractors.",
    "dailyActivities": [
      "Clear jams in sorting equipment.",
      "Operate various types of equipment, such as computer scanning equipment, addressographs, mimeographs, optical character readers, and bar-code sorters.",
      "Sort odd-sized mail by hand, sort mail that other workers have been unable to sort, and segregate items requiring special handling.",
      "Direct items according to established routing schemes, using computer-controlled keyboards or voice-recognition equipment.",
      "Check items to ensure that addresses are legible and correct, that sufficient postage has been paid or the appropriate documentation is attached, and that items are in a suitable condition for processing.",
      "Bundle, label, and route sorted mail to designated areas, depending on destinations and according to established procedures and deadlines."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "procurement_clerks",
    "onet_code": "43-3061.00",
    "title": "Procurement Clerks",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "13-1022.00",
      "43-5071.00",
      "43-5061.00"
    ],
    "training_paths": [],
    "description": "Compile information and records to draw up purchase orders for procurement of materials and services.",
    "dailyActivities": [
      "Track the status of requisitions, contracts, and orders.",
      "Perform buying duties when necessary.",
      "Prepare purchase orders and send copies to suppliers and to departments originating requests.",
      "Calculate costs of orders, and charge or forward invoices to appropriate accounts.",
      "Compare prices, specifications, and delivery dates to determine the best bid among potential suppliers.",
      "Approve and pay bills."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "production_planning_and_expediting_clerks",
    "onet_code": "43-5061.00",
    "title": "Production, Planning, and Expediting Clerks",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Coordination",
      "Complex Problem Solving"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "13-1082.00",
      "43-5071.00",
      "53-1042.00"
    ],
    "training_paths": [],
    "description": "Coordinate and expedite the flow of work and materials within or between departments of an establishment according to production schedule. Duties include reviewing and distributing production, work, and shipment schedules; conferring with department supervisors to determine progress of work and completion dates; and compiling reports on progress of work, inventory levels, costs, and production problems.",
    "dailyActivities": [
      "Distribute production schedules or work orders to departments.",
      "Revise production schedules when required due to design changes, labor or material shortages, backlogs, or other interruptions, collaborating with management, marketing, sales, production, or engineering.",
      "Review documents, such as production schedules, work orders, or staffing tables, to determine personnel or materials requirements or material priorities.",
      "Arrange for delivery, assembly, or distribution of supplies or parts to expedite flow of materials and meet production schedules.",
      "Confer with establishment personnel, vendors, or customers to coordinate production or shipping activities and to resolve complaints or eliminate delays.",
      "Requisition and maintain inventories of materials or supplies necessary to meet production demands."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "public_safety_telecommunicators",
    "onet_code": "43-5031.00",
    "title": "Public Safety Telecommunicators",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-5032.00",
      "29-2042.00",
      "43-2011.00"
    ],
    "training_paths": [],
    "description": "Operate telephone, radio, or other communication systems to receive and communicate requests for emergency assistance at 9-1-1 public safety answering points and emergency operations centers. Take information from the public and other sources regarding crimes, threats, disturbances, acts of terrorism, fires, medical emergencies, and other public safety matters. May coordinate and provide information to law enforcement and emergency response personnel. May access sensitive databases and other information sources as needed. May provide additional instructions to callers based on knowledge of and certification in law enforcement, fire, or emergency medical procedures.",
    "dailyActivities": [
      "Provide emergency medical instructions to callers.",
      "Question callers to determine their locations and the nature of their problems to determine type of response needed.",
      "Determine response requirements and relative priorities of situations, and dispatch units in accordance with established procedures.",
      "Receive incoming telephone or alarm system calls regarding emergency and non-emergency police and fire service, emergency ambulance service, information, and after-hours calls for departments within a city.",
      "Relay information and messages to and from emergency sites, to law enforcement agencies, and to all other individuals or groups requiring notification.",
      "Record details of calls, dispatches, and messages."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "receptionists_and_information_clerks",
    "onet_code": "43-4171.00",
    "title": "Receptionists and Information Clerks",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Near Vision"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "hands_on",
      "technical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-6013.00",
      "43-9061.00",
      "43-4051.00"
    ],
    "training_paths": [],
    "description": "Answer inquiries and provide information to the general public, customers, visitors, and other interested parties regarding activities conducted at establishment and location of departments, offices, and employees within the organization.",
    "dailyActivities": [
      "Operate telephone switchboard to answer, screen, or forward calls, providing information, taking messages, or scheduling appointments.",
      "Greet persons entering establishment, determine nature and purpose of visit, and direct or escort them to specific destinations.",
      "Receive payment and record receipts for services.",
      "Schedule appointments and maintain and update appointment calendars.",
      "Transmit information or documents to customers, using computer, mail, or facsimile machine.",
      "Hear and resolve complaints from customers or the public."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "reservation_and_transportation_ticket_agents_and_travel_clerks",
    "onet_code": "43-4181.00",
    "title": "Reservation and Transportation Ticket Agents and Travel Clerks",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Social Perceptiveness",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "41-3041.00",
      "53-2031.00",
      "53-6061.00"
    ],
    "training_paths": [],
    "description": "Make and confirm reservations for transportation or lodging, or sell transportation tickets. May check baggage and direct passengers to designated concourse, pier, or track; deliver tickets and contact individuals and groups to inform them of package tours; or provide tourists with travel or transportation information.",
    "dailyActivities": [
      "Examine passenger documentation to determine destinations and to assign boarding passes.",
      "Trace lost, delayed, or misdirected baggage for customers.",
      "Check baggage and cargo and direct passengers to designated locations for loading.",
      "Provide boarding or disembarking assistance to passengers needing special assistance.",
      "Confer with customers to determine their service requirements and travel preferences.",
      "Announce arrival and departure information, using public address systems."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "secretaries_and_administrative_assistants_except_legal_medical_and_executive",
    "onet_code": "43-6014.00",
    "title": "Secretaries and Administrative Assistants, Except Legal, Medical, and Executive",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "hands_on",
      "analytical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-6011.00",
      "43-9061.00",
      "11-3012.00"
    ],
    "training_paths": [],
    "description": "Perform routine administrative functions such as drafting correspondence, scheduling appointments, organizing and maintaining paper and electronic files, or providing information to callers.",
    "dailyActivities": [
      "Answer telephones and give information to callers, take messages, or transfer calls to appropriate individuals.",
      "Greet visitors or callers and handle their inquiries or direct them to the appropriate persons according to their needs.",
      "Create, maintain, and enter information into databases.",
      "Use computers for various applications, such as database management or word processing.",
      "Operate office equipment, such as fax machines, copiers, or phone systems and arrange for repairs when equipment malfunctions.",
      "Set up and manage paper or electronic filing systems, recording information, updating paperwork, or maintaining documents, such as attendance records, correspondence, or other material."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "shipping_receiving_and_inventory_clerks",
    "onet_code": "43-5071.00",
    "title": "Shipping, Receiving, and Inventory Clerks",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Information Ordering"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "hands_on",
      "physical",
      "technical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [
        "lifting",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-5051.00",
      "53-7065.00",
      "43-5011.00"
    ],
    "training_paths": [],
    "description": "Verify and maintain records on incoming and outgoing shipments involving inventory. Duties include verifying and recording incoming merchandise or material and arranging for the transportation of products. May prepare items for shipment.",
    "dailyActivities": [
      "Examine shipment contents and compare with records, such as manifests, invoices, or orders, to verify accuracy.",
      "Requisition and store shipping materials and supplies to maintain inventory of stock.",
      "Prepare documents, such as work orders, bills of lading, or shipping orders, to route materials.",
      "Pack, seal, label, or affix postage to prepare materials for shipping, using hand tools, power tools, or postage meter.",
      "Record shipment data, such as weight, charges, space availability, damages, or discrepancies, for reporting, accounting, or recordkeeping purposes.",
      "Confer or correspond with establishment representatives to rectify problems, such as damages, shortages, or nonconformance to specifications."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "military_mos_relevant": [
      "92A"
    ],
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "switchboard_operators_including_answering_service",
    "onet_code": "43-2011.00",
    "title": "Switchboard Operators, Including Answering Service",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Near Vision",
      "Speech Recognition",
      "Speech Clarity"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "hands_on",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-4171.00",
      "43-9061.00",
      "43-2021.00"
    ],
    "training_paths": [],
    "description": "Operate telephone business systems equipment or switchboards to relay incoming, outgoing, and interoffice calls. May supply information to callers and record messages.",
    "dailyActivities": [
      "Operate communication systems, such as telephone, switchboard, intercom, two-way radio, or public address.",
      "Answer incoming calls, greeting callers, providing information, transferring calls or taking messages as necessary.",
      "Greet visitors, log them in and out of the facility, assign them security badges, and contact employee escorts.",
      "Monitor emergency and code alarms, make emergency announcements, or route emergency calls to the appropriate location.",
      "Record messages, suggesting rewording for clarity or conciseness.",
      "Page individuals to inform them of telephone calls, using paging or interoffice communication equipment."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "telephone_operators",
    "onet_code": "43-2021.00",
    "title": "Telephone Operators",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Speaking",
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Selective Attention",
      "Speech Recognition"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "hands_on",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-2011.00",
      "43-4171.00",
      "41-9041.00"
    ],
    "training_paths": [],
    "description": "Provide information by accessing alphabetical, geographical, or other directories. Assist customers with special billing requests, such as charges to a third party and credits or refunds for incorrectly dialed numbers or bad connections. May handle emergency calls and assist children or people with physical disabilities to make telephone calls.",
    "dailyActivities": [
      "Observe signal lights on switchboards, and dial or press buttons to make connections.",
      "Operate telephone switchboards and systems to advance and complete connections, including those for local, long distance, pay telephone, mobile, person-to-person, and emergency calls.",
      "Listen to customer requests, referring to alphabetical or geographical directories to answer questions and provide telephone information.",
      "Update directory information.",
      "Suggest and check alternate spellings, locations, or listing formats to customers lacking details or complete information.",
      "Perform clerical duties such as typing, proofreading, and sorting mail."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "tellers",
    "onet_code": "43-3071.00",
    "title": "Tellers",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-4141.00",
      "41-2011.00",
      "43-4041.00"
    ],
    "training_paths": [],
    "description": "Receive and pay out money. Keep records of money and negotiable instruments involved in a financial institution's various transactions.",
    "dailyActivities": [
      "Balance currency, coin, and checks in cash drawers at ends of shifts and calculate daily transactions, using computers, calculators, or adding machines.",
      "Receive checks and cash for deposit, verify amounts, and check accuracy of deposit slips.",
      "Monitor bank vaults to ensure cash balances are correct.",
      "Cash checks and pay out money after verifying that signatures are correct, that written and numerical amounts agree, and that accounts have sufficient funds.",
      "Count currency, coins, and checks received, by hand or using currency-counting machine, to prepare them for deposit or shipment to branch banks or the Federal Reserve Bank.",
      "Enter customers' transactions into computers to record transactions and issue computer-generated receipts."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "weighers_measurers_checkers_and_samplers_recordkeeping",
    "onet_code": "43-5111.00",
    "title": "Weighers, Measurers, Checkers, and Samplers, Recordkeeping",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Coordination",
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Deductive Reasoning"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9061.00",
      "43-5071.00",
      "53-7064.00"
    ],
    "training_paths": [],
    "description": "Weigh, measure, and check materials, supplies, and equipment for the purpose of keeping relevant records. Duties are primarily clerical by nature. Includes workers who collect and keep record of samples of products or materials.",
    "dailyActivities": [
      "Document quantity, quality, type, weight, test result data, and value of materials or products to maintain shipping, receiving, and production records and files.",
      "Weigh or measure materials, equipment, or products to maintain relevant records, using volume meters, scales, rules, or calipers.",
      "Collect or prepare measurement, weight, or identification labels and attach them to products.",
      "Examine products or materials, parts, subassemblies, and packaging for damage, defects, or shortages, using specification sheets, gauges, and standards charts.",
      "Signal or instruct other workers to weigh, move, or check products.",
      "Collect product samples and prepare them for laboratory analysis or testing."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "word_processors_and_typists",
    "onet_code": "43-9022.00",
    "title": "Word Processors and Typists",
    "category": "Administrative",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Information Ordering"
    ],
    "keywords": [
      "administrative",
      "customer_service",
      "analytical",
      "hands_on",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 26736,
      "entry_max": 35649,
      "mid_min": 35649,
      "mid_max": 46343
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-9021.00",
      "43-4071.00",
      "31-9094.00"
    ],
    "training_paths": [],
    "description": "Use word processor, computer, or typewriter to type letters, reports, forms, or other material from rough draft, corrected copy, or voice recording. May perform other clerical duties as assigned.",
    "dailyActivities": [
      "Perform other clerical duties, such as answering telephone, sorting and distributing mail, running errands or sending faxes.",
      "Check completed work for spelling, grammar, punctuation, and format.",
      "File and store completed documents on computer hard drive or disk, or maintain a computer filing system to store, retrieve, update, and delete documents.",
      "Print and make copies of work.",
      "Transmit work electronically to other locations.",
      "Address envelopes or prepare envelope labels, using typewriter or computer."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "agricultural_equipment_operators",
    "onet_code": "45-2091.00",
    "title": "Agricultural Equipment Operators",
    "category": "Agriculture",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance",
      "Troubleshooting",
      "Repairing"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Information Ordering",
      "Manual Dexterity"
    ],
    "keywords": [
      "agriculture",
      "physical",
      "hands_on",
      "technical"
    ],
    "salary": {
      "entry_min": 17708,
      "entry_max": 23611,
      "mid_min": 23611,
      "mid_max": 30694
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "45-2092.00",
      "53-7063.00",
      "51-9012.00"
    ],
    "training_paths": [],
    "description": "Drive and control equipment to support agricultural activities such as tilling soil; planting, cultivating, and harvesting crops; feeding and herding livestock; or removing animal waste. May perform tasks such as crop baling or hay bucking. May operate stationary equipment to perform post-harvest tasks such as husking, shelling, threshing, and ginning.",
    "dailyActivities": [
      "Load and unload crops or containers of materials, manually or using conveyors, handtrucks, forklifts, or transfer augers.",
      "Mix specified materials or chemicals, and dump solutions, powders, or seeds into planter or sprayer machinery.",
      "Spray fertilizer or pesticide solutions to control insects, fungus and weed growth, and diseases, using hand sprayers.",
      "Observe and listen to machinery operation to detect equipment malfunctions.",
      "Manipulate controls to set, activate, and adjust mechanisms on machinery.",
      "Operate or tend equipment used in agricultural production, such as tractors, combines, and irrigation equipment."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "agricultural_inspectors",
    "onet_code": "45-2011.00",
    "title": "Agricultural Inspectors",
    "category": "Agriculture",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "agriculture",
      "analytical",
      "physical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 21502,
      "entry_max": 28670,
      "mid_min": 28670,
      "mid_max": 37271
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-4011.00",
      "19-4013.00",
      "45-1011.00"
    ],
    "training_paths": [],
    "description": "Inspect agricultural commodities, processing equipment, and facilities, and fish and logging operations, to ensure compliance with regulations and laws governing health, quality, and safety.",
    "dailyActivities": [
      "Inspect food products and processing procedures to determine whether products are safe to eat.",
      "Interpret and enforce government acts and regulations and explain required standards to agricultural workers.",
      "Inspect agricultural commodities or related operations, as well as fish or logging operations, for compliance with laws and regulations governing health, quality, and safety.",
      "Label and seal graded products and issue official grading certificates.",
      "Monitor the operations and sanitary conditions of slaughtering or meat processing plants.",
      "Take emergency actions, such as closing production facilities, if product safety is compromised."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "agricultural_workers_all_other",
    "onet_code": "45-2099.00",
    "title": "Agricultural Workers, All Other",
    "category": "Agriculture",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "agriculture"
    ],
    "salary": {
      "entry_min": 21502,
      "entry_max": 28670,
      "mid_min": 28670,
      "mid_max": 37271
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All agricultural workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "animal_breeders",
    "onet_code": "45-2021.00",
    "title": "Animal Breeders",
    "category": "Agriculture",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Critical Thinking",
      "Monitoring",
      "Judgment and Decision Making"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "agriculture",
      "hands_on",
      "physical",
      "analytical",
      "problem_solving",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 21502,
      "entry_max": 28670,
      "mid_min": 28670,
      "mid_max": 37271
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "45-2093.00",
      "39-2021.00",
      "39-2011.00"
    ],
    "training_paths": [],
    "description": "Select and breed animals according to their genealogy, characteristics, and offspring. May require knowledge of artificial insemination techniques and equipment use. May involve keeping records on heats, birth intervals, or pedigree.",
    "dailyActivities": [
      "Feed and water animals, and clean and disinfect pens, cages, yards, and hutches.",
      "Observe animals in heat to detect approach of estrus and exercise animals to induce or hasten estrus, if necessary.",
      "Treat minor injuries and ailments and contact veterinarians to obtain treatment for animals with serious illnesses or injuries.",
      "Purchase and stock supplies of feed and medicines.",
      "Select animals to be bred, and semen specimens to be used, according to knowledge of animals, genealogies, traits, and desired offspring characteristics.",
      "Examine animals to detect symptoms of illness or injury."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "fallers",
    "onet_code": "45-4021.00",
    "title": "Fallers",
    "category": "Agriculture",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Critical Thinking"
    ],
    "niceToHave": [
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Flexibility of Closure",
      "Perceptual Speed",
      "Visualization"
    ],
    "keywords": [
      "agriculture",
      "hands_on",
      "physical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 17708,
      "entry_max": 23611,
      "mid_min": 23611,
      "mid_max": 30694
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "37-3013.00",
      "45-4022.00",
      "45-4011.00"
    ],
    "training_paths": [],
    "description": "Use axes or chainsaws to fell trees using knowledge of tree characteristics and cutting techniques to control direction of fall and minimize tree damage.",
    "dailyActivities": [
      "Stop saw engines, pull cutting bars from cuts, and run to safety as tree falls.",
      "Appraise trees for certain characteristics, such as twist, rot, and heavy limb growth, and gauge amount and direction of lean, to determine how to control the direction of a tree's fall with the least damage.",
      "Saw back-cuts, leaving sufficient sound wood to control direction of fall.",
      "Clear brush from work areas and escape routes, and cut saplings and other trees from direction of falls, using axes, chainsaws, or bulldozers.",
      "Measure felled trees and cut them into specified log lengths, using chain saws and axes.",
      "Assess logs after cutting to ensure that the quality and length are correct."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "farmworkers_and_laborers_crop_nursery_and_greenhouse",
    "onet_code": "45-2092.00",
    "title": "Farmworkers and Laborers, Crop, Nursery, and Greenhouse",
    "category": "Agriculture",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Oral Expression",
      "Problem Sensitivity",
      "Arm-Hand Steadiness",
      "Manual Dexterity",
      "Finger Dexterity"
    ],
    "keywords": [
      "agriculture",
      "analytical",
      "physical",
      "hands_on",
      "communication"
    ],
    "salary": {
      "entry_min": 17708,
      "entry_max": 23611,
      "mid_min": 23611,
      "mid_max": 30694
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "45-2091.00",
      "45-2093.00",
      "45-2041.00"
    ],
    "training_paths": [],
    "description": "Manually plant, cultivate, and harvest vegetables, fruits, nuts, horticultural specialties, and field crops. Use hand tools, such as shovels, trowels, hoes, tampers, pruning hooks, shears, and knives. Duties may include tilling soil and applying fertilizers; transplanting, weeding, thinning, or pruning crops; applying pesticides; or cleaning, grading, sorting, packing, and loading harvested products. May construct trellises, repair fences and farm buildings, or participate in irrigation activities.",
    "dailyActivities": [
      "Record information about crops, such as pesticide use, yields, or costs.",
      "Direct and monitor the work of casual and seasonal help during planting and harvesting.",
      "Participate in the inspection, grading, sorting, storage, and post-harvest treatment of crops.",
      "Harvest plants, and transplant or pot and label them.",
      "Repair and maintain farm vehicles, implements, and mechanical equipment.",
      "Harvest fruits and vegetables by hand."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "farmworkers_farm_ranch_and_aquacultural_animals",
    "onet_code": "45-2093.00",
    "title": "Farmworkers, Farm, Ranch, and Aquacultural Animals",
    "category": "Agriculture",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Critical Thinking",
      "Monitoring",
      "Coordination",
      "Operations Monitoring",
      "Operation and Control",
      "Judgment and Decision Making"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "agriculture",
      "analytical",
      "physical",
      "hands_on",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 21502,
      "entry_max": 28670,
      "mid_min": 28670,
      "mid_max": 37271
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "45-2021.00",
      "45-2092.00",
      "45-2091.00"
    ],
    "training_paths": [],
    "description": "Attend to live farm, ranch, open range or aquacultural animals that may include cattle, sheep, swine, goats, horses and other equines, poultry, rabbits, finfish, shellfish, and bees. Attend to animals produced for animal products, such as meat, fur, skins, feathers, eggs, milk, and honey. Duties may include feeding, watering, herding, grazing, milking, castrating, branding, de-beaking, weighing, catching, and loading animals. May maintain records on animals; examine animals to detect diseases and injuries; assist in birth deliveries; and administer medications, vaccinations, or insecticides as appropriate. May clean and maintain animal housing areas. Includes workers who shear wool from sheep and collect eggs in hatcheries.",
    "dailyActivities": [
      "Feed and water livestock and monitor food and water supplies.",
      "Herd livestock to pastures for grazing or to scales, trucks, or other enclosures.",
      "Examine animals to detect illness, injury, or disease, and to check physical characteristics, such as rate of weight gain.",
      "Provide medical treatment, such as administering medications and vaccinations, or arrange for veterinarians to provide more extensive treatment.",
      "Mark livestock to identify ownership and grade, using brands, tags, paint, or tattoos.",
      "Drive trucks, tractors, and other equipment to distribute feed to animals."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "first_line_supervisors_of_farming_fishing_and_forestry_workers",
    "onet_code": "45-1011.00",
    "title": "First-Line Supervisors of Farming, Fishing, and Forestry Workers",
    "category": "Agriculture",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "agriculture",
      "analytical",
      "physical",
      "hands_on",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 25297,
      "entry_max": 33730,
      "mid_min": 33730,
      "mid_max": 43849
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-1011.00",
      "49-1011.00",
      "47-1011.00"
    ],
    "training_paths": [],
    "description": "Directly supervise and coordinate the activities of agricultural, forestry, aquacultural, and related workers.",
    "dailyActivities": [
      "Assign tasks such as feeding and treatment of animals, and cleaning and maintenance of animal quarters.",
      "Record the numbers and types of fish or shellfish reared, harvested, released, sold, and shipped.",
      "Monitor workers to ensure that safety regulations are followed, warning or disciplining those who violate safety regulations.",
      "Observe animals for signs of illness, injury, or unusual behavior, notifying veterinarians or managers as warranted.",
      "Observe fish and beds or ponds to detect diseases, monitor fish growth, determine quality of fish, or determine completeness of harvesting.",
      "Train workers in tree felling or bucking, operation of tractors or loading machines, yarding or loading techniques, or safety regulations."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "fishing_and_hunting_workers",
    "onet_code": "45-3031.00",
    "title": "Fishing and Hunting Workers",
    "category": "Agriculture",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Flexibility of Closure",
      "Spatial Orientation"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "agriculture",
      "physical",
      "analytical",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 17708,
      "entry_max": 23611,
      "mid_min": 23611,
      "mid_max": 30694
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-5011.00",
      "53-5022.00",
      "53-5021.00"
    ],
    "training_paths": [],
    "description": "Hunt, trap, catch, or gather wild animals or aquatic animals and plants. May use nets, traps, or other equipment. May haul catch onto ship or other vessel.",
    "dailyActivities": [
      "Steer vessels and operate navigational instruments.",
      "Remove catches from fishing equipment and measure them to ensure compliance with legal size.",
      "Direct fishing or hunting operations, and supervise crew members.",
      "Interpret weather and vessel conditions to determine appropriate responses.",
      "Travel on foot, by vehicle, or by equipment such as boats, snowmobiles, helicopters, snowshoes, or skis to reach hunting areas.",
      "Select, bait, and set traps, and lay poison along trails, according to species, size, habits, and environs of birds or animals and reasons for trapping them."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "forest_and_conservation_workers",
    "onet_code": "45-4011.00",
    "title": "Forest and Conservation Workers",
    "category": "Agriculture",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Speaking",
      "Critical Thinking",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Inductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "agriculture",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 21502,
      "entry_max": 28670,
      "mid_min": 28670,
      "mid_max": 37271
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "19-4071.00",
      "19-1032.00",
      "19-1031.02"
    ],
    "training_paths": [],
    "description": "Under supervision, perform manual labor necessary to develop, maintain, or protect areas such as forests, forested areas, woodlands, wetlands, and rangelands through such activities as raising and transporting seedlings; combating insects, pests, and diseases harmful to plant life; and building structures to control water, erosion, and leaching of soil. Includes forester aides, seedling pullers, tree planters, and gatherers of nontimber forestry products such as pine straw.",
    "dailyActivities": [
      "Check equipment to ensure that it is operating properly.",
      "Fight forest fires or perform prescribed burning tasks under the direction of fire suppression officers or forestry technicians.",
      "Perform fire protection or suppression duties, such as constructing fire breaks or disposing of brush.",
      "Confer with other workers to discuss issues, such as safety, cutting heights, or work needs.",
      "Maintain tallies of trees examined and counted during tree marking or measuring efforts.",
      "Explain or enforce regulations regarding camping, vehicle use, fires, use of buildings, or sanitation."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "graders_and_sorters_agricultural_products",
    "onet_code": "45-2041.00",
    "title": "Graders and Sorters, Agricultural Products",
    "category": "Agriculture",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Manual Dexterity"
    ],
    "keywords": [
      "customer_service",
      "agriculture",
      "hands_on",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 17708,
      "entry_max": 23611,
      "mid_min": 23611,
      "mid_max": 30694
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-7064.00",
      "51-3091.00",
      "51-3022.00"
    ],
    "training_paths": [],
    "description": "Grade, sort, or classify unprocessed food and other agricultural products by size, weight, color, or condition.",
    "dailyActivities": [
      "Place products in containers according to grade and mark grades on containers.",
      "Weigh products or estimate their weight, visually or by feel.",
      "Discard inferior or defective products or foreign matter, and place acceptable products in containers for further processing.",
      "Grade and sort products according to factors such as color, species, length, width, appearance, feel, smell, and quality to ensure correct processing and usage.",
      "Record grade or identification numbers on tags or on shipping, receiving, or sales sheets."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "log_graders_and_scalers",
    "onet_code": "45-4023.00",
    "title": "Log Graders and Scalers",
    "category": "Agriculture",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Writing",
      "Critical Thinking",
      "Monitoring",
      "Coordination",
      "Judgment and Decision Making"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "agriculture",
      "analytical",
      "physical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 21502,
      "entry_max": 28670,
      "mid_min": 28670,
      "mid_max": 37271
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-5111.00",
      "51-9061.00",
      "45-2041.00"
    ],
    "training_paths": [],
    "description": "Grade logs or estimate the marketable content or value of logs or pulpwood in sorting yards, millpond, log deck, or similar locations. Inspect logs for defects or measure logs to determine volume.",
    "dailyActivities": [
      "Evaluate log characteristics and determine grades, using established criteria.",
      "Record data about individual trees or load volumes into tally books or hand-held collection terminals.",
      "Measure felled logs or loads of pulpwood to calculate volume, weight, dimensions, and marketable value, using measuring devices and conversion tables.",
      "Paint identification marks of specified colors on logs to identify grades or species, using spray cans, or call out grades to log markers.",
      "Jab logs with metal ends of scale sticks, and inspect logs to ascertain characteristics or defects such as water damage, splits, knots, broken ends, rotten areas, twists, and curves.",
      "Identify logs of substandard or special grade so that they can be returned to shippers, regraded, recut, or transferred for other processing."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "logging_equipment_operators",
    "onet_code": "45-4022.00",
    "title": "Logging Equipment Operators",
    "category": "Agriculture",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance",
      "Troubleshooting",
      "Repairing",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Expression",
      "Information Ordering",
      "Category Flexibility",
      "Perceptual Speed",
      "Visualization"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "agriculture",
      "hands_on",
      "analytical",
      "physical",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 17708,
      "entry_max": 23611,
      "mid_min": 23611,
      "mid_max": 30694
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2073.00",
      "47-5041.00",
      "47-5044.00"
    ],
    "training_paths": [],
    "description": "Drive logging tractor or wheeled vehicle equipped with one or more accessories, such as bulldozer blade, frontal shear, grapple, logging arch, cable winches, hoisting rack, or crane boom, to fell tree; to skid, load, unload, or stack logs; or to pull stumps or clear brush. Includes operating stand-alone logging machines, such as log chippers.",
    "dailyActivities": [
      "Inspect equipment for safety prior to use, and perform necessary basic maintenance tasks.",
      "Control hydraulic tractors equipped with tree clamps and booms to lift, swing, and bunch sheared trees.",
      "Grade logs according to characteristics such as knot size and straightness, and according to established industry or company standards.",
      "Drive straight or articulated tractors equipped with accessories such as bulldozer blades, grapples, logging arches, cable winches, and crane booms to skid, load, unload, or stack logs, pull stumps, or clear brush.",
      "Drive crawler or wheeled tractors to drag or transport logs from felling sites to log landing areas for processing and loading.",
      "Fill out required job or shift report forms."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "logging_workers_all_other",
    "onet_code": "45-4029.00",
    "title": "Logging Workers, All Other",
    "category": "Agriculture",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "agriculture"
    ],
    "salary": {
      "entry_min": 21502,
      "entry_max": 28670,
      "mid_min": 28670,
      "mid_max": 37271
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All logging workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "actors",
    "onet_code": "27-2011.00",
    "title": "Actors",
    "category": "Arts & Media",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Social Perceptiveness",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "arts_media",
      "hands_on",
      "physical",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 35540,
      "entry_max": 47387,
      "mid_min": 47387,
      "mid_max": 61603
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "27-2042.00",
      "27-2012.04",
      "27-2032.00"
    ],
    "training_paths": [],
    "description": "Play parts in stage, television, radio, video, or film productions, or other settings for entertainment, information, or instruction. Interpret serious or comic role by speech, gesture, and body movement to entertain or inform audience. May dance and sing.",
    "dailyActivities": [
      "Collaborate with other actors as part of an ensemble.",
      "Portray and interpret roles, using speech, gestures, and body movements, to entertain, inform, or instruct radio, film, television, or live audiences.",
      "Work closely with directors, other actors, and playwrights to find the interpretation most suited to the role.",
      "Perform humorous and serious interpretations of emotions, actions, and situations, using body movements, facial expressions, and gestures.",
      "Study and rehearse roles from scripts to interpret, learn and memorize lines, stunts, and cues as directed.",
      "Learn about characters in scripts and their relationships to each other to develop role interpretations."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "artists_and_related_workers_all_other",
    "onet_code": "27-1019.00",
    "title": "Artists and Related Workers, All Other",
    "category": "Arts & Media",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "arts_media"
    ],
    "salary": {
      "entry_min": 35540,
      "entry_max": 47387,
      "mid_min": 47387,
      "mid_max": 61603
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All artists and related workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "athletes_and_sports_competitors",
    "onet_code": "27-2021.00",
    "title": "Athletes and Sports Competitors",
    "category": "Arts & Media",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Fluency of Ideas",
      "Originality"
    ],
    "keywords": [
      "arts_media",
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 35540,
      "entry_max": 47387,
      "mid_min": 47387,
      "mid_max": 61603
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "27-2022.00",
      "27-2023.00",
      "39-9031.00"
    ],
    "training_paths": [],
    "description": "Compete in athletic events.",
    "dailyActivities": [
      "Assess performance following athletic competition, identifying strengths and weaknesses and making adjustments to improve future performance.",
      "Maintain equipment used in a particular sport.",
      "Attend scheduled practice or training sessions.",
      "Maintain optimum physical fitness levels by training regularly, following nutrition plans, or consulting with health professionals.",
      "Participate in athletic events or competitive sports, according to established rules and regulations.",
      "Exercise or practice under the direction of athletic trainers or professional coaches to develop skills, improve physical condition, or prepare for competitions."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "audio_and_video_technicians",
    "onet_code": "27-4011.00",
    "title": "Audio and Video Technicians",
    "category": "Arts & Media",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "arts_media",
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 41812,
      "entry_max": 55750,
      "mid_min": 55750,
      "mid_max": 72475
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "27-4012.00",
      "27-4014.00",
      "27-4031.00"
    ],
    "training_paths": [],
    "description": "Set up, maintain, and dismantle audio and video equipment, such as microphones, sound speakers, connecting wires and cables, sound and mixing boards, video cameras, video monitors and servers, and related electronic equipment for live or recorded events, such as concerts, meetings, conventions, presentations, podcasts, news conferences, and sporting events.",
    "dailyActivities": [
      "Notify supervisors when major equipment repairs are needed.",
      "Diagnose and resolve media system problems.",
      "Direct and coordinate activities of assistants and other personnel during production.",
      "Compress, digitize, duplicate, and store audio and video data.",
      "Install, adjust, and operate electronic equipment to record, edit, and transmit radio and television programs, motion pictures, video conferencing, or multimedia presentations.",
      "Control the lights and sound of events, such as live concerts, before and after performances, and during intermissions."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "broadcast_technicians",
    "onet_code": "27-4012.00",
    "title": "Broadcast Technicians",
    "category": "Arts & Media",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "arts_media",
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "technical",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 41812,
      "entry_max": 55750,
      "mid_min": 55750,
      "mid_max": 72475
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "27-4011.00",
      "17-3023.00",
      "49-2094.00"
    ],
    "training_paths": [],
    "description": "Set up, operate, and maintain the electronic equipment used to acquire, edit, and transmit audio and video for radio or television programs. Control and adjust incoming and outgoing broadcast signals to regulate sound volume, signal strength, and signal clarity. Operate satellite, microwave, or other transmitter equipment to broadcast radio or television programs.",
    "dailyActivities": [
      "Report equipment problems, ensure that repairs are made, and make emergency repairs to equipment when necessary and possible.",
      "Monitor and log transmitter readings.",
      "Maintain programming logs as required by station management and the Federal Communications Commission.",
      "Monitor strength, clarity, and reliability of incoming and outgoing signals, and adjust equipment as necessary to maintain quality broadcasts.",
      "Observe monitors and converse with station personnel to determine audio and video levels and to ascertain that programs are airing.",
      "Preview scheduled programs to ensure that signals are functioning and programs are ready for transmission."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "camera_operators_television_video_and_film",
    "onet_code": "27-4031.00",
    "title": "Camera Operators, Television, Video, and Film",
    "category": "Arts & Media",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "arts_media",
      "detail_oriented",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 41812,
      "entry_max": 55750,
      "mid_min": 55750,
      "mid_max": 72475
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "17-3024.00",
      "27-4012.00",
      "27-4011.00"
    ],
    "training_paths": [],
    "description": "Operate television, video, or film camera to record images or scenes for television, video, or film productions.",
    "dailyActivities": [
      "Compose and frame each shot, applying the technical aspects of light, lenses, film, filters, and camera settings to achieve the effects sought by directors.",
      "Operate television or motion picture cameras to record scenes for television broadcasts, advertising, or motion pictures.",
      "Adjust positions and controls of cameras, printers, and related equipment to change focus, exposure, and lighting.",
      "Confer with directors, sound and lighting technicians, electricians, and other crew members to discuss assignments and determine filming sequences, desired effects, camera movements, and lighting requirements.",
      "Operate zoom lenses, changing images according to specifications and rehearsal instructions.",
      "Observe sets or locations for potential problems and to determine filming and lighting requirements."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "choreographers",
    "onet_code": "27-2032.00",
    "title": "Choreographers",
    "category": "Arts & Media",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "arts_media",
      "customer_service",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 41812,
      "entry_max": 55750,
      "mid_min": 55750,
      "mid_max": 72475
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "27-2031.00",
      "27-2041.00",
      "27-2042.00"
    ],
    "training_paths": [],
    "description": "Create new dance routines. Rehearse performance of routines. May direct and stage presentations.",
    "dailyActivities": [
      "Direct rehearsals to instruct dancers in dance steps and in techniques to achieve desired effects.",
      "Advise dancers on standing and moving properly, teaching correct dance techniques to help prevent injuries.",
      "Teach students, dancers, and other performers about rhythm and interpretive movement.",
      "Record dance movements and their technical aspects, using a technical understanding of the patterns and formations of choreography.",
      "Direct and stage dance presentations for various forms of entertainment.",
      "Choose the music, sound effects, or spoken narrative to accompany a dance."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "court_reporters_and_simultaneous_captioners",
    "onet_code": "27-3092.00",
    "title": "Court Reporters and Simultaneous Captioners",
    "category": "Arts & Media",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Information Ordering"
    ],
    "keywords": [
      "arts_media",
      "customer_service",
      "hands_on",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 41812,
      "entry_max": 55750,
      "mid_min": 55750,
      "mid_max": 72475
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-6012.00",
      "43-4031.00",
      "23-2011.00"
    ],
    "training_paths": [],
    "description": "Use verbatim methods and equipment to capture, store, retrieve, and transcribe pretrial and trial proceedings or other information. Includes stenocaptioners who operate computerized stenographic captioning equipment to provide captions of live or prerecorded broadcasts for hearing-impaired viewers.",
    "dailyActivities": [
      "Record verbatim proceedings of courts, legislative assemblies, committee meetings, and other proceedings, using computerized recording equipment, electronic stenograph machines, or stenomasks.",
      "Proofread transcripts for correct spelling of words.",
      "Ask speakers to clarify inaudible statements.",
      "Provide transcripts of proceedings upon request of judges, lawyers, or the public.",
      "Transcribe recorded proceedings in accordance with established formats.",
      "Log and store exhibits from court proceedings."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "craft_artists",
    "onet_code": "27-1012.00",
    "title": "Craft Artists",
    "category": "Arts & Media",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Social Perceptiveness",
      "Persuasion",
      "Judgment and Decision Making"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Fluency of Ideas",
      "Originality"
    ],
    "keywords": [
      "arts_media",
      "customer_service",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 41812,
      "entry_max": 55750,
      "mid_min": 55750,
      "mid_max": 72475
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9071.00",
      "27-1013.00",
      "51-9194.00"
    ],
    "training_paths": [],
    "description": "Create or reproduce handmade objects for sale and exhibition using a variety of techniques, such as welding, weaving, pottery, and needlecraft.",
    "dailyActivities": [
      "Select materials for use based on strength, color, texture, balance, weight, size, malleability and other characteristics.",
      "Create functional or decorative objects by hand, using a variety of methods and materials.",
      "Develop concepts or creative ideas for craft objects.",
      "Apply finishes to objects being crafted.",
      "Cut, shape, fit, join, mold, or otherwise process materials, using hand tools, power tools, or machinery.",
      "Set specifications for materials, dimensions, and finishes."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "dancers",
    "onet_code": "27-2031.00",
    "title": "Dancers",
    "category": "Arts & Media",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Speaking",
      "Monitoring",
      "Social Perceptiveness",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Originality",
      "Information Ordering",
      "Memorization"
    ],
    "keywords": [
      "arts_media",
      "hands_on",
      "physical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 41812,
      "entry_max": 55750,
      "mid_min": 55750,
      "mid_max": 72475
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "27-2032.00",
      "27-2042.00",
      "27-2011.00"
    ],
    "training_paths": [],
    "description": "Perform dances. May perform on stage, for broadcasting, or for video recording.",
    "dailyActivities": [
      "Study and practice dance moves required in roles.",
      "Harmonize body movements to rhythm of musical accompaniment.",
      "Train, exercise, and attend dance classes to maintain high levels of technical proficiency, physical ability, and physical fitness.",
      "Coordinate dancing with that of partners or dance ensembles.",
      "Develop self-understanding of physical capabilities and limitations, and choose dance styles accordingly.",
      "Perform classical, modern, or acrobatic dances in productions, expressing stories, rhythm, and sound with their bodies."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "designers_all_other",
    "onet_code": "27-1029.00",
    "title": "Designers, All Other",
    "category": "Arts & Media",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "arts_media"
    ],
    "salary": {
      "entry_min": 35540,
      "entry_max": 47387,
      "mid_min": 47387,
      "mid_max": 61603
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All designers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "disc_jockeys_except_radio",
    "onet_code": "27-2091.00",
    "title": "Disc Jockeys, Except Radio",
    "category": "Arts & Media",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "arts_media"
    ],
    "salary": {
      "entry_min": 35540,
      "entry_max": 47387,
      "mid_min": 47387,
      "mid_max": 61603
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "27-3011.00",
      "27-4014.00",
      "27-2041.00"
    ],
    "training_paths": [],
    "description": "Play prerecorded music for live audiences at venues or events such as clubs, parties, or wedding receptions. May use techniques such as mixing, cutting, or sampling to manipulate recordings. May also perform as emcee (master of ceremonies).",
    "dailyActivities": [
      "Accept music requests from event guests.",
      "Adhere to schedules to keep events running on time.",
      "Advertise services using media such as internet advertising and brochures.",
      "Assemble audio and video equipment.",
      "Collect payments from customers.",
      "Communicate with clients or venue owners to determine event information, such as music preferences, scheduling, and anticipated attendance."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "entertainers_and_performers_sports_and_related_workers_all_other",
    "onet_code": "27-2099.00",
    "title": "Entertainers and Performers, Sports and Related Workers, All Other",
    "category": "Arts & Media",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "arts_media"
    ],
    "salary": {
      "entry_min": 35540,
      "entry_max": 47387,
      "mid_min": 47387,
      "mid_max": 61603
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All entertainers and performers, sports and related workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "fashion_designers",
    "onet_code": "27-1022.00",
    "title": "Fashion Designers",
    "category": "Arts & Media",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "arts_media",
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 41812,
      "entry_max": 55750,
      "mid_min": 55750,
      "mid_max": 72475
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-6092.00",
      "27-1021.00",
      "27-1012.00"
    ],
    "training_paths": [],
    "description": "Design clothing and accessories. Create original designs or adapt fashion trends.",
    "dailyActivities": [
      "Sketch rough and detailed drawings of apparel or accessories, and write specifications such as color schemes, construction, material types, and accessory requirements.",
      "Examine sample garments on and off models, modifying designs to achieve desired effects.",
      "Confer with sales and management executives or with clients to discuss design ideas.",
      "Select materials and production techniques to be used for products.",
      "Provide sample garments to agents and sales representatives, and arrange for showings of sample garments at sales meetings or fashion shows.",
      "Direct and coordinate workers involved in drawing and cutting patterns and constructing samples or finished garments."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "fine_artists_including_painters_sculptors_and_illustrators",
    "onet_code": "27-1013.00",
    "title": "Fine Artists, Including Painters, Sculptors, and Illustrators",
    "category": "Arts & Media",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Critical Thinking",
      "Active Learning",
      "Judgment and Decision Making"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "arts_media",
      "customer_service",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 41812,
      "entry_max": 55750,
      "mid_min": 55750,
      "mid_max": 72475
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "27-1014.00",
      "27-1024.00",
      "27-1012.00"
    ],
    "training_paths": [],
    "description": "Create original artwork using any of a wide variety of media and techniques.",
    "dailyActivities": [
      "Use materials such as pens and ink, watercolors, charcoal, oil, or computer software to create artwork.",
      "Integrate and develop visual elements, such as line, space, mass, color, and perspective, to produce desired effects, such as the illustration of ideas, emotions, or moods.",
      "Confer with clients, editors, writers, art directors, and other interested parties regarding the nature and content of artwork to be produced.",
      "Maintain portfolios of artistic work to demonstrate styles, interests, and abilities.",
      "Market artwork through brochures, mailings, or Web sites.",
      "Study different techniques to learn how to apply them to artistic endeavors."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "floral_designers",
    "onet_code": "27-1023.00",
    "title": "Floral Designers",
    "category": "Arts & Media",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Social Perceptiveness",
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Fluency of Ideas",
      "Originality"
    ],
    "keywords": [
      "arts_media",
      "customer_service",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 35540,
      "entry_max": 47387,
      "mid_min": 47387,
      "mid_max": 61603
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "27-1012.00",
      "51-9123.00",
      "27-1022.00"
    ],
    "training_paths": [],
    "description": "Design, cut, and arrange live, dried, or artificial flowers and foliage.",
    "dailyActivities": [
      "Confer with clients regarding price and type of arrangement desired and the date, time, and place of delivery.",
      "Select flora and foliage for arrangements, working with numerous combinations to synthesize and develop new creations.",
      "Order and purchase flowers and supplies from wholesalers and growers.",
      "Deliver arrangements to customers, or oversee employees responsible for deliveries.",
      "Plan arrangement according to client's requirements, using knowledge of design and properties of materials, or select appropriate standard design pattern.",
      "Water plants, and cut, condition, and clean flowers and foliage for storage."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "lighting_technicians",
    "onet_code": "27-4015.00",
    "title": "Lighting Technicians",
    "category": "Arts & Media",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "arts_media"
    ],
    "salary": {
      "entry_min": 41812,
      "entry_max": 55750,
      "mid_min": 55750,
      "mid_max": 72475
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2111.00",
      "49-2093.00",
      "17-3023.00"
    ],
    "training_paths": [],
    "description": "Set up, maintain, and dismantle light fixtures, lighting control devices, and the associated lighting electrical and rigging equipment used for photography, television, film, video, and live productions. May focus or operate light fixtures, or attach color filters or other lighting accessories.",
    "dailyActivities": [
      "Assess safety of wiring or equipment set-up to determine the risk of fire or electrical shock.",
      "Consult with lighting director or production staff to determine lighting requirements.",
      "Disassemble and store equipment after performances.",
      "Install color effects or image patterns, such as color filters, onto lighting fixtures.",
      "Install electrical cables or wire fixtures.",
      "Load, unload, or position lighting equipment."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "media_and_communication_equipment_workers_all_other",
    "onet_code": "27-4099.00",
    "title": "Media and Communication Equipment Workers, All Other",
    "category": "Arts & Media",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "arts_media"
    ],
    "salary": {
      "entry_min": 35540,
      "entry_max": 47387,
      "mid_min": 47387,
      "mid_max": 61603
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All media and communication equipment workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "media_and_communication_workers_all_other",
    "onet_code": "27-3099.00",
    "title": "Media and Communication Workers, All Other",
    "category": "Arts & Media",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "arts_media"
    ],
    "salary": {
      "entry_min": 35540,
      "entry_max": 47387,
      "mid_min": 47387,
      "mid_max": 61603
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All media and communication workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "merchandise_displayers_and_window_trimmers",
    "onet_code": "27-1026.00",
    "title": "Merchandise Displayers and Window Trimmers",
    "category": "Arts & Media",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Coordination",
      "Persuasion",
      "Judgment and Decision Making"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "arts_media",
      "customer_service",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 41812,
      "entry_max": 55750,
      "mid_min": 55750,
      "mid_max": 72475
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "41-2031.00",
      "41-3011.00",
      "27-1022.00"
    ],
    "training_paths": [],
    "description": "Plan and erect commercial displays, such as those in windows and interiors of retail stores and at trade exhibitions.",
    "dailyActivities": [
      "Plan commercial displays to entice and appeal to customers.",
      "Arrange properties, furniture, merchandise, backdrops, or other accessories, as shown in prepared sketches.",
      "Change or rotate window displays, interior display areas, or signage to reflect changes in inventory or promotion.",
      "Place prices or descriptive signs on backdrops, fixtures, merchandise, or floor.",
      "Consult with store managers, buyers, sales associates, housekeeping staff, or engineering staff to determine appropriate placement of displays or products.",
      "Maintain props, products, or mannequins, inspecting them for imperfections, doing touch-ups, cleaning up after customers, or applying preservative coatings as necessary."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "photographers",
    "onet_code": "27-4021.00",
    "title": "Photographers",
    "category": "Arts & Media",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "arts_media",
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 41812,
      "entry_max": 55750,
      "mid_min": 55750,
      "mid_max": 72475
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9151.00",
      "27-1013.00",
      "27-1024.00"
    ],
    "training_paths": [],
    "description": "Photograph people, landscapes, merchandise, or other subjects. May use lighting equipment to enhance a subject's appearance. May use editing software to produce finished images and prints. Includes commercial and industrial photographers, scientific photographers, and photojournalists.",
    "dailyActivities": [
      "Adjust apertures, shutter speeds, and camera focus according to a combination of factors, such as lighting, field depth, subject motion, film type, and film speed.",
      "Create artificial light, using flashes and reflectors.",
      "Determine desired images and picture composition, selecting and adjusting subjects, equipment, and lighting to achieve desired effects.",
      "Transfer photographs to computers for editing, archiving, and electronic transmission.",
      "Use traditional or digital cameras, along with a variety of equipment, such as tripods, filters, and flash attachments.",
      "Manipulate and enhance scanned or digital images to create desired effects, using computers and specialized software."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "sound_engineering_technicians",
    "onet_code": "27-4014.00",
    "title": "Sound Engineering Technicians",
    "category": "Arts & Media",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "arts_media",
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 41812,
      "entry_max": 55750,
      "mid_min": 55750,
      "mid_max": 72475
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "27-4011.00",
      "27-4012.00",
      "27-4015.00"
    ],
    "training_paths": [],
    "description": "Assemble and operate equipment to record, synchronize, mix, edit, or reproduce sound, including music, voices, or sound effects, for theater, video, film, television, podcasts, sporting events, and other productions.",
    "dailyActivities": [
      "Confer with producers, performers, and others to determine and achieve the desired sound for a production, such as a musical recording or a film.",
      "Regulate volume level and sound quality during recording sessions, using control consoles.",
      "Record speech, music, and other sounds on recording media, using recording equipment.",
      "Separate instruments, vocals, and other sounds, and combine sounds during the mixing or postproduction stage.",
      "Set up, test, and adjust recording equipment for recording sessions and live performances.",
      "Report equipment problems and ensure that required repairs are made."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "umpires_referees_and_other_sports_officials",
    "onet_code": "27-2023.00",
    "title": "Umpires, Referees, and Other Sports Officials",
    "category": "Arts & Media",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Coordination",
      "Judgment and Decision Making"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "arts_media",
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 35540,
      "entry_max": 47387,
      "mid_min": 47387,
      "mid_max": 61603
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "27-2022.00",
      "27-2021.00",
      "39-3091.00"
    ],
    "training_paths": [],
    "description": "Officiate at competitive athletic or sporting events. Detect infractions of rules and decide penalties according to established regulations. Includes all sporting officials, referees, and competition judges.",
    "dailyActivities": [
      "Officiate at sporting events, games, or competitions, to maintain standards of play and to ensure that game rules are observed.",
      "Inspect game sites for compliance with regulations or safety requirements.",
      "Resolve claims of rule infractions or complaints by participants and assess any necessary penalties, according to regulations.",
      "Signal participants or other officials to make them aware of infractions or to otherwise regulate play or competition.",
      "Teach and explain the rules and regulations governing a specific sport.",
      "Inspect sporting equipment or examine participants to ensure compliance with event and safety regulations."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "building_cleaning_workers_all_other",
    "onet_code": "37-2019.00",
    "title": "Building Cleaning Workers, All Other",
    "category": "Building & Grounds",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "building_grounds"
    ],
    "salary": {
      "entry_min": 21789,
      "entry_max": 29053,
      "mid_min": 29053,
      "mid_max": 37768
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All building cleaning workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "first_line_supervisors_of_housekeeping_and_janitorial_workers",
    "onet_code": "37-1011.00",
    "title": "First-Line Supervisors of Housekeeping and Janitorial Workers",
    "category": "Building & Grounds",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Learning Strategies",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "building_grounds",
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 21789,
      "entry_max": 29053,
      "mid_min": 29053,
      "mid_max": 37768
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-1011.00",
      "49-1011.00",
      "39-1014.00"
    ],
    "training_paths": [],
    "description": "Directly supervise and coordinate work activities of cleaning personnel in hotels, hospitals, offices, and other establishments.",
    "dailyActivities": [
      "Supervise in-house services, such as laundries, maintenance and repair, dry cleaning, or valet services.",
      "Select the most suitable cleaning materials for different types of linens, furniture, flooring, and surfaces.",
      "Advise managers, desk clerks, or admitting personnel of rooms ready for occupancy.",
      "Inspect work performed to ensure that it meets specifications and established standards.",
      "Perform or assist with cleaning duties as necessary.",
      "Plan and prepare employee work schedules."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "first_line_supervisors_of_landscaping_lawn_service_and_groundskeeping_workers",
    "onet_code": "37-1012.00",
    "title": "First-Line Supervisors of Landscaping, Lawn Service, and Groundskeeping Workers",
    "category": "Building & Grounds",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "building_grounds",
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 25635,
      "entry_max": 34180,
      "mid_min": 34180,
      "mid_max": 44434
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-1011.00",
      "45-1011.00",
      "49-1011.00"
    ],
    "training_paths": [],
    "description": "Directly supervise and coordinate activities of workers engaged in landscaping or groundskeeping activities. Work may involve reviewing contracts to ascertain service, machine, and workforce requirements; answering inquiries from potential customers regarding methods, material, and price ranges; and preparing estimates according to labor, material, and machine costs.",
    "dailyActivities": [
      "Establish and enforce operating procedures and work standards that will ensure adequate performance and personnel safety.",
      "Schedule work for crews, depending on work priorities, crew or equipment availability, or weather conditions.",
      "Tour grounds, such as parks, botanical gardens, cemeteries, or golf courses, to inspect conditions of plants and soil.",
      "Monitor project activities to ensure that instructions are followed, deadlines are met, and schedules are maintained.",
      "Direct activities of workers who perform duties, such as landscaping, cultivating lawns, or pruning trees and shrubs.",
      "Inspect completed work to ensure conformance to specifications, standards, and contract requirements."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "grounds_maintenance_workers_all_other",
    "onet_code": "37-3019.00",
    "title": "Grounds Maintenance Workers, All Other",
    "category": "Building & Grounds",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "building_grounds"
    ],
    "salary": {
      "entry_min": 21789,
      "entry_max": 29053,
      "mid_min": 29053,
      "mid_max": 37768
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All grounds maintenance workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "janitors_and_cleaners_except_maids_and_housekeeping_cleaners",
    "onet_code": "37-2011.00",
    "title": "Janitors and Cleaners, Except Maids and Housekeeping Cleaners",
    "category": "Building & Grounds",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Static Strength",
      "Trunk Strength",
      "Extent Flexibility",
      "Near Vision"
    ],
    "keywords": [
      "building_grounds",
      "customer_service",
      "hands_on",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 25635,
      "entry_max": 34180,
      "mid_min": 34180,
      "mid_max": 44434
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "37-2012.00",
      "53-7061.00",
      "51-6011.00"
    ],
    "training_paths": [],
    "description": "Keep buildings in clean and orderly condition. Perform heavy cleaning duties, such as cleaning floors, shampooing rugs, washing walls and glass, and removing rubbish. Duties may include tending furnace and boiler, performing routine maintenance activities, notifying management of need for repairs, and cleaning snow or debris from sidewalk.",
    "dailyActivities": [
      "Service, clean, or supply restrooms.",
      "Gather and empty trash.",
      "Clean building floors by sweeping, mopping, scrubbing, or vacuuming.",
      "Monitor building security and safety by performing tasks such as locking doors after operating hours or checking electrical appliance use to ensure that hazards are not created.",
      "Notify managers concerning the need for major repairs or additions to building operating systems.",
      "Follow procedures for the use of chemical cleaners and power equipment to prevent damage to floors and fixtures."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "landscaping_and_groundskeeping_workers",
    "onet_code": "37-3011.00",
    "title": "Landscaping and Groundskeeping Workers",
    "category": "Building & Grounds",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Oral Comprehension",
      "Manual Dexterity",
      "Control Precision",
      "Multilimb Coordination",
      "Static Strength"
    ],
    "keywords": [
      "building_grounds",
      "analytical",
      "physical",
      "hands_on"
    ],
    "salary": {
      "entry_min": 17944,
      "entry_max": 23926,
      "mid_min": 23926,
      "mid_max": 31103
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "37-3012.00",
      "37-3013.00",
      "45-2092.00"
    ],
    "training_paths": [],
    "description": "Landscape or maintain grounds of property using hand or power tools or equipment. Workers typically perform a variety of tasks, which may include any combination of the following: sod laying, mowing, trimming, planting, watering, fertilizing, digging, raking, sprinkler installation, and installation of mortarless segmental concrete masonry wall units.",
    "dailyActivities": [
      "Gather and remove litter.",
      "Use hand tools, such as shovels, rakes, pruning saws, saws, hedge or brush trimmers, or axes.",
      "Operate vehicles or powered equipment, such as mowers, tractors, twin-axle vehicles, snow blowers, chainsaws, electric clippers, sod cutters, or pruning saws.",
      "Water lawns, trees, or plants, using portable sprinkler systems, hoses, or watering cans.",
      "Prune or trim trees, shrubs, or hedges, using shears, pruners, or chain saws.",
      "Mix and spray or spread fertilizers, herbicides, or insecticides onto grass, shrubs, or trees, using hand or automatic sprayers or spreaders."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "maids_and_housekeeping_cleaners",
    "onet_code": "37-2012.00",
    "title": "Maids and Housekeeping Cleaners",
    "category": "Building & Grounds",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Oral Expression",
      "Trunk Strength",
      "Extent Flexibility",
      "Near Vision"
    ],
    "keywords": [
      "building_grounds",
      "physical",
      "customer_service"
    ],
    "salary": {
      "entry_min": 17944,
      "entry_max": 23926,
      "mid_min": 23926,
      "mid_max": 31103
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "37-2011.00",
      "51-6011.00",
      "39-3093.00"
    ],
    "training_paths": [],
    "description": "Perform any combination of light cleaning duties to maintain private households or commercial establishments, such as hotels and hospitals, in a clean and orderly manner. Duties may include making beds, replenishing linens, cleaning rooms and halls, and vacuuming.",
    "dailyActivities": [
      "Keep storage areas and carts well-stocked, clean, and tidy.",
      "Carry linens, towels, toilet items, and cleaning supplies, using wheeled carts.",
      "Clean rooms, hallways, lobbies, lounges, restrooms, corridors, elevators, stairways, locker rooms, and other work areas so that health standards are met.",
      "Empty wastebaskets, empty and clean ashtrays, and transport other trash and waste to disposal areas.",
      "Sweep, scrub, wax, or polish floors, using brooms, mops, or powered scrubbing and waxing machines.",
      "Replenish supplies, such as drinking glasses, linens, writing supplies, and bathroom items."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "pest_control_workers",
    "onet_code": "37-2021.00",
    "title": "Pest Control Workers",
    "category": "Building & Grounds",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Coordination",
      "Persuasion"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "building_grounds",
      "customer_service",
      "hands_on",
      "physical",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 21789,
      "entry_max": 29053,
      "mid_min": 29053,
      "mid_max": 37768
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "37-3012.00",
      "47-4041.00",
      "47-4071.00"
    ],
    "training_paths": [],
    "description": "Apply or release chemical solutions or toxic gases and set traps to kill or remove pests and vermin that infest buildings and surrounding areas.",
    "dailyActivities": [
      "Record work activities performed.",
      "Inspect premises to identify infestation source and extent of damage to property, wall, or roof porosity and access to infested locations.",
      "Recommend treatment and prevention methods for pest problems to clients.",
      "Spray or dust chemical solutions, powders, or gases into rooms, onto clothing, furnishings, or wood, or over marshlands, ditches, or catch basins.",
      "Clean work site after completion of job.",
      "Drive truck equipped with power spraying equipment."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "pesticide_handlers_sprayers_and_applicators_vegetation",
    "onet_code": "37-3012.00",
    "title": "Pesticide Handlers, Sprayers, and Applicators, Vegetation",
    "category": "Building & Grounds",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Speaking",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Deductive Reasoning",
      "Information Ordering"
    ],
    "keywords": [
      "building_grounds",
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 21789,
      "entry_max": 29053,
      "mid_min": 29053,
      "mid_max": 37768
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "37-3011.00",
      "45-2091.00",
      "51-8031.00"
    ],
    "training_paths": [],
    "description": "Mix or apply pesticides, herbicides, fungicides, or insecticides through sprays, dusts, vapors, soil incorporation, or chemical application on trees, shrubs, lawns, or crops. Usually requires specific training and state or federal certification.",
    "dailyActivities": [
      "Mix pesticides, herbicides, or fungicides for application to trees, shrubs, lawns, or botanical crops.",
      "Fill sprayer tanks with water and chemicals, according to formulas.",
      "Lift, push, and swing nozzles, hoses, and tubes to direct spray over designated areas.",
      "Identify lawn or plant diseases to determine the appropriate course of treatment.",
      "Cover areas to specified depths with pesticides, applying knowledge of weather conditions, droplet sizes, elevation-to-distance ratios, and obstructions.",
      "Start motors and engage machinery, such as sprayer agitators or pumps or portable spray equipment."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "tree_trimmers_and_pruners",
    "onet_code": "37-3013.00",
    "title": "Tree Trimmers and Pruners",
    "category": "Building & Grounds",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Critical Thinking",
      "Monitoring",
      "Coordination",
      "Instructing",
      "Operations Monitoring",
      "Operation and Control",
      "Time Management"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Inductive Reasoning"
    ],
    "keywords": [
      "building_grounds",
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 21789,
      "entry_max": 29053,
      "mid_min": 29053,
      "mid_max": 37768
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "45-4021.00",
      "37-3011.00",
      "37-3012.00"
    ],
    "training_paths": [],
    "description": "Using sophisticated climbing and rigging techniques, cut away dead or excess branches from trees or shrubs to maintain right-of-way for roads, sidewalks, or utilities, or to improve appearance, health, and value of tree. Prune or treat trees or shrubs using handsaws, hand pruners, clippers, and power pruners. Works off the ground in the tree canopy and may use truck-mounted lifts.",
    "dailyActivities": [
      "Operate shredding and chipping equipment, and feed limbs and brush into the machines.",
      "Operate boom trucks, loaders, stump chippers, brush chippers, tractors, power saws, trucks, sprayers, and other equipment and tools.",
      "Cut away dead and excess branches from trees, or clear branches around power lines, using climbing equipment or buckets of extended truck booms, or chainsaws, hooks, handsaws, shears, and clippers.",
      "Clean, sharpen, and lubricate tools and equipment.",
      "Hoist tools and equipment to tree trimmers, and lower branches with ropes or block and tackle.",
      "Climb trees, using climbing hooks and belts, or climb ladders to gain access to work areas."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "business_operations_specialists_all_other",
    "onet_code": "13-1199.00",
    "title": "Business Operations Specialists, All Other",
    "category": "Business & Finance",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "business_finance"
    ],
    "salary": {
      "entry_min": 48991,
      "entry_max": 65322,
      "mid_min": 65322,
      "mid_max": 84918
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All business operations specialists not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "coroners",
    "onet_code": "13-1041.06",
    "title": "Coroners",
    "category": "Business & Finance",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Science",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "business_finance",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 57637,
      "entry_max": 76850,
      "mid_min": 76850,
      "mid_max": 99905
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "33-3021.02",
      "33-3021.00",
      "29-2072.00"
    ],
    "training_paths": [],
    "description": "Direct activities such as autopsies, pathological and toxicological analyses, and inquests relating to the investigation of deaths occurring within a legal jurisdiction to determine cause of death or to fix responsibility for accidental, violent, or unexplained deaths.",
    "dailyActivities": [
      "Complete death certificates, including the assignment of cause and manner of death.",
      "Perform medicolegal examinations and autopsies, conducting preliminary examinations of the body to identify victims, locate signs of trauma, and identify factors that would indicate time of death.",
      "Interview persons present at death scenes to obtain information useful in determining the manner of death.",
      "Observe and record the positions and conditions of bodies and related evidence.",
      "Provide information concerning the circumstances of death to relatives of the deceased.",
      "Remove or supervise removal of bodies from death scenes, using the proper equipment and supplies, and arrange for transportation to morgues."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "customs_brokers",
    "onet_code": "13-1041.08",
    "title": "Customs Brokers",
    "category": "Business & Finance",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "business_finance",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 57637,
      "entry_max": 76850,
      "mid_min": 76850,
      "mid_max": 99905
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-5011.01",
      "43-5011.00",
      "33-3051.04"
    ],
    "training_paths": [],
    "description": "Prepare customs documentation and ensure that shipments meet all applicable laws to facilitate the import and export of goods. Determine and track duties and taxes payable and process payments on behalf of client. Sign documents under a power of attorney. Represent clients in meetings with customs officials and apply for duty refunds and tariff reclassifications. Coordinate transportation and storage of imported goods.",
    "dailyActivities": [
      "Prepare and process import and export documentation according to customs regulations, laws, or procedures.",
      "Clear goods through customs and to their destinations for clients.",
      "Pay, or arrange for payment of, taxes and duties on shipments.",
      "Calculate duty and tariff payments owed on shipments.",
      "Request or compile necessary import documentation, such as customs invoices, certificates of origin, and cargo-control documents.",
      "Classify goods according to tariff coding system."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "farm_labor_contractors",
    "onet_code": "13-1074.00",
    "title": "Farm Labor Contractors",
    "category": "Business & Finance",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Social Perceptiveness",
      "Coordination",
      "Negotiation",
      "Time Management",
      "Management of Personnel Resources"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "business_finance",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 48991,
      "entry_max": 65322,
      "mid_min": 65322,
      "mid_max": 84918
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "45-1011.00",
      "11-9013.00",
      "53-1043.00"
    ],
    "training_paths": [],
    "description": "Recruit and hire seasonal or temporary agricultural laborers. May transport, house, and provide meals for workers.",
    "dailyActivities": [
      "Pay wages of contracted farm laborers.",
      "Provide food, drinking water, and field sanitation facilities to contracted workers.",
      "Recruit and hire agricultural workers.",
      "Employ foremen to deal directly with workers when recruiting, hiring, instructing, assigning tasks, and enforcing work rules.",
      "Supervise the work of contracted employees.",
      "Furnish tools for employee use."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "financial_specialists_all_other",
    "onet_code": "13-2099.00",
    "title": "Financial Specialists, All Other",
    "category": "Business & Finance",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "business_finance"
    ],
    "salary": {
      "entry_min": 48991,
      "entry_max": 65322,
      "mid_min": 65322,
      "mid_max": 84918
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All financial specialists not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "government_property_inspectors_and_investigators",
    "onet_code": "13-1041.04",
    "title": "Government Property Inspectors and Investigators",
    "category": "Business & Finance",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "business_finance",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 57637,
      "entry_max": 76850,
      "mid_min": 76850,
      "mid_max": 99905
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-4011.00",
      "13-1041.01",
      "11-9199.02"
    ],
    "training_paths": [],
    "description": "Investigate or inspect government property to ensure compliance with contract agreements and government regulations.",
    "dailyActivities": [
      "Prepare correspondence, reports of inspections or investigations, or recommendations for action.",
      "Examine records, reports, or other documents to establish facts or detect discrepancies.",
      "Inspect government property, such as construction sites or public housing, to ensure compliance with contract specifications or legal requirements.",
      "Investigate alleged license or permit violations.",
      "Inspect manufactured or processed products to ensure compliance with contract specifications or legal requirements.",
      "Collect, identify, evaluate, or preserve case evidence."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "insurance_appraisers_auto_damage",
    "onet_code": "13-1032.00",
    "title": "Insurance Appraisers, Auto Damage",
    "category": "Business & Finance",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Social Perceptiveness",
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "business_finance",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 57637,
      "entry_max": 76850,
      "mid_min": 76850,
      "mid_max": 99905
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-6051.07",
      "49-3021.00",
      "49-3023.00"
    ],
    "training_paths": [],
    "description": "Appraise automobile or other vehicle damage to determine repair costs for insurance claim settlement. Prepare insurance forms to indicate repair cost or cost estimates and recommendations. May seek agreement with automotive repair shop on repair costs.",
    "dailyActivities": [
      "Evaluate practicality of repair as opposed to payment of market value of vehicle before accident.",
      "Review repair cost estimates with automobile repair shop to secure agreement on cost of repairs.",
      "Examine damaged vehicle to determine extent of structural, body, mechanical, electrical, or interior damage.",
      "Prepare insurance forms to indicate repair cost estimates and recommendations.",
      "Estimate parts and labor to repair damage, using standard automotive labor and parts cost manuals and knowledge of automotive repair.",
      "Determine salvage value on total-loss vehicle."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "tax_examiners_and_collectors_and_revenue_agents",
    "onet_code": "13-2081.00",
    "title": "Tax Examiners and Collectors, and Revenue Agents",
    "category": "Business & Finance",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "business_finance",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 57637,
      "entry_max": 76850,
      "mid_min": 76850,
      "mid_max": 99905
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "13-2082.00",
      "13-2011.00",
      "43-3011.00"
    ],
    "training_paths": [],
    "description": "Determine tax liability or collect taxes from individuals or business firms according to prescribed laws and regulations.",
    "dailyActivities": [
      "Send notices to taxpayers when accounts are delinquent.",
      "Confer with taxpayers or their representatives to discuss the issues, laws, and regulations involved in returns, and to resolve problems with returns.",
      "Notify taxpayers of any overpayment or underpayment, and either issue a refund or request further payment.",
      "Maintain records for each case, including contacts, telephone numbers, and actions taken.",
      "Contact taxpayers by mail or telephone to address discrepancies and to request supporting documentation.",
      "Answer questions from taxpayers and assist them in completing tax forms."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "tax_preparers",
    "onet_code": "13-2082.00",
    "title": "Tax Preparers",
    "category": "Business & Finance",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "business_finance",
      "problem_solving",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 57637,
      "entry_max": 76850,
      "mid_min": 76850,
      "mid_max": 99905
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "13-2081.00",
      "13-2011.00",
      "13-2052.00"
    ],
    "training_paths": [],
    "description": "Prepare tax returns for individuals or small businesses.",
    "dailyActivities": [
      "Compute taxes owed or overpaid, using adding machines or personal computers, and complete entries on forms, following tax form instructions and tax tables.",
      "Use all appropriate adjustments, deductions, and credits to keep clients' taxes to a minimum.",
      "Furnish taxpayers with sufficient information and advice to ensure correct tax form completion.",
      "Interview clients to obtain additional information on taxable income and deductible expenses and allowances.",
      "Prepare or assist in preparing simple to complex tax returns for individuals or small businesses.",
      "Review financial records, such as income statements and documentation of expenditures to determine forms needed to prepare tax returns."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "wholesale_and_retail_buyers_except_farm_products",
    "onet_code": "13-1022.00",
    "title": "Wholesale and Retail Buyers, Except Farm Products",
    "category": "Business & Finance",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "business_finance",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 57637,
      "entry_max": 76850,
      "mid_min": 76850,
      "mid_max": 99905
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "13-1023.00",
      "43-3061.00",
      "13-1021.00"
    ],
    "training_paths": [],
    "description": "Buy merchandise or commodities, other than farm products, for resale to consumers at the wholesale or retail level, including both durable and nondurable goods. Analyze past buying trends, sales records, price, and quality of merchandise to determine value and yield. Select, order, and authorize payment for merchandise according to contractual agreements. May conduct meetings with sales personnel and introduce new products. May negotiate contracts. Includes assistant wholesale and retail buyers of nonfarm products.",
    "dailyActivities": [
      "Buy merchandise or commodities for resale to wholesale or retail consumers.",
      "Negotiate prices, discount terms, or transportation arrangements with suppliers.",
      "Examine, select, order, or purchase merchandise consistent with quality, quantity, specification requirements, or other factors, such as environmental soundness.",
      "Recommend mark-up rates, mark-down rates, or merchandise selling prices.",
      "Obtain information about customer needs or preferences by conferring with sales or purchasing personnel.",
      "Authorize payment of invoices or return of merchandise."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "boilermakers",
    "onet_code": "47-2011.00",
    "title": "Boilermakers",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Complex Problem Solving",
      "Equipment Selection"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "physical",
      "technical",
      "problem_solving",
      "construction",
      "communication"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2152.00",
      "49-9044.00",
      "47-3015.00"
    ],
    "training_paths": [],
    "description": "Construct, assemble, maintain, and repair stationary steam boilers and boiler house auxiliaries. Align structures or plate sections to assemble boiler frame tanks or vats, following blueprints. Work involves use of hand and power tools, plumb bobs, levels, wedges, dogs, or turnbuckles. Assist in testing assembled vessels. Direct cleaning of boilers and boiler furnaces. Inspect and repair boiler fittings, such as safety valves, regulators, automatic-control mechanisms, water columns, and auxiliary machines.",
    "dailyActivities": [
      "Conduct pressure tests on vessels, such as boilers.",
      "Study blueprints to determine locations, relationships, or dimensions of parts.",
      "Examine boilers, pressure vessels, tanks, or vats to locate defects, such as leaks, weak spots, or defective sections, so that they can be repaired.",
      "Inspect assembled vessels or individual components, such as tubes, fittings, valves, controls, or auxiliary mechanisms, to locate any defects.",
      "Lay out plate, sheet steel, or other heavy metal and locate and mark bending and cutting lines, using protractors, compasses, and drawing instruments or templates.",
      "Bell, bead with power hammers, or weld pressure vessel tube ends to ensure leakproof joints."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "brickmasons_and_blockmasons",
    "onet_code": "47-2021.00",
    "title": "Brickmasons and Blockmasons",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Mathematics",
      "Critical Thinking",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Information Ordering",
      "Category Flexibility"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-3011.00",
      "49-9045.00",
      "47-2022.00"
    ],
    "training_paths": [],
    "description": "Lay and bind building materials, such as brick, structural tile, concrete block, cinder block, glass block, and terra-cotta block, with mortar and other substances, to construct or repair walls, partitions, arches, sewers, and other structures.",
    "dailyActivities": [
      "Measure distance from reference points and mark guidelines to lay out work, using plumb bobs and levels.",
      "Construct corners by fastening in plumb position a corner pole or building a corner pyramid of bricks, and filling in between the corners using a line from corner to corner to guide each course, or layer, of brick.",
      "Apply and smooth mortar or other mixture over work surface.",
      "Calculate angles and courses and determine vertical and horizontal alignment of courses.",
      "Break or cut bricks, tiles, or blocks to size, using trowel edge, hammer, or power saw.",
      "Interpret blueprints and drawings to determine specifications and to calculate the materials required."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "carpenters",
    "onet_code": "47-2031.00",
    "title": "Carpenters",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Monitoring",
      "Coordination",
      "Instructing"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Originality",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2081.00",
      "47-2221.00",
      "47-2021.00"
    ],
    "training_paths": [],
    "description": "Construct, erect, install, or repair structures and fixtures made of wood and comparable materials, such as concrete forms; building frameworks, including partitions, joists, studding, and rafters; and wood stairways, window and door frames, and hardwood floors. May also install cabinets, siding, drywall, and batt or roll insulation. Includes brattice builders who build doors or brattices (ventilation walls or partitions) in underground passageways.",
    "dailyActivities": [
      "Follow established safety rules and regulations and maintain a safe and clean environment.",
      "Measure and mark cutting lines on materials, using a ruler, pencil, chalk, and marking gauge.",
      "Assemble and fasten materials to make frameworks or props, using hand tools and wood screws, nails, dowel pins, or glue.",
      "Study specifications in blueprints, sketches, or building plans to prepare project layout and determine dimensions and materials required.",
      "Shape or cut materials to specified measurements, using hand tools, machines, or power saws.",
      "Verify trueness of structure, using plumb bob and level."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "carpet_installers",
    "onet_code": "47-2041.00",
    "title": "Carpet Installers",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Mathematics",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Information Ordering",
      "Flexibility of Closure",
      "Visualization"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2042.00",
      "47-2044.00",
      "47-2043.00"
    ],
    "training_paths": [],
    "description": "Lay and install carpet from rolls or blocks on floors. Install padding and trim flooring materials.",
    "dailyActivities": [
      "Inspect the surface to be covered to determine its condition, and correct any imperfections that might show through carpet or cause carpet to wear unevenly.",
      "Roll out, measure, mark, and cut carpeting to size with a carpet knife, following floor sketches and allowing extra carpet for final fitting.",
      "Join edges of carpet and seam edges where necessary, by sewing or by using tape with glue and heated carpet iron.",
      "Cut and trim carpet to fit along wall edges, openings, and projections, finishing the edges with a wall trimmer.",
      "Plan the layout of the carpet, allowing for expected traffic patterns and placing seams for best appearance and longest wear.",
      "Stretch carpet to align with walls and ensure a smooth surface, and press carpet in place over tack strips or use staples, tape, tacks or glue to hold carpet in place."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "cement_masons_and_concrete_finishers",
    "onet_code": "47-2051.00",
    "title": "Cement Masons and Concrete Finishers",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Visualization",
      "Arm-Hand Steadiness",
      "Manual Dexterity",
      "Control Precision"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 26223,
      "entry_max": 34965,
      "mid_min": 34965,
      "mid_max": 45454
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2053.00",
      "47-2061.00",
      "47-2021.00"
    ],
    "training_paths": [],
    "description": "Smooth and finish surfaces of poured concrete, such as floors, walks, sidewalks, roads, or curbs using a variety of hand and power tools. Align forms for sidewalks, curbs, or gutters; patch voids; and use saws to cut expansion joints.",
    "dailyActivities": [
      "Check the forms that hold the concrete to see that they are properly constructed.",
      "Set the forms that hold concrete to the desired pitch and depth, and align them.",
      "Spread, level, and smooth concrete, using rake, shovel, hand or power trowel, hand or power screed, and float.",
      "Monitor how the wind, heat, or cold affect the curing of the concrete throughout the entire process.",
      "Mold expansion joints and edges, using edging tools, jointers, and straightedge.",
      "Signal truck driver to position truck to facilitate pouring concrete, and move chute to direct concrete on forms."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "construction_laborers",
    "onet_code": "47-2061.00",
    "title": "Construction Laborers",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Coordination",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Information Ordering",
      "Arm-Hand Steadiness"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2071.00",
      "47-5022.00",
      "47-2051.00"
    ],
    "training_paths": [],
    "description": "Perform tasks involving physical labor at construction sites. May operate hand and power tools of all types: air hammers, earth tampers, cement mixers, small mechanical hoists, surveying and measuring equipment, and a variety of other equipment and instruments. May clean and prepare sites, dig trenches, set braces to support the sides of excavations, erect scaffolding, and clean up rubble, debris, and other waste materials. May assist other craft workers.",
    "dailyActivities": [
      "Tend pumps, compressors, or generators to provide power for tools, machinery, or equipment or to heat or move materials, such as asphalt.",
      "Lubricate, clean, or repair machinery, equipment, or tools.",
      "Signal equipment operators to facilitate alignment, movement, or adjustment of machinery, equipment, or materials.",
      "Read plans, instructions, or specifications to determine work activities.",
      "Measure, mark, or record openings or distances to layout areas where construction work will be performed.",
      "Clean or prepare construction sites to eliminate possible hazards."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "construction_and_building_inspectors",
    "onet_code": "47-4011.00",
    "title": "Construction and Building Inspectors",
    "category": "Construction",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37462,
      "entry_max": 49950,
      "mid_min": 49950,
      "mid_max": 64935
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "13-1041.04",
      "47-1011.00",
      "53-6051.07"
    ],
    "training_paths": [],
    "description": "Inspect structures using engineering skills to determine structural soundness and compliance with specifications, building codes, and other regulations. Inspections may be general in nature or may be limited to a specific area, such as electrical systems or plumbing.",
    "dailyActivities": [
      "Approve building plans that meet required specifications.",
      "Review and interpret plans, blueprints, site layouts, specifications, or construction methods to ensure compliance to legal requirements and safety regulations.",
      "Issue permits for construction, relocation, demolition, or occupancy.",
      "Inspect bridges, dams, highways, buildings, wiring, plumbing, electrical circuits, sewers, heating systems, or foundations during and after construction for structural quality, general safety, or conformance to specifications and codes.",
      "Monitor installation of plumbing, wiring, equipment, or appliances to ensure that installation is performed properly and is in compliance with applicable regulations.",
      "Inspect and monitor construction sites to ensure adherence to safety standards, building codes, or specifications."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "construction_and_related_workers_all_other",
    "onet_code": "47-4099.00",
    "title": "Construction and Related Workers, All Other",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "construction"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All construction and related workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "continuous_mining_machine_operators",
    "onet_code": "47-5041.00",
    "title": "Continuous Mining Machine Operators",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Critical Thinking",
      "Monitoring",
      "Coordination",
      "Complex Problem Solving",
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance",
      "Troubleshooting"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Inductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "analytical",
      "physical",
      "technical",
      "problem_solving",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2073.00",
      "47-5022.00",
      "47-5081.00"
    ],
    "training_paths": [],
    "description": "Operate self-propelled mining machines that rip coal, metal and nonmetal ores, rock, stone, or sand from the mine face and load it onto conveyors, shuttle cars, or trucks in a continuous operation.",
    "dailyActivities": [
      "Hang ventilation tubing and ventilation curtains to ensure that the mining face area is kept properly ventilated.",
      "Conduct methane gas checks to ensure breathing quality of air.",
      "Check the stability of roof and rib support systems before mining face areas.",
      "Operate mining machines to gather coal and convey it to floors or shuttle cars.",
      "Drive machines into position at working faces.",
      "Move controls to start and regulate movement of conveyors and to start and position drill cutters or torches."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "derrick_operators_oil_and_gas",
    "onet_code": "47-5011.00",
    "title": "Derrick Operators, Oil and Gas",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Coordination",
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Information Ordering",
      "Flexibility of Closure"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "technical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 26223,
      "entry_max": 34965,
      "mid_min": 34965,
      "mid_max": 45454
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-5012.00",
      "47-5071.00",
      "47-5081.00"
    ],
    "training_paths": [],
    "description": "Rig derrick equipment and operate pumps to circulate mud or fluid through drill hole.",
    "dailyActivities": [
      "Inspect derricks, or order their inspection, prior to being raised or lowered.",
      "Inspect derricks for flaws, and clean and oil derricks to maintain proper working conditions.",
      "Control the viscosity and weight of the drilling fluid.",
      "Repair pumps, mud tanks, and related equipment.",
      "Set and bolt crown blocks to posts at tops of derricks.",
      "Listen to mud pumps and check regularly for vibration and other problems to ensure that rig pumps and drilling mud systems are working properly."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "drywall_and_ceiling_tile_installers",
    "onet_code": "47-2081.00",
    "title": "Drywall and Ceiling Tile Installers",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Visualization",
      "Arm-Hand Steadiness",
      "Manual Dexterity"
    ],
    "keywords": [
      "hands_on",
      "analytical",
      "physical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2131.00",
      "47-2082.00",
      "47-2211.00"
    ],
    "training_paths": [],
    "description": "Apply plasterboard or other wallboard to ceilings or interior walls of buildings. Apply or mount acoustical tiles or blocks, strips, or sheets of shock-absorbing materials to ceilings and walls of buildings to reduce or reflect sound. Materials may be of decorative quality. Includes lathers who fasten wooden, metal, or rockboard lath to walls, ceilings, or partitions of buildings to provide support base for plaster, fireproofing, or acoustical material.",
    "dailyActivities": [
      "Read blueprints or other specifications to determine methods of installation, work procedures, or material or tool requirements.",
      "Measure and mark surfaces to lay out work, according to blueprints or drawings, using tape measures, straightedges or squares, and marking devices.",
      "Fit and fasten wallboard or drywall into position on wood or metal frameworks, using glue, nails, or screws.",
      "Measure and cut openings in panels or tiles for electrical outlets, windows, vents, plumbing, or other fixtures, using keyhole saws or other cutting tools.",
      "Assemble or install metal framing or decorative trim for windows, doorways, or vents.",
      "Cut metal or wood framing and trim to size, using cutting tools."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "earth_drillers_except_oil_and_gas",
    "onet_code": "47-5023.00",
    "title": "Earth Drillers, Except Oil and Gas",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Critical Thinking",
      "Monitoring",
      "Coordination",
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance",
      "Troubleshooting"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Inductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "technical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-5012.00",
      "47-5081.00",
      "51-4032.00"
    ],
    "training_paths": [],
    "description": "Operate a variety of drills such as rotary, churn, and pneumatic to tap subsurface water and salt deposits, to remove core samples during mineral exploration or soil testing, and to facilitate the use of explosives in mining or construction. Includes horizontal and earth boring machine operators.",
    "dailyActivities": [
      "Operate controls to stabilize machines and to position and align drills.",
      "Start, stop, and control drilling speed of machines and insertion of casings into holes.",
      "Regulate air pressure, rotary speed, and downward pressure, according to the type of rock or concrete being drilled.",
      "Select and attach drill bits and drill rods, adding more rods as hole depths increase, and changing drill bits as needed.",
      "Drive or guide truck-mounted equipment into position, level and stabilize rigs, and extend telescoping derricks.",
      "Operate machines to flush earth cuttings or to blow dust from holes."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "electricians",
    "onet_code": "47-2111.00",
    "title": "Electricians",
    "category": "Construction",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37462,
      "entry_max": 49950,
      "mid_min": 49950,
      "mid_max": 64935
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "27-4015.00",
      "47-3013.00",
      "47-2152.00"
    ],
    "training_paths": [],
    "description": "Install, maintain, and repair electrical wiring, equipment, and fixtures. Ensure that work is in accordance with relevant codes. May install or service street lights, intercom systems, or electrical control systems.",
    "dailyActivities": [
      "Prepare sketches or follow blueprints to determine the location of wiring or equipment and to ensure conformance to building and safety codes.",
      "Place conduit, pipes, or tubing, inside designated partitions, walls, or other concealed areas, and pull insulated wires or cables through the conduit to complete circuits between boxes.",
      "Work from ladders, scaffolds, or roofs to install, maintain, or repair electrical wiring, equipment, or fixtures.",
      "Use a variety of tools or equipment, such as power construction equipment, measuring devices, power tools, and testing equipment, such as oscilloscopes, ammeters, or test lamps.",
      "Assemble, install, test, or maintain electrical or electronic wiring, equipment, appliances, apparatus, or fixtures, using hand tools or power tools.",
      "Connect wires to circuit breakers, transformers, or other components."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "military_mos_relevant": [
      "3E0X1"
    ],
    "last_updated": new Date()
  },
  {
    "id": "elevator_and_escalator_installers_and_repairers",
    "onet_code": "47-4021.00",
    "title": "Elevator and Escalator Installers and Repairers",
    "category": "Construction",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Coordination",
      "Complex Problem Solving",
      "Equipment Selection"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "physical",
      "technical",
      "problem_solving",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37462,
      "entry_max": 49950,
      "mid_min": 49950,
      "mid_max": 64935
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-9071.00",
      "49-3042.00",
      "49-9044.00"
    ],
    "training_paths": [],
    "description": "Assemble, install, repair, or maintain electric or hydraulic freight or passenger elevators, escalators, or dumbwaiters.",
    "dailyActivities": [
      "Inspect wiring connections, control panel hookups, door installations, and alignments and clearances of cars and hoistways to ensure that equipment will operate properly.",
      "Assemble, install, repair, and maintain elevators, escalators, moving sidewalks, and dumbwaiters, using hand and power tools, and testing devices such as test lamps, ammeters, and voltmeters.",
      "Disassemble defective units, and repair or replace parts such as locks, gears, cables, and electric wiring.",
      "Check that safety regulations and building codes are met, and complete service reports verifying conformance to standards.",
      "Locate malfunctions in brakes, motors, switches, and signal and control systems, using test equipment.",
      "Adjust safety controls, counterweights, door mechanisms, and components such as valves, ratchets, seals, and brake linings."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "energy_auditors",
    "onet_code": "47-4011.01",
    "title": "Energy Auditors",
    "category": "Construction",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37462,
      "entry_max": 49950,
      "mid_min": 49950,
      "mid_max": 64935
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "17-2199.03",
      "17-2199.11",
      "47-1011.03"
    ],
    "training_paths": [],
    "description": "Conduct energy audits of buildings, building systems, or process systems. May also conduct investment grade audits of buildings or systems.",
    "dailyActivities": [
      "Identify and prioritize energy-saving measures.",
      "Prepare audit reports containing energy analysis results or recommendations for energy cost savings.",
      "Identify any health or safety issues related to planned weatherization projects.",
      "Identify opportunities to improve the operation, maintenance, or energy efficiency of building or process systems.",
      "Calculate potential for energy savings.",
      "Inspect or evaluate building envelopes, mechanical systems, electrical systems, or process systems to determine the energy consumption of each system."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "excavating_and_loading_machine_and_dragline_operators_surface_mining",
    "onet_code": "47-5022.00",
    "title": "Excavating and Loading Machine and Dragline Operators, Surface Mining",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Critical Thinking",
      "Monitoring",
      "Coordination",
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Flexibility of Closure"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "technical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2073.00",
      "47-2061.00",
      "53-7041.00"
    ],
    "training_paths": [],
    "description": "Operate or tend machinery at surface mining site, equipped with scoops, shovels, or buckets to excavate and load loose materials.",
    "dailyActivities": [
      "Move levers, depress foot pedals, and turn dials to operate power machinery, such as power shovels, stripping shovels, scraper loaders, or backhoes.",
      "Set up or inspect equipment prior to operation.",
      "Become familiar with digging plans, machine capabilities and limitations, and efficient and safe digging procedures in a given application.",
      "Observe hand signals, grade stakes, or other markings when operating machines so that work can be performed to specifications.",
      "Operate machinery to perform activities such as backfilling excavations, vibrating or breaking rock or concrete, or making winter roads.",
      "Receive written or oral instructions regarding material movement or excavation."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "explosives_workers_ordnance_handling_experts_and_blasters",
    "onet_code": "47-5032.00",
    "title": "Explosives Workers, Ordnance Handling Experts, and Blasters",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Coordination",
      "Instructing"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Fluency of Ideas",
      "Originality"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-5023.00",
      "47-5081.00",
      "47-5012.00"
    ],
    "training_paths": [],
    "description": "Place and detonate explosives to demolish structures or to loosen, remove, or displace earth, rock, or other materials. May perform specialized handling, storage, and accounting procedures.",
    "dailyActivities": [
      "Examine blast areas to determine amounts and kinds of explosive charges needed and to ensure that safety laws are observed.",
      "Tie specified lengths of delaying fuses into patterns in order to time sequences of explosions.",
      "Place safety cones around blast areas to alert other workers of danger zones, and signal workers as necessary to ensure that they clear blast sites prior to explosions.",
      "Place explosive charges in holes or other spots; then detonate explosives to demolish structures or to loosen, remove, or displace earth, rock, or other materials.",
      "Insert, pack, and pour explosives, such as dynamite, ammonium nitrate, black powder, or slurries into blast holes; then shovel drill cuttings, admit water into boreholes, and tamp material to compact charges.",
      "Mark patterns, locations, and depths of charge holes for drilling, and issue drilling instructions."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "extraction_workers_all_other",
    "onet_code": "47-5099.00",
    "title": "Extraction Workers, All Other",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "construction"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All extraction workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "fence_erectors",
    "onet_code": "47-4031.00",
    "title": "Fence Erectors",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Visualization",
      "Manual Dexterity",
      "Finger Dexterity"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "analytical",
      "physical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2031.00",
      "47-2221.00",
      "47-2171.00"
    ],
    "training_paths": [],
    "description": "Erect and repair fences and fence gates, using hand and power tools.",
    "dailyActivities": [
      "Establish the location for a fence, and gather information needed to ensure that there are no electric cables or water lines in the area.",
      "Set metal or wooden posts in upright positions in postholes.",
      "Measure and lay out fence lines and mark posthole positions, following instructions, drawings, or specifications.",
      "Align posts, by lines or sighting, and verify vertical alignment of posts, using plumb bobs or spirit levels.",
      "Attach rails or tension wire along bottoms of posts to form fencing frames.",
      "Dig postholes, using spades, posthole diggers, or power-driven augers."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "first_line_supervisors_of_construction_trades_and_extraction_workers",
    "onet_code": "47-1011.00",
    "title": "First-Line Supervisors of Construction Trades and Extraction Workers",
    "category": "Construction",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37462,
      "entry_max": 49950,
      "mid_min": 49950,
      "mid_max": 64935
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-1011.00",
      "51-1011.00",
      "53-1042.00"
    ],
    "training_paths": [],
    "description": "Directly supervise and coordinate activities of construction or extraction workers.",
    "dailyActivities": [
      "Inspect work progress, equipment, or construction sites to verify safety or to ensure that specifications are met.",
      "Read specifications, such as blueprints, to determine construction requirements or to plan procedures.",
      "Supervise, coordinate, or schedule the activities of construction or extractive workers.",
      "Assign work to employees, based on material or worker requirements of specific jobs.",
      "Coordinate work activities with other construction project activities.",
      "Estimate material or worker requirements to complete jobs."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "floor_layers_except_carpet_wood_and_hard_tiles",
    "onet_code": "47-2042.00",
    "title": "Floor Layers, Except Carpet, Wood, and Hard Tiles",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Monitoring",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Deductive Reasoning",
      "Information Ordering",
      "Visualization"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2044.00",
      "47-2041.00",
      "47-2131.00"
    ],
    "training_paths": [],
    "description": "Apply blocks, strips, or sheets of shock-absorbing, sound-deadening, or decorative coverings to floors.",
    "dailyActivities": [
      "Sweep, scrape, sand, or chip dirt and irregularities to clean base surfaces, correcting imperfections that may show through the covering.",
      "Cut flooring material to fit around obstructions.",
      "Inspect surface to be covered to ensure that it is firm and dry.",
      "Trim excess covering materials, tack edges, and join sections of covering material to form tight joint.",
      "Form a smooth foundation by stapling plywood or Masonite over the floor or by brushing waterproof compound onto surface and filling cracks with plaster, putty, or grout to seal pores.",
      "Measure and mark guidelines on surfaces or foundations, using chalk lines and dividers."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "floor_sanders_and_finishers",
    "onet_code": "47-2043.00",
    "title": "Floor Sanders and Finishers",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Control Precision",
      "Multilimb Coordination",
      "Reaction Time"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "analytical",
      "physical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 26223,
      "entry_max": 34965,
      "mid_min": 34965,
      "mid_max": 45454
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2042.00",
      "51-7021.00",
      "47-2041.00"
    ],
    "training_paths": [],
    "description": "Scrape and sand wooden floors to smooth surfaces using floor scraper and floor sanding machine, and apply coats of finish.",
    "dailyActivities": [
      "Buff and vacuum floors to ensure their cleanliness prior to the application of finish.",
      "Scrape and sand floor edges and areas inaccessible to floor sanders, using scrapers, disk-type sanders, and sandpaper.",
      "Inspect floors for smoothness.",
      "Attach sandpaper to rollers of sanding machines.",
      "Guide sanding machines over surfaces of floors until surfaces are smooth.",
      "Apply filler compound and coats of finish to floors to seal wood."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "glaziers",
    "onet_code": "47-2121.00",
    "title": "Glaziers",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Critical Thinking",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-3022.00",
      "47-2031.00",
      "47-2081.00"
    ],
    "training_paths": [],
    "description": "Install glass in windows, skylights, store fronts, and display cases, or on surfaces, such as building fronts, interior walls, ceilings, and tabletops.",
    "dailyActivities": [
      "Read and interpret blueprints or specifications to determine size, shape, color, type, or thickness of glass, location of framing, installation procedures, or staging or scaffolding materials required.",
      "Determine plumb of walls or ceilings, using plumb lines and levels.",
      "Install pre-assembled metal or wood frameworks for windows or doors to be fitted with glass panels, using hand tools.",
      "Fabricate or install metal sashes or moldings for glass installation, using aluminum or steel framing.",
      "Operate cranes or hoists with suction cups to lift large, heavy pieces of glass.",
      "Set glass doors into frames and bolt metal hinges, handles, locks, or other hardware to attach doors to frames and walls."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "hazardous_materials_removal_workers",
    "onet_code": "47-4041.00",
    "title": "Hazardous Materials Removal Workers",
    "category": "Construction",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Coordination",
      "Complex Problem Solving",
      "Operations Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37462,
      "entry_max": 49950,
      "mid_min": 49950,
      "mid_max": 64935
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-7062.04",
      "51-8031.00",
      "47-4051.00"
    ],
    "training_paths": [],
    "description": "Identify, remove, pack, transport, or dispose of hazardous materials, including asbestos, lead-based paint, waste oil, fuel, transmission fluid, radioactive materials, or contaminated soil. Specialized training and certification in hazardous materials handling or a confined entry permit are generally required. May operate earth-moving equipment or trucks.",
    "dailyActivities": [
      "Build containment areas prior to beginning abatement or decontamination work.",
      "Remove asbestos or lead from surfaces, using hand or power tools such as scrapers, vacuums, or high-pressure sprayers.",
      "Identify asbestos, lead, or other hazardous materials to be removed, using monitoring devices.",
      "Prepare hazardous material for removal or storage.",
      "Comply with prescribed safety procedures or federal laws regulating waste disposal methods.",
      "Load or unload materials into containers or onto trucks, using hoists or forklifts."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "helpers_construction_trades_all_other",
    "onet_code": "47-3019.00",
    "title": "Helpers, Construction Trades, All Other",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "construction"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All construction trades helpers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "helpers_brickmasons_blockmasons_stonemasons_and_tile_and_marble_setters",
    "onet_code": "47-3011.00",
    "title": "Helpers--Brickmasons, Blockmasons, Stonemasons, and Tile and Marble Setters",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Coordination"
    ],
    "niceToHave": [
      "Visualization",
      "Manual Dexterity",
      "Finger Dexterity",
      "Control Precision",
      "Multilimb Coordination"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2021.00",
      "47-3012.00",
      "47-3014.00"
    ],
    "training_paths": [],
    "description": "Help brickmasons, blockmasons, stonemasons, or tile and marble setters by performing duties requiring less skill. Duties include using, supplying, or holding materials or tools, and cleaning work area and equipment.",
    "dailyActivities": [
      "Mix mortar, plaster, and grout, manually or using machines, according to standard formulas.",
      "Erect scaffolding or other installation structures.",
      "Cut materials to specified sizes for installation, using power saws or tile cutters.",
      "Modify material moving, mixing, grouting, grinding, polishing, or cleaning procedures, according to installation or material requirements.",
      "Transport materials, tools, or machines to installation sites, manually or using conveyance equipment.",
      "Provide assistance in the preparation, installation, repair, or rebuilding of tile, brick, or stone surfaces."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "helpers_carpenters",
    "onet_code": "47-3012.00",
    "title": "Helpers--Carpenters",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Visualization",
      "Arm-Hand Steadiness"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-3011.00",
      "47-3014.00",
      "47-3015.00"
    ],
    "training_paths": [],
    "description": "Help carpenters by performing duties requiring less skill. Duties include using, supplying, or holding materials or tools, and cleaning work area and equipment.",
    "dailyActivities": [
      "Clean work areas, machines, or equipment, to maintain a clean and safe job site.",
      "Fasten timbers or lumber with glue, screws, pegs, or nails and install hardware.",
      "Perform tie spacing layout and measure, mark, drill or cut.",
      "Select tools, equipment, or materials from storage and transport items to work site.",
      "Drill holes in timbers or lumber.",
      "Cut timbers, lumber, or paneling to specified dimensions."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "helpers_electricians",
    "onet_code": "47-3013.00",
    "title": "Helpers--Electricians",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Critical Thinking",
      "Troubleshooting"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Information Ordering"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "technical",
      "problem_solving",
      "construction",
      "communication"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-3015.00",
      "49-9098.00",
      "47-2111.00"
    ],
    "training_paths": [],
    "description": "Help electricians by performing duties requiring less skill. Duties include using, supplying, or holding materials or tools, and cleaning work area and equipment.",
    "dailyActivities": [
      "Strip insulation from wire ends, using wire stripping pliers, and attach wires to terminals for subsequent soldering.",
      "Trace out short circuits in wiring, using test meter.",
      "Measure, cut, and bend wire and conduit, using measuring instruments and hand tools.",
      "Examine electrical units for loose connections and broken insulation and tighten connections, using hand tools.",
      "Maintain tools, vehicles, and equipment and keep parts and supplies in order.",
      "Drill holes and pull or push wiring through openings, using hand and power tools."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "helpers_extraction_workers",
    "onet_code": "47-5081.00",
    "title": "Helpers--Extraction Workers",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Monitoring",
      "Coordination",
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance",
      "Troubleshooting",
      "Repairing"
    ],
    "niceToHave": [
      "Problem Sensitivity",
      "Visualization",
      "Selective Attention",
      "Arm-Hand Steadiness",
      "Manual Dexterity"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "analytical",
      "physical",
      "technical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-9098.00",
      "51-9198.00",
      "47-5012.00"
    ],
    "training_paths": [],
    "description": "Help extraction craft workers, such as earth drillers, blasters and explosives workers, derrick operators, and mining machine operators, by performing duties requiring less skill. Duties include supplying equipment or cleaning work area.",
    "dailyActivities": [
      "Observe and monitor equipment operation during the extraction process to detect any problems.",
      "Drive moving equipment to transport materials and parts to excavation sites.",
      "Unload materials, devices, and machine parts, using hand tools.",
      "Set up and adjust equipment used to excavate geological materials.",
      "Organize materials to prepare for use.",
      "Repair and maintain automotive and drilling equipment, using hand tools."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "helpers_painters_paperhangers_plasterers_and_stucco_masons",
    "onet_code": "47-3014.00",
    "title": "Helpers--Painters, Paperhangers, Plasterers, and Stucco Masons",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Static Strength",
      "Trunk Strength",
      "Extent Flexibility",
      "Gross Body Equilibrium"
    ],
    "keywords": [
      "hands_on",
      "physical",
      "construction",
      "communication"
    ],
    "salary": {
      "entry_min": 26223,
      "entry_max": 34965,
      "mid_min": 34965,
      "mid_max": 45454
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-3011.00",
      "47-3012.00",
      "47-3015.00"
    ],
    "training_paths": [],
    "description": "Help painters, paperhangers, plasterers, or stucco masons by performing duties requiring less skill. Duties include using, supplying, or holding materials or tools, and cleaning work area and equipment.",
    "dailyActivities": [
      "Clean work areas and equipment.",
      "Perform support duties to assist painters, paperhangers, plasterers, or masons.",
      "Apply protective coverings, such as masking tape, to articles or areas that could be damaged or stained by work processes.",
      "Erect scaffolding.",
      "Fill cracks or breaks in surfaces of plaster articles or areas with putty or epoxy compounds.",
      "Supply or hold tools and materials."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "helpers_pipelayers_plumbers_pipefitters_and_steamfitters",
    "onet_code": "47-3015.00",
    "title": "Helpers--Pipelayers, Plumbers, Pipefitters, and Steamfitters",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Information Ordering",
      "Visualization",
      "Arm-Hand Steadiness",
      "Control Precision"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2152.00",
      "49-9098.00",
      "47-3013.00"
    ],
    "training_paths": [],
    "description": "Help plumbers, pipefitters, steamfitters, or pipelayers by performing duties requiring less skill. Duties include using, supplying, or holding materials or tools, and cleaning work area and equipment.",
    "dailyActivities": [
      "Measure, cut, thread and assemble new pipe, placing the assembled pipe in hangers or other supports.",
      "Cut or drill holes in walls or floors to accommodate the passage of pipes.",
      "Perform rough-ins, repair and replace fixtures and water heaters, and locate, repair, or remove leaking or broken pipes.",
      "Assist pipe fitters in the layout, assembly, and installation of piping for air, ammonia, gas, and water systems.",
      "Cut pipe and lift up to fitters.",
      "Fit or assist in fitting valves, couplings, or assemblies to tanks, pumps, or systems, using hand tools."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "helpers_roofers",
    "onet_code": "47-3016.00",
    "title": "Helpers--Roofers",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Coordination"
    ],
    "niceToHave": [
      "Flexibility of Closure",
      "Visualization",
      "Manual Dexterity",
      "Finger Dexterity",
      "Static Strength"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2181.00",
      "47-3014.00",
      "47-3015.00"
    ],
    "training_paths": [],
    "description": "Help roofers by performing duties requiring less skill. Duties include using, supplying, or holding materials or tools, and cleaning work area and equipment.",
    "dailyActivities": [
      "Check to ensure that completed roofs are watertight.",
      "Sweep and clean roofs to prepare them for the application of new roofing materials.",
      "Locate worn or torn areas in roofs.",
      "Clean work areas and equipment.",
      "Maintain tools and equipment.",
      "Cover roofs with layers of roofing felt or asphalt strips before installing tile, slate, or composition materials."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "highway_maintenance_workers",
    "onet_code": "47-4051.00",
    "title": "Highway Maintenance Workers",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Coordination",
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Flexibility of Closure",
      "Visualization"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2073.00",
      "47-2071.00",
      "47-4061.00"
    ],
    "training_paths": [],
    "description": "Maintain highways, municipal and rural roads, airport runways, and rights-of-way. Duties include patching broken or eroded pavement and repairing guard rails, highway markers, and snow fences. May also mow or clear brush from along road, or plow snow from roadway.",
    "dailyActivities": [
      "Set out signs and cones around work areas to divert traffic.",
      "Flag motorists to warn them of obstacles or repair work ahead.",
      "Perform preventative maintenance on vehicles and heavy equipment.",
      "Drive trucks to transport crews and equipment to work sites.",
      "Erect, install, or repair guardrails, road shoulders, berms, highway markers, warning signals, and highway lighting, using hand tools and power tools.",
      "Clean and clear debris from culverts, catch basins, drop inlets, ditches, and other drain structures."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "insulation_workers_floor_ceiling_and_wall",
    "onet_code": "47-2131.00",
    "title": "Insulation Workers, Floor, Ceiling, and Wall",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Operation and Control"
    ],
    "niceToHave": [
      "Visualization",
      "Manual Dexterity",
      "Control Precision",
      "Multilimb Coordination",
      "Static Strength"
    ],
    "keywords": [
      "hands_on",
      "physical",
      "construction",
      "communication"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2132.00",
      "47-2042.00",
      "47-2081.00"
    ],
    "training_paths": [],
    "description": "Line and cover structures with insulating materials. May work with batt, roll, or blown insulation materials.",
    "dailyActivities": [
      "Measure and cut insulation for covering surfaces, using tape measures, handsaws, power saws, knives, or scissors.",
      "Fit, wrap, staple, or glue insulating materials to structures or surfaces, using hand tools or wires.",
      "Cover and line structures with blown or rolled forms of materials to insulate against cold, heat, or moisture, using saws, knives, rasps, trowels, blowers, or other tools and implements.",
      "Distribute insulating materials evenly into small spaces within floors, ceilings, or walls, using blowers and hose attachments, or cement mortars.",
      "Move controls, buttons, or levers to start blowers and regulate flow of materials through nozzles.",
      "Fill blower hoppers with insulating materials."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "insulation_workers_mechanical",
    "onet_code": "47-2132.00",
    "title": "Insulation Workers, Mechanical",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Critical Thinking",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Selective Attention",
      "Arm-Hand Steadiness",
      "Manual Dexterity",
      "Finger Dexterity"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2131.00",
      "47-2081.00",
      "47-2211.00"
    ],
    "training_paths": [],
    "description": "Apply insulating materials to pipes or ductwork, or other mechanical systems in order to help control and maintain temperature.",
    "dailyActivities": [
      "Measure and cut insulation for covering surfaces, using tape measures, handsaws, knives, and scissors.",
      "Apply, remove, and repair insulation on industrial equipment, pipes, ductwork, or other mechanical systems such as heat exchangers, tanks, and vessels, to help control noise and maintain temperatures.",
      "Select appropriate insulation, such as fiberglass, Styrofoam, or cork, based on the heat retaining or excluding characteristics of the material.",
      "Fit insulation around obstructions, and shape insulating materials and protective coverings as required.",
      "Determine the amounts and types of insulation needed, and methods of installation, based on factors such as location, surface shape, and equipment use.",
      "Cover, seal, or finish insulated surfaces or access holes with plastic covers, canvas strips, sealants, tape, cement, or asphalt mastic."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "loading_and_moving_machine_operators_underground_mining",
    "onet_code": "47-5044.00",
    "title": "Loading and Moving Machine Operators, Underground Mining",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Coordination",
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance",
      "Troubleshooting",
      "Repairing"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Information Ordering",
      "Category Flexibility"
    ],
    "keywords": [
      "hands_on",
      "analytical",
      "physical",
      "technical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-7051.00",
      "47-5022.00",
      "47-5041.00"
    ],
    "training_paths": [],
    "description": "Operate underground loading or moving machine to load or move coal, ore, or rock using shuttle or mine car or conveyors. Equipment may include power shovels, hoisting engines equipped with cable-drawn scraper or scoop, or machines equipped with gathering arms and conveyor.",
    "dailyActivities": [
      "Handle high voltage sources and hang electrical cables.",
      "Drive loaded shuttle cars to ramps and move controls to discharge loads into mine cars or onto conveyors.",
      "Pry off loose material from roofs and move it into the paths of machines, using crowbars.",
      "Move trailing electrical cables clear of obstructions, using rubber safety gloves.",
      "Control conveyors that run the entire length of shuttle cars to distribute loads as loading progresses.",
      "Observe hand signals, grade stakes, or other markings when operating machines."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "operating_engineers_and_other_construction_equipment_operators",
    "onet_code": "47-2073.00",
    "title": "Operating Engineers and Other Construction Equipment Operators",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Critical Thinking",
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance",
      "Troubleshooting",
      "Repairing"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Inductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "analytical",
      "physical",
      "technical",
      "problem_solving",
      "construction",
      "communication"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-5022.00",
      "53-7041.00",
      "49-3042.00"
    ],
    "training_paths": [],
    "description": "Operate one or several types of power construction equipment, such as motor graders, bulldozers, scrapers, compressors, pumps, derricks, shovels, tractors, or front-end loaders to excavate, move, and grade earth, erect structures, or pour concrete or other hard surface pavement. May repair and maintain equipment in addition to other duties.",
    "dailyActivities": [
      "Learn and follow safety regulations.",
      "Take actions to avoid potential hazards or obstructions, such as utility lines, other equipment, other workers, or falling objects.",
      "Start engines, move throttles, switches, or levers, or depress pedals to operate machines, such as bulldozers, trench excavators, road graders, or backhoes.",
      "Coordinate machine actions with other activities, positioning or moving loads in response to hand or audio signals from crew members.",
      "Align machines, cutterheads, or depth gauge makers with reference stakes and guidelines or ground or position equipment, following hand signals of other workers.",
      "Locate underground services, such as pipes or wires, prior to beginning work."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "military_mos_relevant": [
      "1345"
    ],
    "last_updated": new Date()
  },
  {
    "id": "painters_construction_and_maintenance",
    "onet_code": "47-2141.00",
    "title": "Painters, Construction and Maintenance",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Critical Thinking"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Information Ordering",
      "Selective Attention"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "construction",
      "communication"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9123.00",
      "47-3014.00",
      "47-2161.00"
    ],
    "training_paths": [],
    "description": "Paint walls, equipment, buildings, bridges, and other structural surfaces, using brushes, rollers, and spray guns. May remove old paint to prepare surface prior to painting. May mix colors or oils to obtain desired color or consistency.",
    "dailyActivities": [
      "Cover surfaces with dropcloths or masking tape and paper to protect surfaces during painting.",
      "Read work orders or receive instructions from supervisors or homeowners to determine work requirements.",
      "Apply paint, stain, varnish, enamel, or other finishes to equipment, buildings, bridges, or other structures, using brushes, spray guns, or rollers.",
      "Fill cracks, holes, or joints with caulk, putty, plaster, or other fillers, using caulking guns or putty knives.",
      "Smooth surfaces, using sandpaper, scrapers, brushes, steel wool, or sanding machines.",
      "Erect scaffolding or swing gates, or set up ladders, to work above ground level."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "paperhangers",
    "onet_code": "47-2142.00",
    "title": "Paperhangers",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Visualization",
      "Arm-Hand Steadiness",
      "Manual Dexterity",
      "Finger Dexterity",
      "Control Precision"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "analytical",
      "physical",
      "construction"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2042.00",
      "47-2041.00",
      "47-2081.00"
    ],
    "training_paths": [],
    "description": "Cover interior walls or ceilings of rooms with decorative wallpaper or fabric, or attach advertising posters on surfaces such as walls and billboards. May remove old materials or prepare surfaces to be papered.",
    "dailyActivities": [
      "Smooth strips or sections of paper with brushes or rollers to remove wrinkles and bubbles and to smooth joints.",
      "Trim rough edges from strips, using straightedges and trimming knives.",
      "Trim excess material at ceilings or baseboards, using knives.",
      "Check finished wallcoverings for proper alignment, pattern matching, and neatness of seams.",
      "Mark vertical guidelines on walls to align strips, using plumb bobs and chalk lines.",
      "Cover interior walls and ceilings of rooms with decorative wallpaper or fabric, using hand tools."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "paving_surfacing_and_tamping_equipment_operators",
    "onet_code": "47-2071.00",
    "title": "Paving, Surfacing, and Tamping Equipment Operators",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Coordination",
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance",
      "Repairing"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Information Ordering",
      "Visualization",
      "Selective Attention"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "analytical",
      "physical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2061.00",
      "47-2073.00",
      "47-4091.00"
    ],
    "training_paths": [],
    "description": "Operate equipment used for applying concrete, asphalt, or other materials to road beds, parking lots, or airport runways and taxiways or for tamping gravel, dirt, or other materials. Includes concrete and asphalt paving machine operators, form tampers, tamping machine operators, and stone spreader operators.",
    "dailyActivities": [
      "Start machine, engage clutch, and push and move levers to guide machine along forms or guidelines and to control the operation of machine attachments.",
      "Fill tanks, hoppers, or machines with paving materials.",
      "Control paving machines to push dump trucks and to maintain a constant flow of asphalt or other material into hoppers or screeds.",
      "Observe distribution of paving material to adjust machine settings or material flow, and indicate low spots for workers to add material.",
      "Coordinate truck dumping.",
      "Drive machines onto truck trailers, and drive trucks to transport machines and material to and from job sites."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "pile_driver_operators",
    "onet_code": "47-2072.00",
    "title": "Pile Driver Operators",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Critical Thinking",
      "Coordination",
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance",
      "Troubleshooting"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Problem Sensitivity",
      "Visualization",
      "Selective Attention",
      "Manual Dexterity"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "analytical",
      "physical",
      "technical",
      "problem_solving",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2073.00",
      "53-7051.00",
      "47-5022.00"
    ],
    "training_paths": [],
    "description": "Operate pile drivers mounted on skids, barges, crawler treads, or locomotive cranes to drive pilings for retaining walls, bulkheads, and foundations of structures such as buildings, bridges, and piers.",
    "dailyActivities": [
      "Move hand and foot levers of hoisting equipment to position piling leads, hoist piling into leads, and position hammers over pilings.",
      "Move levers and turn valves to activate power hammers, or to raise and lower drophammers that drive piles to required depths.",
      "Drive pilings to provide support for buildings or other structures, using heavy equipment with a pile driver head.",
      "Conduct pre-operational checks on equipment to ensure proper functioning.",
      "Clean, lubricate, and refill equipment."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "pipelayers",
    "onet_code": "47-2151.00",
    "title": "Pipelayers",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Coordination",
      "Installation",
      "Operations Monitoring",
      "Operation and Control",
      "Troubleshooting",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Information Ordering",
      "Flexibility of Closure",
      "Visualization"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "physical",
      "technical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 26223,
      "entry_max": 34965,
      "mid_min": 34965,
      "mid_max": 45454
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2152.00",
      "47-3015.00",
      "47-2061.00"
    ],
    "training_paths": [],
    "description": "Lay pipe for storm or sanitation sewers, drains, and water mains. Perform any combination of the following tasks: grade trenches or culverts, position pipe, or seal joints.",
    "dailyActivities": [
      "Grade or level trench bases, using tamping machines or hand tools.",
      "Dig trenches to desired or required depths, by hand or using trenching tools.",
      "Cut pipes to required lengths.",
      "Install or use instruments such as lasers, grade rods, or transit levels.",
      "Cover pipes with earth or other materials.",
      "Connect pipe pieces and seal joints, using welding equipment, cement, or glue."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "plasterers_and_stucco_masons",
    "onet_code": "47-2161.00",
    "title": "Plasterers and Stucco Masons",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Oral Expression",
      "Visualization",
      "Arm-Hand Steadiness",
      "Manual Dexterity",
      "Finger Dexterity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "construction",
      "communication"
    ],
    "salary": {
      "entry_min": 26223,
      "entry_max": 34965,
      "mid_min": 34965,
      "mid_max": 45454
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-3014.00",
      "47-2081.00",
      "47-3011.00"
    ],
    "training_paths": [],
    "description": "Apply interior or exterior plaster, cement, stucco, or similar materials. May also set ornamental plaster.",
    "dailyActivities": [
      "Cover surfaces such as windows, doors, or sidewalks to protect from splashing.",
      "Clean job sites.",
      "Mix mortar and plaster to desired consistency or direct workers who perform mixing.",
      "Apply coats of plaster or stucco to walls, ceilings, or partitions of buildings, using trowels, brushes, or spray guns.",
      "Set up scaffolds.",
      "Determine materials needed to complete the job and place orders accordingly."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "plumbers_pipefitters_and_steamfitters",
    "onet_code": "47-2152.00",
    "title": "Plumbers, Pipefitters, and Steamfitters",
    "category": "Construction",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Critical Thinking",
      "Coordination",
      "Installation",
      "Operations Monitoring",
      "Troubleshooting",
      "Repairing",
      "Judgment and Decision Making"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Inductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "analytical",
      "physical",
      "technical",
      "problem_solving",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37462,
      "entry_max": 49950,
      "mid_min": 49950,
      "mid_max": 64935
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-3015.00",
      "47-2011.00",
      "47-2151.00"
    ],
    "training_paths": [],
    "description": "Assemble, install, alter, and repair pipelines or pipe systems that carry water, steam, air, or other liquids or gases. May install heating and cooling equipment and mechanical control systems. Includes sprinkler fitters.",
    "dailyActivities": [
      "Shut off steam, water, or other gases or liquids from pipe sections, using valve keys or wrenches.",
      "Install underground storm, sanitary, or water piping systems, extending piping as needed to connect fixtures and plumbing.",
      "Assemble pipe sections, tubing, or fittings, using couplings, clamps, screws, bolts, cement, plastic solvent, caulking, or soldering, brazing, or welding equipment.",
      "Locate and mark the position of pipe installations, connections, passage holes, or fixtures in structures, using measuring instruments such as rulers or levels.",
      "Cut, thread, or hammer pipes to specifications, using tools such as saws, cutting torches, pipe threaders, or pipe benders.",
      "Lay out full scale drawings of pipe systems, supports, or related equipment, according to blueprints."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "rail_track_laying_and_maintenance_equipment_operators",
    "onet_code": "47-4061.00",
    "title": "Rail-Track Laying and Maintenance Equipment Operators",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Critical Thinking",
      "Coordination",
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance",
      "Troubleshooting",
      "Repairing",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Flexibility of Closure"
    ],
    "keywords": [
      "detail_oriented",
      "hands_on",
      "analytical",
      "physical",
      "technical",
      "problem_solving",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2071.00",
      "47-2073.00",
      "49-9044.00"
    ],
    "training_paths": [],
    "description": "Lay, repair, and maintain track for standard or narrow-gauge railroad equipment used in regular railroad service or in plant yards, quarries, sand and gravel pits, and mines. Includes ballast cleaning machine operators and railroad bed tamping machine operators.",
    "dailyActivities": [
      "Patrol assigned track sections so that damaged or broken track can be located and reported.",
      "Repair or adjust track switches, using wrenches and replacement parts.",
      "Weld sections of track together, such as switch points and frogs.",
      "Observe leveling indicator arms to verify levelness and alignment of tracks.",
      "Operate single- or multiple-head spike driving machines to drive spikes into ties and secure rails.",
      "Operate track wrenches to tighten or loosen bolts at joints that hold ends of rails together."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "reinforcing_iron_and_rebar_workers",
    "onet_code": "47-2171.00",
    "title": "Reinforcing Iron and Rebar Workers",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Coordination"
    ],
    "niceToHave": [
      "Visualization",
      "Arm-Hand Steadiness",
      "Manual Dexterity",
      "Finger Dexterity",
      "Control Precision"
    ],
    "keywords": [
      "hands_on",
      "analytical",
      "physical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2221.00",
      "51-2041.00",
      "47-2081.00"
    ],
    "training_paths": [],
    "description": "Position and secure steel bars or mesh in concrete forms in order to reinforce concrete. Use a variety of fasteners, rod-bending machines, blowtorches, and hand tools. Includes rod busters.",
    "dailyActivities": [
      "Determine quantities, sizes, shapes, and locations of reinforcing rods from blueprints, sketches, or oral instructions.",
      "Space and fasten together rods in forms according to blueprints, using wire and pliers.",
      "Position and secure steel bars, rods, cables, or mesh in concrete forms, using fasteners, rod-bending machines, blowtorches, or hand tools.",
      "Cut rods to required lengths, using metal shears, hacksaws, bar cutters, or acetylene torches.",
      "Place blocks under rebar to hold the bars off the deck when reinforcing floors.",
      "Cut and fit wire mesh or fabric, using hooked rods, and position fabric or mesh in concrete to reinforce concrete."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "rock_splitters_quarry",
    "onet_code": "47-5051.00",
    "title": "Rock Splitters, Quarry",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Arm-Hand Steadiness",
      "Manual Dexterity",
      "Finger Dexterity",
      "Control Precision"
    ],
    "keywords": [
      "hands_on",
      "physical",
      "construction",
      "communication"
    ],
    "salary": {
      "entry_min": 26223,
      "entry_max": 34965,
      "mid_min": 34965,
      "mid_max": 45454
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9195.03",
      "47-5012.00",
      "51-4071.00"
    ],
    "training_paths": [],
    "description": "Separate blocks of rough dimension stone from quarry mass using jackhammers, wedges, or chop saws.",
    "dailyActivities": [
      "Locate grain line patterns to determine how rocks will split when cut.",
      "Remove pieces of stone from larger masses, using jackhammers, wedges, and other tools.",
      "Insert wedges and feathers into holes, and drive wedges with sledgehammers to split stone sections from masses.",
      "Mark dimensions or outlines on stone prior to cutting, using rules and chalk lines.",
      "Cut slabs of stone into sheets that will be used for floors or counters.",
      "Set charges of explosives to split rock."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "roof_bolters_mining",
    "onet_code": "47-5043.00",
    "title": "Roof Bolters, Mining",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Critical Thinking",
      "Monitoring",
      "Coordination",
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance",
      "Troubleshooting",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Information Ordering"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "physical",
      "technical",
      "problem_solving",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-5041.00",
      "47-5023.00",
      "47-2221.00"
    ],
    "training_paths": [],
    "description": "Operate machinery to install roof support bolts in underground mine.",
    "dailyActivities": [
      "Drill bolt holes into roofs at specified distances from ribs or adjacent bolts.",
      "Pull down loose rock that cannot be supported.",
      "Position bolting machines, and insert drill bits into chucks.",
      "Perform safety checks on equipment before operating.",
      "Perform tests to determine if methane gas is present.",
      "Force bolts into holes, using hydraulic mechanisms of self-propelled bolting machines."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "roofers",
    "onet_code": "47-2181.00",
    "title": "Roofers",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Deductive Reasoning",
      "Information Ordering",
      "Visualization"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-3016.00",
      "47-2081.00",
      "47-2131.00"
    ],
    "training_paths": [],
    "description": "Cover roofs of structures with shingles, slate, asphalt, aluminum, wood, or related materials. May spray roofs, sidings, and walls with material to bind, seal, insulate, or soundproof sections of structures.",
    "dailyActivities": [
      "Inspect problem roofs to determine the best repair procedures.",
      "Remove snow, water, or debris from roofs prior to applying roofing materials.",
      "Set up scaffolding to provide safe access to roofs.",
      "Estimate materials and labor required to complete roofing jobs.",
      "Cement or nail flashing strips of metal or shingle over joints to make them watertight.",
      "Install partially overlapping layers of material over roof insulation surfaces, using chalk lines, gauges on shingling hatchets, or lines on shingles."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "rotary_drill_operators_oil_and_gas",
    "onet_code": "47-5012.00",
    "title": "Rotary Drill Operators, Oil and Gas",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Writing",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring",
      "Coordination",
      "Instructing"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "technical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-5023.00",
      "47-5081.00",
      "47-5013.00"
    ],
    "training_paths": [],
    "description": "Set up or operate a variety of drills to remove underground oil and gas, or remove core samples for testing during oil and gas exploration.",
    "dailyActivities": [
      "Train crews, and introduce procedures to make drill work more safe and effective.",
      "Observe pressure gauge and move throttles and levers to control the speed of rotary tables, and to regulate pressure of tools at bottoms of boreholes.",
      "Count sections of drill rod to determine depths of boreholes.",
      "Push levers and brake pedals to control gasoline, diesel, electric, or steam draw works that lower and raise drill pipes and casings in and out of wells.",
      "Connect sections of drill pipe, using hand tools and powered wrenches and tongs.",
      "Maintain records of footage drilled, location and nature of strata penetrated, materials and tools used, services rendered, and time required."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "roustabouts_oil_and_gas",
    "onet_code": "47-5071.00",
    "title": "Roustabouts, Oil and Gas",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Perceptual Speed",
      "Visualization",
      "Selective Attention",
      "Arm-Hand Steadiness"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 26223,
      "entry_max": 34965,
      "mid_min": 34965,
      "mid_max": 45454
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-5012.00",
      "47-5013.00",
      "53-7041.00"
    ],
    "training_paths": [],
    "description": "Assemble or repair oil field equipment using hand and power tools. Perform other tasks as needed.",
    "dailyActivities": [
      "Unscrew or tighten pipes, casing, tubing, and pump rods, using hand and power wrenches and tongs.",
      "Dismantle and repair oil field machinery, boilers, and steam engine parts, using hand tools and power tools.",
      "Guide cranes to move loads about decks.",
      "Walk flow lines to locate leaks, using electronic detectors and by making visual inspections, and repair the leaks.",
      "Lay gas and oil pipelines.",
      "Bolt together pump and engine parts."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "segmental_pavers",
    "onet_code": "47-4091.00",
    "title": "Segmental Pavers",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Critical Thinking",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Deductive Reasoning",
      "Information Ordering",
      "Visualization"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2051.00",
      "47-2071.00",
      "47-2053.00"
    ],
    "training_paths": [],
    "description": "Lay out, cut, and place segmental paving units. Includes installers of bedding and restraining materials for the paving units.",
    "dailyActivities": [
      "Prepare base for installation by removing unstable or unsuitable materials, compacting and grading the soil, draining or stabilizing weak or saturated soils and taking measures to prevent water penetration and migration of bedding sand.",
      "Supply and place base materials, edge restraints, bedding sand and jointing sand.",
      "Discuss the design with the client.",
      "Set pavers, aligning and spacing them correctly.",
      "Sweep sand into the joints and compact pavement until the joints are full.",
      "Screed sand level to an even thickness, and recheck sand exposed to elements, raking and rescreeding if necessary."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "septic_tank_servicers_and_sewer_pipe_cleaners",
    "onet_code": "47-4071.00",
    "title": "Septic Tank Servicers and Sewer Pipe Cleaners",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Critical Thinking",
      "Complex Problem Solving",
      "Operations Monitoring",
      "Operation and Control",
      "Troubleshooting",
      "Repairing"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Inductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "physical",
      "technical",
      "problem_solving",
      "construction",
      "communication"
    ],
    "salary": {
      "entry_min": 26223,
      "entry_max": 34965,
      "mid_min": 34965,
      "mid_max": 45454
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2152.00",
      "47-2151.00",
      "51-8031.00"
    ],
    "training_paths": [],
    "description": "Clean and repair septic tanks, sewer lines, or drains. May patch walls and partitions of tank, replace damaged drain tile, or repair breaks in underground piping.",
    "dailyActivities": [
      "Communicate with supervisors and other workers, using equipment such as wireless phones, pagers, or radio telephones.",
      "Drive trucks to transport crews, materials, and equipment.",
      "Inspect manholes to locate sewer line stoppages.",
      "Operate sewer cleaning equipment, including power rodders, high-velocity water jets, sewer flushers, bucket machines, wayne balls, and vac-alls.",
      "Prepare and keep records of actions taken, including maintenance and repair work.",
      "Clean and repair septic tanks, sewer lines, or related structures such as manholes, culverts, and catch basins."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "service_unit_operators_oil_and_gas",
    "onet_code": "47-5013.00",
    "title": "Service Unit Operators, Oil and Gas",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Inductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "technical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-5012.00",
      "47-5071.00",
      "53-7073.00"
    ],
    "training_paths": [],
    "description": "Operate equipment to increase oil flow from producing wells or to remove stuck pipe, casing, tools, or other obstructions from drilling wells. Includes fishing-tool technicians.",
    "dailyActivities": [
      "Maintain and perform safety inspections on equipment and tools.",
      "Operate controls that raise derricks or level rigs.",
      "Listen to engines, rotary chains, or other equipment to detect faulty operations or unusual well conditions.",
      "Prepare reports of services rendered, tools used, or time required, for billing purposes.",
      "Install pressure-control devices onto wellheads.",
      "Confer with others to gather information regarding pipe or tool sizes or borehole conditions in wells."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "sheet_metal_workers",
    "onet_code": "47-2211.00",
    "title": "Sheet Metal Workers",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Mathematics",
      "Critical Thinking",
      "Coordination",
      "Quality Control Analysis",
      "Time Management"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-2041.00",
      "51-2011.00",
      "47-2221.00"
    ],
    "training_paths": [],
    "description": "Fabricate, assemble, install, and repair sheet metal products and equipment, such as ducts, control boxes, drainpipes, and furnace casings. Work may involve any of the following: setting up and operating fabricating machines to cut, bend, and straighten sheet metal; shaping metal over anvils, blocks, or forms using hammer; operating soldering and welding equipment to join sheet metal parts; or inspecting, assembling, and smoothing seams and joints of burred surfaces. Includes sheet metal duct installers who install prefabricated sheet metal ducts used for heating, air conditioning, or other purposes.",
    "dailyActivities": [
      "Maintain equipment, making repairs or modifications when necessary.",
      "Fabricate ducts for high efficiency heating, ventilating, and air conditioning (HVAC) systems to maximize efficiency of systems.",
      "Fasten seams or joints together with welds, bolts, cement, rivets, solder, caulks, metal drive clips, or bonds to assemble components into products or to repair sheet metal items.",
      "Transport prefabricated parts to construction sites for assembly and installation.",
      "Install assemblies, such as flashing, pipes, tubes, heating and air conditioning ducts, furnace casings, rain gutters, or downspouts in supportive frameworks.",
      "Hire, train, or supervise new employees or apprentices."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "solar_energy_installation_managers",
    "onet_code": "47-1011.03",
    "title": "Solar Energy Installation Managers",
    "category": "Construction",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37462,
      "entry_max": 49950,
      "mid_min": 49950,
      "mid_max": 64935
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2231.00",
      "47-1011.00",
      "41-4011.07"
    ],
    "training_paths": [],
    "description": "Direct work crews installing residential or commercial solar photovoltaic or thermal systems.",
    "dailyActivities": [
      "Plan and coordinate installations of photovoltaic (PV) solar and solar thermal systems to ensure conformance to codes.",
      "Supervise solar installers, technicians, and subcontractors for solar installation projects to ensure compliance with safety standards.",
      "Estimate materials, equipment, and personnel needed for residential or commercial solar installation projects.",
      "Prepare solar installation project proposals, quotes, budgets, or schedules.",
      "Provide technical assistance to installers, technicians, or other solar professionals in areas such as solar electric systems, solar thermal systems, electrical systems, or mechanical systems.",
      "Coordinate or schedule building inspections for solar installation projects."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "solar_photovoltaic_installers",
    "onet_code": "47-2231.00",
    "title": "Solar Photovoltaic Installers",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Coordination",
      "Complex Problem Solving"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "technical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2152.04",
      "47-1011.03",
      "49-9081.00"
    ],
    "training_paths": [],
    "description": "Assemble, install, or maintain solar photovoltaic (PV) systems on roofs or other structures in compliance with site assessment and schematics. May include measuring, cutting, assembling, and bolting structural framing and solar modules. May perform minor electrical work such as current checks.",
    "dailyActivities": [
      "Install photovoltaic (PV) systems in accordance with codes and standards, using drawings, schematics, and instructions.",
      "Check electrical installation for proper wiring, polarity, grounding, or integrity of terminations.",
      "Identify electrical, environmental, and safety hazards associated with photovoltaic (PV) installations.",
      "Identify installation locations with proper orientation, area, solar access, or structural integrity for photovoltaic (PV) arrays.",
      "Assemble solar modules, panels, or support structures, as specified.",
      "Apply weather sealing to array, building, or support mechanisms."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "solar_thermal_installers_and_technicians",
    "onet_code": "47-2152.04",
    "title": "Solar Thermal Installers and Technicians",
    "category": "Construction",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Instructing"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "physical",
      "technical",
      "problem_solving",
      "construction",
      "communication"
    ],
    "salary": {
      "entry_min": 37462,
      "entry_max": 49950,
      "mid_min": 49950,
      "mid_max": 64935
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2231.00",
      "17-2199.11",
      "49-9021.00"
    ],
    "training_paths": [],
    "description": "Install or repair solar energy systems designed to collect, store, and circulate solar-heated water for residential, commercial or industrial use.",
    "dailyActivities": [
      "Test operation or functionality of mechanical, plumbing, electrical, and control systems.",
      "Apply weather seal, such as pipe flashings and sealants, to roof penetrations and structural devices.",
      "Install solar collector mounting devices on tile, asphalt, shingle, or built-up gravel roofs, using appropriate materials and penetration methods.",
      "Install copper or plastic plumbing using pipes, fittings, pipe cutters, acetylene torches, solder, wire brushes, sand cloths, flux, plastic pipe cleaners, or plastic glue.",
      "Identify plumbing, electrical, environmental, or safety hazards associated with solar thermal installations.",
      "Demonstrate start-up, shut-down, maintenance, diagnostic, and safety procedures to thermal system owners."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "stonemasons",
    "onet_code": "47-2022.00",
    "title": "Stonemasons",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Mathematics",
      "Critical Thinking",
      "Monitoring",
      "Coordination",
      "Time Management"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Information Ordering"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2021.00",
      "47-2044.00",
      "51-9195.03"
    ],
    "training_paths": [],
    "description": "Build stone structures, such as piers, walls, and abutments. Lay walks, curbstones, or special types of masonry for vats, tanks, and floors.",
    "dailyActivities": [
      "Set vertical and horizontal alignment of structures, using plumb bob, gauge line, and level.",
      "Lay out wall patterns or foundations, using straight edge, rule, or staked lines.",
      "Set stone or marble in place, according to layout or pattern.",
      "Remove wedges, fill joints between stones, finish joints between stones, using a trowel, and smooth the mortar to an attractive finish, using a tuck pointer.",
      "Clean excess mortar or grout from surface of marble, stone, or monument, using sponge, brush, water, or acid.",
      "Shape, trim, face and cut marble or stone preparatory to setting, using power saws, cutting equipment, and hand tools."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "structural_iron_and_steel_workers",
    "onet_code": "47-2221.00",
    "title": "Structural Iron and Steel Workers",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring",
      "Coordination",
      "Operations Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2171.00",
      "51-2041.00",
      "47-2211.00"
    ],
    "training_paths": [],
    "description": "Raise, place, and unite iron or steel girders, columns, and other structural members to form completed structures or structural frameworks. May erect metal storage tanks and assemble prefabricated metal buildings.",
    "dailyActivities": [
      "Read specifications or blueprints to determine the locations, quantities, or sizes of materials required.",
      "Connect columns, beams, and girders with bolts, following blueprints and instructions from supervisors.",
      "Bolt aligned structural steel members in position for permanent riveting, bolting, or welding into place.",
      "Fasten structural steel members to hoist cables, using chains, cables, or rope.",
      "Hoist steel beams, girders, or columns into place, using cranes or signaling hoisting equipment operators to lift and position structural steel members.",
      "Verify vertical and horizontal alignment of structural steel members, using plumb bobs, laser equipment, transits, or levels."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "tapers",
    "onet_code": "47-2082.00",
    "title": "Tapers",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Arm-Hand Steadiness",
      "Manual Dexterity",
      "Trunk Strength",
      "Extent Flexibility",
      "Near Vision"
    ],
    "keywords": [
      "physical",
      "construction",
      "communication"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2081.00",
      "47-2131.00",
      "47-2051.00"
    ],
    "training_paths": [],
    "description": "Seal joints between plasterboard or other wallboard to prepare wall surface for painting or papering.",
    "dailyActivities": [
      "Spread sealing compound between boards or panels or over cracks, holes, nail heads, or screw heads, using trowels, broadknives, or spatulas.",
      "Press paper tape over joints to embed tape into sealing compound and to seal joints.",
      "Apply additional coats to fill in holes and make surfaces smooth.",
      "Seal joints between plasterboard or other wallboard to prepare wall surfaces for painting or papering.",
      "Spread and smooth cementing material over tape, using trowels or floating machines to blend joints with wall surfaces.",
      "Sand or patch nicks or cracks in plasterboard or wallboard."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "terrazzo_workers_and_finishers",
    "onet_code": "47-2053.00",
    "title": "Terrazzo Workers and Finishers",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Coordination"
    ],
    "niceToHave": [
      "Visualization",
      "Arm-Hand Steadiness",
      "Manual Dexterity",
      "Finger Dexterity",
      "Control Precision"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "physical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2044.00",
      "47-3011.00",
      "47-2042.00"
    ],
    "training_paths": [],
    "description": "Apply a mixture of cement, sand, pigment, or marble chips to floors, stairways, and cabinet fixtures to fashion durable and decorative surfaces.",
    "dailyActivities": [
      "Measure designated amounts of ingredients for terrazzo or grout, according to standard formulas and specifications, using graduated containers and scales, and load ingredients into portable mixer.",
      "Grind surfaces with a power grinder, or polish surfaces with polishing or surfacing machines.",
      "Cut metal division strips and press them into the terrazzo base for joints or changes of color to form designs or patterns or to help prevent cracks.",
      "Blend marble chip mixtures, place into panels, and push a roller over the surface to embed the chips.",
      "Modify mixing, grouting, grinding, or cleaning procedures, according to type of installation or material used.",
      "Spread, level, or smooth concrete or terrazzo mixtures to form bases or finished surfaces, using rakes, shovels, hand or power trowels, hand or power screeds, or floats."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "tile_and_stone_setters",
    "onet_code": "47-2044.00",
    "title": "Tile and Stone Setters",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Mathematics",
      "Critical Thinking",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Deductive Reasoning",
      "Inductive Reasoning",
      "Information Ordering"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2042.00",
      "47-2053.00",
      "47-2022.00"
    ],
    "training_paths": [],
    "description": "Apply hard tile, stone, and comparable materials to walls, floors, ceilings, countertops, and roof decks.",
    "dailyActivities": [
      "Align and straighten tile using levels, squares, and straightedges.",
      "Finish and dress the joints and wipe excess grout from between tiles, using damp sponge.",
      "Cut and shape tile to fit around obstacles and into odd spaces and corners, using hand and power cutting tools.",
      "Determine and implement the best layout to achieve a desired pattern.",
      "Mix, apply, and spread plaster, concrete, mortar, cement, mastic, glue or other adhesives to form a bed for the tiles, using brush, trowel and screed.",
      "Study blueprints and examine surface to be covered to determine amount of material needed."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "underground_mining_machine_operators_all_other",
    "onet_code": "47-5049.00",
    "title": "Underground Mining Machine Operators, All Other",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "construction"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All underground mining machine operators not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "weatherization_installers_and_technicians",
    "onet_code": "47-4099.03",
    "title": "Weatherization Installers and Technicians",
    "category": "Construction",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Coordination",
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "construction",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31842,
      "entry_max": 42457,
      "mid_min": 42457,
      "mid_max": 55194
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2131.00",
      "47-2132.00",
      "47-2152.04"
    ],
    "training_paths": [],
    "description": "Perform a variety of activities to weatherize homes and make them more energy efficient. Duties include repairing windows, insulating ducts, and performing heating, ventilating, and air-conditioning (HVAC) work. May perform energy audits and advise clients on energy conservation measures.",
    "dailyActivities": [
      "Test combustible appliances, such as gas appliances.",
      "Determine amount of air leakage in buildings, using a blower door machine.",
      "Test and diagnose air flow systems, using furnace efficiency analysis equipment.",
      "Install and seal air ducts, combustion air openings, or ventilation openings to improve heating and cooling efficiency.",
      "Inspect buildings to identify required weatherization measures, including repair work, modification, or replacement.",
      "Recommend weatherization techniques to clients in accordance with needs and applicable energy regulations, codes, policies, or statutes."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "career_technical_education_teachers_postsecondary",
    "onet_code": "25-1194.00",
    "title": "Career/Technical Education Teachers, Postsecondary",
    "category": "Education",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "education",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 41512,
      "entry_max": 55350,
      "mid_min": 55350,
      "mid_max": 71955
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "25-2032.00",
      "25-2023.00",
      "25-1032.00"
    ],
    "training_paths": [],
    "description": "Teach vocational courses intended to provide occupational training below the baccalaureate level in subjects such as construction, mechanics/repair, manufacturing, transportation, or cosmetology, primarily to students who have graduated from or left high school. Teaching takes place in public or private schools whose primary business is academic or vocational education.",
    "dailyActivities": [
      "Observe and evaluate students' work to determine progress, provide feedback, and make suggestions for improvement.",
      "Present lectures and conduct discussions to increase students' knowledge and competence using visual aids, such as graphs, charts, videotapes, and slides.",
      "Supervise and monitor students' use of tools and equipment.",
      "Administer oral, written, or performance tests to measure progress and to evaluate training effectiveness.",
      "Provide individualized instruction and tutorial or remedial instruction.",
      "Prepare reports and maintain records, such as student grades, attendance rolls, and training activity details."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "educational_instruction_and_library_workers_all_other",
    "onet_code": "25-9099.00",
    "title": "Educational Instruction and Library Workers, All Other",
    "category": "Education",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "education"
    ],
    "salary": {
      "entry_min": 35285,
      "entry_max": 47047,
      "mid_min": 47047,
      "mid_max": 61161
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All educational instruction and library workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "library_technicians",
    "onet_code": "25-4031.00",
    "title": "Library Technicians",
    "category": "Education",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Coordination",
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "education",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 41512,
      "entry_max": 55350,
      "mid_min": 55350,
      "mid_max": 71955
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-4121.00",
      "43-4071.00",
      "43-9061.00"
    ],
    "training_paths": [],
    "description": "Assist librarians by helping readers in the use of library catalogs, databases, and indexes to locate books and other materials; and by answering questions that require only brief consultation of standard reference. Compile records; sort and shelve books or other media; remove or repair damaged books or other media; register patrons; and check materials in and out of the circulation process. Replace materials in shelving area (stacks) or files. Includes bookmobile drivers who assist with providing services in mobile libraries.",
    "dailyActivities": [
      "Reserve, circulate, renew, and discharge books and other materials.",
      "Answer routine telephone or in-person reference inquiries, referring patrons to librarians for further assistance, when necessary.",
      "Help patrons find and use library resources, such as reference materials, audio-visual equipment, computers, and other electronic resources and provide technical assistance when needed.",
      "Deliver and retrieve items throughout the library by hand or using pushcart.",
      "Process print and non-print library materials to prepare them for inclusion in library collections.",
      "Catalogue and sort books and other print and non-print materials according to procedure and return them to shelves, files, or other designated storage areas."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "postsecondary_teachers_all_other",
    "onet_code": "25-1199.00",
    "title": "Postsecondary Teachers, All Other",
    "category": "Education",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "education"
    ],
    "salary": {
      "entry_min": 35285,
      "entry_max": 47047,
      "mid_min": 47047,
      "mid_max": 61161
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All postsecondary teachers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "preschool_teachers_except_special_education",
    "onet_code": "25-2011.00",
    "title": "Preschool Teachers, Except Special Education",
    "category": "Education",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "education",
      "hands_on",
      "physical",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 41512,
      "entry_max": 55350,
      "mid_min": 55350,
      "mid_max": 71955
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "25-2012.00",
      "25-2055.00",
      "25-2021.00"
    ],
    "training_paths": [],
    "description": "Instruct preschool-aged students, following curricula or lesson plans, in activities designed to promote social, physical, and intellectual growth.",
    "dailyActivities": [
      "Teach basic skills, such as color, shape, number and letter recognition, personal hygiene, and social skills.",
      "Establish and enforce rules for behavior and procedures for maintaining order.",
      "Adapt teaching methods and instructional materials to meet students' varying needs and interests.",
      "Provide a variety of materials and resources for children to explore, manipulate, and use, both in learning activities and in imaginative play.",
      "Serve meals and snacks in accordance with nutritional guidelines.",
      "Attend to children's basic needs by feeding them, dressing them, and changing their diapers."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "self_enrichment_teachers",
    "onet_code": "25-3021.00",
    "title": "Self-Enrichment Teachers",
    "category": "Education",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "education",
      "hands_on",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 41512,
      "entry_max": 55350,
      "mid_min": 55350,
      "mid_max": 71955
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "25-2031.00",
      "25-2021.00",
      "25-3041.00"
    ],
    "training_paths": [],
    "description": "Teach or instruct individuals or groups for the primary purpose of self-enrichment or recreation, rather than for an occupational objective, educational attainment, competition, or fitness.",
    "dailyActivities": [
      "Instruct students individually and in groups, using various teaching methods, such as lectures, discussions, and demonstrations.",
      "Adapt teaching methods and instructional materials to meet students' varying needs and interests.",
      "Prepare students for further development by encouraging them to explore learning opportunities and to persevere with challenging tasks.",
      "Observe students to determine qualifications, limitations, abilities, interests, and other individual characteristics.",
      "Maintain accurate and complete student records as required by administrative policy.",
      "Monitor students' performance to make suggestions for improvement and to ensure that they satisfy course standards, training requirements, and objectives."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "social_sciences_teachers_postsecondary_all_other",
    "onet_code": "25-1069.00",
    "title": "Social Sciences Teachers, Postsecondary, All Other",
    "category": "Education",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "education"
    ],
    "salary": {
      "entry_min": 35285,
      "entry_max": 47047,
      "mid_min": 47047,
      "mid_max": 61161
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All postsecondary social sciences teachers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "special_education_teachers_all_other",
    "onet_code": "25-2059.00",
    "title": "Special Education Teachers, All Other",
    "category": "Education",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "education"
    ],
    "salary": {
      "entry_min": 35285,
      "entry_max": 47047,
      "mid_min": 47047,
      "mid_max": 61161
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All special education teachers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "teachers_and_instructors_all_other",
    "onet_code": "25-3099.00",
    "title": "Teachers and Instructors, All Other",
    "category": "Education",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "education"
    ],
    "salary": {
      "entry_min": 35285,
      "entry_max": 47047,
      "mid_min": 47047,
      "mid_max": 61161
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All teachers and instructors not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "teaching_assistants_all_other",
    "onet_code": "25-9049.00",
    "title": "Teaching Assistants, All Other",
    "category": "Education",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "education"
    ],
    "salary": {
      "entry_min": 35285,
      "entry_max": 47047,
      "mid_min": 47047,
      "mid_max": 61161
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All teaching assistants not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "teaching_assistants_preschool_elementary_middle_and_secondary_school_except_special_education",
    "onet_code": "25-9042.00",
    "title": "Teaching Assistants, Preschool, Elementary, Middle, and Secondary School, Except Special Education",
    "category": "Education",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Learning Strategies",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "education",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 41512,
      "entry_max": 55350,
      "mid_min": 55350,
      "mid_max": 71955
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "25-9043.00",
      "25-3041.00",
      "25-2058.00"
    ],
    "training_paths": [],
    "description": "Assist a preschool, elementary, middle, or secondary school teacher with instructional duties. Serve in a position for which a teacher has primary responsibility for the design and implementation of educational programs and services.",
    "dailyActivities": [
      "Supervise students in classrooms, halls, cafeterias, school yards, and gymnasiums, or on field trips.",
      "Tutor and assist children individually or in small groups to help them master assignments and to reinforce learning concepts presented by teachers.",
      "Enforce administration policies and rules governing students.",
      "Teach social skills to students.",
      "Instruct and monitor students in the use and care of equipment and materials to prevent injuries and damage.",
      "Discuss assigned duties with classroom teachers to coordinate instructional efforts."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "teaching_assistants_special_education",
    "onet_code": "25-9043.00",
    "title": "Teaching Assistants, Special Education",
    "category": "Education",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Learning Strategies",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "education",
      "analytical",
      "hands_on",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 41512,
      "entry_max": 55350,
      "mid_min": 55350,
      "mid_max": 71955
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "25-2055.00",
      "25-2058.00",
      "25-2056.00"
    ],
    "training_paths": [],
    "description": "Assist a preschool, elementary, middle, or secondary school teacher to provide academic, social, or life skills to students who have learning, emotional, or physical disabilities. Serve in a position for which a teacher has primary responsibility for the design and implementation of educational programs and services.",
    "dailyActivities": [
      "Provide assistance to students with special needs.",
      "Teach socially acceptable behavior, employing techniques such as behavior modification or positive reinforcement.",
      "Supervise students in classrooms, halls, cafeterias, school yards, and gymnasiums, or on field trips.",
      "Provide students with disabilities with assistive devices, supportive technology, and assistance accessing facilities, such as restrooms.",
      "Carry out therapeutic regimens, such as behavior modification and personal development programs, under the supervision of special education instructors, psychologists, or speech-language pathologists.",
      "Tutor and assist children individually or in small groups to help them master assignments and to reinforce learning concepts presented by teachers."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "tutors",
    "onet_code": "25-3041.00",
    "title": "Tutors",
    "category": "Education",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "education",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 41512,
      "entry_max": 55350,
      "mid_min": 55350,
      "mid_max": 71955
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "25-2031.00",
      "25-3011.00",
      "25-2021.00"
    ],
    "training_paths": [],
    "description": "Instruct individual students or small groups of students in academic subjects to support formal class instruction or to prepare students for standardized or admissions tests.",
    "dailyActivities": [
      "Provide feedback to students, using positive reinforcement techniques to encourage, motivate, or build confidence in students.",
      "Review class material with students by discussing text, working solutions to problems, or reviewing worksheets or other assignments.",
      "Assess students' progress throughout tutoring sessions.",
      "Teach students study skills, note-taking skills, and test-taking strategies.",
      "Provide private instruction to individual or small groups of students to improve academic performance, improve occupational skills, or prepare for academic or occupational tests.",
      "Participate in training and development sessions to improve tutoring practices or learn new tutoring techniques."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "aerospace_engineering_and_operations_technologists_and_technicians",
    "onet_code": "17-3021.00",
    "title": "Aerospace Engineering and Operations Technologists and Technicians",
    "category": "Engineering",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Science",
      "Critical Thinking",
      "Active Learning"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "engineering",
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 62482,
      "entry_max": 83310,
      "mid_min": 83310,
      "mid_max": 108303
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "17-3028.00",
      "49-2091.00",
      "17-3024.00"
    ],
    "training_paths": [],
    "description": "Operate, install, adjust, and maintain integrated computer/communications systems, consoles, simulators, and other data acquisition, test, and measurement instruments and equipment, which are used to launch, track, position, and evaluate air and space vehicles. May record and interpret test data.",
    "dailyActivities": [
      "Test aircraft systems under simulated operational conditions, performing systems readiness tests and pre- and post-operational checkouts, to establish design or fabrication parameters.",
      "Identify required data, data acquisition plans, and test parameters, setting up equipment to conform to these specifications.",
      "Inspect, diagnose, maintain, and operate test setups and equipment to detect malfunctions.",
      "Confer with engineering personnel regarding details and implications of test procedures and results.",
      "Operate and calibrate computer systems and devices to comply with test requirements and to perform data acquisition and analysis.",
      "Record and interpret test data on parts, assemblies, and mechanisms."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "architectural_and_civil_drafters",
    "onet_code": "17-3011.00",
    "title": "Architectural and Civil Drafters",
    "category": "Engineering",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "engineering",
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 62482,
      "entry_max": 83310,
      "mid_min": 83310,
      "mid_max": 108303
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "17-3013.00",
      "17-3012.00",
      "17-3022.00"
    ],
    "training_paths": [],
    "description": "Prepare detailed drawings of architectural and structural features of buildings or drawings and topographical relief maps used in civil engineering projects, such as highways, bridges, and public works. Use knowledge of building materials, engineering practices, and mathematics to complete drawings.",
    "dailyActivities": [
      "Produce drawings, using computer-assisted drafting systems (CAD) or drafting machines, or by hand, using compasses, dividers, protractors, triangles, and other drafting devices.",
      "Draft plans and detailed drawings for structures, installations, and construction projects, such as highways, sewage disposal systems, and dikes, working from sketches or notes.",
      "Coordinate structural, electrical, and mechanical designs and determine a method of presentation to graphically represent building plans.",
      "Analyze building codes, by-laws, space and site requirements, and other technical documents and reports to determine their effect on architectural designs.",
      "Draw maps, diagrams, and profiles, using cross-sections and surveys, to represent elevations, topographical contours, subsurface formations, and structures.",
      "Lay out and plan interior room arrangements for commercial buildings, using computer-assisted drafting (CAD) equipment and software."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "automotive_engineering_technicians",
    "onet_code": "17-3027.01",
    "title": "Automotive Engineering Technicians",
    "category": "Engineering",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Science",
      "Critical Thinking",
      "Active Learning"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "engineering",
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 62482,
      "entry_max": 83310,
      "mid_min": 83310,
      "mid_max": 108303
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "17-3028.00",
      "17-3021.00",
      "17-3027.00"
    ],
    "training_paths": [],
    "description": "Assist engineers in determining the practicality of proposed product design changes and plan and carry out tests on experimental test devices or equipment for performance, durability, or efficiency.",
    "dailyActivities": [
      "Document test results, using cameras, spreadsheets, documents, or other tools.",
      "Set up mechanical, hydraulic, or electric test equipment in accordance with engineering specifications, standards, or test procedures.",
      "Read and interpret blueprints, schematics, work specifications, drawings, or charts.",
      "Inspect or test parts to determine nature or cause of defects or malfunctions.",
      "Monitor computer-controlled test equipment, according to written or verbal instructions.",
      "Analyze test data for automotive systems, subsystems, or component parts."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "calibration_technologists_and_technicians",
    "onet_code": "17-3028.00",
    "title": "Calibration Technologists and Technicians",
    "category": "Engineering",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "engineering"
    ],
    "salary": {
      "entry_min": 62482,
      "entry_max": 83310,
      "mid_min": 83310,
      "mid_max": 108303
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "17-3021.00",
      "17-3023.00",
      "17-3027.00"
    ],
    "training_paths": [],
    "description": "Execute or adapt procedures and techniques for calibrating measurement devices, by applying knowledge of measurement science, mathematics, physics, chemistry, and electronics, sometimes under the direction of engineering staff. Determine measurement standard suitability for calibrating measurement devices. May perform preventive maintenance on equipment. May perform corrective actions to address identified calibration problems.",
    "dailyActivities": [
      "Analyze test data to identify defects or determine calibration requirements.",
      "Attend conferences, workshops, or other training sessions to learn about new tools or methods.",
      "Calibrate devices by comparing measurements of pressure, temperature, humidity, or other environmental conditions to known standards.",
      "Conduct calibration tests to determine performance or reliability of mechanical, structural, or electromechanical equipment.",
      "Develop new calibration methods or techniques based on measurement science, analyses, or calibration requirements.",
      "Disassemble and reassemble equipment for inspection."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "civil_engineering_technologists_and_technicians",
    "onet_code": "17-3022.00",
    "title": "Civil Engineering Technologists and Technicians",
    "category": "Engineering",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "engineering",
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 62482,
      "entry_max": 83310,
      "mid_min": 83310,
      "mid_max": 108303
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "17-3011.00",
      "17-3027.00",
      "11-9021.00"
    ],
    "training_paths": [],
    "description": "Apply theory and principles of civil engineering in planning, designing, and overseeing construction and maintenance of structures and facilities under the direction of engineering staff or physical scientists.",
    "dailyActivities": [
      "Calculate dimensions, square footage, profile and component specifications, and material quantities, using calculator or computer.",
      "Read and review project blueprints and structural specifications to determine dimensions of structure or system and material requirements.",
      "Draft detailed dimensional drawings and design layouts for projects to ensure conformance to specifications.",
      "Confer with supervisor to determine project details such as plan preparation, acceptance testing, and evaluation of field conditions.",
      "Analyze proposed site factors and design maps, graphs, tracings, and diagrams to illustrate findings.",
      "Prepare reports and document project activities and data."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "drafters_all_other",
    "onet_code": "17-3019.00",
    "title": "Drafters, All Other",
    "category": "Engineering",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "engineering"
    ],
    "salary": {
      "entry_min": 53109,
      "entry_max": 70813,
      "mid_min": 70813,
      "mid_max": 92056
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All drafters not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "electrical_and_electronic_engineering_technologists_and_technicians",
    "onet_code": "17-3023.00",
    "title": "Electrical and Electronic Engineering Technologists and Technicians",
    "category": "Engineering",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Complex Problem Solving"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "engineering",
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "physical",
      "technical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 62482,
      "entry_max": 83310,
      "mid_min": 83310,
      "mid_max": 108303
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "17-3028.00",
      "17-2072.00",
      "17-3027.00"
    ],
    "training_paths": [],
    "description": "Apply electrical and electronic theory and related knowledge, usually under the direction of engineering staff, to design, build, repair, adjust, and modify electrical components, circuitry, controls, and machinery for subsequent evaluation and use by engineering staff in making engineering design decisions.",
    "dailyActivities": [
      "Modify, maintain, or repair electronics equipment or systems to ensure proper functioning.",
      "Replace defective components or parts, using hand tools and precision instruments.",
      "Set up and operate specialized or standard test equipment to diagnose, test, or analyze the performance of electronic components, assemblies, or systems.",
      "Read blueprints, wiring diagrams, schematic drawings, or engineering instructions for assembling electronics units, applying knowledge of electronic theory and components.",
      "Identify and resolve equipment malfunctions, working with manufacturers or field representatives as necessary to procure replacement parts.",
      "Assemble electrical systems or prototypes, using hand tools or measuring instruments."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "military_mos_relevant": [
      "ET"
    ],
    "last_updated": new Date()
  },
  {
    "id": "electrical_and_electronics_drafters",
    "onet_code": "17-3012.00",
    "title": "Electrical and Electronics Drafters",
    "category": "Engineering",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "engineering",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 62482,
      "entry_max": 83310,
      "mid_min": 83310,
      "mid_max": 108303
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "17-3013.00",
      "17-3011.00",
      "17-3023.00"
    ],
    "training_paths": [],
    "description": "Prepare wiring diagrams, circuit board assembly diagrams, and layout drawings used for the manufacture, installation, or repair of electrical equipment.",
    "dailyActivities": [
      "Draft detail and assembly drawings of design components, circuitry or printed circuit boards, using computer-assisted equipment or standard drafting techniques and devices.",
      "Draft working drawings, wiring diagrams, wiring connection specifications, or cross-sections of underground cables, as required for instructions to installation crew.",
      "Assemble documentation packages and produce drawing sets to be checked by an engineer or an architect.",
      "Review completed construction drawings and cost estimates for accuracy and conformity to standards and regulations.",
      "Consult with engineers to discuss or interpret design concepts, or determine requirements of detailed working drawings.",
      "Confer with engineering staff and other personnel to resolve problems."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "electro_mechanical_and_mechatronics_technologists_and_technicians",
    "onet_code": "17-3024.00",
    "title": "Electro-Mechanical and Mechatronics Technologists and Technicians",
    "category": "Engineering",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Science",
      "Critical Thinking",
      "Active Learning"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "engineering",
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 62482,
      "entry_max": 83310,
      "mid_min": 83310,
      "mid_max": 108303
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "17-3021.00",
      "49-2091.00",
      "17-3024.01"
    ],
    "training_paths": [],
    "description": "Operate, test, maintain, or adjust unmanned, automated, servomechanical, or electromechanical equipment. May operate unmanned submarines, aircraft, or other equipment to observe or record visual information at sites such as oil rigs, crop fields, buildings, or for similar infrastructure, deep ocean exploration, or hazardous waste removal. May assist engineers in testing and designing robotics equipment.",
    "dailyActivities": [
      "Test performance of electromechanical assemblies, using test instruments such as oscilloscopes, electronic voltmeters, or bridges.",
      "Install or program computer hardware or machine or instrumentation software in microprocessor-based systems.",
      "Read blueprints, schematics, diagrams, or technical orders to determine methods and sequences of assembly.",
      "Modify, maintain, or repair electrical, electronic, or mechanical components, equipment, or systems to ensure proper functioning.",
      "Inspect parts for surface defects.",
      "Install electrical or electronic parts and hardware in housings or assemblies, using soldering equipment and hand tools."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "engineering_technologists_and_technicians_except_drafters_all_other",
    "onet_code": "17-3029.00",
    "title": "Engineering Technologists and Technicians, Except Drafters, All Other",
    "category": "Engineering",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "engineering"
    ],
    "salary": {
      "entry_min": 53109,
      "entry_max": 70813,
      "mid_min": 70813,
      "mid_max": 92056
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All engineering technologists and technicians, except drafters, not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "engineers_all_other",
    "onet_code": "17-2199.00",
    "title": "Engineers, All Other",
    "category": "Engineering",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "engineering"
    ],
    "salary": {
      "entry_min": 53109,
      "entry_max": 70813,
      "mid_min": 70813,
      "mid_max": 92056
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All engineers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "industrial_engineering_technologists_and_technicians",
    "onet_code": "17-3026.00",
    "title": "Industrial Engineering Technologists and Technicians",
    "category": "Engineering",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Science",
      "Critical Thinking",
      "Active Learning"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "engineering",
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 62482,
      "entry_max": 83310,
      "mid_min": 83310,
      "mid_max": 108303
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "17-2112.00",
      "17-2112.03",
      "17-3027.00"
    ],
    "training_paths": [],
    "description": "Apply engineering theory and principles to problems of industrial layout or manufacturing production, usually under the direction of engineering staff. May perform time and motion studies on worker operations in a variety of industries for purposes such as establishing standard production rates or improving efficiency.",
    "dailyActivities": [
      "Test selected products at specified stages in the production process for performance characteristics or adherence to specifications.",
      "Compile and evaluate statistical data to determine and maintain quality and reliability of products.",
      "Study time, motion, methods, or speed involved in maintenance, production, or other operations to establish standard production rate or improve efficiency.",
      "Read worker logs, product processing sheets, or specification sheets to verify that records adhere to quality assurance specifications.",
      "Verify that equipment is being operated and maintained according to quality assurance standards by observing worker performance.",
      "Aid in planning work assignments in accordance with worker performance, machine capacity, production schedules, or anticipated delays."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "mechanical_drafters",
    "onet_code": "17-3013.00",
    "title": "Mechanical Drafters",
    "category": "Engineering",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "engineering",
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 62482,
      "entry_max": 83310,
      "mid_min": 83310,
      "mid_max": 108303
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "17-3012.00",
      "17-3011.00",
      "17-3027.00"
    ],
    "training_paths": [],
    "description": "Prepare detailed working diagrams of machinery and mechanical devices, including dimensions, fastening methods, and other engineering information.",
    "dailyActivities": [
      "Develop detailed design drawings and specifications for mechanical equipment, dies, tools, and controls, using computer-assisted drafting (CAD) equipment.",
      "Produce three-dimensional models, using computer-aided design (CAD) software.",
      "Lay out and draw schematic, orthographic, or angle views to depict functional relationships of components, assemblies, systems, and machines.",
      "Modify and revise designs to correct operating deficiencies or to reduce production problems.",
      "Review and analyze specifications, sketches, drawings, ideas, and related data to assess factors affecting component designs and the procedures and instructions to be followed.",
      "Check dimensions of materials to be used and assign numbers to the materials."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "mechanical_engineering_technologists_and_technicians",
    "onet_code": "17-3027.00",
    "title": "Mechanical Engineering Technologists and Technicians",
    "category": "Engineering",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Science",
      "Critical Thinking",
      "Active Learning"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "engineering",
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 62482,
      "entry_max": 83310,
      "mid_min": 83310,
      "mid_max": 108303
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "17-3028.00",
      "17-3023.00",
      "17-3021.00"
    ],
    "training_paths": [],
    "description": "Apply theory and principles of mechanical engineering to modify, develop, test, or adjust machinery and equipment under direction of engineering staff or physical scientists.",
    "dailyActivities": [
      "Assemble or disassemble complex mechanical systems.",
      "Interpret engineering sketches, specifications, or drawings.",
      "Calculate required capacities for equipment of proposed system to obtain specified performance and submit data to engineering personnel for approval.",
      "Review project instructions and blueprints to ascertain test specifications, procedures, and objectives, and test nature of technical problems such as redesign.",
      "Provide technical support to other employees regarding mechanical design, fabrication, testing, or documentation.",
      "Test machines, components, materials, or products to determine characteristics such as performance, strength, or response to stress."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "non_destructive_testing_specialists",
    "onet_code": "17-3029.01",
    "title": "Non-Destructive Testing Specialists",
    "category": "Engineering",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Science",
      "Critical Thinking",
      "Active Learning"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "engineering",
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 53109,
      "entry_max": 70813,
      "mid_min": 70813,
      "mid_max": 92056
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "17-3021.00",
      "17-3028.00",
      "17-3027.00"
    ],
    "training_paths": [],
    "description": "Test the safety of structures, vehicles, or vessels using x-ray, ultrasound, fiber optic or related equipment.",
    "dailyActivities": [
      "Interpret the results of all methods of non-destructive testing (NDT), such as acoustic emission, electromagnetic, leak, liquid penetrant, magnetic particle, neutron radiographic, radiographic, thermal or infrared, ultrasonic, vibration analysis, and visual testing.",
      "Interpret or evaluate test results in accordance with applicable codes, standards, specifications, or procedures.",
      "Identify defects in solid materials, using ultrasonic testing techniques.",
      "Make radiographic images to detect flaws in objects while leaving objects intact.",
      "Prepare reports on non-destructive testing results.",
      "Select, calibrate, or operate equipment used in the non-destructive testing of products or materials."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "photonics_technicians",
    "onet_code": "17-3029.08",
    "title": "Photonics Technicians",
    "category": "Engineering",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "engineering",
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 62482,
      "entry_max": 83310,
      "mid_min": 83310,
      "mid_max": 108303
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "17-2199.07",
      "17-3023.00",
      "17-3028.00"
    ],
    "training_paths": [],
    "description": "Build, install, test, or maintain optical or fiber optic equipment, such as lasers, lenses, or mirrors, using spectrometers, interferometers, or related equipment.",
    "dailyActivities": [
      "Compute or record photonic test data.",
      "Maintain clean working environments, according to clean room standards.",
      "Adjust or maintain equipment, such as lasers, laser systems, microscopes, oscilloscopes, pulse generators, power meters, beam analyzers, or energy measurement devices.",
      "Document procedures, such as calibration of optical or fiber optic equipment.",
      "Set up or operate assembly or processing equipment, such as lasers, cameras, die bonders, wire bonders, dispensers, reflow ovens, soldering irons, die shears, wire pull testers, temperature or humidity chambers, or optical spectrum analyzers.",
      "Assist scientists or engineers in the conduct of photonic experiments."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "robotics_technicians",
    "onet_code": "17-3024.01",
    "title": "Robotics Technicians",
    "category": "Engineering",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Science",
      "Critical Thinking",
      "Active Learning"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "engineering",
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 62482,
      "entry_max": 83310,
      "mid_min": 83310,
      "mid_max": 108303
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "17-3023.00",
      "17-3028.00",
      "17-3024.00"
    ],
    "training_paths": [],
    "description": "Build, install, test, or maintain robotic equipment or related automated production systems.",
    "dailyActivities": [
      "Make repairs to robots or peripheral equipment, such as replacement of defective circuit boards, sensors, controllers, encoders, or servomotors.",
      "Troubleshoot robotic systems, using knowledge of microprocessors, programmable controllers, electronics, circuit analysis, mechanics, sensor or feedback systems, hydraulics, or pneumatics.",
      "Install, program, or repair programmable controllers, robot controllers, end-of-arm tools, or conveyors.",
      "Maintain service records of robotic equipment or automated production systems.",
      "Modify computer-controlled robot movements.",
      "Perform preventive or corrective maintenance on robotic systems or components."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "surveying_and_mapping_technicians",
    "onet_code": "17-3031.00",
    "title": "Surveying and Mapping Technicians",
    "category": "Engineering",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "engineering",
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 62482,
      "entry_max": 83310,
      "mid_min": 83310,
      "mid_max": 108303
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "17-1021.00",
      "17-1022.01",
      "15-1299.02"
    ],
    "training_paths": [],
    "description": "Perform surveying and mapping duties, usually under the direction of an engineer, surveyor, cartographer, or photogrammetrist, to obtain data used for construction, mapmaking, boundary location, mining, or other purposes. May calculate mapmaking information and create maps from source data, such as surveying notes, aerial photography, satellite data, or other maps to show topographical features, political boundaries, and other features. May verify accuracy and completeness of maps.",
    "dailyActivities": [
      "Position and hold the vertical rods, or targets, that theodolite operators use for sighting to measure angles, distances, and elevations.",
      "Check all layers of maps to ensure accuracy, identifying and marking errors and making corrections.",
      "Design or develop information databases that include geographic or topographic data.",
      "Monitor mapping work or the updating of maps to ensure accuracy, inclusion of new or changed information, or compliance with rules and regulations.",
      "Produce or update overlay maps to show information boundaries, water locations, or topographic features on various base maps or at different scales.",
      "Determine scales, line sizes, or colors to be used for hard copies of computerized maps, using plotters."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "baristas",
    "onet_code": "35-3023.01",
    "title": "Baristas",
    "category": "Food Service",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Finger Dexterity",
      "Trunk Strength"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "food_service",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 16091,
      "entry_max": 21455,
      "mid_min": 21455,
      "mid_max": 27891
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "35-3023.00",
      "35-9011.00",
      "35-2021.00"
    ],
    "training_paths": [],
    "description": "Prepare or serve specialty coffee or other beverages. Serve food such as baked goods or sandwiches to patrons.",
    "dailyActivities": [
      "Receive and process customer payments.",
      "Prepare or serve hot or cold beverages, such as coffee, espresso drinks, blended coffees, or teas.",
      "Take customer orders and convey them to other employees for preparation.",
      "Clean or sanitize work areas, utensils, or equipment.",
      "Describe menu items to customers, or suggest products that might appeal to them.",
      "Clean service or seating areas."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "bartenders",
    "onet_code": "35-3011.00",
    "title": "Bartenders",
    "category": "Food Service",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "food_service",
      "hands_on",
      "physical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 19539,
      "entry_max": 26052,
      "mid_min": 26052,
      "mid_max": 33867
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "35-3031.00",
      "35-9011.00",
      "35-3023.00"
    ],
    "training_paths": [],
    "description": "Mix and serve drinks to patrons, directly or through waitstaff.",
    "dailyActivities": [
      "Clean glasses, utensils, and bar equipment.",
      "Collect money for drinks served.",
      "Balance cash receipts.",
      "Check identification of customers to verify age requirements for purchase of alcohol.",
      "Clean bars, work areas, and tables.",
      "Attempt to limit problems and liability related to customers' excessive drinking by taking steps such as persuading customers to stop drinking, or ordering taxis or other transportation for intoxicated patrons."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "chefs_and_head_cooks",
    "onet_code": "35-1011.00",
    "title": "Chefs and Head Cooks",
    "category": "Food Service",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "food_service",
      "analytical",
      "physical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 22987,
      "entry_max": 30650,
      "mid_min": 30650,
      "mid_max": 39845
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-3011.00",
      "35-2014.00",
      "35-2013.00"
    ],
    "training_paths": [],
    "description": "Direct and may participate in the preparation, seasoning, and cooking of salads, soups, fish, meats, vegetables, desserts, or other foods. May plan and price menu items, order supplies, and keep records and accounts.",
    "dailyActivities": [
      "Monitor sanitation practices to ensure that employees follow standards and regulations.",
      "Instruct cooks or other workers in the preparation, cooking, garnishing, or presentation of food.",
      "Supervise or coordinate activities of cooks or workers engaged in food preparation.",
      "Order or requisition food or other supplies needed to ensure efficient operation.",
      "Inspect supplies, equipment, or work areas to ensure conformance to established standards.",
      "Check the quantity and quality of received products."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "cooks_all_other",
    "onet_code": "35-2019.00",
    "title": "Cooks, All Other",
    "category": "Food Service",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "food_service"
    ],
    "salary": {
      "entry_min": 19539,
      "entry_max": 26052,
      "mid_min": 26052,
      "mid_max": 33867
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All cooks not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "cooks_fast_food",
    "onet_code": "35-2011.00",
    "title": "Cooks, Fast Food",
    "category": "Food Service",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Oral Comprehension",
      "Near Vision"
    ],
    "keywords": [
      "food_service",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 16091,
      "entry_max": 21455,
      "mid_min": 21455,
      "mid_max": 27891
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "35-2015.00",
      "35-2014.00",
      "35-2021.00"
    ],
    "training_paths": [],
    "description": "Prepare and cook food in a fast food restaurant with a limited menu. Duties of these cooks are limited to preparation of a few basic items and normally involve operating large-volume single-purpose cooking equipment.",
    "dailyActivities": [
      "Order and take delivery of supplies.",
      "Cook the exact number of items ordered by each customer, working on several different orders simultaneously.",
      "Prepare specialty foods, such as pizzas, fish and chips, sandwiches, or tacos, following specific methods that usually require short preparation time.",
      "Operate large-volume cooking equipment, such as grills, deep-fat fryers, or griddles.",
      "Wash, cut, and prepare foods designated for cooking.",
      "Prepare and serve beverages, such as coffee or fountain drinks."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "cooks_institution_and_cafeteria",
    "onet_code": "35-2012.00",
    "title": "Cooks, Institution and Cafeteria",
    "category": "Food Service",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Monitoring",
      "Coordination",
      "Service Orientation",
      "Time Management",
      "Management of Personnel Resources"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "food_service",
      "analytical",
      "physical",
      "hands_on",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 19539,
      "entry_max": 26052,
      "mid_min": 26052,
      "mid_max": 33867
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "35-2014.00",
      "35-2021.00",
      "35-2013.00"
    ],
    "training_paths": [],
    "description": "Prepare and cook large quantities of food for institutions, such as schools, hospitals, or cafeterias.",
    "dailyActivities": [
      "Monitor and record food temperatures to ensure food safety.",
      "Cook foodstuffs according to menus, special dietary or nutritional restrictions, or numbers of portions to be served.",
      "Rotate and store food supplies.",
      "Wash pots, pans, dishes, utensils, or other cooking equipment.",
      "Apportion and serve food to facility residents, employees, or patrons.",
      "Clean and inspect galley equipment, kitchen appliances, and work areas to ensure cleanliness and functional operation."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "cooks_private_household",
    "onet_code": "35-2013.00",
    "title": "Cooks, Private Household",
    "category": "Food Service",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness",
      "Coordination",
      "Service Orientation",
      "Judgment and Decision Making"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Fluency of Ideas",
      "Originality"
    ],
    "keywords": [
      "customer_service",
      "food_service",
      "hands_on",
      "physical",
      "analytical",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 22987,
      "entry_max": 30650,
      "mid_min": 30650,
      "mid_max": 39845
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "35-2014.00",
      "35-1011.00",
      "35-2012.00"
    ],
    "training_paths": [],
    "description": "Prepare meals in private homes. Includes personal chefs.",
    "dailyActivities": [
      "Peel, wash, trim, and cook vegetables and meats, and bake breads and pastries.",
      "Cool, package, label, and freeze foods for later consumption and provide instructions for reheating.",
      "Plan menus according to employers' needs and diet restrictions.",
      "Shop for or order food and kitchen supplies and equipment.",
      "Prepare meals in private homes according to employers' recipes or tastes, handling all meals for the family and possibly for other household staff.",
      "Keep records pertaining to menus, finances, and other business-related issues."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "cooks_restaurant",
    "onet_code": "35-2014.00",
    "title": "Cooks, Restaurant",
    "category": "Food Service",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Critical Thinking",
      "Monitoring",
      "Time Management"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Information Ordering",
      "Perceptual Speed"
    ],
    "keywords": [
      "food_service",
      "physical",
      "problem_solving"
    ],
    "salary": {
      "entry_min": 19539,
      "entry_max": 26052,
      "mid_min": 26052,
      "mid_max": 33867
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "35-2015.00",
      "35-2012.00",
      "35-2021.00"
    ],
    "training_paths": [],
    "description": "Prepare, season, and cook dishes such as soups, meats, vegetables, or desserts in restaurants. May order supplies, keep records and accounts, price items on menu, or plan menu.",
    "dailyActivities": [
      "Ensure food is stored and cooked at correct temperature by regulating temperature of ovens, broilers, grills, and roasters.",
      "Inspect and clean food preparation areas, such as equipment, work surfaces, and serving areas, to ensure safe and sanitary food-handling practices.",
      "Portion, arrange, and garnish food, and serve food to waiters or patrons.",
      "Ensure freshness of food and ingredients by checking for quality, keeping track of old and new items, and rotating stock.",
      "Season and cook food according to recipes or personal judgment and experience.",
      "Coordinate and supervise work of kitchen staff."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "cooks_short_order",
    "onet_code": "35-2015.00",
    "title": "Cooks, Short Order",
    "category": "Food Service",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Coordination",
      "Time Management"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Information Ordering",
      "Manual Dexterity",
      "Trunk Strength",
      "Near Vision"
    ],
    "keywords": [
      "leadership",
      "food_service"
    ],
    "salary": {
      "entry_min": 19539,
      "entry_max": 26052,
      "mid_min": 26052,
      "mid_max": 33867
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "35-2014.00",
      "35-2011.00",
      "35-2021.00"
    ],
    "training_paths": [],
    "description": "Prepare and cook to order a variety of foods that require only a short preparation time. May take orders from customers and serve patrons at counters or tables.",
    "dailyActivities": [
      "Clean food preparation equipment, work areas, and counters or tables.",
      "Restock kitchen supplies, rotate food, and stamp the time and date on food in coolers.",
      "Complete orders from steam tables, placing food on plates and serving customers at tables or counters.",
      "Plan work on orders so that items served together are finished at the same time.",
      "Grill, cook, and fry foods such as french fries, eggs, and pancakes.",
      "Perform food preparation tasks, such as making sandwiches, carving meats, making soups or salads, baking breads or desserts, and brewing coffee or tea."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "dining_room_and_cafeteria_attendants_and_bartender_helpers",
    "onet_code": "35-9011.00",
    "title": "Dining Room and Cafeteria Attendants and Bartender Helpers",
    "category": "Food Service",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Manual Dexterity",
      "Static Strength",
      "Trunk Strength",
      "Extent Flexibility",
      "Near Vision"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "food_service",
      "physical",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 16091,
      "entry_max": 21455,
      "mid_min": 21455,
      "mid_max": 27891
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "35-3041.00",
      "35-3023.00",
      "35-3031.00"
    ],
    "training_paths": [],
    "description": "Facilitate food service. Clean tables; remove dirty dishes; replace soiled table linens; set tables; replenish supply of clean linens, silverware, glassware, and dishes; supply service bar with food; and serve items such as water, condiments, and coffee to patrons.",
    "dailyActivities": [
      "Run cash registers.",
      "Serve ice water, coffee, rolls, or butter to patrons.",
      "Scrape and stack dirty dishes and carry dishes and other tableware to kitchens for cleaning.",
      "Wipe tables or seats with dampened cloths or replace dirty tablecloths.",
      "Set tables with clean linens, condiments, or other supplies.",
      "Greet and seat customers."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "dishwashers",
    "onet_code": "35-9021.00",
    "title": "Dishwashers",
    "category": "Food Service",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Arm-Hand Steadiness",
      "Manual Dexterity",
      "Trunk Strength",
      "Extent Flexibility"
    ],
    "keywords": [
      "food_service",
      "physical"
    ],
    "salary": {
      "entry_min": 16091,
      "entry_max": 21455,
      "mid_min": 21455,
      "mid_max": 27891
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-7061.00",
      "51-6011.00",
      "35-2021.00"
    ],
    "training_paths": [],
    "description": "Clean dishes, kitchen, food preparation equipment, or utensils.",
    "dailyActivities": [
      "Wash dishes, glassware, flatware, pots, or pans, using dishwashers or by hand.",
      "Maintain kitchen work areas, equipment, or utensils in clean and orderly condition.",
      "Place clean dishes, utensils, or cooking equipment in storage areas.",
      "Sweep or scrub floors.",
      "Stock supplies, such as food or utensils, in serving stations, cupboards, refrigerators, or salad bars.",
      "Clean or prepare various foods for cooking or serving."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "fast_food_and_counter_workers",
    "onet_code": "35-3023.00",
    "title": "Fast Food and Counter Workers",
    "category": "Food Service",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Speech Recognition",
      "Speech Clarity"
    ],
    "keywords": [
      "customer_service",
      "food_service",
      "hands_on",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 16091,
      "entry_max": 21455,
      "mid_min": 21455,
      "mid_max": 27891
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "35-9011.00",
      "35-2021.00",
      "35-3041.00"
    ],
    "training_paths": [],
    "description": "Perform duties such as taking orders and serving food and beverages. Serve customers at counter or from a steam table. May take payment. May prepare food and beverages.",
    "dailyActivities": [
      "Accept payment from customers, and make change as necessary.",
      "Serve customers in eating places that specialize in fast service and inexpensive carry-out food.",
      "Request and record customer orders, and compute bills, using cash registers, multi-counting machines, or pencil and paper.",
      "Balance receipts and payments in cash registers.",
      "Communicate with customers regarding orders, comments, and complaints.",
      "Serve food, beverages, or desserts to customers in such settings as take-out counters of restaurants or lunchrooms, business or industrial establishments, hotel rooms, and cars."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "first_line_supervisors_of_food_preparation_and_serving_workers",
    "onet_code": "35-1012.00",
    "title": "First-Line Supervisors of Food Preparation and Serving Workers",
    "category": "Food Service",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "food_service",
      "analytical",
      "physical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 19539,
      "entry_max": 26052,
      "mid_min": 26052,
      "mid_max": 33867
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "39-1014.00",
      "37-1011.00",
      "45-1011.00"
    ],
    "training_paths": [],
    "description": "Directly supervise and coordinate activities of workers engaged in preparing and serving food.",
    "dailyActivities": [
      "Resolve customer complaints regarding food service.",
      "Train workers in food preparation, and in service, sanitation, and safety procedures.",
      "Assign duties, responsibilities, and work stations to employees in accordance with work requirements.",
      "Present bills and accept payments.",
      "Perform various financial activities, such as cash handling, deposit preparation, and payroll.",
      "Supervise and participate in kitchen and dining area cleaning activities."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "food_preparation_workers",
    "onet_code": "35-2021.00",
    "title": "Food Preparation Workers",
    "category": "Food Service",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Oral Comprehension",
      "Trunk Strength",
      "Near Vision"
    ],
    "keywords": [
      "food_service",
      "physical",
      "hands_on"
    ],
    "salary": {
      "entry_min": 19539,
      "entry_max": 26052,
      "mid_min": 26052,
      "mid_max": 33867
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "35-2014.00",
      "35-2015.00",
      "35-3023.00"
    ],
    "training_paths": [],
    "description": "Perform a variety of food preparation duties other than cooking, such as preparing cold foods and shellfish, slicing meat, and brewing coffee or tea.",
    "dailyActivities": [
      "Clean and sanitize work areas, equipment, utensils, dishes, or silverware.",
      "Assist cooks and kitchen staff with various tasks as needed, and provide cooks with needed items.",
      "Take and record temperature of food and food storage areas, such as refrigerators and freezers.",
      "Carry food supplies, equipment, and utensils to and from storage and work areas.",
      "Remove trash and clean kitchen garbage containers.",
      "Store food in designated containers and storage areas to prevent spoilage."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "food_preparation_and_serving_related_workers_all_other",
    "onet_code": "35-9099.00",
    "title": "Food Preparation and Serving Related Workers, All Other",
    "category": "Food Service",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "food_service"
    ],
    "salary": {
      "entry_min": 19539,
      "entry_max": 26052,
      "mid_min": 26052,
      "mid_max": 33867
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All food preparation and serving related workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "food_servers_nonrestaurant",
    "onet_code": "35-3041.00",
    "title": "Food Servers, Nonrestaurant",
    "category": "Food Service",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Near Vision",
      "Speech Recognition",
      "Speech Clarity"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "food_service",
      "physical",
      "analytical",
      "communication"
    ],
    "salary": {
      "entry_min": 19539,
      "entry_max": 26052,
      "mid_min": 26052,
      "mid_max": 33867
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "35-9011.00",
      "35-3023.00",
      "35-3031.00"
    ],
    "training_paths": [],
    "description": "Serve food to individuals outside of a restaurant environment, such as in hotel rooms, hospital rooms, residential care facilities, or cars.",
    "dailyActivities": [
      "Place food servings on plates or trays according to orders or instructions.",
      "Clean or sterilize dishes, kitchen utensils, equipment, or facilities.",
      "Monitor food distribution, ensuring that meals are delivered to the correct recipients and that guidelines, such as those for special diets, are followed.",
      "Examine trays to ensure that they contain required items.",
      "Load trays with accessories, such as eating utensils, napkins, or condiments.",
      "Take food orders and relay orders to kitchens or serving counters so they can be filled."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "hosts_and_hostesses_restaurant_lounge_and_coffee_shop",
    "onet_code": "35-9031.00",
    "title": "Hosts and Hostesses, Restaurant, Lounge, and Coffee Shop",
    "category": "Food Service",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Trunk Strength",
      "Near Vision",
      "Speech Recognition"
    ],
    "keywords": [
      "customer_service",
      "food_service",
      "hands_on",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 16091,
      "entry_max": 21455,
      "mid_min": 21455,
      "mid_max": 27891
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "35-3031.00",
      "35-9011.00",
      "35-3041.00"
    ],
    "training_paths": [],
    "description": "Welcome patrons, seat them at tables or in lounge, and help ensure quality of facilities and service.",
    "dailyActivities": [
      "Provide guests with menus.",
      "Greet guests and seat them at tables or in waiting areas.",
      "Maintain contact with kitchen staff, management, serving staff, and customers to ensure that dining details are handled properly and customers' concerns are addressed.",
      "Assign patrons to tables suitable for their needs and according to rotation so that servers receive an appropriate number of seatings.",
      "Speak with patrons to ensure satisfaction with food and service, to respond to complaints, or to make conversation.",
      "Inspect dining and serving areas to ensure cleanliness and proper setup."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "waiters_and_waitresses",
    "onet_code": "35-3031.00",
    "title": "Waiters and Waitresses",
    "category": "Food Service",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Trunk Strength",
      "Near Vision"
    ],
    "keywords": [
      "customer_service",
      "food_service",
      "hands_on",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 19539,
      "entry_max": 26052,
      "mid_min": 26052,
      "mid_max": 33867
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "35-9011.00",
      "35-3041.00",
      "35-3011.00"
    ],
    "training_paths": [],
    "description": "Take orders and serve food and beverages to patrons at tables in dining establishment.",
    "dailyActivities": [
      "Collect payments from customers.",
      "Check patrons' identification to ensure that they meet minimum age requirements for consumption of alcoholic beverages.",
      "Write patrons' food orders on order slips, memorize orders, or enter orders into computers for transmittal to kitchen staff.",
      "Check with customers to ensure that they are enjoying their meals, and take action to correct any problems.",
      "Take orders from patrons for food or beverages.",
      "Prepare checks that itemize and total meal costs and sales taxes."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "air_crew_members",
    "onet_code": "55-3011.00",
    "title": "Air Crew Members",
    "category": "General",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "general"
    ],
    "salary": {
      "entry_min": 28687,
      "entry_max": 38250,
      "mid_min": 38250,
      "mid_max": 49725
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "Perform in-flight duties to ensure the successful completion of combat, reconnaissance, transport, and search and rescue missions. Duties include operating aircraft communications and detection equipment, including establishing satellite linkages and jamming enemy communications capabilities; conducting preflight, in-flight, and postflight inspections of onboard equipment; operating and maintaining aircraft weapons and defensive systems; operating and maintaining aircraft in-flight refueling systems; executing aircraft safety and emergency procedures; computing and verifying passenger, cargo, fuel, and emergency and special equipment weight and balance data; and conducting cargo and personnel drops.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "air_crew_officers",
    "onet_code": "55-1011.00",
    "title": "Air Crew Officers",
    "category": "General",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "general"
    ],
    "salary": {
      "entry_min": 28687,
      "entry_max": 38250,
      "mid_min": 38250,
      "mid_max": 49725
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "Perform and direct in-flight duties to ensure the successful completion of combat, reconnaissance, transport, and search and rescue missions. Duties include operating aircraft communications and radar equipment, such as establishing satellite linkages and jamming enemy communications capabilities; operating aircraft weapons and defensive systems; conducting preflight, in-flight, and postflight inspections of onboard equipment; and directing cargo and personnel drops.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "aircraft_launch_and_recovery_officers",
    "onet_code": "55-1012.00",
    "title": "Aircraft Launch and Recovery Officers",
    "category": "General",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "general"
    ],
    "salary": {
      "entry_min": 28687,
      "entry_max": 38250,
      "mid_min": 38250,
      "mid_max": 49725
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "Plan and direct the operation and maintenance of catapults, arresting gear, and associated mechanical, hydraulic, and control systems involved primarily in aircraft carrier takeoff and landing operations. Duties include supervision of readiness and safety of arresting gear, launching equipment, barricades, and visual landing aid systems; planning and coordinating the design, development, and testing of launch and recovery systems; preparing specifications for catapult and arresting gear installations; evaluating design proposals; determining handling equipment needed for new aircraft; preparing technical data and instructions for operation of landing aids; and training personnel in carrier takeoff and landing procedures.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "aircraft_launch_and_recovery_specialists",
    "onet_code": "55-3012.00",
    "title": "Aircraft Launch and Recovery Specialists",
    "category": "General",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "general"
    ],
    "salary": {
      "entry_min": 28687,
      "entry_max": 38250,
      "mid_min": 38250,
      "mid_max": 49725
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "Operate and maintain catapults, arresting gear, and associated mechanical, hydraulic, and control systems involved primarily in aircraft carrier takeoff and landing operations. Duties include installing and maintaining visual landing aids; testing and maintaining launch and recovery equipment using electric and mechanical test equipment and hand tools; activating airfield arresting systems, such as crash barriers and cables, during emergency landing situations; directing aircraft launch and recovery operations using hand or light signals; and maintaining logs of airplane launches, recoveries, and equipment maintenance.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "armored_assault_vehicle_crew_members",
    "onet_code": "55-3013.00",
    "title": "Armored Assault Vehicle Crew Members",
    "category": "General",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "general"
    ],
    "salary": {
      "entry_min": 28687,
      "entry_max": 38250,
      "mid_min": 38250,
      "mid_max": 49725
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "Operate tanks, light armor, and amphibious assault vehicles during combat situations on land or in aquatic environments. Duties include driving armored vehicles that require specialized training; operating and maintaining targeting and firing systems; operating and maintaining advanced onboard communications and navigation equipment; transporting personnel and equipment in a combat environment; and operating and maintaining auxiliary weapons, including machine guns and grenade launchers.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "armored_assault_vehicle_officers",
    "onet_code": "55-1013.00",
    "title": "Armored Assault Vehicle Officers",
    "category": "General",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "general"
    ],
    "salary": {
      "entry_min": 28687,
      "entry_max": 38250,
      "mid_min": 38250,
      "mid_max": 49725
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "Direct the operation of tanks, light armor, and amphibious assault vehicle units during combat situations on land or in aquatic environments. Duties include directing crew members in the operation of targeting and firing systems; coordinating the operation of advanced onboard communications and navigation equipment; directing the transport of personnel and equipment during combat; formulating and implementing battle plans, including the tactical employment of armored vehicle units; and coordinating with infantry, artillery, and air support units.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "artillery_and_missile_crew_members",
    "onet_code": "55-3014.00",
    "title": "Artillery and Missile Crew Members",
    "category": "General",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "general"
    ],
    "salary": {
      "entry_min": 28687,
      "entry_max": 38250,
      "mid_min": 38250,
      "mid_max": 49725
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "Target, fire, and maintain weapons used to destroy enemy positions, aircraft, and vessels. Field artillery crew members predominantly use guns, cannons, and howitzers in ground combat operations, while air defense artillery crew members predominantly use missiles and rockets. Naval artillery crew members predominantly use torpedoes and missiles launched from a ship or submarine. Duties include testing, inspecting, and storing ammunition, missiles, and torpedoes; conducting preventive and routine maintenance on weapons and related equipment; establishing and maintaining radio and wire communications; and operating weapons targeting, firing, and launch computer systems.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "artillery_and_missile_officers",
    "onet_code": "55-1014.00",
    "title": "Artillery and Missile Officers",
    "category": "General",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "general"
    ],
    "salary": {
      "entry_min": 28687,
      "entry_max": 38250,
      "mid_min": 38250,
      "mid_max": 49725
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "Manage personnel and weapons operations to destroy enemy positions, aircraft, and vessels. Duties include planning, targeting, and coordinating the tactical deployment of field artillery and air defense artillery missile systems units; directing the establishment and operation of fire control communications systems; targeting and launching intercontinental ballistic missiles; directing the storage and handling of nuclear munitions and components; overseeing security of weapons storage and launch facilities; and managing maintenance of weapons systems.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "command_and_control_center_officers",
    "onet_code": "55-1015.00",
    "title": "Command and Control Center Officers",
    "category": "General",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "general"
    ],
    "salary": {
      "entry_min": 28687,
      "entry_max": 38250,
      "mid_min": 38250,
      "mid_max": 49725
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "Manage the operation of communications, detection, and weapons systems essential for controlling air, ground, and naval operations. Duties include managing critical communication links between air, naval, and ground forces; formulating and implementing emergency plans for natural and wartime disasters; coordinating emergency response teams and agencies; evaluating command center information and need for high-level military and government reporting; managing the operation of surveillance and detection systems; providing technical information and advice on capabilities and operational readiness; and directing operation of weapons targeting, firing, and launch computer systems.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "command_and_control_center_specialists",
    "onet_code": "55-3015.00",
    "title": "Command and Control Center Specialists",
    "category": "General",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "general"
    ],
    "salary": {
      "entry_min": 28687,
      "entry_max": 38250,
      "mid_min": 38250,
      "mid_max": 49725
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "Operate and monitor communications, detection, and weapons systems essential for controlling air, ground, and naval operations. Duties include maintaining and relaying critical communications between air, naval, and ground forces; implementing emergency plans for natural and wartime disasters; relaying command center information to high-level military and government decisionmakers; monitoring surveillance and detection systems, such as air defense; interpreting and evaluating tactical situations and making recommendations to superiors; and operating weapons targeting, firing, and launch computer systems.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "first_line_supervisors_of_air_crew_members",
    "onet_code": "55-2011.00",
    "title": "First-Line Supervisors of Air Crew Members",
    "category": "General",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "general"
    ],
    "salary": {
      "entry_min": 28687,
      "entry_max": 38250,
      "mid_min": 38250,
      "mid_max": 49725
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "Supervise and coordinate the activities of air crew members. Supervisors may also perform the same activities as the workers they supervise.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "first_line_supervisors_of_all_other_tactical_operations_specialists",
    "onet_code": "55-2013.00",
    "title": "First-Line Supervisors of All Other Tactical Operations Specialists",
    "category": "General",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "general"
    ],
    "salary": {
      "entry_min": 28687,
      "entry_max": 38250,
      "mid_min": 38250,
      "mid_max": 49725
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "Supervise and coordinate the activities of all other tactical operations specialists not classified separately above. Supervisors may also perform the same activities as the workers they supervise.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "first_line_supervisors_of_weapons_specialists_crew_members",
    "onet_code": "55-2012.00",
    "title": "First-Line Supervisors of Weapons Specialists/Crew Members",
    "category": "General",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "general"
    ],
    "salary": {
      "entry_min": 28687,
      "entry_max": 38250,
      "mid_min": 38250,
      "mid_max": 49725
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "Supervise and coordinate the activities of weapons specialists/crew members. Supervisors may also perform the same activities as the workers they supervise.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "infantry",
    "onet_code": "55-3016.00",
    "title": "Infantry",
    "category": "General",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "general"
    ],
    "salary": {
      "entry_min": 28687,
      "entry_max": 38250,
      "mid_min": 38250,
      "mid_max": 49725
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "Operate weapons and equipment in ground combat operations. Duties include operating and maintaining weapons, such as rifles, machine guns, mortars, and hand grenades; locating, constructing, and camouflaging infantry positions and equipment; evaluating terrain and recording topographical information; operating and maintaining field communications equipment; assessing need for and directing supporting fire; placing explosives and performing minesweeping activities on land; and participating in basic reconnaissance operations.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "infantry_officers",
    "onet_code": "55-1016.00",
    "title": "Infantry Officers",
    "category": "General",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "general"
    ],
    "salary": {
      "entry_min": 28687,
      "entry_max": 38250,
      "mid_min": 38250,
      "mid_max": 49725
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "Direct, train, and lead infantry units in ground combat operations. Duties include directing deployment of infantry weapons, vehicles, and equipment; directing location, construction, and camouflage of infantry positions and equipment; managing field communications operations; coordinating with armor, artillery, and air support units; performing strategic and tactical planning, including battle plan development; and leading basic reconnaissance operations.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "military_enlisted_tactical_operations_and_air_weapons_specialists_and_crew_members_all_other",
    "onet_code": "55-3019.00",
    "title": "Military Enlisted Tactical Operations and Air/Weapons Specialists and Crew Members, All Other",
    "category": "General",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "general"
    ],
    "salary": {
      "entry_min": 28687,
      "entry_max": 38250,
      "mid_min": 38250,
      "mid_max": 49725
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All military enlisted tactical operations and air/weapons specialists and crewmembers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "military_officer_special_and_tactical_operations_leaders_all_other",
    "onet_code": "55-1019.00",
    "title": "Military Officer Special and Tactical Operations Leaders, All Other",
    "category": "General",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "general"
    ],
    "salary": {
      "entry_min": 28687,
      "entry_max": 38250,
      "mid_min": 38250,
      "mid_max": 49725
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All military officer special and tactical operations leaders not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "special_forces",
    "onet_code": "55-3018.00",
    "title": "Special Forces",
    "category": "General",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "general"
    ],
    "salary": {
      "entry_min": 28687,
      "entry_max": 38250,
      "mid_min": 38250,
      "mid_max": 49725
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "Implement unconventional operations by air, land, or sea during combat or peacetime as members of elite teams. These activities include offensive raids, demolitions, reconnaissance, search and rescue, and counterterrorism. In addition to their combat training, special forces members often have specialized training in swimming, diving, parachuting, survival, emergency medicine, and foreign languages. Duties include conducting advanced reconnaissance operations and collecting intelligence information; recruiting, training, and equipping friendly forces; conducting raids and invasions on enemy territories; laying and detonating explosives for demolition targets; locating, identifying, defusing, and disposing of ordnance; and operating and maintaining sophisticated communications equipment.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "special_forces_officers",
    "onet_code": "55-1017.00",
    "title": "Special Forces Officers",
    "category": "General",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "general"
    ],
    "salary": {
      "entry_min": 28687,
      "entry_max": 38250,
      "mid_min": 38250,
      "mid_max": 49725
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "Lead elite teams that implement unconventional operations by air, land, or sea during combat or peacetime. These activities include offensive raids, demolitions, reconnaissance, search and rescue, and counterterrorism. In addition to their combat training, special forces officers often have specialized training in swimming, diving, parachuting, survival, emergency medicine, and foreign languages. Duties include directing advanced reconnaissance operations and evaluating intelligence information; recruiting, training, and equipping friendly forces; leading raids and invasions on enemy territories; training personnel to implement individual missions and contingency plans; performing strategic and tactical planning for politically sensitive missions; and operating sophisticated communications equipment.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "cardiovascular_technologists_and_technicians",
    "onet_code": "29-2031.00",
    "title": "Cardiovascular Technologists and Technicians",
    "category": "Healthcare",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare",
      "leadership"
    ],
    "salary": {
      "entry_min": 56325,
      "entry_max": 75100,
      "mid_min": 75100,
      "mid_max": 97630
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-2032.00",
      "29-2099.01",
      "29-2034.00"
    ],
    "training_paths": [],
    "description": "Conduct tests on pulmonary or cardiovascular systems of patients for diagnostic, therapeutic, or research purposes. May conduct or assist in electrocardiograms, cardiac catheterizations, pulmonary functions, lung capacity, and similar tests.",
    "dailyActivities": [
      "Conduct electrocardiogram (EKG), phonocardiogram, echocardiogram, stress testing, or other cardiovascular tests to record patients' cardiac activity, using specialized electronic test equipment, recording devices, or laboratory instruments.",
      "Explain testing procedures to patients to obtain cooperation and reduce anxiety.",
      "Monitor patients' blood pressure and heart rate using electrocardiogram (EKG) equipment during diagnostic or therapeutic procedures to notify the physician if something appears wrong.",
      "Obtain and record patient identification, medical history, or test results.",
      "Monitor patients' comfort and safety during tests, alerting physicians to abnormalities or changes in patient responses.",
      "Prepare and position patients for testing."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "dental_hygienists",
    "onet_code": "29-1292.00",
    "title": "Dental Hygienists",
    "category": "Healthcare",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare",
      "leadership"
    ],
    "salary": {
      "entry_min": 56325,
      "entry_max": 75100,
      "mid_min": 75100,
      "mid_max": 97630
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "31-9091.00",
      "29-9093.00",
      "31-9092.00"
    ],
    "training_paths": [],
    "description": "Administer oral hygiene care to patients. Assess patient oral hygiene problems or needs and maintain health records. Advise patients on oral health maintenance and disease prevention. May provide advanced care such as providing fluoride treatment or administering topical anesthesia.",
    "dailyActivities": [
      "Record and review patient medical histories.",
      "Feel and visually examine gums for sores and signs of disease.",
      "Examine gums, using probes, to locate periodontal recessed gums and signs of gum disease.",
      "Clean calcareous deposits, accretions, and stains from teeth and beneath margins of gums, using dental instruments.",
      "Provide clinical services or health education to improve and maintain the oral health of patients or the general public.",
      "Chart conditions of decay and disease for diagnosis and treatment by dentist."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "dentists_all_other_specialists",
    "onet_code": "29-1029.00",
    "title": "Dentists, All Other Specialists",
    "category": "Healthcare",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "healthcare"
    ],
    "salary": {
      "entry_min": 47876,
      "entry_max": 63835,
      "mid_min": 63835,
      "mid_max": 82985
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All dentists not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "diagnostic_medical_sonographers",
    "onet_code": "29-2032.00",
    "title": "Diagnostic Medical Sonographers",
    "category": "Healthcare",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare",
      "leadership"
    ],
    "salary": {
      "entry_min": 56325,
      "entry_max": 75100,
      "mid_min": 75100,
      "mid_max": 97630
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-2031.00",
      "29-2034.00",
      "29-2099.01"
    ],
    "training_paths": [],
    "description": "Produce ultrasonic recordings of internal organs for use by physicians. Includes vascular technologists.",
    "dailyActivities": [
      "Observe screen during scan to ensure that image produced is satisfactory for diagnostic purposes, making adjustments to equipment as required.",
      "Observe and care for patients throughout examinations to ensure their safety and comfort.",
      "Provide sonogram and oral or written summary of technical findings to physician for use in medical diagnosis.",
      "Select appropriate equipment settings and adjust patient positions to obtain the best sites and angles.",
      "Operate ultrasound equipment to produce and record images of the motion, shape, and composition of blood, organs, tissues, or bodily masses, such as fluid accumulations.",
      "Decide which images to include, looking for differences between healthy and pathological areas."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "dietetic_technicians",
    "onet_code": "29-2051.00",
    "title": "Dietetic Technicians",
    "category": "Healthcare",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare",
      "leadership"
    ],
    "salary": {
      "entry_min": 56325,
      "entry_max": 75100,
      "mid_min": 75100,
      "mid_max": 97630
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-1031.00",
      "21-1091.00",
      "31-1121.00"
    ],
    "training_paths": [],
    "description": "Assist in the provision of food service and nutritional programs, under the supervision of a dietitian. May plan and produce meals based on established guidelines, teach principles of food and nutrition, or counsel individuals.",
    "dailyActivities": [
      "Observe and monitor patient food intake and body weight, and report changes, progress, and dietary problems to dietician.",
      "Conduct nutritional assessments of individuals, including obtaining and evaluating individuals' dietary histories, to plan nutritional programs.",
      "Prepare a major meal, following recipes and determining group food quantities.",
      "Supervise food production or service or assist dietitians or nutritionists in food service supervision or planning.",
      "Plan menus or diets or guide individuals or families in food selection, preparation, or menu planning, based upon nutritional needs and established guidelines.",
      "Develop job specifications, job descriptions, or work schedules."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "emergency_medical_technicians",
    "onet_code": "29-2042.00",
    "title": "Emergency Medical Technicians",
    "category": "Healthcare",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "healthcare"
    ],
    "salary": {
      "entry_min": 56325,
      "entry_max": 75100,
      "mid_min": 75100,
      "mid_max": 97630
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-2043.00",
      "53-3011.00",
      "29-9093.00"
    ],
    "training_paths": [],
    "description": "Assess injuries and illnesses and administer basic emergency medical care. May transport injured or sick persons to medical facilities.",
    "dailyActivities": [
      "Administer first aid treatment or life support care to sick or injured persons in prehospital settings.",
      "Assess nature and extent of illness or injury to establish and prioritize medical procedures.",
      "Attend training classes to maintain certification licensure, keep abreast of new developments in the field, or maintain existing knowledge.",
      "Comfort and reassure patients.",
      "Communicate with dispatchers or treatment center personnel to provide information about situation, to arrange reception of survivors, or to receive instructions for further treatment.",
      "Coordinate work with other emergency medical team members or police or fire department personnel."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "military_mos_relevant": [
      "68W",
      "HM"
    ],
    "last_updated": new Date()
  },
  {
    "id": "health_information_technologists_and_medical_registrars",
    "onet_code": "29-9021.00",
    "title": "Health Information Technologists and Medical Registrars",
    "category": "Healthcare",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "healthcare"
    ],
    "salary": {
      "entry_min": 56325,
      "entry_max": 75100,
      "mid_min": 75100,
      "mid_max": 97630
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-2072.00",
      "15-2051.02",
      "15-1211.01"
    ],
    "training_paths": [],
    "description": "Apply knowledge of healthcare and information systems to assist in the design, development, and continued modification and analysis of computerized healthcare systems. Abstract, collect, and analyze treatment and followup information of patients. May educate staff and assist in problem solving to promote the implementation of the healthcare information system. May design, develop, test, and implement databases with complete history, diagnosis, treatment, and health status to help monitor diseases.",
    "dailyActivities": [
      "Assign the patient to diagnosis-related groups (DRGs), using appropriate computer software.",
      "Compile medical care and census data for statistical reports on diseases treated, surgery performed, or use of hospital beds.",
      "Design databases to support healthcare applications, ensuring security, performance and reliability.",
      "Develop in-service educational materials.",
      "Evaluate and recommend upgrades or improvements to existing computerized healthcare systems.",
      "Facilitate and promote activities, such as lunches, seminars, or tours, to foster healthcare information privacy or security awareness within the organization."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "health_technologists_and_technicians_all_other",
    "onet_code": "29-2099.00",
    "title": "Health Technologists and Technicians, All Other",
    "category": "Healthcare",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "healthcare"
    ],
    "salary": {
      "entry_min": 47876,
      "entry_max": 63835,
      "mid_min": 63835,
      "mid_max": 82985
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All health technologists and technicians not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "healthcare_diagnosing_or_treating_practitioners_all_other",
    "onet_code": "29-1299.00",
    "title": "Healthcare Diagnosing or Treating Practitioners, All Other",
    "category": "Healthcare",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "healthcare"
    ],
    "salary": {
      "entry_min": 47876,
      "entry_max": 63835,
      "mid_min": 63835,
      "mid_max": 82985
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All healthcare diagnosing or treating practitioners not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "healthcare_practitioners_and_technical_workers_all_other",
    "onet_code": "29-9099.00",
    "title": "Healthcare Practitioners and Technical Workers, All Other",
    "category": "Healthcare",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "healthcare"
    ],
    "salary": {
      "entry_min": 47876,
      "entry_max": 63835,
      "mid_min": 63835,
      "mid_max": 82985
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All healthcare practitioners and technical workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "hearing_aid_specialists",
    "onet_code": "29-2092.00",
    "title": "Hearing Aid Specialists",
    "category": "Healthcare",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare",
      "leadership"
    ],
    "salary": {
      "entry_min": 56325,
      "entry_max": 75100,
      "mid_min": 75100,
      "mid_max": 97630
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-2057.00",
      "29-2091.00",
      "29-2099.01"
    ],
    "training_paths": [],
    "description": "Select and fit hearing aids for customers. Administer and interpret tests of hearing. Assess hearing instrument efficacy. Take ear impressions and prepare, design, and modify ear molds.",
    "dailyActivities": [
      "Train clients to use hearing aids or other augmentative communication devices.",
      "Counsel patients and families on communication strategies and the effects of hearing loss.",
      "Select and administer tests to evaluate hearing or related disabilities.",
      "Administer basic hearing tests including air conduction, bone conduction, or speech audiometry tests.",
      "Maintain or repair hearing aids or other communication devices.",
      "Perform basic screening procedures, such as pure tone screening, otoacoustic screening, immittance screening, and screening of ear canal status using otoscope."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "histology_technicians",
    "onet_code": "29-2012.01",
    "title": "Histology Technicians",
    "category": "Healthcare",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Critical Thinking",
      "Active Learning",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare"
    ],
    "salary": {
      "entry_min": 56325,
      "entry_max": 75100,
      "mid_min": 75100,
      "mid_max": 97630
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-2011.04",
      "29-2012.00",
      "29-2011.00"
    ],
    "training_paths": [],
    "description": "Prepare histological slides from tissue sections for microscopic examination and diagnosis by pathologists. May assist with research studies.",
    "dailyActivities": [
      "Cut sections of body tissues for microscopic examination, using microtomes.",
      "Embed tissue specimens into paraffin wax blocks, or infiltrate tissue specimens with wax.",
      "Mount tissue specimens on glass slides.",
      "Stain tissue specimens with dyes or other chemicals to make cell details visible under microscopes.",
      "Freeze tissue specimens.",
      "Operate computerized laboratory equipment to dehydrate, decalcify, or microincinerate tissue samples."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "licensed_practical_and_licensed_vocational_nurses",
    "onet_code": "29-2061.00",
    "title": "Licensed Practical and Licensed Vocational Nurses",
    "category": "Healthcare",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare",
      "leadership"
    ],
    "salary": {
      "entry_min": 56325,
      "entry_max": 75100,
      "mid_min": 75100,
      "mid_max": 97630
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-1141.00",
      "29-2043.00",
      "29-1171.00"
    ],
    "training_paths": [],
    "description": "Care for ill, injured, or convalescing patients or persons with disabilities in hospitals, nursing homes, clinics, private homes, group homes, and similar institutions. May work under the supervision of a registered nurse. Licensing required.",
    "dailyActivities": [
      "Observe patients, charting and reporting changes in patients' conditions, such as adverse reactions to medication or treatment, and taking any necessary action.",
      "Measure and record patients' vital signs, such as height, weight, temperature, blood pressure, pulse, or respiration.",
      "Administer prescribed medications or start intravenous fluids, noting times and amounts on patients' charts.",
      "Provide basic patient care or treatments, such as taking temperatures or blood pressures, dressing wounds, treating bedsores, giving enemas or douches, rubbing with alcohol, massaging, or performing catheterizations.",
      "Answer patients' calls and determine how to assist them.",
      "Supervise nurses' aides or assistants."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "military_mos_relevant": [
      "68C"
    ],
    "last_updated": new Date()
  },
  {
    "id": "magnetic_resonance_imaging_technologists",
    "onet_code": "29-2035.00",
    "title": "Magnetic Resonance Imaging Technologists",
    "category": "Healthcare",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare",
      "leadership"
    ],
    "salary": {
      "entry_min": 56325,
      "entry_max": 75100,
      "mid_min": 75100,
      "mid_max": 97630
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-2034.00",
      "29-2031.00",
      "29-2032.00"
    ],
    "training_paths": [],
    "description": "Operate Magnetic Resonance Imaging (MRI) scanners. Monitor patient safety and comfort, and view images of area being scanned to ensure quality of pictures. May administer gadolinium contrast dosage intravenously. May interview patient, explain MRI procedures, and position patient on examining table. May enter into the computer data such as patient history, anatomical area to be scanned, orientation specified, and position of entry.",
    "dailyActivities": [
      "Review physicians' orders to confirm prescribed exams.",
      "Conduct screening interviews of patients to identify contraindications, such as ferrous objects, pregnancy, prosthetic heart valves, cardiac pacemakers, or tattoos.",
      "Select appropriate imaging techniques or coils to produce required images.",
      "Operate magnetic resonance imaging (MRI) scanners.",
      "Provide headphones or earplugs to patients to improve comfort and reduce unpleasant noise.",
      "Position patients on cradle, attaching immobilization devices, if needed, to ensure appropriate placement for imaging."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "medical_records_specialists",
    "onet_code": "29-2072.00",
    "title": "Medical Records Specialists",
    "category": "Healthcare",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "healthcare"
    ],
    "salary": {
      "entry_min": 56325,
      "entry_max": 75100,
      "mid_min": 75100,
      "mid_max": 97630
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "31-9094.00",
      "29-9021.00",
      "43-6013.00"
    ],
    "training_paths": [],
    "description": "Compile, process, and maintain medical records of hospital and clinic patients in a manner consistent with medical, administrative, ethical, legal, and regulatory requirements of the healthcare system. Classify medical and healthcare concepts, including diagnosis, procedures, medical services, and equipment, into the healthcare industry's numerical coding system. Includes medical coders.",
    "dailyActivities": [
      "Assign the patient to diagnosis-related groups (DRGs), using appropriate computer software.",
      "Compile and maintain patients' medical records to document condition and treatment and to provide data for research or cost control and care improvement efforts.",
      "Consult classification manuals to locate information about disease processes.",
      "Enter data, such as demographic characteristics, history and extent of disease, diagnostic procedures, or treatment into computer.",
      "Identify, compile, abstract, and code patient data, using standard classification systems.",
      "Maintain or operate a variety of health record indexes or storage and retrieval systems to collect, classify, store, or analyze information."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "medical_and_clinical_laboratory_technicians",
    "onet_code": "29-2012.00",
    "title": "Medical and Clinical Laboratory Technicians",
    "category": "Healthcare",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Science",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare",
      "leadership"
    ],
    "salary": {
      "entry_min": 56325,
      "entry_max": 75100,
      "mid_min": 75100,
      "mid_max": 97630
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-2011.00",
      "29-2011.04",
      "29-2012.01"
    ],
    "training_paths": [],
    "description": "Perform routine medical laboratory tests for the diagnosis, treatment, and prevention of disease. May work under the supervision of a medical technologist.",
    "dailyActivities": [
      "Conduct chemical analyses of body fluids, such as blood or urine, using microscope or automatic analyzer to detect abnormalities or diseases and enter findings into computer.",
      "Analyze the results of tests or experiments to ensure conformity to specifications, using special mechanical or electrical devices.",
      "Set up, maintain, calibrate, clean, and test sterility of medical laboratory equipment.",
      "Prepare standard volumetric solutions or reagents to be combined with samples, following standardized formulas or experimental procedures.",
      "Collect blood or tissue samples from patients, observing principles of asepsis to obtain blood sample.",
      "Supervise or instruct other technicians or laboratory assistants."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "neurodiagnostic_technologists",
    "onet_code": "29-2099.01",
    "title": "Neurodiagnostic Technologists",
    "category": "Healthcare",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare",
      "leadership"
    ],
    "salary": {
      "entry_min": 56325,
      "entry_max": 75100,
      "mid_min": 75100,
      "mid_max": 97630
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-2031.00",
      "29-2034.00",
      "29-2032.00"
    ],
    "training_paths": [],
    "description": "Conduct electroneurodiagnostic (END) tests such as electroencephalograms, evoked potentials, polysomnograms, or electronystagmograms. May perform nerve conduction studies.",
    "dailyActivities": [
      "Indicate artifacts or interferences derived from sources outside of the brain, such as poor electrode contact or patient movement, on electroneurodiagnostic recordings.",
      "Monitor patients during tests or surgeries, using electroencephalographs (EEG), evoked potential (EP) instruments, or video recording equipment.",
      "Conduct tests or studies such as electroencephalography (EEG), polysomnography (PSG), nerve conduction studies (NCS), electromyography (EMG), and intraoperative monitoring (IOM).",
      "Collect patients' medical information needed to customize tests.",
      "Explain testing procedures to patients, answering questions or reassuring patients, as needed.",
      "Set up, program, or record montages or electrical combinations when testing peripheral nerve, spinal cord, subcortical, or cortical responses."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "nuclear_medicine_technologists",
    "onet_code": "29-2033.00",
    "title": "Nuclear Medicine Technologists",
    "category": "Healthcare",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Science",
      "Critical Thinking",
      "Active Learning"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare",
      "leadership"
    ],
    "salary": {
      "entry_min": 56325,
      "entry_max": 75100,
      "mid_min": 75100,
      "mid_max": 97630
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-2031.00",
      "29-2034.00",
      "29-1124.00"
    ],
    "training_paths": [],
    "description": "Prepare, administer, and measure radioactive isotopes in therapeutic, diagnostic, and tracer studies using a variety of radioisotope equipment. Prepare stock solutions of radioactive materials and calculate doses to be administered by radiologists. Subject patients to radiation. Execute blood volume, red cell survival, and fat absorption studies following standard laboratory techniques.",
    "dailyActivities": [
      "Administer radiopharmaceuticals or radiation intravenously to detect or treat diseases, using radioisotope equipment, under direction of a physician.",
      "Detect and map radiopharmaceuticals in patients' bodies, using a camera to produce photographic or computer images.",
      "Process cardiac function studies, using computer.",
      "Calculate, measure, and record radiation dosage or radiopharmaceuticals received, used, and disposed, using computer and following physician's prescription.",
      "Record and process results of procedures.",
      "Produce a computer-generated or film image for interpretation by a physician."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "ophthalmic_medical_technicians",
    "onet_code": "29-2057.00",
    "title": "Ophthalmic Medical Technicians",
    "category": "Healthcare",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare",
      "leadership"
    ],
    "salary": {
      "entry_min": 56325,
      "entry_max": 75100,
      "mid_min": 75100,
      "mid_max": 97630
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-2099.05",
      "29-2031.00",
      "31-9092.00"
    ],
    "training_paths": [],
    "description": "Assist ophthalmologists by performing ophthalmic clinical functions. May administer eye exams, administer eye medications, and instruct the patient in care and use of corrective lenses.",
    "dailyActivities": [
      "Take and document patients' medical histories.",
      "Conduct tonometry or tonography tests to measure intraocular pressure.",
      "Operate ophthalmic equipment, such as autorefractors, phoropters, tomographs, or retinoscopes.",
      "Take anatomical or functional ocular measurements of the eye or surrounding tissue, such as axial length measurements.",
      "Measure visual acuity, including near, distance, pinhole, or dynamic visual acuity, using appropriate tests.",
      "Measure and record lens power, using lensometers."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "ophthalmic_medical_technologists",
    "onet_code": "29-2099.05",
    "title": "Ophthalmic Medical Technologists",
    "category": "Healthcare",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare",
      "leadership"
    ],
    "salary": {
      "entry_min": 56325,
      "entry_max": 75100,
      "mid_min": 75100,
      "mid_max": 97630
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-2057.00",
      "29-2031.00",
      "29-2034.00"
    ],
    "training_paths": [],
    "description": "Assist ophthalmologists by performing ophthalmic clinical functions and ophthalmic photography. Provide instruction and supervision to other ophthalmic personnel. Assist with minor surgical procedures, applying aseptic techniques and preparing instruments. May perform eye exams, administer eye medications, and instruct patients in care and use of corrective lenses.",
    "dailyActivities": [
      "Conduct tonometry or tonography tests to measure intraocular pressure.",
      "Take and document patients' medical histories.",
      "Take anatomical or functional ocular measurements, such as axial length measurements, of the eye or surrounding tissue.",
      "Measure visual acuity, including near, distance, pinhole, or dynamic visual acuity, using appropriate tests.",
      "Administer topical ophthalmic or oral medications.",
      "Measure and record lens power, using lensometers."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "opticians_dispensing",
    "onet_code": "29-2081.00",
    "title": "Opticians, Dispensing",
    "category": "Healthcare",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Originality"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare",
      "leadership"
    ],
    "salary": {
      "entry_min": 56325,
      "entry_max": 75100,
      "mid_min": 75100,
      "mid_max": 97630
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9083.00",
      "29-1041.00",
      "29-2057.00"
    ],
    "training_paths": [],
    "description": "Design, measure, fit, and adapt lenses and frames for client according to written optical prescription or specification. Assist client with inserting, removing, and caring for contact lenses. Assist client with selecting frames. Measure customer for size of eyeglasses and coordinate frames with facial and eye measurements and optical prescription. Prepare work order for optical laboratory containing instructions for grinding and mounting lenses in frames. Verify exactness of finished lens spectacles. Adjust frame and lens position to fit client. May shape or reshape frames. Includes contact lens opticians.",
    "dailyActivities": [
      "Measure clients' bridge and eye size, temple length, vertex distance, pupillary distance, and optical centers of eyes, using measuring devices.",
      "Verify that finished lenses are ground to specifications.",
      "Evaluate prescriptions in conjunction with clients' vocational and avocational visual requirements.",
      "Recommend specific lenses, lens coatings, and frames to suit client needs.",
      "Assist clients in selecting frames according to style and color, and ensure that frames are coordinated with facial and eye measurements and optical prescriptions.",
      "Maintain records of customer prescriptions, work orders, and payments."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "paramedics",
    "onet_code": "29-2043.00",
    "title": "Paramedics",
    "category": "Healthcare",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "healthcare"
    ],
    "salary": {
      "entry_min": 56325,
      "entry_max": 75100,
      "mid_min": 75100,
      "mid_max": 97630
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-2042.00",
      "29-1141.00",
      "29-1141.01"
    ],
    "training_paths": [],
    "description": "Administer basic or advanced emergency medical care and assess injuries and illnesses. May administer medication intravenously, use equipment such as EKGs, or administer advanced life support to sick or injured individuals.",
    "dailyActivities": [
      "Administer drugs, orally or by injection, or perform intravenous procedures.",
      "Administer first aid treatment or life support care to sick or injured persons in prehospital settings.",
      "Assess nature and extent of illness or injury to establish and prioritize medical procedures.",
      "Attend training classes to maintain certification licensure, keep abreast of new developments in the field, or maintain existing knowledge.",
      "Comfort and reassure patients.",
      "Coordinate with treatment center personnel to obtain patients' vital statistics and medical history, to determine the circumstances of the emergency, and to administer emergency treatment."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "patient_representatives",
    "onet_code": "29-2099.08",
    "title": "Patient Representatives",
    "category": "Healthcare",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "healthcare",
      "leadership"
    ],
    "salary": {
      "entry_min": 56325,
      "entry_max": 75100,
      "mid_min": 75100,
      "mid_max": 97630
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-9021.00",
      "29-2072.00",
      "21-1094.00"
    ],
    "training_paths": [],
    "description": "Assist patients in obtaining services, understanding policies and making health care decisions.",
    "dailyActivities": [
      "Coordinate communication between patients, family members, medical staff, administrative staff, or regulatory agencies.",
      "Interview patients or their representatives to identify problems relating to care.",
      "Refer patients to appropriate health care services or resources.",
      "Maintain knowledge of community services and resources available to patients.",
      "Explain policies, procedures, or services to patients using medical or administrative knowledge.",
      "Investigate and direct patient inquiries or complaints to appropriate medical staff members and follow up to ensure satisfactory resolution."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "pharmacy_technicians",
    "onet_code": "29-2052.00",
    "title": "Pharmacy Technicians",
    "category": "Healthcare",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare",
      "leadership"
    ],
    "salary": {
      "entry_min": 56325,
      "entry_max": 75100,
      "mid_min": 75100,
      "mid_max": 97630
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-1051.00",
      "31-9095.00",
      "31-9092.00"
    ],
    "training_paths": [],
    "description": "Prepare medications under the direction of a pharmacist. May measure, mix, count out, label, and record amounts and dosages of medications according to prescription orders.",
    "dailyActivities": [
      "Receive written prescription or refill requests and verify that information is complete and accurate.",
      "Enter prescription information into computer databases.",
      "Establish or maintain patient profiles, including lists of medications taken by individual patients.",
      "Maintain proper storage and security conditions for drugs.",
      "Receive and store incoming supplies, verify quantities against invoices, check for outdated medications in current inventory, and inform supervisors of stock needs and shortages.",
      "Answer telephones, responding to questions or requests."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "physicians_all_other",
    "onet_code": "29-1229.00",
    "title": "Physicians, All Other",
    "category": "Healthcare",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "healthcare"
    ],
    "salary": {
      "entry_min": 47876,
      "entry_max": 63835,
      "mid_min": 63835,
      "mid_max": 82985
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All physicians not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "psychiatric_technicians",
    "onet_code": "29-2053.00",
    "title": "Psychiatric Technicians",
    "category": "Healthcare",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "healthcare",
      "leadership"
    ],
    "salary": {
      "entry_min": 56325,
      "entry_max": 75100,
      "mid_min": 75100,
      "mid_max": 97630
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "31-1133.00",
      "31-2021.00",
      "31-2012.00"
    ],
    "training_paths": [],
    "description": "Care for individuals with mental or emotional conditions or disabilities, following the instructions of physicians or other health practitioners. Monitor patients' physical and emotional well-being and report to medical staff. May participate in rehabilitation and treatment programs, help with personal hygiene, and administer oral or injectable medications.",
    "dailyActivities": [
      "Provide nursing, psychiatric, or personal care to patients with cognitive, intellectual, or developmental disabilities.",
      "Encourage patients to develop work skills and to participate in social, recreational, or other therapeutic activities that enhance interpersonal skills or develop social relationships.",
      "Restrain violent, potentially violent, or suicidal patients by verbal or physical means as required.",
      "Lead prescribed individual or group therapy sessions as part of specific therapeutic procedures.",
      "Monitor patients' physical and emotional well-being and report unusual behavior or physical ailments to medical staff.",
      "Take and record measures of patients' physical condition, using devices such as thermometers or blood pressure gauges."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "radiation_therapists",
    "onet_code": "29-1124.00",
    "title": "Radiation Therapists",
    "category": "Healthcare",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Science",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare",
      "leadership"
    ],
    "salary": {
      "entry_min": 56325,
      "entry_max": 75100,
      "mid_min": 75100,
      "mid_max": 97630
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-2031.00",
      "29-2034.00",
      "29-1126.00"
    ],
    "training_paths": [],
    "description": "Provide radiation therapy to patients as prescribed by a radiation oncologist according to established practices and standards. Duties may include reviewing prescription and diagnosis; acting as liaison with physician and supportive care personnel; preparing equipment, such as immobilization, treatment, and protection devices; and maintaining records, reports, and files. May assist in dosimetry procedures and tumor localization.",
    "dailyActivities": [
      "Position patients for treatment with accuracy, according to prescription.",
      "Administer prescribed doses of radiation to specific body parts, using radiation therapy equipment according to established practices and standards.",
      "Follow principles of radiation protection for patient, self, and others.",
      "Review prescription, diagnosis, patient chart, and identification.",
      "Conduct most treatment sessions independently, in accordance with the long-term treatment plan and under the general direction of the patient's physician.",
      "Enter data into computer and set controls to operate or adjust equipment or regulate dosage."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "radiologic_technologists_and_technicians",
    "onet_code": "29-2034.00",
    "title": "Radiologic Technologists and Technicians",
    "category": "Healthcare",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Social Perceptiveness",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare",
      "leadership"
    ],
    "salary": {
      "entry_min": 56325,
      "entry_max": 75100,
      "mid_min": 75100,
      "mid_max": 97630
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-2031.00",
      "29-2032.00",
      "29-2035.00"
    ],
    "training_paths": [],
    "description": "Take x-rays and CAT scans or administer nonradioactive materials into patient's bloodstream for diagnostic or research purposes. Includes radiologic technologists and technicians who specialize in other scanning modalities.",
    "dailyActivities": [
      "Position imaging equipment and adjust controls to set exposure time and distance, according to specification of examination.",
      "Position patient on examining table and set up and adjust equipment to obtain optimum view of specific body area as requested by physician.",
      "Monitor patients' conditions and reactions, reporting abnormal signs to physician.",
      "Explain procedures and observe patients to ensure safety and comfort during scan.",
      "Use radiation safety measures and protection devices to comply with government regulations and to ensure safety of patients and staff.",
      "Review and evaluate developed x-rays, video tape, or computer-generated information to determine if images are satisfactory for diagnostic purposes."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "respiratory_therapists",
    "onet_code": "29-1126.00",
    "title": "Respiratory Therapists",
    "category": "Healthcare",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Science",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Originality"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare",
      "leadership"
    ],
    "salary": {
      "entry_min": 56325,
      "entry_max": 75100,
      "mid_min": 75100,
      "mid_max": 97630
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-2031.00",
      "29-2043.00",
      "29-1141.01"
    ],
    "training_paths": [],
    "description": "Assess, treat, and care for patients with breathing disorders. Assume primary responsibility for all respiratory care modalities, including the supervision of respiratory therapy technicians. Initiate and conduct therapeutic procedures; maintain patient records; and select, assemble, check, and operate equipment.",
    "dailyActivities": [
      "Provide emergency care, such as artificial respiration, external cardiac massage, or assistance with cardiopulmonary resuscitation.",
      "Monitor patient's physiological responses to therapy, such as vital signs, arterial blood gases, or blood chemistry changes, and consult with physician if adverse reactions occur.",
      "Set up and operate devices, such as mechanical ventilators, therapeutic gas administration apparatus, environmental control systems, or aerosol generators, following specified parameters of treatment.",
      "Work as part of a team of physicians, nurses, or other healthcare professionals to manage patient care by assisting with medical procedures or related duties.",
      "Maintain charts that contain patients' pertinent identification and therapy information.",
      "Read prescription, measure arterial blood gases, and review patient information to assess patient condition."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "surgeons_all_other",
    "onet_code": "29-1249.00",
    "title": "Surgeons, All Other",
    "category": "Healthcare",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "healthcare"
    ],
    "salary": {
      "entry_min": 47876,
      "entry_max": 63835,
      "mid_min": 63835,
      "mid_max": 82985
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All surgeons not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "surgical_assistants",
    "onet_code": "29-9093.00",
    "title": "Surgical Assistants",
    "category": "Healthcare",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare",
      "leadership"
    ],
    "salary": {
      "entry_min": 56325,
      "entry_max": 75100,
      "mid_min": 75100,
      "mid_max": 97630
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-2055.00",
      "29-1071.01",
      "29-2043.00"
    ],
    "training_paths": [],
    "description": "Assist in operations, under the supervision of surgeons. May, in accordance with state laws, help surgeons to make incisions and close surgical sites, manipulate or remove tissues, implant surgical devices or drains, suction the surgical site, place catheters, clamp or cauterize vessels or tissue, and apply dressings to surgical site.",
    "dailyActivities": [
      "Verify the identity of patient or operative site.",
      "Monitor and maintain aseptic technique throughout procedures.",
      "Cover patients with surgical drapes to create and maintain a sterile operative field.",
      "Coordinate or participate in the positioning of patients, using body stabilizing equipment or protective padding to provide appropriate exposure for the procedure or to protect against nerve damage or circulation impairment.",
      "Maintain an unobstructed operative field, using surgical retractors, sponges, or suctioning and irrigating equipment.",
      "Prepare and apply sterile wound dressings."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "surgical_technologists",
    "onet_code": "29-2055.00",
    "title": "Surgical Technologists",
    "category": "Healthcare",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare",
      "leadership"
    ],
    "salary": {
      "entry_min": 56325,
      "entry_max": 75100,
      "mid_min": 75100,
      "mid_max": 97630
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-9093.00",
      "29-2031.00",
      "31-9099.02"
    ],
    "training_paths": [],
    "description": "Assist in operations, under the supervision of surgeons, registered nurses, or other surgical personnel. May help set up operating room, prepare and transport patients for surgery, adjust lights and equipment, pass instruments and other supplies to surgeons and surgeons' assistants, hold retractors, cut sutures, and help count sponges, needles, supplies, and instruments.",
    "dailyActivities": [
      "Maintain a proper sterile field during surgical procedures.",
      "Count sponges, needles, and instruments before and after operation.",
      "Scrub arms and hands and assist the surgical team to scrub and put on gloves, masks, and surgical clothing.",
      "Provide technical assistance to surgeons, surgical nurses, or anesthesiologists.",
      "Prepare patients for surgery, including positioning patients on the operating table and covering them with sterile surgical drapes to prevent exposure.",
      "Hand instruments and supplies to surgeons and surgeons' assistants, hold retractors and cut sutures, and perform other tasks as directed by surgeon during operation."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "therapists_all_other",
    "onet_code": "29-1129.00",
    "title": "Therapists, All Other",
    "category": "Healthcare",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "healthcare"
    ],
    "salary": {
      "entry_min": 47876,
      "entry_max": 63835,
      "mid_min": 63835,
      "mid_max": 82985
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All therapists not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "veterinary_technologists_and_technicians",
    "onet_code": "29-2056.00",
    "title": "Veterinary Technologists and Technicians",
    "category": "Healthcare",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare",
      "leadership"
    ],
    "salary": {
      "entry_min": 56325,
      "entry_max": 75100,
      "mid_min": 75100,
      "mid_max": 97630
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "31-9096.00",
      "29-9093.00",
      "31-9092.00"
    ],
    "training_paths": [],
    "description": "Perform medical tests in a laboratory environment for use in the treatment and diagnosis of diseases in animals. Prepare vaccines and serums for prevention of diseases. Prepare tissue samples, take blood samples, and execute laboratory tests, such as urinalysis and blood counts. Clean and sterilize instruments and materials and maintain equipment and machines. May assist a veterinarian during surgery.",
    "dailyActivities": [
      "Administer anesthesia to animals, under the direction of a veterinarian, and monitor animals' responses to anesthetics so that dosages can be adjusted.",
      "Care for and monitor the condition of animals recovering from surgery.",
      "Maintain controlled drug inventory and related log books.",
      "Perform laboratory tests on blood, urine, or feces, such as urinalyses or blood counts, to assist in the diagnosis and treatment of animal health problems.",
      "Prepare and administer medications, vaccines, serums, or treatments, as prescribed by veterinarians.",
      "Restrain animals during exams or procedures."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "dental_assistants",
    "onet_code": "31-9091.00",
    "title": "Dental Assistants",
    "category": "Healthcare Support",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare_support",
      "leadership"
    ],
    "salary": {
      "entry_min": 27195,
      "entry_max": 36260,
      "mid_min": 36260,
      "mid_max": 47138
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-1292.00",
      "31-9092.00",
      "29-2057.00"
    ],
    "training_paths": [],
    "description": "Perform limited clinical duties under the direction of a dentist. Clinical duties may include equipment preparation and sterilization, preparing patients for treatment, assisting the dentist during treatment, and providing patients with instructions for oral healthcare procedures. May perform administrative duties such as scheduling appointments, maintaining medical records, billing, and coding information for insurance purposes.",
    "dailyActivities": [
      "Prepare patient, sterilize or disinfect instruments, set up instrument trays, prepare materials, or assist dentist during dental procedures.",
      "Record treatment information in patient records.",
      "Assist dentist in management of medical or dental emergencies.",
      "Order and monitor dental supplies and equipment inventory.",
      "Expose dental diagnostic x-rays.",
      "Provide postoperative instructions prescribed by dentist."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "endoscopy_technicians",
    "onet_code": "31-9099.02",
    "title": "Endoscopy Technicians",
    "category": "Healthcare Support",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare_support",
      "leadership"
    ],
    "salary": {
      "entry_min": 23115,
      "entry_max": 30821,
      "mid_min": 30821,
      "mid_max": 40067
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-2055.00",
      "29-2031.00",
      "29-9093.00"
    ],
    "training_paths": [],
    "description": "Maintain a sterile field to provide support for physicians and nurses during endoscopy procedures. Prepare and maintain instruments and equipment. May obtain specimens.",
    "dailyActivities": [
      "Clean, disinfect, or calibrate scopes or other endoscopic instruments according to manufacturer recommendations and facility standards.",
      "Collect specimens from patients, using standard medical procedures.",
      "Perform safety checks to verify proper equipment functioning.",
      "Maintain or repair endoscopic equipment.",
      "Assist physicians or registered nurses in the conduct of endoscopic procedures.",
      "Place devices, such as blood pressure cuffs, pulse oximeter sensors, nasal cannulas, surgical cautery pads, and cardiac monitoring electrodes, on patients to monitor vital signs."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "healthcare_support_workers_all_other",
    "onet_code": "31-9099.00",
    "title": "Healthcare Support Workers, All Other",
    "category": "Healthcare Support",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "healthcare_support"
    ],
    "salary": {
      "entry_min": 23115,
      "entry_max": 30821,
      "mid_min": 30821,
      "mid_max": 40067
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All healthcare support workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "home_health_aides",
    "onet_code": "31-1121.00",
    "title": "Home Health Aides",
    "category": "Healthcare Support",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "communication",
      "healthcare_support",
      "leadership"
    ],
    "salary": {
      "entry_min": 23115,
      "entry_max": 30821,
      "mid_min": 30821,
      "mid_max": 40067
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "31-1131.00",
      "31-1122.00",
      "29-2043.00"
    ],
    "training_paths": [],
    "description": "Monitor the health status of an individual with disabilities or illness, and address their health-related needs, such as changing bandages, dressing wounds, or administering medication. Work is performed under the direction of offsite or intermittent onsite licensed nursing staff. Provide assistance with routine healthcare tasks or activities of daily living, such as feeding, bathing, toileting, or ambulation. May also help with tasks such as preparing meals, doing light housekeeping, and doing laundry depending on the patient's abilities.",
    "dailyActivities": [
      "Maintain records of patient care, condition, progress, or problems to report and discuss observations with supervisor or case manager.",
      "Provide patients with help moving in and out of beds, baths, wheelchairs, or automobiles and with dressing and grooming.",
      "Bathe patients.",
      "Care for patients by changing bed linens, washing and ironing laundry, cleaning, or assisting with their personal care.",
      "Entertain, converse with, or read aloud to patients to keep them mentally healthy and alert.",
      "Plan, purchase, prepare, or serve meals to patients or other family members, according to prescribed diets."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "massage_therapists",
    "onet_code": "31-9011.00",
    "title": "Massage Therapists",
    "category": "Healthcare Support",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness",
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "communication",
      "healthcare_support",
      "leadership"
    ],
    "salary": {
      "entry_min": 27195,
      "entry_max": 36260,
      "mid_min": 36260,
      "mid_max": 47138
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "31-2021.00",
      "29-1125.00",
      "31-2011.00"
    ],
    "training_paths": [],
    "description": "Perform therapeutic massages of soft tissues and joints. May assist in the assessment of range of motion and muscle strength, or propose client therapy plans.",
    "dailyActivities": [
      "Confer with clients about their medical histories and problems with stress or pain to determine how massage will be most helpful.",
      "Massage and knead muscles and soft tissues of the body to provide treatment for medical conditions, injuries, or wellness maintenance.",
      "Maintain massage areas by restocking supplies or sanitizing equipment.",
      "Apply finger and hand pressure to specific points of the body.",
      "Develop and propose client treatment plans that specify which types of massage are to be used.",
      "Maintain treatment records."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "medical_assistants",
    "onet_code": "31-9092.00",
    "title": "Medical Assistants",
    "category": "Healthcare Support",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare_support",
      "leadership"
    ],
    "salary": {
      "entry_min": 27195,
      "entry_max": 36260,
      "mid_min": 36260,
      "mid_max": 47138
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-9093.00",
      "29-2057.00",
      "29-1141.00"
    ],
    "training_paths": [],
    "description": "Perform administrative and certain clinical duties under the direction of a physician. Administrative duties may include scheduling appointments, maintaining medical records, billing, and coding information for insurance purposes. Clinical duties may include taking and recording vital signs and medical histories, preparing patients for examination, drawing blood, and administering medications as directed by physician.",
    "dailyActivities": [
      "Interview patients to obtain medical information and measure their vital signs, weight, and height.",
      "Clean and sterilize instruments and dispose of contaminated supplies.",
      "Record patients' medical history, vital statistics, or information such as test results in medical records.",
      "Explain treatment procedures, medications, diets, or physicians' instructions to patients.",
      "Prepare treatment rooms for patient examinations, keeping the rooms neat and clean.",
      "Collect blood, tissue, or other laboratory specimens, log the specimens, and prepare them for testing."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "military_mos_relevant": [
      "68W",
      "HM",
      "4N0X1"
    ],
    "last_updated": new Date()
  },
  {
    "id": "medical_equipment_preparers",
    "onet_code": "31-9093.00",
    "title": "Medical Equipment Preparers",
    "category": "Healthcare Support",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Active Learning",
      "Monitoring",
      "Operations Monitoring",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "technical",
      "communication",
      "healthcare_support"
    ],
    "salary": {
      "entry_min": 23115,
      "entry_max": 30821,
      "mid_min": 30821,
      "mid_max": 40067
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-2055.00",
      "29-2012.00",
      "31-9099.02"
    ],
    "training_paths": [],
    "description": "Prepare, sterilize, install, or clean laboratory or healthcare equipment. May perform routine laboratory tasks and operate or inspect equipment.",
    "dailyActivities": [
      "Operate and maintain steam autoclaves, keeping records of loads completed, items in loads, and maintenance procedures performed.",
      "Clean instruments to prepare them for sterilization.",
      "Record sterilizer test results.",
      "Organize and assemble routine or specialty surgical instrument trays or other sterilized supplies, filling special requests as needed.",
      "Examine equipment to detect leaks, worn or loose parts, or other indications of disrepair.",
      "Report defective equipment to appropriate supervisors or staff."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "medical_transcriptionists",
    "onet_code": "31-9094.00",
    "title": "Medical Transcriptionists",
    "category": "Healthcare Support",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "healthcare_support"
    ],
    "salary": {
      "entry_min": 27195,
      "entry_max": 36260,
      "mid_min": 36260,
      "mid_max": 47138
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-2072.00",
      "43-9022.00",
      "31-9092.00"
    ],
    "training_paths": [],
    "description": "Transcribe medical reports recorded by physicians and other healthcare practitioners using various electronic devices, covering office visits, emergency room visits, diagnostic imaging studies, operations, chart reviews, and final summaries. Transcribe dictated reports and translate abbreviations into fully understandable form. Edit as necessary and return reports in either printed or electronic form for review and signature, or correction.",
    "dailyActivities": [
      "Return dictated reports in printed or electronic form for physician's review, signature, and corrections and for inclusion in patients' medical records.",
      "Produce medical reports, correspondence, records, patient-care information, statistics, medical research, and administrative material.",
      "Identify mistakes in reports and check with doctors to obtain the correct information.",
      "Review and edit transcribed reports or dictated material for spelling, grammar, clarity, consistency, and proper medical terminology.",
      "Transcribe dictation for a variety of medical reports, such as patient histories, physical examinations, emergency room visits, operations, chart reviews, consultation, or discharge summaries.",
      "Distinguish between homonyms and recognize inconsistencies and mistakes in medical terms, referring to dictionaries, drug references, and other sources on anatomy, physiology, and medicine."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "nursing_assistants",
    "onet_code": "31-1131.00",
    "title": "Nursing Assistants",
    "category": "Healthcare Support",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Social Perceptiveness",
      "Coordination",
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "communication",
      "healthcare_support",
      "leadership"
    ],
    "salary": {
      "entry_min": 27195,
      "entry_max": 36260,
      "mid_min": 36260,
      "mid_max": 47138
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "31-1121.00",
      "29-2043.00",
      "29-2061.00"
    ],
    "training_paths": [],
    "description": "Provide or assist with basic care or support under the direction of onsite licensed nursing staff. Perform duties such as monitoring of health status, feeding, bathing, dressing, grooming, toileting, or ambulation of patients in a health or nursing facility. May include medication administration and other health-related tasks. Includes nursing care attendants, nursing aides, and nursing attendants.",
    "dailyActivities": [
      "Turn or reposition bedridden patients.",
      "Answer patient call signals, signal lights, bells, or intercom systems to determine patients' needs.",
      "Feed patients or assist patients to eat or drink.",
      "Measure and record food and liquid intake or urinary and fecal output, reporting changes to medical or nursing staff.",
      "Provide physical support to assist patients to perform daily living activities, such as getting out of bed, bathing, dressing, using the toilet, standing, walking, or exercising.",
      "Document or otherwise report observations of patient behavior, complaints, or physical symptoms to nurses."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "military_mos_relevant": [
      "68C"
    ],
    "last_updated": new Date()
  },
  {
    "id": "occupational_therapy_aides",
    "onet_code": "31-2012.00",
    "title": "Occupational Therapy Aides",
    "category": "Healthcare Support",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare_support",
      "leadership"
    ],
    "salary": {
      "entry_min": 27195,
      "entry_max": 36260,
      "mid_min": 36260,
      "mid_max": 47138
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "31-2022.00",
      "31-2011.00",
      "31-2021.00"
    ],
    "training_paths": [],
    "description": "Under close supervision of an occupational therapist or occupational therapy assistant, perform only delegated, selected, or routine tasks in specific situations. These duties include preparing patient and treatment room.",
    "dailyActivities": [
      "Encourage patients and attend to their physical needs to facilitate the attainment of therapeutic goals.",
      "Report to supervisors or therapists, verbally or in writing, on patients' progress, attitudes, attendance, and accomplishments.",
      "Observe patients' attendance, progress, attitudes, and accomplishments and record and maintain information in client records.",
      "Prepare and maintain work area, materials, and equipment and maintain inventory of treatment and educational supplies.",
      "Transport patients to and from the occupational therapy work area.",
      "Instruct patients and families in work, social, and living skills, the care and use of adaptive equipment, and other skills to facilitate home and work adjustment to disability."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "occupational_therapy_assistants",
    "onet_code": "31-2011.00",
    "title": "Occupational Therapy Assistants",
    "category": "Healthcare Support",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare_support",
      "leadership"
    ],
    "salary": {
      "entry_min": 27195,
      "entry_max": 36260,
      "mid_min": 36260,
      "mid_max": 47138
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "31-2012.00",
      "31-2021.00",
      "31-2022.00"
    ],
    "training_paths": [],
    "description": "Assist occupational therapists in providing occupational therapy treatments and procedures. May, in accordance with state laws, assist in development of treatment plans, carry out routine functions, direct activity programs, and document the progress of treatments. Generally requires formal training.",
    "dailyActivities": [
      "Instruct, or assist in instructing, patients and families in home programs, basic living skills, or the care and use of adaptive equipment.",
      "Maintain and promote a positive attitude toward clients and their treatment programs.",
      "Report to supervisors, verbally or in writing, on patients' progress, attitudes, and behavior.",
      "Implement, or assist occupational therapists with implementing, treatment plans designed to help clients function independently.",
      "Monitor patients' performance in therapy activities, providing encouragement.",
      "Observe and record patients' progress, attitudes, and behavior and maintain this information in client records."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "orderlies",
    "onet_code": "31-1132.00",
    "title": "Orderlies",
    "category": "Healthcare Support",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Static Strength",
      "Trunk Strength",
      "Extent Flexibility"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "healthcare_support"
    ],
    "salary": {
      "entry_min": 23115,
      "entry_max": 30821,
      "mid_min": 30821,
      "mid_max": 40067
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "31-1131.00",
      "53-3011.00",
      "31-2022.00"
    ],
    "training_paths": [],
    "description": "Transport patients to areas such as operating rooms or x-ray rooms using wheelchairs, stretchers, or moveable beds. May maintain stocks of supplies or clean and transport equipment. Psychiatric orderlies are included in Psychiatric Aides.",
    "dailyActivities": [
      "Lift or assist others to lift patients to move them on or off beds, examination tables, surgical tables, or stretchers.",
      "Transport patients to treatment units, testing units, operating rooms, or other areas, using wheelchairs, stretchers, or moveable beds.",
      "Disinfect or sterilize equipment or supplies, using germicides or sterilizing equipment.",
      "Clean equipment, such as wheelchairs, hospital beds, or portable medical equipment, documenting needed repairs or maintenance.",
      "Respond to emergency situations, such as emergency medical calls, security calls, or fire alarms.",
      "Change soiled linens, such as bed linens, drapes, or cubicle curtains."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "personal_care_aides",
    "onet_code": "31-1122.00",
    "title": "Personal Care Aides",
    "category": "Healthcare Support",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Social Perceptiveness",
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare_support",
      "leadership"
    ],
    "salary": {
      "entry_min": 23115,
      "entry_max": 30821,
      "mid_min": 30821,
      "mid_max": 40067
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "31-1121.00",
      "31-1131.00",
      "21-1021.00"
    ],
    "training_paths": [],
    "description": "Provide personalized assistance to individuals with disabilities or illness who require help with personal care and activities of daily living support (e.g., feeding, bathing, dressing, grooming, toileting, and ambulation). May also provide help with tasks such as preparing meals, doing light housekeeping, and doing laundry. Work is performed in various settings depending on the needs of the care recipient and may include locations such as their home, place of work, out in the community, or at a daytime nonresidential facility.",
    "dailyActivities": [
      "Prepare and maintain records of client progress and services performed, reporting changes in client condition to manager or supervisor.",
      "Administer bedside or personal care, such as ambulation or personal hygiene assistance.",
      "Perform healthcare-related tasks, such as monitoring vital signs and medication, under the direction of registered nurses or physiotherapists.",
      "Participate in case reviews, consulting with the team caring for the client, to evaluate the client's needs and plan for continuing services.",
      "Instruct or advise clients on issues, such as household cleanliness, utilities, hygiene, nutrition, or infant care.",
      "Care for individuals or families during periods of incapacitation, family disruption, or convalescence, providing companionship, personal care, or help in adjusting to new lifestyles."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "pharmacy_aides",
    "onet_code": "31-9095.00",
    "title": "Pharmacy Aides",
    "category": "Healthcare Support",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "technical",
      "communication",
      "healthcare_support"
    ],
    "salary": {
      "entry_min": 23115,
      "entry_max": 30821,
      "mid_min": 30821,
      "mid_max": 40067
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-2052.00",
      "41-2011.00",
      "43-6013.00"
    ],
    "training_paths": [],
    "description": "Record drugs delivered to the pharmacy, store incoming merchandise, and inform the supervisor of stock needs. May operate cash register and accept prescriptions for filling.",
    "dailyActivities": [
      "Greet customers and help them locate merchandise.",
      "Accept prescriptions for filling, gathering and processing necessary information.",
      "Operate cash register to process cash or credit sales.",
      "Answer telephone inquiries, referring callers to pharmacist when necessary.",
      "Receive, store, and inventory pharmaceutical supplies or medications, check for out-of-date medications, and notify pharmacist when inventory levels are low.",
      "Unpack, sort, count, and label incoming merchandise, including items requiring special handling or refrigeration."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "phlebotomists",
    "onet_code": "31-9097.00",
    "title": "Phlebotomists",
    "category": "Healthcare Support",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare_support",
      "leadership"
    ],
    "salary": {
      "entry_min": 27195,
      "entry_max": 36260,
      "mid_min": 36260,
      "mid_max": 47138
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-2012.00",
      "29-2011.00",
      "29-2031.00"
    ],
    "training_paths": [],
    "description": "Draw blood for tests, transfusions, donations, or research. May explain the procedure to patients and assist in the recovery of patients with adverse reactions.",
    "dailyActivities": [
      "Dispose of contaminated sharps, in accordance with applicable laws, standards, and policies.",
      "Organize or clean blood-drawing trays, ensuring that all instruments are sterile and all needles, syringes, or related items are of first-time use.",
      "Draw blood from veins by vacuum tube, syringe, or butterfly venipuncture methods.",
      "Match laboratory requisition forms to specimen tubes.",
      "Dispose of blood or other biohazard fluids or tissue, in accordance with applicable laws, standards, or policies.",
      "Conduct standards tests, such as blood alcohol, blood culture, oral glucose tolerance, glucose screening, blood smears, or peak and trough drug levels tests."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "physical_therapist_aides",
    "onet_code": "31-2022.00",
    "title": "Physical Therapist Aides",
    "category": "Healthcare Support",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Inductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare_support",
      "leadership"
    ],
    "salary": {
      "entry_min": 23115,
      "entry_max": 30821,
      "mid_min": 30821,
      "mid_max": 40067
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "31-2021.00",
      "31-2012.00",
      "31-2011.00"
    ],
    "training_paths": [],
    "description": "Under close supervision of a physical therapist or physical therapy assistant, perform only delegated, selected, or routine tasks in specific situations. These duties include preparing the patient and the treatment area.",
    "dailyActivities": [
      "Clean and organize work area and disinfect equipment after treatment.",
      "Secure patients into or onto therapy equipment.",
      "Instruct, motivate, safeguard, or assist patients practicing exercises or functional activities, under direction of medical staff.",
      "Confer with physical therapy staff or others to discuss and evaluate patient information for planning, modifying, or coordinating treatment.",
      "Observe patients during treatment to compile and evaluate data on patients' responses and progress and report to physical therapist.",
      "Change linens, such as bed sheets and pillow cases."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "physical_therapist_assistants",
    "onet_code": "31-2021.00",
    "title": "Physical Therapist Assistants",
    "category": "Healthcare Support",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare_support",
      "leadership"
    ],
    "salary": {
      "entry_min": 27195,
      "entry_max": 36260,
      "mid_min": 36260,
      "mid_max": 47138
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "31-2022.00",
      "31-2011.00",
      "31-2012.00"
    ],
    "training_paths": [],
    "description": "Assist physical therapists in providing physical therapy treatments and procedures. May, in accordance with state laws, assist in the development of treatment plans, carry out routine functions, document the progress of treatment, and modify specific treatments in accordance with patient status and within the scope of treatment plans established by a physical therapist. Generally requires formal training.",
    "dailyActivities": [
      "Instruct, motivate, safeguard, and assist patients as they practice exercises or functional activities.",
      "Document patient information, such as notes on their progress.",
      "Observe patients during treatments to compile and evaluate data on their responses and progress and provide results to physical therapist in person or through progress notes.",
      "Instruct patients in proper body mechanics and in ways to improve functional mobility, such as aquatic exercise.",
      "Secure patients into or onto therapy equipment.",
      "Confer with physical therapy staff or others to discuss and evaluate patient information for planning, modifying, or coordinating treatment."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "psychiatric_aides",
    "onet_code": "31-1133.00",
    "title": "Psychiatric Aides",
    "category": "Healthcare Support",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "communication",
      "healthcare_support",
      "leadership"
    ],
    "salary": {
      "entry_min": 23115,
      "entry_max": 30821,
      "mid_min": 30821,
      "mid_max": 40067
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-2053.00",
      "31-2022.00",
      "31-2012.00"
    ],
    "training_paths": [],
    "description": "Assist mentally impaired or emotionally disturbed patients, working under direction of nursing and medical staff. May assist with daily living activities, lead patients in educational and recreational activities, or accompany patients to and from examinations and treatments. May restrain violent patients. Includes psychiatric orderlies.",
    "dailyActivities": [
      "Listen and provide emotional support and encouragement to psychiatric patients.",
      "Provide patients with cognitive, intellectual, or developmental disabilities with routine physical, emotional, psychological, or rehabilitation care under the direction of nursing or medical staff.",
      "Complete physical checks and monitor patients to detect unusual or harmful behavior and report observations to professional staff.",
      "Restrain or aid patients as necessary to prevent injury.",
      "Work as part of a team that may include psychiatrists, psychologists, psychiatric nurses, or social workers.",
      "Record and maintain patient information, such as vital signs, eating habits, behavior, progress notes, treatments, or discharge plans."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "speech_language_pathology_assistants",
    "onet_code": "31-9099.01",
    "title": "Speech-Language Pathology Assistants",
    "category": "Healthcare Support",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "communication",
      "healthcare_support",
      "leadership"
    ],
    "salary": {
      "entry_min": 27195,
      "entry_max": 36260,
      "mid_min": 36260,
      "mid_max": 47138
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-1127.00",
      "31-2012.00",
      "31-2011.00"
    ],
    "training_paths": [],
    "description": "Assist speech-language pathologists in the assessment and treatment of speech, language, voice, and fluency disorders. Implement speech and language programs or activities as planned and directed by speech-language pathologists. Monitor the use of alternative communication devices and systems.",
    "dailyActivities": [
      "Document clients' progress toward meeting established treatment objectives.",
      "Implement treatment plans or protocols as directed by speech-language pathologists.",
      "Collect and compile data to document clients' performance or assess program quality.",
      "Perform support duties, such as preparing materials, keeping records, maintaining supplies, and scheduling activities.",
      "Assist speech-language pathologists in the remediation or development of speech and language skills.",
      "Select or prepare speech-language instructional materials."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "veterinary_assistants_and_laboratory_animal_caretakers",
    "onet_code": "31-9096.00",
    "title": "Veterinary Assistants and Laboratory Animal Caretakers",
    "category": "Healthcare Support",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "healthcare_support",
      "leadership"
    ],
    "salary": {
      "entry_min": 23115,
      "entry_max": 30821,
      "mid_min": 30821,
      "mid_max": 40067
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-2056.00",
      "39-2021.00",
      "31-9092.00"
    ],
    "training_paths": [],
    "description": "Feed, water, and examine pets and other nonfarm animals for signs of illness, disease, or injury in laboratories and animal hospitals and clinics. Clean and disinfect cages and work areas, and sterilize laboratory and surgical equipment. May provide routine postoperative care, administer medication orally or topically, or prepare samples for laboratory examination under the supervision of veterinary or laboratory animal technologists or technicians, veterinarians, or scientists.",
    "dailyActivities": [
      "Hold or restrain animals during veterinary procedures.",
      "Monitor animals recovering from surgery and notify veterinarians of any unusual changes or symptoms.",
      "Fill medication prescriptions.",
      "Clean and maintain kennels, animal holding areas, examination or operating rooms, or animal loading or unloading facilities to control the spread of disease.",
      "Examine animals to detect behavioral changes or clinical symptoms that could indicate illness or injury.",
      "Perform routine laboratory tests or diagnostic tests, such as taking or developing x-rays."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "computer_occupations_all_other",
    "onet_code": "15-1299.00",
    "title": "Computer Occupations, All Other",
    "category": "IT & Technology",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "it_technology"
    ],
    "salary": {
      "entry_min": 66567,
      "entry_max": 88757,
      "mid_min": 88757,
      "mid_max": 115384
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All computer occupations not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "computer_systems_analysts",
    "onet_code": "15-1211.00",
    "title": "Computer Systems Analysts",
    "category": "IT & Technology",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "it_technology",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 78315,
      "entry_max": 104420,
      "mid_min": 104420,
      "mid_max": 135746
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "15-1252.00",
      "15-1299.08",
      "15-1242.00"
    ],
    "training_paths": [],
    "description": "Analyze science, engineering, business, and other data processing problems to develop and implement solutions to complex applications problems, system administration issues, or network concerns. Perform systems management and integration functions, improve existing computer systems, and review computer system capabilities, workflow, and schedule limitations. May analyze or recommend commercially available software.",
    "dailyActivities": [
      "Troubleshoot program and system malfunctions to restore normal functioning.",
      "Provide staff and users with assistance solving computer-related problems, such as malfunctions and program problems.",
      "Test, maintain, and monitor computer programs and systems, including coordinating the installation of computer programs and systems.",
      "Use the computer in the analysis and solution of business problems, such as development of integrated production and inventory control and cost analysis systems.",
      "Coordinate and link the computer systems within an organization to increase compatibility so that information can be shared.",
      "Use object-oriented programming languages, as well as client and server applications development processes and multimedia and Internet technology."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "computer_systems_engineers_architects",
    "onet_code": "15-1299.08",
    "title": "Computer Systems Engineers/Architects",
    "category": "IT & Technology",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Science",
      "Critical Thinking",
      "Active Learning"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "it_technology",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 78315,
      "entry_max": 104420,
      "mid_min": 104420,
      "mid_max": 135746
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "15-1252.00",
      "15-1211.00",
      "15-1241.00"
    ],
    "training_paths": [],
    "description": "Design and develop solutions to complex applications problems, system administration issues, or network concerns. Perform systems management and integration functions.",
    "dailyActivities": [
      "Communicate with staff or clients to understand specific system requirements.",
      "Investigate system component suitability for specified purposes, and make recommendations regarding component use.",
      "Provide customers or installation teams guidelines for implementing secure systems.",
      "Direct the analysis, development, and operation of complete computer systems.",
      "Direct the installation of operating systems, network or application software, or computer or network hardware.",
      "Monitor system operation to detect potential problems."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "computer_user_support_specialists",
    "onet_code": "15-1232.00",
    "title": "Computer User Support Specialists",
    "category": "IT & Technology",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "it_technology",
      "communication"
    ],
    "salary": {
      "entry_min": 78315,
      "entry_max": 104420,
      "mid_min": 104420,
      "mid_max": 135746
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "15-1231.00",
      "15-1244.00",
      "15-1299.08"
    ],
    "training_paths": [],
    "description": "Provide technical assistance to computer users. Answer questions or resolve computer problems for clients in person, via telephone, or electronically. May provide assistance concerning the use of computer hardware and software, including printing, installation, word processing, electronic mail, and operating systems.",
    "dailyActivities": [
      "Oversee the daily performance of computer systems.",
      "Set up equipment for employee use, performing or ensuring proper installation of cables, operating systems, or appropriate software.",
      "Read technical manuals, confer with users, or conduct computer diagnostics to investigate and resolve problems or to provide technical assistance and support.",
      "Answer user inquiries regarding computer software or hardware operation to resolve problems.",
      "Install and perform minor repairs to hardware, software, or peripheral equipment, following design or installation specifications.",
      "Confer with staff, users, and management to establish requirements for new systems or modifications."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "military_mos_relevant": [
      "25B",
      "IT",
      "0621"
    ],
    "last_updated": new Date()
  },
  {
    "id": "geographic_information_systems_technologists_and_technicians",
    "onet_code": "15-1299.02",
    "title": "Geographic Information Systems Technologists and Technicians",
    "category": "IT & Technology",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "it_technology",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 78315,
      "entry_max": 104420,
      "mid_min": 104420,
      "mid_max": 135746
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "17-3031.00",
      "15-2051.00",
      "17-1021.00"
    ],
    "training_paths": [],
    "description": "Assist scientists or related professionals in building, maintaining, modifying, or using geographic information systems (GIS) databases. May also perform some custom application development or provide user support.",
    "dailyActivities": [
      "Produce data layers, maps, tables, or reports, using spatial analysis procedures or Geographic Information Systems (GIS) technology, equipment, or systems.",
      "Design or prepare graphic representations of Geographic Information Systems (GIS) data, using GIS hardware or software applications.",
      "Maintain or modify existing Geographic Information Systems (GIS) databases.",
      "Provide technical expertise in Geographic Information Systems (GIS) technology to clients or users.",
      "Perform computer programming, data analysis, or software development for Geographic Information Systems (GIS) applications, including the maintenance of existing systems or research and development for future enhancements.",
      "Enter data into Geographic Information Systems (GIS) databases, using techniques such as coordinate geometry, keyboard entry of tabular data, manual digitizing of maps, scanning or automatic conversion to vectors, or conversion of other sources of digital data."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "mathematical_science_occupations_all_other",
    "onet_code": "15-2099.00",
    "title": "Mathematical Science Occupations, All Other",
    "category": "IT & Technology",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "it_technology"
    ],
    "salary": {
      "entry_min": 66567,
      "entry_max": 88757,
      "mid_min": 88757,
      "mid_max": 115384
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All mathematical scientists not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "telecommunications_engineering_specialists",
    "onet_code": "15-1241.01",
    "title": "Telecommunications Engineering Specialists",
    "category": "IT & Technology",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "it_technology",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 78315,
      "entry_max": 104420,
      "mid_min": 104420,
      "mid_max": 135746
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "15-1241.00",
      "15-1231.00",
      "49-2022.00"
    ],
    "training_paths": [],
    "description": "Design or configure wired, wireless, and satellite communications systems for voice, video, and data services. Supervise installation, service, and maintenance.",
    "dailyActivities": [
      "Consult with users, administrators, and engineers to identify business and technical requirements for proposed system modifications or technology purchases.",
      "Implement system renovation projects in collaboration with technical staff, engineering consultants, installers, and vendors.",
      "Keep abreast of changes in industry practices and emerging telecommunications technology by reviewing current literature, talking with colleagues, participating in educational programs, attending meetings or workshops, or participating in professional organizations or conferences.",
      "Review and evaluate requests from engineers, managers, and technicians for system modifications.",
      "Assess existing facilities' needs for new or modified telecommunications systems.",
      "Develop, maintain, or implement telecommunications disaster recovery plans to ensure business continuity."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "web_developers",
    "onet_code": "15-1254.00",
    "title": "Web Developers",
    "category": "IT & Technology",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "it_technology",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 78315,
      "entry_max": 104420,
      "mid_min": 104420,
      "mid_max": 135746
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": true,
      "hybrid_available": true,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "15-1255.00",
      "15-1299.01",
      "15-1252.00"
    ],
    "training_paths": [],
    "description": "Develop and implement websites, web applications, application databases, and interactive web interfaces. Evaluate code to ensure that it is properly structured, meets industry standards, and is compatible with browsers and devices. Optimize website performance, scalability, and server-side code and processes. May develop website infrastructure and integrate websites with other computer applications.",
    "dailyActivities": [
      "Write supporting code for Web applications or Web sites.",
      "Design, build, or maintain Web sites, using authoring or scripting languages, content creation tools, management tools, and digital media.",
      "Back up files from Web sites to local directories for instant recovery in case of problems.",
      "Select programming languages, design tools, or applications.",
      "Evaluate code to ensure that it is valid, is properly structured, meets industry standards, and is compatible with browsers, devices, or operating systems.",
      "Develop databases that support Web applications and Web sites."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "aircraft_mechanics_and_service_technicians",
    "onet_code": "49-3011.00",
    "title": "Aircraft Mechanics and Service Technicians",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "technical",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-2091.00",
      "51-2011.00",
      "53-6032.00"
    ],
    "training_paths": [],
    "description": "Diagnose, adjust, repair, or overhaul aircraft engines and assemblies, such as hydraulic and pneumatic systems.",
    "dailyActivities": [
      "Inspect completed work to certify that maintenance meets standards and that aircraft are ready for operation.",
      "Read and interpret maintenance manuals, service bulletins, and other specifications to determine the feasibility and method of repairing or replacing malfunctioning or damaged components.",
      "Maintain repair logs, documenting all preventive and corrective aircraft maintenance.",
      "Examine and inspect aircraft components, including landing gear, hydraulic systems, and deicers to locate cracks, breaks, leaks, or other problems.",
      "Conduct routine and special inspections as required by regulations.",
      "Replace or repair worn, defective, or damaged components, using hand tools, gauges, and testing equipment."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "military_mos_relevant": [
      "2A6X1"
    ],
    "last_updated": new Date()
  },
  {
    "id": "audiovisual_equipment_installers_and_repairers",
    "onet_code": "49-2097.00",
    "title": "Audiovisual Equipment Installers and Repairers",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Service Orientation",
      "Complex Problem Solving",
      "Installation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "problem_solving",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-2022.00",
      "49-2021.00",
      "49-9052.00"
    ],
    "training_paths": [],
    "description": "Install, repair, or adjust audio or television receivers, stereo systems, camcorders, video systems, or other electronic entertainment equipment in homes or other venues. May perform routine maintenance.",
    "dailyActivities": [
      "Install, service, and repair electronic equipment or instruments such as televisions, radios, and videocassette recorders.",
      "Calibrate and test equipment, and locate circuit and component faults, using hand and power tools and measuring and testing instruments such as resistance meters and oscilloscopes.",
      "Confer with customers to determine the nature of problems or to explain repairs.",
      "Position or mount speakers, and wire speakers to consoles.",
      "Instruct customers on the safe and proper use of equipment.",
      "Make service calls to repair units in customers' homes, or return units to shops for major repairs."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "automotive_body_and_related_repairers",
    "onet_code": "49-3021.00",
    "title": "Automotive Body and Related Repairers",
    "category": "Installation & Repair",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Critical Thinking",
      "Complex Problem Solving",
      "Operation and Control",
      "Troubleshooting",
      "Repairing",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Inductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "technical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 32295,
      "entry_max": 43061,
      "mid_min": 43061,
      "mid_max": 55979
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-3023.00",
      "49-3043.00",
      "51-9197.00"
    ],
    "training_paths": [],
    "description": "Repair and refinish automotive vehicle bodies and straighten vehicle frames.",
    "dailyActivities": [
      "File, grind, sand, and smooth filled or repaired surfaces, using power tools and hand tools.",
      "Inspect repaired vehicles for proper functioning, completion of work, dimensional accuracy, and overall appearance of paint job, and test-drive vehicles to ensure proper alignment and handling.",
      "Fit and weld replacement parts into place, using wrenches and welding equipment, and grind down welds to smooth them, using power grinders and other tools.",
      "Prime and paint repaired surfaces, using paint sprayguns and motorized sanders.",
      "Follow supervisors' instructions as to which parts to restore or replace and how much time the job should take.",
      "Sand body areas to be painted and cover bumpers, windows, and trim with masking tape or paper to protect them from the paint."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "automotive_glass_installers_and_repairers",
    "onet_code": "49-3022.00",
    "title": "Automotive Glass Installers and Repairers",
    "category": "Installation & Repair",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Time Management"
    ],
    "niceToHave": [
      "Visualization",
      "Arm-Hand Steadiness",
      "Manual Dexterity",
      "Finger Dexterity",
      "Control Precision"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "physical",
      "installation_repair",
      "communication"
    ],
    "salary": {
      "entry_min": 32295,
      "entry_max": 43061,
      "mid_min": 43061,
      "mid_max": 55979
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2121.00",
      "49-3021.00",
      "49-3023.00"
    ],
    "training_paths": [],
    "description": "Replace or repair broken windshields and window glass in motor vehicles.",
    "dailyActivities": [
      "Prime all scratches on pinchwelds with primer and allow to dry.",
      "Remove all dirt, foreign matter, and loose glass from damaged areas, apply primer along windshield or window edges, and allow primer to dry.",
      "Allow all glass parts installed with urethane ample time to cure, taking temperature and humidity into account.",
      "Apply a bead of urethane around the perimeter of each pinchweld and dress the remaining urethane on the pinchwelds so that it is of uniform level and thickness.",
      "Select appropriate tools, safety equipment, and parts, according to job requirements.",
      "Install replacement glass in vehicles."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "automotive_service_technicians_and_mechanics",
    "onet_code": "49-3023.00",
    "title": "Automotive Service Technicians and Mechanics",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Critical Thinking",
      "Complex Problem Solving",
      "Installation",
      "Operations Monitoring",
      "Equipment Maintenance",
      "Troubleshooting",
      "Repairing",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "technical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-3043.00",
      "49-3031.00",
      "49-2092.00"
    ],
    "training_paths": [],
    "description": "Diagnose, adjust, repair, or overhaul automotive vehicles.",
    "dailyActivities": [
      "Inspect vehicles for damage and record findings so that necessary repairs can be made.",
      "Test drive vehicles and test components and systems, using equipment such as infrared engine analyzers, compression gauges, and computerized diagnostic devices.",
      "Test and adjust repaired systems to meet manufacturers' performance specifications.",
      "Repair, reline, replace, and adjust brakes.",
      "Review work orders and discuss work with supervisors.",
      "Estimate costs of vehicle repair."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "military_mos_relevant": [
      "91B"
    ],
    "last_updated": new Date()
  },
  {
    "id": "avionics_technicians",
    "onet_code": "49-2091.00",
    "title": "Avionics Technicians",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "technical",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "17-3021.00",
      "49-3011.00",
      "17-3024.00"
    ],
    "training_paths": [],
    "description": "Install, inspect, test, adjust, or repair avionics equipment, such as radar, radio, navigation, and missile control systems in aircraft or space vehicles.",
    "dailyActivities": [
      "Test and troubleshoot instruments, components, and assemblies, using circuit testers, oscilloscopes, or voltmeters.",
      "Keep records of maintenance and repair work.",
      "Adjust, repair, or replace malfunctioning components or assemblies, using hand tools or soldering irons.",
      "Install electrical and electronic components, assemblies, and systems in aircraft, using hand tools, power tools, or soldering irons.",
      "Set up and operate ground support and test equipment to perform functional flight tests of electrical and electronic systems.",
      "Assemble components such as switches, electrical controls, and junction boxes, using hand tools or soldering irons."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "bicycle_repairers",
    "onet_code": "49-3091.00",
    "title": "Bicycle Repairers",
    "category": "Installation & Repair",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Social Perceptiveness",
      "Service Orientation",
      "Complex Problem Solving",
      "Troubleshooting"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Information Ordering"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 32295,
      "entry_max": 43061,
      "mid_min": 43061,
      "mid_max": 55979
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-3052.00",
      "49-3093.00",
      "49-3053.00"
    ],
    "training_paths": [],
    "description": "Repair and service bicycles.",
    "dailyActivities": [
      "Install and adjust brakes and brake pads.",
      "Help customers select bicycles that fit their body sizes and intended bicycle uses.",
      "Align wheels.",
      "Assemble new bicycles.",
      "Sell bicycles and accessories.",
      "Install, repair, and replace equipment or accessories, such as handlebars, stands, lights, and seats."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "bus_and_truck_mechanics_and_diesel_engine_specialists",
    "onet_code": "49-3031.00",
    "title": "Bus and Truck Mechanics and Diesel Engine Specialists",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Complex Problem Solving",
      "Equipment Selection",
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "technical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-3042.00",
      "49-3043.00",
      "49-3023.00"
    ],
    "training_paths": [],
    "description": "Diagnose, adjust, repair, or overhaul buses and trucks, or maintain and repair any type of diesel engines. Includes mechanics working primarily with automobile or marine diesel engines.",
    "dailyActivities": [
      "Use handtools, such as screwdrivers, pliers, wrenches, pressure gauges, or precision instruments, as well as power tools, such as pneumatic wrenches, lathes, welding equipment, or jacks and hoists.",
      "Inspect brake systems, steering mechanisms, wheel bearings, and other important parts to ensure that they are in proper operating condition.",
      "Raise trucks, buses, and heavy parts or equipment using hydraulic jacks or hoists.",
      "Adjust and reline brakes, align wheels, tighten bolts and screws, and reassemble equipment.",
      "Attach test instruments to equipment, and read dials and gauges to diagnose malfunctions.",
      "Perform routine maintenance such as changing oil, checking batteries, and lubricating equipment and machinery."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "military_mos_relevant": [
      "91B"
    ],
    "last_updated": new Date()
  },
  {
    "id": "camera_and_photographic_equipment_repairers",
    "onet_code": "49-9061.00",
    "title": "Camera and Photographic Equipment Repairers",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Complex Problem Solving",
      "Equipment Selection"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "installation_repair",
      "physical",
      "technical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9151.00",
      "17-3028.00",
      "39-3021.00"
    ],
    "training_paths": [],
    "description": "Repair and adjust cameras and photographic equipment, including commercial video and motion picture camera equipment.",
    "dailyActivities": [
      "Adjust cameras, photographic mechanisms, or equipment such as range and view finders, shutters, light meters, or lens systems, using hand tools.",
      "Disassemble equipment to gain access to defect, using hand tools.",
      "Test equipment performance, focus of lens system, diaphragm alignment, lens mounts, or film transport, using precision gauges.",
      "Clean and lubricate cameras and polish camera lenses, using cleaning materials and work aids.",
      "Requisition parts or materials.",
      "Calibrate and verify accuracy of light meters, shutter diaphragm operation, or lens carriers, using timing instruments."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "coin_vending_and_amusement_machine_servicers_and_repairers",
    "onet_code": "49-9091.00",
    "title": "Coin, Vending, and Amusement Machine Servicers and Repairers",
    "category": "Installation & Repair",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance",
      "Troubleshooting",
      "Repairing"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "physical",
      "installation_repair",
      "technical"
    ],
    "salary": {
      "entry_min": 32295,
      "entry_max": 43061,
      "mid_min": 43061,
      "mid_max": 55979
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-2011.00",
      "51-9196.00",
      "49-9041.00"
    ],
    "training_paths": [],
    "description": "Install, service, adjust, or repair coin, vending, or amusement machines including video games, juke boxes, pinball machines, or slot machines.",
    "dailyActivities": [
      "Fill machines with products, ingredients, money, and other supplies.",
      "Inspect machines and meters to determine causes of malfunctions and fix minor problems such as jammed bills or stuck products.",
      "Test machines to determine proper functioning.",
      "Replace malfunctioning parts, such as worn magnetic heads on automatic teller machine (ATM) card readers.",
      "Maintain records of machine maintenance and repair.",
      "Clean and oil machine parts."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "commercial_divers",
    "onet_code": "49-9092.00",
    "title": "Commercial Divers",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-9096.00",
      "47-2152.00",
      "53-5031.00"
    ],
    "training_paths": [],
    "description": "Work below surface of water, using surface-supplied air or scuba equipment to inspect, repair, remove, or install equipment and structures. May use a variety of power and hand tools, such as drills, sledgehammers, torches, and welding equipment. May conduct tests or experiments, rig explosives, or photograph structures or marine life.",
    "dailyActivities": [
      "Take appropriate safety precautions, such as monitoring dive lengths and depths and registering with authorities before diving expeditions begin.",
      "Check and maintain diving equipment, such as helmets, masks, air tanks, harnesses, or gauges.",
      "Communicate with workers on the surface while underwater, using signal lines or telephones.",
      "Descend into water with the aid of diver helpers, using scuba gear or diving suits.",
      "Obtain information about diving tasks and environmental conditions.",
      "Supervise or train other divers, including hobby divers."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "computer_automated_teller_and_office_machine_repairers",
    "onet_code": "49-2011.00",
    "title": "Computer, Automated Teller, and Office Machine Repairers",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "installation_repair",
      "physical",
      "technical",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-2094.00",
      "17-3028.00",
      "49-2022.00"
    ],
    "training_paths": [],
    "description": "Repair, maintain, or install computers, word processing systems, automated teller machines, and electronic office machines, such as duplicating and fax machines.",
    "dailyActivities": [
      "Reassemble machines after making repairs or replacing parts.",
      "Converse with customers to determine details of equipment problems.",
      "Disassemble machines to examine parts, such as wires, gears, or bearings for wear or defects, using hand or power tools and measuring devices.",
      "Advise customers concerning equipment operation, maintenance, or programming.",
      "Align, adjust, or calibrate equipment according to specifications.",
      "Repair, adjust, or replace electrical or mechanical components or parts, using hand tools, power tools, or soldering or welding equipment."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "control_and_valve_installers_and_repairers_except_mechanical_door",
    "onet_code": "49-9012.00",
    "title": "Control and Valve Installers and Repairers, Except Mechanical Door",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Coordination",
      "Complex Problem Solving",
      "Operations Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-2092.00",
      "49-9041.00",
      "51-2031.00"
    ],
    "training_paths": [],
    "description": "Install, repair, and maintain mechanical regulating and controlling devices, such as electric meters, gas regulators, thermostats, safety and flow valves, and other mechanical governors.",
    "dailyActivities": [
      "Record maintenance information, including test results, material usage, and repairs made.",
      "Disassemble and repair mechanical control devices or valves, such as regulators, thermostats, or hydrants, using power tools, hand tools, and cutting torches.",
      "Lubricate wearing surfaces of mechanical parts, using oils or other lubricants.",
      "Calibrate instrumentation, such as meters, gauges, and regulators, for pressure, temperature, flow, and level.",
      "Install, inspect and test electric meters, relays, and power sources to detect causes of malfunctions and inaccuracies, using hand tools and testing equipment.",
      "Test valves and regulators for leaks and accurate temperature and pressure settings, using precision testing equipment."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "electric_motor_power_tool_and_related_repairers",
    "onet_code": "49-2092.00",
    "title": "Electric Motor, Power Tool, and Related Repairers",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Complex Problem Solving",
      "Equipment Selection"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "technical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-2031.00",
      "51-2022.00",
      "49-9041.00"
    ],
    "training_paths": [],
    "description": "Repair, maintain, or install electric motors, wiring, or switches.",
    "dailyActivities": [
      "Inspect and test equipment to locate damage or worn parts and diagnose malfunctions, or read work orders or schematic drawings to determine required repairs.",
      "Reassemble repaired electric motors to specified requirements and ratings, using hand tools and electrical meters.",
      "Measure velocity, horsepower, revolutions per minute (rpm), amperage, circuitry, and voltage of units or parts to diagnose problems, using ammeters, voltmeters, wattmeters, and other testing devices.",
      "Repair and rebuild defective mechanical parts in electric motors, generators, and related equipment, using hand tools and power tools.",
      "Lift units or parts such as motors or generators, using cranes or chain hoists, or signal crane operators to lift heavy parts or subassemblies.",
      "Record repairs required, parts used, and labor time."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "electrical_power_line_installers_and_repairers",
    "onet_code": "49-9051.00",
    "title": "Electrical Power-Line Installers and Repairers",
    "category": "Installation & Repair",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Coordination",
      "Complex Problem Solving",
      "Operations Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Information Ordering"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 32295,
      "entry_max": 43061,
      "mid_min": 43061,
      "mid_max": 55979
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-9052.00",
      "47-3013.00",
      "47-2111.00"
    ],
    "training_paths": [],
    "description": "Install or repair cables or wires used in electrical power or distribution systems. May erect poles and light or heavy duty transmission towers.",
    "dailyActivities": [
      "Adhere to safety practices and procedures, such as checking equipment regularly and erecting barriers around work areas.",
      "Drive vehicles equipped with tools and materials to job sites.",
      "Open switches or attach grounding devices to remove electrical hazards from disturbed or fallen lines or to facilitate repairs.",
      "Climb poles or use truck-mounted buckets to access equipment.",
      "Install, maintain, and repair electrical distribution and transmission systems, including conduits, cables, wires, and related equipment, such as transformers, circuit breakers, and switches.",
      "Inspect and test power lines and auxiliary equipment to locate and identify problems, using reading and testing instruments."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "electrical_and_electronics_installers_and_repairers_transportation_equipment",
    "onet_code": "49-2093.00",
    "title": "Electrical and Electronics Installers and Repairers, Transportation Equipment",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Social Perceptiveness",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-2094.00",
      "17-3023.00",
      "49-2091.00"
    ],
    "training_paths": [],
    "description": "Install, adjust, or maintain mobile electronics communication equipment, including sound, sonar, security, navigation, and surveillance systems on trains, watercraft, or other mobile equipment.",
    "dailyActivities": [
      "Inspect and test electrical systems and equipment to locate and diagnose malfunctions, using visual inspections, testing devices, and computer software.",
      "Reassemble and test equipment after repairs.",
      "Adjust, repair, or replace defective wiring and relays in ignition, lighting, air-conditioning, and safety control systems, using electrician's tools.",
      "Splice wires with knives or cutting pliers, and solder connections to fixtures, outlets, and equipment.",
      "Locate and remove or repair circuit defects such as blown fuses or malfunctioning transistors.",
      "Maintain equipment service records."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "electrical_and_electronics_repairers_commercial_and_industrial_equipment",
    "onet_code": "49-2094.00",
    "title": "Electrical and Electronics Repairers, Commercial and Industrial Equipment",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "technical",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "17-3028.00",
      "17-3023.00",
      "49-2093.00"
    ],
    "training_paths": [],
    "description": "Repair, test, adjust, or install electronic equipment, such as industrial controls, transmitters, and antennas.",
    "dailyActivities": [
      "Test faulty equipment to diagnose malfunctions, using test equipment or software, and applying knowledge of the functional operation of electronic units and systems.",
      "Maintain equipment logs that record performance problems, repairs, calibrations, or tests.",
      "Set up and test industrial equipment to ensure that it functions properly.",
      "Inspect components of industrial equipment for accurate assembly and installation or for defects, such as loose connections or frayed wires.",
      "Install repaired equipment in various settings, such as industrial or military establishments.",
      "Operate equipment to demonstrate proper use or to analyze malfunctions."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "military_mos_relevant": [
      "ET"
    ],
    "last_updated": new Date()
  },
  {
    "id": "electrical_and_electronics_repairers_powerhouse_substation_and_relay",
    "onet_code": "49-2095.00",
    "title": "Electrical and Electronics Repairers, Powerhouse, Substation, and Relay",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Coordination",
      "Complex Problem Solving"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Originality"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-2094.00",
      "49-9012.00",
      "49-2093.00"
    ],
    "training_paths": [],
    "description": "Inspect, test, repair, or maintain electrical equipment in generating stations, substations, and in-service relays.",
    "dailyActivities": [
      "Inspect and test equipment and circuits to identify malfunctions or defects, using wiring diagrams and testing devices such as ohmmeters, voltmeters, or ammeters.",
      "Prepare and maintain records detailing tests, repairs, and maintenance.",
      "Consult manuals, schematics, wiring diagrams, and engineering personnel to troubleshoot and solve equipment problems and to determine optimum equipment functioning.",
      "Analyze test data to diagnose malfunctions, to determine performance characteristics of systems, or to evaluate effects of system modifications.",
      "Open and close switches to isolate defective relays, performing adjustments or repairs.",
      "Notify facility personnel of equipment shutdowns."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "electronic_equipment_installers_and_repairers_motor_vehicles",
    "onet_code": "49-2096.00",
    "title": "Electronic Equipment Installers and Repairers, Motor Vehicles",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Coordination",
      "Complex Problem Solving",
      "Installation",
      "Operations Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-2093.00",
      "49-2092.00",
      "49-2094.00"
    ],
    "training_paths": [],
    "description": "Install, diagnose, or repair communications, sound, security, or navigation equipment in motor vehicles.",
    "dailyActivities": [
      "Install equipment and accessories, such as stereos, navigation equipment, communication equipment, and security systems.",
      "Inspect and test electrical or electronic systems to locate and diagnose malfunctions, using visual inspections and testing instruments, such as oscilloscopes and voltmeters.",
      "Cut openings and drill holes for fixtures and equipment, using electric drills and routers.",
      "Splice wires with knives or cutting pliers, and solder connections to fixtures and equipment.",
      "Diagnose or repair problems with electronic equipment, such as sound, navigation, communication, and security equipment, in motor vehicles.",
      "Run new speaker and electrical cables."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "farm_equipment_mechanics_and_service_technicians",
    "onet_code": "49-3041.00",
    "title": "Farm Equipment Mechanics and Service Technicians",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Complex Problem Solving",
      "Equipment Selection",
      "Operations Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "technical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-3042.00",
      "49-9041.00",
      "49-3053.00"
    ],
    "training_paths": [],
    "description": "Diagnose, adjust, repair, or overhaul farm machinery and vehicles, such as tractors, harvesters, dairy equipment, and irrigation systems.",
    "dailyActivities": [
      "Reassemble machines and equipment following repair, testing operation and making adjustments, as necessary.",
      "Maintain, repair, and overhaul farm machinery and vehicles, such as tractors, harvesters, and irrigation systems.",
      "Examine and listen to equipment, read inspection reports, and confer with customers to locate and diagnose malfunctions.",
      "Record details of repairs made and parts used.",
      "Dismantle defective machines for repair, using hand tools.",
      "Clean and lubricate parts."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "first_line_supervisors_of_mechanics_installers_and_repairers",
    "onet_code": "49-1011.00",
    "title": "First-Line Supervisors of Mechanics, Installers, and Repairers",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "installation_repair",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-1011.00",
      "47-1011.00",
      "53-1042.00"
    ],
    "training_paths": [],
    "description": "Directly supervise and coordinate the activities of mechanics, installers, and repairers. May also advise customers on recommended services. Excludes team or work leaders.",
    "dailyActivities": [
      "Inspect, test, and measure completed work, using devices such as hand tools or gauges to verify conformance to standards or repair requirements.",
      "Inspect and monitor work areas, examine tools and equipment, and provide employee safety training to prevent, detect, and correct unsafe conditions or violations of procedures and safety rules.",
      "Interpret specifications, blueprints, or job orders to construct templates and lay out reference points for workers.",
      "Monitor employees' work levels and review work performance.",
      "Perform skilled repair or maintenance operations, using equipment such as hand or power tools, hydraulic presses or shears, or welding equipment.",
      "Compute estimates and actual costs of factors such as materials, labor, or outside contractors."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "geothermal_technicians",
    "onet_code": "49-9099.01",
    "title": "Geothermal Technicians",
    "category": "Installation & Repair",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "installation_repair",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 32295,
      "entry_max": 43061,
      "mid_min": 43061,
      "mid_max": 55979
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-8013.04",
      "11-3051.02",
      "51-8013.00"
    ],
    "training_paths": [],
    "description": "Perform technical activities at power plants or individual installations necessary for the generation of power from geothermal energy sources. Monitor and control operating activities at geothermal power generation facilities and perform maintenance and repairs as necessary. Install, test, and maintain residential and commercial geothermal heat pumps.",
    "dailyActivities": [
      "Monitor and adjust operations of geothermal power plant equipment or systems.",
      "Prepare and maintain logs, reports, or other documentation of work performed.",
      "Identify and correct malfunctions of geothermal plant equipment, electrical systems, instrumentation, or controls.",
      "Collect and record data associated with operating geothermal power plants or well fields.",
      "Determine whether emergency or auxiliary systems will be needed to keep properties heated or cooled in extreme weather conditions.",
      "Perform pre- and post-installation pressure, flow, and related tests of vertical and horizontal geothermal loop piping."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "heating_air_conditioning_and_refrigeration_mechanics_and_installers",
    "onet_code": "49-9021.00",
    "title": "Heating, Air Conditioning, and Refrigeration Mechanics and Installers",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Coordination",
      "Complex Problem Solving",
      "Equipment Selection",
      "Installation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "technical",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-8021.00",
      "47-2152.00",
      "49-9012.00"
    ],
    "training_paths": [],
    "description": "Install or repair heating, central air conditioning, HVAC, or refrigeration systems, including oil burners, hot-air furnaces, and heating stoves.",
    "dailyActivities": [
      "Test electrical circuits or components for continuity, using electrical test equipment.",
      "Comply with all applicable standards, policies, or procedures, such as safety procedures or the maintenance of a clean work area.",
      "Study blueprints, design specifications, or manufacturers' recommendations to ascertain the configuration of heating or cooling equipment components and to ensure the proper installation of components.",
      "Discuss heating or cooling system malfunctions with users to isolate problems or to verify that repairs corrected malfunctions.",
      "Connect heating or air conditioning equipment to fuel, water, or refrigerant source to form complete circuit.",
      "Adjust system controls to settings recommended by manufacturer to balance system."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "helpers_installation_maintenance_and_repair_workers",
    "onet_code": "49-9098.00",
    "title": "Helpers--Installation, Maintenance, and Repair Workers",
    "category": "Installation & Repair",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance",
      "Troubleshooting",
      "Repairing",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Visualization",
      "Selective Attention",
      "Arm-Hand Steadiness",
      "Manual Dexterity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 32295,
      "entry_max": 43061,
      "mid_min": 43061,
      "mid_max": 55979
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9198.00",
      "47-3015.00",
      "47-3013.00"
    ],
    "training_paths": [],
    "description": "Help installation, maintenance, and repair workers in maintenance, parts replacement, and repair of vehicles, industrial machinery, and electrical and electronic equipment. Perform duties such as furnishing tools, materials, and supplies to other workers; cleaning work area, machines, and tools; and holding materials or tools for other workers.",
    "dailyActivities": [
      "Install or replace machinery, equipment, and new or replacement parts and instruments, using hand or power tools.",
      "Examine and test machinery, equipment, components, and parts for defects to ensure proper functioning.",
      "Tend and observe equipment and machinery to verify efficient and safe operation.",
      "Adjust, connect, or disconnect wiring, piping, tubing, and other parts, using hand or power tools.",
      "Clean or lubricate vehicles, machinery, equipment, instruments, tools, work areas, and other objects, using hand tools, power tools, and cleaning equipment.",
      "Hold or supply tools, parts, equipment, and supplies for other workers."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "home_appliance_repairers",
    "onet_code": "49-9031.00",
    "title": "Home Appliance Repairers",
    "category": "Installation & Repair",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Complex Problem Solving",
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance",
      "Troubleshooting"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "technical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 32295,
      "entry_max": 43061,
      "mid_min": 43061,
      "mid_max": 55979
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-9021.00",
      "49-2092.00",
      "49-9041.00"
    ],
    "training_paths": [],
    "description": "Repair, adjust, or install all types of electric or gas household appliances, such as refrigerators, washers, dryers, and ovens.",
    "dailyActivities": [
      "Bill customers for repair work, and collect payment.",
      "Observe and examine appliances during operation to detect specific malfunctions such as loose parts or leaking fluid.",
      "Talk to customers or refer to work orders to establish the nature of appliance malfunctions.",
      "Refer to schematic drawings, product manuals, and troubleshooting guides to diagnose and repair problems.",
      "Trace electrical circuits, following diagrams, and conduct tests with circuit testers and other equipment to locate shorts and grounds.",
      "Replace worn and defective parts such as switches, bearings, transmissions, belts, gears, circuit boards, or defective wiring."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "industrial_machinery_mechanics",
    "onet_code": "49-9041.00",
    "title": "Industrial Machinery Mechanics",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Coordination",
      "Complex Problem Solving"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "technical",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-9043.00",
      "49-2092.00",
      "51-4081.00"
    ],
    "training_paths": [],
    "description": "Repair, install, adjust, or maintain industrial production and processing machinery or refinery and pipeline distribution systems. May also install, dismantle, or move machinery and heavy equipment according to plans.",
    "dailyActivities": [
      "Repair or maintain the operating condition of industrial production or processing machinery or equipment.",
      "Repair or replace broken or malfunctioning components of machinery or equipment.",
      "Clean, lubricate, or adjust parts, equipment, or machinery.",
      "Disassemble machinery or equipment to remove parts and make repairs.",
      "Reassemble equipment after completion of inspections, testing, or repairs.",
      "Examine parts for defects, such as breakage or excessive wear."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "installation_maintenance_and_repair_workers_all_other",
    "onet_code": "49-9099.00",
    "title": "Installation, Maintenance, and Repair Workers, All Other",
    "category": "Installation & Repair",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "installation_repair"
    ],
    "salary": {
      "entry_min": 32295,
      "entry_max": 43061,
      "mid_min": 43061,
      "mid_max": 55979
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All installation, maintenance, and repair workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "locksmiths_and_safe_repairers",
    "onet_code": "49-9094.00",
    "title": "Locksmiths and Safe Repairers",
    "category": "Installation & Repair",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Operation and Control",
      "Troubleshooting",
      "Repairing",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "technical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 32295,
      "entry_max": 43061,
      "mid_min": 43061,
      "mid_max": 55979
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-9011.00",
      "49-9098.00",
      "47-4021.00"
    ],
    "training_paths": [],
    "description": "Repair and open locks, make keys, change locks and safe combinations, and install and repair safes.",
    "dailyActivities": [
      "Cut new or duplicate keys, using impressions or code key machines.",
      "Insert new or repaired tumblers into locks to change combinations.",
      "Move picklocks in cylinders to open door locks without keys.",
      "Cut new or duplicate keys, using key cutting machines.",
      "Open safe locks by drilling.",
      "Set up and maintain master key systems."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "maintenance_workers_machinery",
    "onet_code": "49-9043.00",
    "title": "Maintenance Workers, Machinery",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Critical Thinking",
      "Coordination",
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance",
      "Troubleshooting"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-9041.00",
      "51-4033.00",
      "49-2092.00"
    ],
    "training_paths": [],
    "description": "Lubricate machinery, change parts, or perform other routine machinery maintenance.",
    "dailyActivities": [
      "Dismantle machines and remove parts for repair, using hand tools, chain falls, jacks, cranes, or hoists.",
      "Reassemble machines after the completion of repair or maintenance work.",
      "Record production, repair, and machine maintenance information.",
      "Lubricate or apply adhesives or other materials to machines, machine parts, or other equipment according to specified procedures.",
      "Install, replace, or change machine parts and attachments, according to production specifications.",
      "Set up and operate machines, and adjust controls to regulate operations."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "maintenance_and_repair_workers_general",
    "onet_code": "49-9071.00",
    "title": "Maintenance and Repair Workers, General",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Coordination",
      "Complex Problem Solving"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "technical",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-9044.00",
      "51-2011.00",
      "47-2152.00"
    ],
    "training_paths": [],
    "description": "Perform work involving the skills of two or more maintenance or craft occupations to keep machines, mechanical equipment, or the structure of a building in repair. Duties may involve pipe fitting; HVAC maintenance; insulating; welding; machining; carpentry; repairing electrical or mechanical equipment; installing, aligning, and balancing new equipment; and repairing buildings, floors, or stairs.",
    "dailyActivities": [
      "Perform routine maintenance, such as inspecting drives, motors, or belts, checking fluid levels, replacing filters, or doing other preventive maintenance actions.",
      "Inspect, operate, or test machinery or equipment to diagnose machine malfunctions.",
      "Adjust functional parts of devices or control instruments, using hand tools, levels, plumb bobs, or straightedges.",
      "Repair machines, equipment, or structures, using tools such as hammers, hoists, saws, drills, wrenches, or equipment such as precision measuring instruments or electrical or electronic testing devices.",
      "Order parts, supplies, or equipment from catalogs or suppliers.",
      "Diagnose mechanical problems and determine how to correct them, checking blueprints, repair manuals, or parts catalogs, as necessary."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "manufactured_building_and_mobile_home_installers",
    "onet_code": "49-9095.00",
    "title": "Manufactured Building and Mobile Home Installers",
    "category": "Installation & Repair",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring",
      "Coordination",
      "Persuasion",
      "Instructing"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "technical",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 32295,
      "entry_max": 43061,
      "mid_min": 43061,
      "mid_max": 55979
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-2011.00",
      "47-2031.00",
      "49-9044.00"
    ],
    "training_paths": [],
    "description": "Move or install mobile homes or prefabricated buildings.",
    "dailyActivities": [
      "Seal open sides of modular units to prepare them for shipment, using polyethylene sheets, nails, and hammers.",
      "Move and set up mobile homes or prefabricated buildings on owners' lots or at mobile home parks.",
      "Inspect, examine, and test the operation of parts or systems to evaluate operating condition and to determine if repairs are needed.",
      "Connect water hoses to inlet pipes of plumbing systems, and test operation of plumbing fixtures.",
      "Remove damaged exterior panels, repair and replace structural frame members, and seal leaks, using hand tools.",
      "List parts needed, estimate costs, and plan work procedures, using parts lists, technical manuals, and diagrams."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "mechanical_door_repairers",
    "onet_code": "49-9011.00",
    "title": "Mechanical Door Repairers",
    "category": "Installation & Repair",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Troubleshooting",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Inductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "technical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 32295,
      "entry_max": 43061,
      "mid_min": 43061,
      "mid_max": 55979
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2121.00",
      "47-4021.00",
      "49-9094.00"
    ],
    "training_paths": [],
    "description": "Install, service, or repair automatic door mechanisms and hydraulic doors. Includes garage door mechanics.",
    "dailyActivities": [
      "Wind large springs with upward motion of arm.",
      "Adjust doors to open or close with the correct amount of effort, or make simple adjustments to electric openers.",
      "Carry springs to tops of doors, using ladders or scaffolding, and attach springs to tracks to install spring systems.",
      "Repair or replace worn or broken door parts, using hand tools.",
      "Complete required paperwork, such as work orders, according to services performed or required.",
      "Fasten angle iron back-hangers to ceilings and tracks, using fasteners or welding equipment."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "medical_equipment_repairers",
    "onet_code": "49-9062.00",
    "title": "Medical Equipment Repairers",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "installation_repair",
      "physical",
      "technical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "17-3028.00",
      "49-2094.00",
      "17-3023.00"
    ],
    "training_paths": [],
    "description": "Test, adjust, or repair biomedical or electromedical equipment.",
    "dailyActivities": [
      "Test or calibrate components or equipment, following manufacturers' manuals and troubleshooting techniques, using hand tools, power tools, or measuring devices.",
      "Perform preventive maintenance or service, such as cleaning, lubricating, or adjusting equipment.",
      "Inspect, test, or troubleshoot malfunctioning medical or related equipment, following manufacturers' specifications and using test and analysis instruments.",
      "Keep records of maintenance, repair, and required updates of equipment.",
      "Disassemble malfunctioning equipment and remove, repair, or replace defective parts, such as motors, clutches, or transformers.",
      "Examine medical equipment or facility's structural environment and check for proper use of equipment to protect patients and staff from electrical or mechanical hazards and to ensure compliance with safety regulations."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "millwrights",
    "onet_code": "49-9044.00",
    "title": "Millwrights",
    "category": "Installation & Repair",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Coordination",
      "Instructing",
      "Complex Problem Solving"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 32295,
      "entry_max": 43061,
      "mid_min": 43061,
      "mid_max": 55979
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-2011.00",
      "49-9071.00",
      "49-9041.00"
    ],
    "training_paths": [],
    "description": "Install, dismantle, or move machinery and heavy equipment according to layout plans, blueprints, or other drawings.",
    "dailyActivities": [
      "Replace defective parts of machine, or adjust clearances and alignment of moving parts.",
      "Align machines or equipment, using hoists, jacks, hand tools, squares, rules, micrometers, lasers, or plumb bobs.",
      "Insert shims, adjust tension on nuts and bolts, or position parts, using hand tools and measuring instruments, to set specified clearances between moving and stationary parts.",
      "Signal crane operator to lower basic assembly units to bedplate, and align unit to centerline.",
      "Conduct preventative maintenance and repair, and lubricate machines and equipment.",
      "Assemble and install equipment, using hand tools and power tools."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "mobile_heavy_equipment_mechanics_except_engines",
    "onet_code": "49-3042.00",
    "title": "Mobile Heavy Equipment Mechanics, Except Engines",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Coordination",
      "Instructing"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "technical",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-9041.00",
      "49-3031.00",
      "49-9043.00"
    ],
    "training_paths": [],
    "description": "Diagnose, adjust, repair, or overhaul mobile mechanical, hydraulic, and pneumatic equipment, such as cranes, bulldozers, graders, and conveyors, used in construction, logging, and mining.",
    "dailyActivities": [
      "Repair and replace damaged or worn parts.",
      "Test mechanical products and equipment after repair or assembly to ensure proper performance and compliance with manufacturers' specifications.",
      "Operate and inspect machines or heavy equipment to diagnose defects.",
      "Read and understand operating manuals, blueprints, and technical drawings.",
      "Dismantle and reassemble heavy equipment using hoists and hand tools.",
      "Overhaul and test machines or equipment to ensure operating efficiency."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "motorboat_mechanics_and_service_technicians",
    "onet_code": "49-3051.00",
    "title": "Motorboat Mechanics and Service Technicians",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Critical Thinking",
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance",
      "Troubleshooting",
      "Repairing"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Inductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "technical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-3031.00",
      "49-2092.00",
      "49-3052.00"
    ],
    "training_paths": [],
    "description": "Repair and adjust electrical and mechanical equipment of inboard or inboard-outboard boat engines.",
    "dailyActivities": [
      "Start motors and monitor performance for signs of malfunctioning, such as smoke, excessive vibration, or misfiring.",
      "Document inspection and test results and work performed or to be performed.",
      "Mount motors to boats, and operate boats at various speeds on waterways to conduct operational tests.",
      "Repair engine mechanical equipment, such as power tilts, bilge pumps, or power take-offs.",
      "Perform routine engine maintenance on motorboats, such as changing oil and filters.",
      "Replace parts, such as gears, magneto points, piston rings, or spark plugs, and reassemble engines."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "motorcycle_mechanics",
    "onet_code": "49-3052.00",
    "title": "Motorcycle Mechanics",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Coordination",
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Fluency of Ideas",
      "Originality",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-3091.00",
      "49-3051.00",
      "49-3023.00"
    ],
    "training_paths": [],
    "description": "Diagnose, adjust, repair, or overhaul motorcycles, scooters, mopeds, dirt bikes, or similar motorized vehicles.",
    "dailyActivities": [
      "Mount, balance, change, or check condition or pressure of tires.",
      "Replace defective parts, using hand tools, arbor presses, flexible power presses, or power tools.",
      "Dismantle engines and repair or replace defective parts, such as magnetos, carburetors, or generators.",
      "Connect test panels to engines and measure generator output, ignition timing, or other engine performance indicators.",
      "Listen to engines, examine vehicle frames, or confer with customers to determine nature and extent of malfunction or damage.",
      "Repair or replace other parts, such as headlights, horns, handlebar controls, gasoline or oil tanks, starters, or mufflers."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "musical_instrument_repairers_and_tuners",
    "onet_code": "49-9063.00",
    "title": "Musical Instrument Repairers and Tuners",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Complex Problem Solving",
      "Operations Monitoring",
      "Troubleshooting",
      "Repairing"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "technical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-2092.00",
      "51-2061.00",
      "49-9064.00"
    ],
    "training_paths": [],
    "description": "Repair percussion, stringed, reed, or wind instruments. May specialize in one area, such as piano tuning.",
    "dailyActivities": [
      "Adjust string tensions to tune instruments, using hand tools and electronic tuning devices.",
      "Compare instrument pitches with tuning tool pitches to tune instruments.",
      "Play instruments to evaluate their sound quality and to locate any defects.",
      "Disassemble instruments and parts for repair and adjustment.",
      "Repair or replace musical instrument parts and components, such as strings, bridges, felts, and keys, using hand and power tools.",
      "Reassemble instruments following repair, using hand tools and power tools and glue, hair, yarn, resin, or clamps, and lubricate instruments as necessary."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "outdoor_power_equipment_and_other_small_engine_mechanics",
    "onet_code": "49-3053.00",
    "title": "Outdoor Power Equipment and Other Small Engine Mechanics",
    "category": "Installation & Repair",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Critical Thinking",
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance",
      "Troubleshooting",
      "Repairing",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Inductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "installation_repair",
      "physical",
      "technical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 32295,
      "entry_max": 43061,
      "mid_min": 43061,
      "mid_max": 55979
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-2092.00",
      "49-3031.00",
      "49-3052.00"
    ],
    "training_paths": [],
    "description": "Diagnose, adjust, repair, or overhaul small engines used to power lawn mowers, chain saws, recreational sporting equipment, and related equipment.",
    "dailyActivities": [
      "Record repairs made, time spent, and parts used.",
      "Test and inspect engines to determine malfunctions, to locate missing and broken parts, and to verify repairs, using diagnostic instruments.",
      "Dismantle engines, using hand tools, and examine parts for defects.",
      "Repair and maintain gasoline engines used to power equipment such as portable saws, lawn mowers, generators, and compressors.",
      "Adjust points, valves, carburetors, distributors, and spark plug gaps, using feeler gauges.",
      "Repair or replace defective parts such as magnetos, water pumps, gears, pistons, and carburetors, using hand tools."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "precision_instrument_and_equipment_repairers_all_other",
    "onet_code": "49-9069.00",
    "title": "Precision Instrument and Equipment Repairers, All Other",
    "category": "Installation & Repair",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "installation_repair"
    ],
    "salary": {
      "entry_min": 32295,
      "entry_max": 43061,
      "mid_min": 43061,
      "mid_max": 55979
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All precision instrument and equipment repairers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "radio_cellular_and_tower_equipment_installers_and_repairers",
    "onet_code": "49-2021.00",
    "title": "Radio, Cellular, and Tower Equipment Installers and Repairers",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Coordination",
      "Installation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-2022.00",
      "49-9052.00",
      "49-2097.00"
    ],
    "training_paths": [],
    "description": "Repair, install, or maintain mobile or stationary radio transmitting, broadcasting, and receiving equipment, and two-way radio communications systems used in cellular telecommunications, mobile broadband, ship-to-shore, aircraft-to-ground communications, and radio equipment in service and emergency vehicles. May test and analyze network coverage.",
    "dailyActivities": [
      "Inspect completed work to ensure all hardware is tight, antennas are level, hangers are properly fastened, proper support is in place, or adequate weather proofing has been installed.",
      "Run appropriate power, ground, or coaxial cables.",
      "Test operation of tower transmission components, using sweep testing tools or software.",
      "Install all necessary transmission equipment components, including antennas or antenna mounts, surge arrestors, transmission lines, connectors, or tower-mounted amplifiers (TMAs).",
      "Read work orders, blueprints, plans, datasheets or site drawings to determine work to be done.",
      "Replace existing antennas with new antennas as directed."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "rail_car_repairers",
    "onet_code": "49-3043.00",
    "title": "Rail Car Repairers",
    "category": "Installation & Repair",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Critical Thinking",
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance",
      "Troubleshooting",
      "Repairing",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Inductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "installation_repair",
      "physical",
      "technical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 32295,
      "entry_max": 43061,
      "mid_min": 43061,
      "mid_max": 55979
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-3031.00",
      "49-3023.00",
      "49-3042.00"
    ],
    "training_paths": [],
    "description": "Diagnose, adjust, repair, or overhaul railroad rolling stock, mine cars, or mass transit rail cars.",
    "dailyActivities": [
      "Record conditions of cars, and repair and maintenance work performed or to be performed.",
      "Inspect components such as bearings, seals, gaskets, wheels, and coupler assemblies to determine if repairs are needed.",
      "Repair or replace defective or worn parts such as bearings, pistons, and gears, using hand tools, torque wrenches, power tools, and welding equipment.",
      "Inspect the interior and exterior of rail cars coming into rail yards to identify defects and to determine the extent of wear and damage.",
      "Remove locomotives, car mechanical units, or other components, using pneumatic hoists and jacks, pinch bars, hand tools, and cutting torches.",
      "Test units for operability before and after repairs."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "recreational_vehicle_service_technicians",
    "onet_code": "49-3092.00",
    "title": "Recreational Vehicle Service Technicians",
    "category": "Installation & Repair",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Service Orientation",
      "Complex Problem Solving"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "installation_repair",
      "physical",
      "problem_solving",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 32295,
      "entry_max": 43061,
      "mid_min": 43061,
      "mid_max": 55979
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-3031.00",
      "49-3051.00",
      "49-3052.00"
    ],
    "training_paths": [],
    "description": "Diagnose, inspect, adjust, repair, or overhaul recreational vehicles including travel trailers. May specialize in maintaining gas, electrical, hydraulic, plumbing, or chassis/towing systems as well as repairing generators, appliances, and interior components. Includes workers who perform customized van conversions.",
    "dailyActivities": [
      "Diagnose and repair furnace or air conditioning systems.",
      "Connect electrical systems to outside power sources, and activate switches to test the operation of appliances or light fixtures.",
      "Examine or test operation of parts or systems to ensure completeness of repairs.",
      "Repair plumbing or propane gas lines, using caulking compounds and plastic or copper pipe.",
      "Inspect recreational vehicles to diagnose problems and perform necessary adjustment, repair, or overhaul.",
      "Locate and repair frayed wiring, broken connections, or incorrect wiring, using ohmmeters, soldering irons, tape, or hand tools."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "refractory_materials_repairers_except_brickmasons",
    "onet_code": "49-9045.00",
    "title": "Refractory Materials Repairers, Except Brickmasons",
    "category": "Installation & Repair",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Critical Thinking",
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Deductive Reasoning",
      "Information Ordering"
    ],
    "keywords": [
      "analytical",
      "hands_on",
      "physical",
      "installation_repair",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 32295,
      "entry_max": 43061,
      "mid_min": 43061,
      "mid_max": 55979
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2021.00",
      "51-9195.00",
      "47-3011.00"
    ],
    "training_paths": [],
    "description": "Build or repair equipment such as furnaces, kilns, cupolas, boilers, converters, ladles, soaking pits, and ovens, using refractory materials.",
    "dailyActivities": [
      "Reline or repair ladles and pouring spouts with refractory clay, using trowels.",
      "Chip slag from linings of ladles or remove linings when beyond repair, using hammers and chisels.",
      "Mix specified amounts of sand, clay, mortar powder, and water to form refractory clay or mortar, using shovels or mixing machines.",
      "Measure furnace walls to determine dimensions and cut required number of sheets from plastic block, using saws.",
      "Dry and bake new linings by placing inverted linings over burners, building fires in ladles, or by using blowtorches.",
      "Remove worn or damaged plastic block refractory linings of furnaces, using hand tools."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "riggers",
    "onet_code": "49-9096.00",
    "title": "Riggers",
    "category": "Installation & Repair",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Critical Thinking",
      "Monitoring",
      "Coordination",
      "Complex Problem Solving",
      "Operations Monitoring",
      "Operation and Control",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Inductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "installation_repair",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 32295,
      "entry_max": 43061,
      "mid_min": 43061,
      "mid_max": 55979
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-7041.00",
      "53-7021.00",
      "49-3042.00"
    ],
    "training_paths": [],
    "description": "Set up or repair rigging for construction projects, manufacturing plants, logging yards, ships and shipyards, or for the entertainment industry.",
    "dailyActivities": [
      "Test rigging to ensure safety and reliability.",
      "Signal or verbally direct workers engaged in hoisting and moving loads to ensure safety of workers and materials.",
      "Control movement of heavy equipment through narrow openings or confined spaces, using chainfalls, gin poles, gallows frames, and other equipment.",
      "Tilt, dip, and turn suspended loads to maneuver over, under, or around obstacles, using multi-point suspension techniques.",
      "Select gear, such as cables, pulleys, and winches, according to load weights and sizes, facilities, and work schedules.",
      "Dismantle and store rigging equipment after use."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "security_and_fire_alarm_systems_installers",
    "onet_code": "49-2098.00",
    "title": "Security and Fire Alarm Systems Installers",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Complex Problem Solving",
      "Installation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "technical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "27-4015.00",
      "49-2096.00",
      "49-2093.00"
    ],
    "training_paths": [],
    "description": "Install, program, maintain, and repair security and fire alarm wiring and equipment. Ensure that work is in accordance with relevant codes.",
    "dailyActivities": [
      "Install, maintain, or repair security systems, alarm devices, or related equipment, following blueprints of electrical layouts and building plans.",
      "Mount and fasten control panels, door and window contacts, sensors, or video cameras, and attach electrical and telephone wiring to connect components.",
      "Demonstrate systems for customers and explain details, such as the causes and consequences of false alarms.",
      "Test and repair circuits and sensors, following wiring and system specifications.",
      "Feed cables through access holes, roof spaces, or cavity walls to reach fixture outlets, positioning and terminating cables, wires, or strapping.",
      "Examine systems to locate problems, such as loose connections or broken insulation."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "signal_and_track_switch_repairers",
    "onet_code": "49-9097.00",
    "title": "Signal and Track Switch Repairers",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Writing",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Complex Problem Solving",
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "technical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-2095.00",
      "49-9051.00",
      "49-2093.00"
    ],
    "training_paths": [],
    "description": "Install, inspect, test, maintain, or repair electric gate crossings, signals, signal equipment, track switches, section lines, or intercommunications systems within a railroad system.",
    "dailyActivities": [
      "Inspect and test operation, mechanical parts, and circuitry of gate crossings, signals, and signal equipment such as interlocks and hotbox detectors.",
      "Inspect electrical units of railroad grade crossing gates and repair loose bolts and defective electrical connections and parts.",
      "Test and repair track circuits.",
      "Drive motor vehicles to job sites.",
      "Install, inspect, maintain, and repair various railroad service equipment on the road or in the shop, including railroad signal systems.",
      "Tighten loose bolts, using wrenches, and test circuits and connections by opening and closing gates."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "telecommunications_equipment_installers_and_repairers_except_line_installers",
    "onet_code": "49-2022.00",
    "title": "Telecommunications Equipment Installers and Repairers, Except Line Installers",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-9052.00",
      "49-2021.00",
      "49-2094.00"
    ],
    "training_paths": [],
    "description": "Install, set up, rearrange, or remove switching, distribution, routing, and dialing equipment used in central offices or headends. Service or repair telephone, cable television, Internet, and other communications equipment on customers' property. May install communications equipment or communications wiring in buildings.",
    "dailyActivities": [
      "Demonstrate equipment to customers and explain its use, responding to any inquiries or complaints.",
      "Test circuits and components of malfunctioning telecommunications equipment to isolate sources of malfunctions, using test meters, circuit diagrams, polarity probes, and other hand tools.",
      "Test repaired, newly installed, or updated equipment to ensure that it functions properly and conforms to specifications, using test equipment and observation.",
      "Climb poles and ladders, use truck-mounted booms, and enter areas such as manholes and cable vaults to install, maintain, or inspect equipment.",
      "Assemble and install communication equipment such as data and telephone communication lines, wiring, switching equipment, wiring frames, power apparatus, computer systems, and networks.",
      "Run wires between components and to outside cable systems, connecting them to wires from telephone poles or underground cable accesses."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "telecommunications_line_installers_and_repairers",
    "onet_code": "49-9052.00",
    "title": "Telecommunications Line Installers and Repairers",
    "category": "Installation & Repair",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Critical Thinking",
      "Coordination",
      "Complex Problem Solving",
      "Operations Monitoring",
      "Operation and Control",
      "Troubleshooting"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "installation_repair",
      "physical",
      "technical",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 32295,
      "entry_max": 43061,
      "mid_min": 43061,
      "mid_max": 55979
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-2022.00",
      "49-9051.00",
      "49-2021.00"
    ],
    "training_paths": [],
    "description": "Install and repair telecommunications cable, including fiber optics.",
    "dailyActivities": [
      "Set up service for customers, installing, connecting, testing, or adjusting equipment.",
      "Travel to customers' premises to install, maintain, or repair audio and visual electronic reception equipment or accessories.",
      "Measure signal strength at utility poles, using electronic test equipment.",
      "Inspect or test lines or cables, recording and analyzing test results, to assess transmission characteristics and locate faults or malfunctions.",
      "Splice cables, using hand tools, epoxy, or mechanical equipment.",
      "Access specific areas to string lines, or install terminal boxes, auxiliary equipment, or appliances, using bucket trucks, climbing poles or ladders, or entering tunnels, trenches, or crawl spaces."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "tire_repairers_and_changers",
    "onet_code": "49-3093.00",
    "title": "Tire Repairers and Changers",
    "category": "Installation & Repair",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Manual Dexterity",
      "Finger Dexterity",
      "Control Precision"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "analytical",
      "physical",
      "installation_repair",
      "communication"
    ],
    "salary": {
      "entry_min": 32295,
      "entry_max": 43061,
      "mid_min": 43061,
      "mid_max": 55979
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9197.00",
      "49-3023.00",
      "49-3052.00"
    ],
    "training_paths": [],
    "description": "Repair and replace tires.",
    "dailyActivities": [
      "Raise vehicles, using hydraulic jacks.",
      "Remount wheels onto vehicles.",
      "Unbolt and remove wheels from vehicles, using lug wrenches or other hand or power tools.",
      "Place wheels on balancing machines to determine counterweights required to balance wheels.",
      "Identify tire size and ply and inflate tires accordingly.",
      "Replace valve stems and remove puncturing objects."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "watch_and_clock_repairers",
    "onet_code": "49-9064.00",
    "title": "Watch and Clock Repairers",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Critical Thinking",
      "Equipment Maintenance",
      "Troubleshooting",
      "Repairing",
      "Quality Control Analysis",
      "Judgment and Decision Making"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "technical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-2061.00",
      "49-2092.00",
      "51-4033.00"
    ],
    "training_paths": [],
    "description": "Repair, clean, and adjust mechanisms of timing instruments, such as watches and clocks. Includes watchmakers, watch technicians, and mechanical timepiece repairers.",
    "dailyActivities": [
      "Clean, rinse, and dry timepiece parts, using solutions and ultrasonic or mechanical watch-cleaning machines.",
      "Adjust timing regulators, using truing calipers, watch-rate recorders, and tweezers.",
      "Reassemble timepieces, replacing glass faces and batteries, before returning them to customers.",
      "Disassemble timepieces and inspect them for defective, worn, misaligned, or rusty parts, using loupes.",
      "Oil moving parts of timepieces.",
      "Estimate repair costs and timepiece values."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "wind_turbine_service_technicians",
    "onet_code": "49-9081.00",
    "title": "Wind Turbine Service Technicians",
    "category": "Installation & Repair",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Fluency of Ideas",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "installation_repair",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37995,
      "entry_max": 50660,
      "mid_min": 50660,
      "mid_max": 65858
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-8013.04",
      "11-9199.09",
      "51-8013.00"
    ],
    "training_paths": [],
    "description": "Inspect, diagnose, adjust, or repair wind turbines. Perform maintenance on wind turbine equipment including resolving electrical, mechanical, and hydraulic malfunctions.",
    "dailyActivities": [
      "Troubleshoot or repair mechanical, hydraulic, or electrical malfunctions related to variable pitch systems, variable speed control systems, converter systems, or related components.",
      "Perform routine maintenance on wind turbine equipment, underground transmission systems, wind fields substations, or fiber optic sensing and control systems.",
      "Diagnose problems involving wind turbine generators or control systems.",
      "Test electrical components of wind systems with devices, such as voltage testers, multimeters, oscilloscopes, infrared testers, or fiber optic equipment.",
      "Start or restart wind turbine generator systems to ensure proper operations.",
      "Climb wind turbine towers to inspect, maintain, or repair equipment."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "legal_support_workers_all_other",
    "onet_code": "23-2099.00",
    "title": "Legal Support Workers, All Other",
    "category": "Legal",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "legal"
    ],
    "salary": {
      "entry_min": 57304,
      "entry_max": 76406,
      "mid_min": 76406,
      "mid_max": 99327
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All legal support workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "paralegals_and_legal_assistants",
    "onet_code": "23-2011.00",
    "title": "Paralegals and Legal Assistants",
    "category": "Legal",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "legal",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 67417,
      "entry_max": 89890,
      "mid_min": 89890,
      "mid_max": 116857
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-6012.00",
      "23-2093.00",
      "27-3092.00"
    ],
    "training_paths": [],
    "description": "Assist lawyers by investigating facts, preparing legal documents, or researching legal precedent. Conduct research to support a legal proceeding, to formulate a defense, or to initiate legal action.",
    "dailyActivities": [
      "Prepare affidavits or other documents, such as legal correspondence, and organize and maintain documents in paper or electronic filing system.",
      "Prepare, edit, or review legal documents, including legislation, briefs, pleadings, appeals, wills, contracts, and real estate closing statements.",
      "Investigate facts and law of cases and search pertinent sources, such as public records and internet sources, to determine causes of action and to prepare cases.",
      "Prepare for trial by performing tasks such as organizing exhibits.",
      "Meet with clients and other professionals to discuss details of cases.",
      "Gather and analyze research data, such as statutes, decisions, and legal articles, codes, and documents."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "title_examiners_abstractors_and_searchers",
    "onet_code": "23-2093.00",
    "title": "Title Examiners, Abstractors, and Searchers",
    "category": "Legal",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Deductive Reasoning"
    ],
    "keywords": [
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "legal",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 57304,
      "entry_max": 76406,
      "mid_min": 76406,
      "mid_max": 99327
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-4071.00",
      "23-2011.00",
      "13-2023.00"
    ],
    "training_paths": [],
    "description": "Search real estate records, examine titles, or summarize pertinent legal or insurance documents or details for a variety of purposes. May compile lists of mortgages, contracts, and other instruments pertaining to titles by searching public and private records for law firms, real estate agencies, or title insurance companies.",
    "dailyActivities": [
      "Examine documentation such as mortgages, liens, judgments, easements, plat books, maps, contracts, and agreements to verify factors such as properties' legal descriptions, ownership, or restrictions.",
      "Examine individual titles to determine if restrictions, such as delinquent taxes, will affect titles and limit property use.",
      "Prepare reports describing any title encumbrances encountered during searching activities and outlining actions needed to clear titles.",
      "Copy or summarize recorded documents, such as mortgages, trust deeds, and contracts, that affect property titles.",
      "Verify accuracy and completeness of land-related documents accepted for registration, preparing rejection notices when documents are not acceptable.",
      "Prepare lists of all legal instruments applying to a specific piece of land and the buildings on it."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "administrative_services_managers",
    "onet_code": "11-3012.00",
    "title": "Administrative Services Managers",
    "category": "Management",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "management",
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 80520,
      "entry_max": 107360,
      "mid_min": 107360,
      "mid_max": 139568
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-1011.00",
      "11-1021.00",
      "43-6011.00"
    ],
    "training_paths": [],
    "description": "Plan, direct, or coordinate one or more administrative services of an organization, such as records and information management, mail distribution, and other office support services.",
    "dailyActivities": [
      "Prepare and review operational reports and schedules to ensure accuracy and efficiency.",
      "Set goals and deadlines for the department.",
      "Acquire, distribute and store supplies.",
      "Analyze internal processes and recommend and implement procedural or policy changes to improve operations, such as supply changes or the disposal of records.",
      "Conduct classes to teach procedures to staff.",
      "Plan, administer, and control budgets for contracts, equipment, and supplies."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "education_administrators_all_other",
    "onet_code": "11-9039.00",
    "title": "Education Administrators, All Other",
    "category": "Management",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "management"
    ],
    "salary": {
      "entry_min": 68442,
      "entry_max": 91256,
      "mid_min": 91256,
      "mid_max": 118632
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All education administrators not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "facilities_managers",
    "onet_code": "11-3013.00",
    "title": "Facilities Managers",
    "category": "Management",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "management",
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 80520,
      "entry_max": 107360,
      "mid_min": 107360,
      "mid_max": 139568
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "11-1021.00",
      "49-9071.00",
      "11-9021.00"
    ],
    "training_paths": [],
    "description": "Plan, direct, or coordinate operations and functionalities of facilities and buildings. May include surrounding grounds or multiple facilities of an organization's campus.",
    "dailyActivities": [
      "Monitor the facility to ensure that it remains safe, secure, and well-maintained.",
      "Oversee the maintenance and repair of machinery, equipment, and electrical and mechanical systems.",
      "Oversee construction and renovation projects to improve efficiency and to ensure that facilities meet environmental, health, and security standards, and comply with government regulations.",
      "Plan, administer, and control budgets for contracts, equipment, and supplies.",
      "Participate in architectural and engineering planning and design, including space and installation management.",
      "Set goals and deadlines for the department."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "food_service_managers",
    "onet_code": "11-9051.00",
    "title": "Food Service Managers",
    "category": "Management",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "management",
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 68442,
      "entry_max": 91256,
      "mid_min": 91256,
      "mid_max": 118632
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "35-1011.00",
      "35-1012.00",
      "35-2012.00"
    ],
    "training_paths": [],
    "description": "Plan, direct, or coordinate activities of an organization or department that serves food and beverages.",
    "dailyActivities": [
      "Count money and make bank deposits.",
      "Establish standards for personnel performance and customer service.",
      "Keep records required by government agencies regarding sanitation or food subsidies.",
      "Schedule staff hours and assign duties.",
      "Investigate and resolve complaints regarding food quality, service, or accommodations.",
      "Maintain food and equipment inventories, and keep inventory records."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "funeral_home_managers",
    "onet_code": "11-9171.00",
    "title": "Funeral Home Managers",
    "category": "Management",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "management",
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 80520,
      "entry_max": 107360,
      "mid_min": 107360,
      "mid_max": 139568
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "39-4031.00",
      "39-4021.00",
      "39-4012.00"
    ],
    "training_paths": [],
    "description": "Plan, direct, or coordinate the services or resources of funeral homes. Includes activities such as determining prices for services or merchandise and managing the facilities of funeral homes.",
    "dailyActivities": [
      "Consult with families or friends of the deceased to arrange funeral details, such as obituary notice wording, casket selection, or plans for services.",
      "Schedule funerals, burials, or cremations.",
      "Deliver death certificates to medical facilities or offices to obtain signatures from legally authorized persons.",
      "Offer counsel and comfort to families and friends of the deceased.",
      "Monitor funeral service operations to ensure that they comply with applicable policies, regulations, and laws.",
      "Direct and supervise work of embalmers, funeral attendants, death certificate clerks, cosmetologists, or other staff."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "gambling_managers",
    "onet_code": "11-9071.00",
    "title": "Gambling Managers",
    "category": "Management",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "management",
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 68442,
      "entry_max": 91256,
      "mid_min": 91256,
      "mid_max": 118632
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "39-1013.00",
      "39-3012.00",
      "33-9031.00"
    ],
    "training_paths": [],
    "description": "Plan, direct, or coordinate gambling operations in a casino. May formulate house rules.",
    "dailyActivities": [
      "Resolve customer complaints regarding problems, such as payout errors.",
      "Remove suspected cheaters, such as card counters or other players who may have systems that shift the odds of winning to their favor.",
      "Track supplies of money to tables and perform any required paperwork.",
      "Explain and interpret house rules, such as game rules or betting limits.",
      "Prepare work schedules and station arrangements and keep attendance records.",
      "Monitor staffing levels to ensure that games and tables are adequately staffed for each shift, arranging for staff rotations and breaks and locating substitute employees as necessary."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "geothermal_production_managers",
    "onet_code": "11-3051.02",
    "title": "Geothermal Production Managers",
    "category": "Management",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "management",
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 80520,
      "entry_max": 107360,
      "mid_min": 107360,
      "mid_max": 139568
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "11-3051.06",
      "11-3051.04",
      "49-9099.01"
    ],
    "training_paths": [],
    "description": "Manage operations at geothermal power generation facilities. Maintain and monitor geothermal plant equipment for efficient and safe plant operations.",
    "dailyActivities": [
      "Supervise employees in geothermal power plants or well fields.",
      "Oversee geothermal plant operations, maintenance, and repairs to ensure compliance with applicable standards or regulations.",
      "Communicate geothermal plant conditions to employees.",
      "Identify and evaluate equipment, procedural, or conditional inefficiencies involving geothermal plant systems.",
      "Perform or direct the performance of preventative maintenance on geothermal plant equipment.",
      "Inspect geothermal plant or injection well fields to verify proper equipment operations."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "hydroelectric_production_managers",
    "onet_code": "11-3051.06",
    "title": "Hydroelectric Production Managers",
    "category": "Management",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Science",
      "Critical Thinking",
      "Active Learning"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "management",
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 80520,
      "entry_max": 107360,
      "mid_min": 107360,
      "mid_max": 139568
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "11-3051.02",
      "51-8013.04",
      "11-3051.04"
    ],
    "training_paths": [],
    "description": "Manage operations at hydroelectric power generation facilities. Maintain and monitor hydroelectric plant equipment for efficient and safe plant operations.",
    "dailyActivities": [
      "Direct operations, maintenance, or repair of hydroelectric power facilities.",
      "Identify and communicate power system emergencies.",
      "Maintain records of hydroelectric facility operations, maintenance, or repairs.",
      "Perform or direct preventive or corrective containment or cleanup to protect the environment.",
      "Monitor or inspect hydroelectric equipment, such as hydro-turbines, generators, or control systems.",
      "Inspect hydroelectric facilities, including switchyards, control houses, or relay houses, for normal operation or adherence to safety standards."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "managers_all_other",
    "onet_code": "11-9199.00",
    "title": "Managers, All Other",
    "category": "Management",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "management"
    ],
    "salary": {
      "entry_min": 68442,
      "entry_max": 91256,
      "mid_min": 91256,
      "mid_max": 118632
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All managers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "personal_service_managers_all_other",
    "onet_code": "11-9179.00",
    "title": "Personal Service Managers, All Other",
    "category": "Management",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "management"
    ],
    "salary": {
      "entry_min": 68442,
      "entry_max": 91256,
      "mid_min": 91256,
      "mid_max": 118632
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All personal service managers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "postmasters_and_mail_superintendents",
    "onet_code": "11-9131.00",
    "title": "Postmasters and Mail Superintendents",
    "category": "Management",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "management",
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 68442,
      "entry_max": 91256,
      "mid_min": 91256,
      "mid_max": 118632
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-5051.00",
      "11-3071.00",
      "43-1011.00"
    ],
    "training_paths": [],
    "description": "Plan, direct, or coordinate operational, administrative, management, and support services of a U.S. post office; or coordinate activities of workers engaged in postal and related work in assigned post office.",
    "dailyActivities": [
      "Monitor employees' work schedules and attendance for payroll purposes.",
      "Organize and supervise activities, such as the processing of incoming and outgoing mail.",
      "Resolve customer complaints.",
      "Prepare employee work schedules.",
      "Direct and coordinate operational, management, and supportive services of one or a number of postal facilities.",
      "Hire and train employees, and evaluate their performance."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "spa_managers",
    "onet_code": "11-9179.02",
    "title": "Spa Managers",
    "category": "Management",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "management",
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 80520,
      "entry_max": 107360,
      "mid_min": 107360,
      "mid_max": 139568
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "11-9179.01",
      "39-1022.00",
      "39-5094.00"
    ],
    "training_paths": [],
    "description": "Plan, direct, or coordinate activities of a spa facility. Coordinate programs, schedule and direct staff, and oversee financial activities.",
    "dailyActivities": [
      "Respond to customer inquiries or complaints.",
      "Schedule guest appointments.",
      "Maintain client databases.",
      "Coordinate facility schedules to maximize usage and efficiency.",
      "Perform accounting duties, such as recording daily cash flow, preparing bank deposits, or generating financial statements.",
      "Monitor operations to ensure compliance with applicable health, safety, or hygiene standards."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "wind_energy_operations_managers",
    "onet_code": "11-9199.09",
    "title": "Wind Energy Operations Managers",
    "category": "Management",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "management",
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 80520,
      "entry_max": 107360,
      "mid_min": 107360,
      "mid_max": 139568
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "11-9199.10",
      "49-9081.00",
      "17-2199.10"
    ],
    "training_paths": [],
    "description": "Manage wind field operations, including personnel, maintenance activities, financial activities, and planning.",
    "dailyActivities": [
      "Supervise employees or subcontractors to ensure quality of work or adherence to safety regulations or policies.",
      "Train or coordinate the training of employees in operations, safety, environmental issues, or technical issues.",
      "Track and maintain records for wind operations, such as site performance, downtime events, parts usage, or substation events.",
      "Oversee the maintenance of wind field equipment or structures, such as towers, transformers, electrical collector systems, roadways, or other site assets.",
      "Prepare wind field operational budgets.",
      "Develop relationships and communicate with customers, site managers, developers, land owners, authorities, utility representatives, or residents."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "amusement_and_recreation_attendants",
    "onet_code": "39-3091.00",
    "title": "Amusement and Recreation Attendants",
    "category": "Personal Care",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Near Vision",
      "Speech Recognition"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "physical",
      "personal_care",
      "communication"
    ],
    "salary": {
      "entry_min": 17440,
      "entry_max": 23254,
      "mid_min": 23254,
      "mid_max": 30230
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "39-3093.00",
      "39-6011.00",
      "53-6021.00"
    ],
    "training_paths": [],
    "description": "Perform a variety of attending duties at amusement or recreation facility. May schedule use of recreation facilities, maintain and provide equipment to participants of sporting events or recreational pursuits, or operate amusement concessions and rides.",
    "dailyActivities": [
      "Sell tickets and collect fees from customers.",
      "Provide information about facilities, entertainment options, and rules and regulations.",
      "Keep informed of shut-down and emergency evacuation procedures.",
      "Direct patrons to rides, seats, or attractions.",
      "Monitor activities to ensure adherence to rules and safety procedures, or arrange for the removal of unruly patrons.",
      "Record details of attendance, sales, receipts, reservations, or repair activities."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "animal_caretakers",
    "onet_code": "39-2021.00",
    "title": "Animal Caretakers",
    "category": "Personal Care",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Static Strength"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "physical",
      "personal_care",
      "communication"
    ],
    "salary": {
      "entry_min": 21177,
      "entry_max": 28237,
      "mid_min": 28237,
      "mid_max": 36708
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "31-9096.00",
      "39-2011.00",
      "45-2021.00"
    ],
    "training_paths": [],
    "description": "Feed, water, groom, bathe, exercise, or otherwise provide care to promote and maintain the well-being of pets and other animals that are not raised for consumption, such as dogs, cats, race horses, ornamental fish or birds, zoo animals, and mice. Work in settings such as kennels, animal shelters, zoos, circuses, and aquariums. May keep records of feedings, treatments, and animals received or discharged. May clean, disinfect, and repair cages, pens, or fish tanks.",
    "dailyActivities": [
      "Feed and water animals according to schedules and feeding instructions.",
      "Provide treatment to sick or injured animals, or contact veterinarians to secure treatment.",
      "Examine and observe animals to detect signs of illness, disease, or injury.",
      "Mix food, liquid formulas, medications, or food supplements according to instructions, prescriptions, and knowledge of animal species.",
      "Do facility laundry and clean, organize, maintain, and disinfect animal quarters, such as pens and stables, and equipment, such as saddles and bridles.",
      "Exercise animals to maintain their physical and mental health."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "animal_trainers",
    "onet_code": "39-2011.00",
    "title": "Animal Trainers",
    "category": "Personal Care",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Fluency of Ideas",
      "Originality"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "personal_care",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 21177,
      "entry_max": 28237,
      "mid_min": 28237,
      "mid_max": 36708
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "39-2021.00",
      "45-2021.00",
      "31-9096.00"
    ],
    "training_paths": [],
    "description": "Train animals for riding, harness, security, performance, or obedience, or for assisting persons with disabilities. Accustom animals to human voice and contact, and condition animals to respond to commands. Train animals according to prescribed standards for show or competition. May train animals to carry pack loads or work as part of pack team.",
    "dailyActivities": [
      "Cue or signal animals during performances.",
      "Talk to or interact with animals to familiarize them to human voices or contact.",
      "Conduct training programs to develop or maintain desired animal behaviors for competition, entertainment, obedience, security, riding, or related purposes.",
      "Feed or exercise animals or provide other general care, such as cleaning or maintaining holding or performance areas.",
      "Observe animals' physical conditions to detect illness or unhealthy conditions requiring medical care.",
      "Evaluate animals to determine their temperaments, abilities, or aptitude for training."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "baggage_porters_and_bellhops",
    "onet_code": "39-6011.00",
    "title": "Baggage Porters and Bellhops",
    "category": "Personal Care",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Static Strength",
      "Trunk Strength",
      "Near Vision"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "physical",
      "personal_care",
      "communication"
    ],
    "salary": {
      "entry_min": 21177,
      "entry_max": 28237,
      "mid_min": 28237,
      "mid_max": 36708
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "39-6012.00",
      "53-6061.00",
      "43-4181.00"
    ],
    "training_paths": [],
    "description": "Handle baggage for travelers at transportation terminals or for guests at hotels or similar establishments.",
    "dailyActivities": [
      "Receive and mark baggage by completing and attaching claim checks.",
      "Greet incoming guests and escort them to their rooms.",
      "Transport guests about premises and local areas, or arrange for transportation.",
      "Maintain clean lobbies or entrance areas for travelers or guests.",
      "Transfer luggage, trunks, and packages to and from rooms, loading areas, vehicles, or transportation terminals, by hand or using baggage carts.",
      "Supply guests or travelers with directions, travel information, and other information, such as available services and points of interest."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "barbers",
    "onet_code": "39-5011.00",
    "title": "Barbers",
    "category": "Personal Care",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Visualization",
      "Selective Attention",
      "Arm-Hand Steadiness"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "physical",
      "personal_care",
      "communication"
    ],
    "salary": {
      "entry_min": 24915,
      "entry_max": 33220,
      "mid_min": 33220,
      "mid_max": 43186
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "39-5012.00",
      "39-5094.00",
      "39-5093.00"
    ],
    "training_paths": [],
    "description": "Provide barbering services, such as cutting, trimming, shampooing, and styling hair; trimming beards; or giving shaves.",
    "dailyActivities": [
      "Clean and sterilize scissors, combs, clippers, and other instruments.",
      "Drape and pin protective cloths around customers' shoulders.",
      "Cut and trim hair according to clients' instructions or current hairstyles, using clippers, combs, hand-held blow driers, and scissors.",
      "Question patrons regarding desired services and haircut styles.",
      "Clean work stations and sweep floors.",
      "Apply lather and shave beards or neck and temple hair contours, using razors."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "childcare_workers",
    "onet_code": "39-9011.00",
    "title": "Childcare Workers",
    "category": "Personal Care",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "physical",
      "problem_solving",
      "personal_care",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 21177,
      "entry_max": 28237,
      "mid_min": 28237,
      "mid_max": 36708
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "25-2011.00",
      "39-9011.01",
      "31-1122.00"
    ],
    "training_paths": [],
    "description": "Attend to children at schools, businesses, private households, and childcare institutions. Perform a variety of tasks, such as dressing, feeding, bathing, and overseeing play.",
    "dailyActivities": [
      "Maintain a safe play environment.",
      "Observe and monitor children's play activities.",
      "Communicate with children's parents or guardians about daily activities, behaviors, and related issues.",
      "Support children's emotional and social development, encouraging understanding of others and positive self-concepts.",
      "Care for children in institutional setting, such as group homes, nursery schools, private businesses, or schools for people with disabilities.",
      "Sanitize toys and play equipment."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "concierges",
    "onet_code": "39-6012.00",
    "title": "Concierges",
    "category": "Personal Care",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Social Perceptiveness",
      "Coordination",
      "Persuasion"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas",
      "Originality"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "personal_care",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 21177,
      "entry_max": 28237,
      "mid_min": 28237,
      "mid_max": 36708
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-4081.00",
      "39-6011.00",
      "41-2021.00"
    ],
    "training_paths": [],
    "description": "Assist patrons at hotel, apartment, or office building with personal services. May take messages; arrange or give advice on transportation, business services, or entertainment; or monitor guest requests for housekeeping and maintenance.",
    "dailyActivities": [
      "Provide information about local features, such as shopping, dining, nightlife, or recreational destinations.",
      "Make reservations for patrons, such as for dinner, spa treatments, or golf tee times, and obtain tickets to special events.",
      "Provide directions to guests.",
      "Order flowers for guests.",
      "Make travel arrangements for sightseeing or other tours.",
      "Pick up and deliver items or run errands for guests."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "costume_attendants",
    "onet_code": "39-3092.00",
    "title": "Costume Attendants",
    "category": "Personal Care",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Monitoring",
      "Social Perceptiveness",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Fluency of Ideas",
      "Originality",
      "Problem Sensitivity"
    ],
    "keywords": [
      "hands_on",
      "analytical",
      "physical",
      "personal_care",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 21177,
      "entry_max": 28237,
      "mid_min": 28237,
      "mid_max": 36708
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "27-1022.00",
      "51-6052.00",
      "39-5091.00"
    ],
    "training_paths": [],
    "description": "Select, fit, and take care of costumes for cast members, and aid entertainers. May assist with multiple costume changes during performances.",
    "dailyActivities": [
      "Create worksheets for dressing lists, show notes, or costume checks.",
      "Provide dressing assistance to cast members or assign cast dressers to assist specific cast members with costume changes.",
      "Arrange costumes in order of use to facilitate quick-change procedures for performances.",
      "Design or construct costumes or send them to tailors for construction, major repairs, or alterations.",
      "Examine costume fit on cast members and sketch or write notes for alterations.",
      "Distribute costumes or related equipment and keep records of item status."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "crematory_operators",
    "onet_code": "39-4012.00",
    "title": "Crematory Operators",
    "category": "Personal Care",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "personal_care"
    ],
    "salary": {
      "entry_min": 21177,
      "entry_max": 28237,
      "mid_min": 28237,
      "mid_max": 36708
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "39-4021.00",
      "39-4031.00",
      "11-9171.00"
    ],
    "training_paths": [],
    "description": "Operate crematory equipment to reduce human or animal remains to bone fragments in accordance with state and local regulations. Duties may include preparing the body for cremation and performing general maintenance on crematory equipment. May use traditional flame-based cremation, calcination, or alkaline hydrolysis.",
    "dailyActivities": [
      "Clean the crematorium, including tables, floors, and equipment.",
      "Document divided remains to ensure parts are not misplaced.",
      "Embalm, dress, or otherwise prepare the deceased for viewing.",
      "Explain the cremation process to family or friends of the deceased.",
      "Offer counsel and comfort to bereaved families or friends.",
      "Pick up and handle human or pet remains in a respectful manner."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "embalmers",
    "onet_code": "39-4011.00",
    "title": "Embalmers",
    "category": "Personal Care",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "personal_care",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 24915,
      "entry_max": 33220,
      "mid_min": 33220,
      "mid_max": 43186
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "39-4031.00",
      "39-4021.00",
      "11-9171.00"
    ],
    "training_paths": [],
    "description": "Prepare bodies for interment in conformity with legal requirements.",
    "dailyActivities": [
      "Conform to laws of health and sanitation and ensure that legal requirements concerning embalming are met.",
      "Apply cosmetics to impart lifelike appearance to the deceased.",
      "Join lips, using needles and thread or wire.",
      "Close incisions, using needles and sutures.",
      "Incise stomach and abdominal walls and probe internal organs, using trocar, to withdraw blood and waste matter from organs.",
      "Clean and disinfect areas in which bodies are prepared and embalmed."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "entertainment_attendants_and_related_workers_all_other",
    "onet_code": "39-3099.00",
    "title": "Entertainment Attendants and Related Workers, All Other",
    "category": "Personal Care",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "personal_care"
    ],
    "salary": {
      "entry_min": 21177,
      "entry_max": 28237,
      "mid_min": 28237,
      "mid_max": 36708
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All entertainment attendants and related workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "exercise_trainers_and_group_fitness_instructors",
    "onet_code": "39-9031.00",
    "title": "Exercise Trainers and Group Fitness Instructors",
    "category": "Personal Care",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Fluency of Ideas",
      "Originality"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "personal_care",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 24915,
      "entry_max": 33220,
      "mid_min": 33220,
      "mid_max": 43186
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "11-9179.01",
      "29-1128.00",
      "27-2022.00"
    ],
    "training_paths": [],
    "description": "Instruct or coach groups or individuals in exercise activities for the primary purpose of personal fitness. Demonstrate techniques and form, observe participants, and explain to them corrective measures necessary to improve their skills. Develop and implement individualized approaches to exercise.",
    "dailyActivities": [
      "Observe participants and inform them of corrective measures necessary for skill improvement.",
      "Offer alternatives during classes to accommodate different levels of fitness.",
      "Monitor participants' progress and adapt programs as needed.",
      "Plan routines, choose appropriate music, and choose different movements for each set of muscles, depending on participants' capabilities and limitations.",
      "Evaluate individuals' abilities, needs, and physical conditions, and develop suitable training programs to meet any special requirements.",
      "Instruct participants in maintaining exertion levels to maximize benefits from exercise routines."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "first_line_supervisors_of_entertainment_and_recreation_workers_except_gambling_services",
    "onet_code": "39-1014.00",
    "title": "First-Line Supervisors of Entertainment and Recreation Workers, Except Gambling Services",
    "category": "Personal Care",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "personal_care"
    ],
    "salary": {
      "entry_min": 21177,
      "entry_max": 28237,
      "mid_min": 28237,
      "mid_max": 36708
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "39-1022.00",
      "43-1011.00",
      "49-1011.00"
    ],
    "training_paths": [],
    "description": "Directly supervise and coordinate activities of entertainment and recreation related workers.",
    "dailyActivities": [
      "Analyze and record personnel or operational data and write related activity reports.",
      "Apply customer feedback to service improvement efforts.",
      "Assign work schedules, following work requirements, to ensure quality and timely delivery of service.",
      "Collaborate with staff members to plan or develop programs of events or schedules of activities.",
      "Direct or coordinate the activities of entertainment and recreation related workers.",
      "Furnish customers with information on events or activities."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "first_line_supervisors_of_gambling_services_workers",
    "onet_code": "39-1013.00",
    "title": "First-Line Supervisors of Gambling Services Workers",
    "category": "Personal Care",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "personal_care",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 21177,
      "entry_max": 28237,
      "mid_min": 28237,
      "mid_max": 36708
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "11-9071.00",
      "41-2012.00",
      "43-3041.00"
    ],
    "training_paths": [],
    "description": "Directly supervise and coordinate activities of workers in assigned gambling areas. May circulate among tables, observe operations, and ensure that stations and games are covered for each shift. May verify and pay off jackpots. May reset slot machines after payoffs and make repairs or adjustments to slot machines or recommend removal of slot machines for repair. May plan and organize activities and services for guests in hotels/casinos.",
    "dailyActivities": [
      "Monitor game operations to ensure that house rules are followed, that tribal, state, and federal regulations are adhered to, and that employees provide prompt and courteous service.",
      "Observe gamblers' behavior for signs of cheating, such as marking, switching, or counting cards, and notify security staff of suspected cheating.",
      "Perform paperwork required for monetary transactions.",
      "Respond to and resolve patrons' complaints.",
      "Greet customers and ask about the quality of service they are receiving.",
      "Perform minor repairs or make adjustments to slot machines, resolving problems such as machine tilts and coin jams."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "first_line_supervisors_of_personal_service_workers",
    "onet_code": "39-1022.00",
    "title": "First-Line Supervisors of Personal Service Workers",
    "category": "Personal Care",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "personal_care",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 24915,
      "entry_max": 33220,
      "mid_min": 33220,
      "mid_max": 43186
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "39-1014.00",
      "37-1011.00",
      "43-1011.00"
    ],
    "training_paths": [],
    "description": "Supervise and coordinate activities of personal service workers.",
    "dailyActivities": [
      "Train workers in proper operational procedures and functions and explain company policies.",
      "Meet with managers or other supervisors to stay informed of changes affecting operations.",
      "Assign work schedules, following work requirements, to ensure quality and timely delivery of service.",
      "Recruit and hire staff members.",
      "Resolve customer complaints regarding worker performance or services rendered.",
      "Take disciplinary action to address performance problems."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "funeral_attendants",
    "onet_code": "39-4021.00",
    "title": "Funeral Attendants",
    "category": "Personal Care",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Speaking",
      "Monitoring",
      "Social Perceptiveness",
      "Coordination",
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Near Vision"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "physical",
      "technical",
      "personal_care",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 21177,
      "entry_max": 28237,
      "mid_min": 28237,
      "mid_max": 36708
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "39-4031.00",
      "11-9171.00",
      "39-4012.00"
    ],
    "training_paths": [],
    "description": "Perform a variety of tasks during funeral, such as placing casket in parlor or chapel prior to service, arranging floral offerings or lights around casket, directing or escorting mourners, closing casket, and issuing and storing funeral equipment.",
    "dailyActivities": [
      "Greet people at the funeral home.",
      "Perform a variety of tasks during funerals to assist funeral directors and to ensure that services run smoothly and as planned.",
      "Close caskets at appropriate point in services.",
      "Direct or escort mourners to parlors or chapels in which wakes or funerals are being held.",
      "Place caskets in parlors or chapels prior to wakes or funerals.",
      "Offer assistance to mourners as they enter or exit limousines."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "gambling_dealers",
    "onet_code": "39-3011.00",
    "title": "Gambling Dealers",
    "category": "Personal Care",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Information Ordering"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "analytical",
      "physical",
      "personal_care",
      "communication"
    ],
    "salary": {
      "entry_min": 21177,
      "entry_max": 28237,
      "mid_min": 28237,
      "mid_max": 36708
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "39-3012.00",
      "11-9071.00",
      "39-1013.00"
    ],
    "training_paths": [],
    "description": "Operate table games. Stand or sit behind table and operate games of chance by dispensing the appropriate number of cards or blocks to players, or operating other gambling equipment. Distribute winnings or collect players' money or chips. May compare the house's hand against players' hands.",
    "dailyActivities": [
      "Pay winnings or collect losing bets as established by the rules and procedures of a specific game.",
      "Greet customers and make them feel welcome.",
      "Exchange paper currency for playing chips or coin money.",
      "Check to ensure that all players have placed bets before play begins.",
      "Inspect cards and equipment to be used in games to ensure that they are in good condition.",
      "Deal cards to house hands, and compare these with players' hands to determine winners, as in black jack."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "gambling_service_workers_all_other",
    "onet_code": "39-3019.00",
    "title": "Gambling Service Workers, All Other",
    "category": "Personal Care",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "personal_care"
    ],
    "salary": {
      "entry_min": 21177,
      "entry_max": 28237,
      "mid_min": 28237,
      "mid_max": 36708
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All gambling service workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "gambling_and_sports_book_writers_and_runners",
    "onet_code": "39-3012.00",
    "title": "Gambling and Sports Book Writers and Runners",
    "category": "Personal Care",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Monitoring",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Deductive Reasoning",
      "Information Ordering"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "analytical",
      "personal_care",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 21177,
      "entry_max": 28237,
      "mid_min": 28237,
      "mid_max": 36708
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "39-3011.00",
      "43-3041.00",
      "41-2012.00"
    ],
    "training_paths": [],
    "description": "Post information enabling patrons to wager on various races and sporting events. Assist in the operation of games such as keno and bingo. May operate random number-generating equipment and announce the numbers for patrons. Receive, verify, and record patrons' wagers. Scan and process winning tickets presented by patrons and pay out winnings for those wagers.",
    "dailyActivities": [
      "Collect bets in the form of cash or chips, verifying and recording amounts.",
      "Collect cards or tickets from players.",
      "Compute and verify amounts won or lost, paying out winnings or referring patrons to workers, such as gaming cashiers, so that winnings can be collected.",
      "Answer questions about game rules or casino policies.",
      "Conduct gambling tables or games, such as dice, roulette, cards, or keno, and ensure that game rules are followed.",
      "Operate games in which players bet that a ball will come to rest in a particular slot on a rotating wheel, performing actions such as spinning the wheel and releasing the ball."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "hairdressers_hairstylists_and_cosmetologists",
    "onet_code": "39-5012.00",
    "title": "Hairdressers, Hairstylists, and Cosmetologists",
    "category": "Personal Care",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Fluency of Ideas",
      "Originality"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "physical",
      "problem_solving",
      "personal_care",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 24915,
      "entry_max": 33220,
      "mid_min": 33220,
      "mid_max": 43186
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "39-5011.00",
      "39-5094.00",
      "39-5093.00"
    ],
    "training_paths": [],
    "description": "Provide beauty services, such as cutting, coloring, and styling hair, and massaging and treating scalp. May shampoo hair, apply makeup, dress wigs, remove hair, and provide nail and skincare services.",
    "dailyActivities": [
      "Keep work stations clean and sanitize tools, such as scissors and combs.",
      "Bleach, dye, or tint hair, using applicator or brush.",
      "Cut, trim and shape hair or hairpieces, based on customers' instructions, hair type, and facial features, using clippers, scissors, trimmers and razors.",
      "Schedule client appointments.",
      "Update and maintain customer information records, such as beauty services provided.",
      "Demonstrate and sell hair care products and cosmetics."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "locker_room_coatroom_and_dressing_room_attendants",
    "onet_code": "39-3093.00",
    "title": "Locker Room, Coatroom, and Dressing Room Attendants",
    "category": "Personal Care",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Near Vision",
      "Speech Recognition"
    ],
    "keywords": [
      "personal_care",
      "hands_on",
      "customer_service"
    ],
    "salary": {
      "entry_min": 21177,
      "entry_max": 28237,
      "mid_min": 28237,
      "mid_max": 36708
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-4081.00",
      "39-6012.00",
      "35-3041.00"
    ],
    "training_paths": [],
    "description": "Provide personal items to patrons or customers in locker rooms, dressing rooms, or coatrooms.",
    "dailyActivities": [
      "Provide towels and sheets to clients in public baths, steam rooms, and restrooms.",
      "Assign dressing room facilities, locker space, or clothing containers to patrons of athletic or bathing establishments.",
      "Check supplies to ensure adequate availability, and order new supplies when necessary.",
      "Monitor patrons' facility use to ensure that rules and regulations are followed, and safety and order are maintained.",
      "Clean facilities such as floors or locker rooms.",
      "Answer customer inquiries or explain cost, availability, policies, and procedures of facilities."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "makeup_artists_theatrical_and_performance",
    "onet_code": "39-5091.00",
    "title": "Makeup Artists, Theatrical and Performance",
    "category": "Personal Care",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "physical",
      "problem_solving",
      "personal_care",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 24915,
      "entry_max": 33220,
      "mid_min": 33220,
      "mid_max": 43186
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "39-5012.00",
      "39-5094.00",
      "39-3092.00"
    ],
    "training_paths": [],
    "description": "Apply makeup to performers to reflect period, setting, and situation of their role.",
    "dailyActivities": [
      "Clean supplies such as makeup brushes.",
      "Duplicate work precisely to replicate characters' appearances on a daily basis.",
      "Apply makeup to enhance or alter the appearance of people appearing in productions such as movies.",
      "Analyze a script, noting events that affect each character's appearance, so that plans can be made for each scene.",
      "Alter or maintain makeup during productions as necessary to compensate for lighting changes or to achieve continuity of effect.",
      "Confer with stage or motion picture officials and performers to determine desired effects."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "manicurists_and_pedicurists",
    "onet_code": "39-5092.00",
    "title": "Manicurists and Pedicurists",
    "category": "Personal Care",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Arm-Hand Steadiness",
      "Finger Dexterity",
      "Near Vision",
      "Speech Recognition"
    ],
    "keywords": [
      "communication",
      "personal_care",
      "hands_on",
      "customer_service"
    ],
    "salary": {
      "entry_min": 21177,
      "entry_max": 28237,
      "mid_min": 28237,
      "mid_max": 36708
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "39-5012.00",
      "51-9123.00",
      "39-5094.00"
    ],
    "training_paths": [],
    "description": "Clean and shape customers' fingernails and toenails. May polish or decorate nails.",
    "dailyActivities": [
      "Clean and sanitize tools and work environment.",
      "Apply undercoat and clear or colored polish onto nails with brush.",
      "Maintain supply inventories and records of client services.",
      "Shape and smooth ends of nails, using scissors, files, or emery boards.",
      "Prepare nail cuticles with water and oil, using cuticle knives to push back cuticles and scissors or nippers to trim cuticles.",
      "Prepare customers' nails in soapy water, using swabs, files, and orange sticks."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "morticians_undertakers_and_funeral_arrangers",
    "onet_code": "39-4031.00",
    "title": "Morticians, Undertakers, and Funeral Arrangers",
    "category": "Personal Care",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "personal_care",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 24915,
      "entry_max": 33220,
      "mid_min": 33220,
      "mid_max": 43186
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "39-4021.00",
      "11-9171.00",
      "39-4011.00"
    ],
    "training_paths": [],
    "description": "Perform various tasks to arrange and direct individual funeral services, such as coordinating transportation of body to mortuary, interviewing family or other authorized person to arrange details, selecting pallbearers, aiding with the selection of officials for religious rites, and providing transportation for mourners.",
    "dailyActivities": [
      "Oversee the preparation and care of the remains of people who have died.",
      "Obtain information needed to complete legal documents, such as death certificates or burial permits.",
      "Perform embalming duties, as necessary.",
      "Consult with families or friends of the deceased to arrange funeral details, such as obituary notice wording, casket selection, or plans for services.",
      "Remove deceased remains from place of death.",
      "Contact cemeteries to schedule the opening and closing of graves."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "motion_picture_projectionists",
    "onet_code": "39-3021.00",
    "title": "Motion Picture Projectionists",
    "category": "Personal Care",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Operations Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Information Ordering",
      "Selective Attention"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "physical",
      "technical",
      "personal_care",
      "communication"
    ],
    "salary": {
      "entry_min": 21177,
      "entry_max": 28237,
      "mid_min": 28237,
      "mid_max": 36708
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-9061.00",
      "27-4015.00",
      "49-2097.00"
    ],
    "training_paths": [],
    "description": "Set up and operate motion picture projection and related sound reproduction equipment.",
    "dailyActivities": [
      "Monitor operations to ensure that standards for sound and image projection quality are met.",
      "Start projectors and open shutters to project images onto screens.",
      "Open and close facilities according to rules and schedules.",
      "Operate equipment to show films in a number of theaters simultaneously.",
      "Perform regular maintenance tasks, such as rotating or replacing xenon bulbs, cleaning projectors and lenses, lubricating machinery, and keeping electrical contacts clean and tight.",
      "Set up and adjust picture projectors and screens to achieve proper size, illumination, and focus of images, and proper volume and tone of sound."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "nannies",
    "onet_code": "39-9011.01",
    "title": "Nannies",
    "category": "Personal Care",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Fluency of Ideas",
      "Originality"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "physical",
      "problem_solving",
      "personal_care",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 21177,
      "entry_max": 28237,
      "mid_min": 28237,
      "mid_max": 36708
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "39-9011.00",
      "31-1122.00",
      "31-1121.00"
    ],
    "training_paths": [],
    "description": "Care for children in private households and provide support and expertise to parents in satisfying children's physical, emotional, intellectual, and social needs. Duties may include meal planning and preparation, laundry and clothing care, organization of play activities and outings, discipline, intellectual stimulation, language activities, and transportation.",
    "dailyActivities": [
      "Instruct children in safe behavior, such as seeking adult assistance when crossing the street and avoiding contact with unsafe objects.",
      "Remove hazards and develop appropriate boundaries and rules to create a safe environment for children.",
      "Perform first aid or cardiopulmonary resuscitation (CPR) when required.",
      "Instruct and assist children in the development of health and personal habits, such as eating, resting, and toilet behavior.",
      "Regulate children's rest periods and nap schedules.",
      "Teach and perform age-appropriate activities, such as lap play, reading, and arts and crafts, to encourage intellectual development of children."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "personal_care_and_service_workers_all_other",
    "onet_code": "39-9099.00",
    "title": "Personal Care and Service Workers, All Other",
    "category": "Personal Care",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "personal_care"
    ],
    "salary": {
      "entry_min": 21177,
      "entry_max": 28237,
      "mid_min": 28237,
      "mid_max": 36708
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All personal care and service workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "residential_advisors",
    "onet_code": "39-9041.00",
    "title": "Residential Advisors",
    "category": "Personal Care",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "personal_care",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 24915,
      "entry_max": 33220,
      "mid_min": 33220,
      "mid_max": 43186
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "11-9151.00",
      "21-1015.00",
      "39-1022.00"
    ],
    "training_paths": [],
    "description": "Coordinate activities in resident facilities in secondary school and college dormitories, group homes, or similar establishments. Order supplies and determine need for maintenance, repairs, and furnishings. May maintain household records and assign rooms. May assist residents with problem solving or refer them to counseling resources.",
    "dailyActivities": [
      "Communicate with other staff to resolve problems with individual students.",
      "Observe students to detect and report unusual behavior.",
      "Supervise, train, and evaluate residence hall staff, including resident assistants, participants in work-study programs, and other student workers.",
      "Provide emergency first aid and summon medical assistance when necessary.",
      "Make regular rounds to ensure that residents and areas are safe and secure.",
      "Mediate interpersonal problems between residents."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "shampooers",
    "onet_code": "39-5093.00",
    "title": "Shampooers",
    "category": "Personal Care",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "customer_service",
      "hands_on",
      "physical",
      "personal_care",
      "communication"
    ],
    "salary": {
      "entry_min": 21177,
      "entry_max": 28237,
      "mid_min": 28237,
      "mid_max": 36708
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "39-5094.00",
      "39-5012.00",
      "31-9011.00"
    ],
    "training_paths": [],
    "description": "Shampoo and rinse customers' hair.",
    "dailyActivities": [
      "Massage, shampoo, and condition patron's hair and scalp to clean them and remove excess oil.",
      "Advise patrons with chronic or potentially contagious scalp conditions to seek medical treatment.",
      "Treat scalp conditions and hair loss, using specialized lotions, shampoos, or equipment such as infrared lamps or vibrating equipment.",
      "Maintain treatment records."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "skincare_specialists",
    "onet_code": "39-5094.00",
    "title": "Skincare Specialists",
    "category": "Personal Care",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness",
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Fluency of Ideas",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "physical",
      "problem_solving",
      "personal_care",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 24915,
      "entry_max": 33220,
      "mid_min": 33220,
      "mid_max": 43186
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "39-5012.00",
      "39-5093.00",
      "31-9011.00"
    ],
    "training_paths": [],
    "description": "Provide skincare treatments to face and body to enhance an individual's appearance. Includes electrologists and laser hair removal specialists.",
    "dailyActivities": [
      "Sterilize equipment and clean work areas.",
      "Cleanse clients' skin with water, creams, or lotions.",
      "Demonstrate how to clean and care for skin properly and recommend skin-care regimens.",
      "Determine which products or colors will improve clients' skin quality and appearance.",
      "Keep records of client needs and preferences and the services provided.",
      "Treat the facial skin to maintain and improve its appearance, using specialized techniques and products, such as peels and masks."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "tour_guides_and_escorts",
    "onet_code": "39-7011.00",
    "title": "Tour Guides and Escorts",
    "category": "Personal Care",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Social Perceptiveness",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Far Vision"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "problem_solving",
      "personal_care",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 24915,
      "entry_max": 33220,
      "mid_min": 33220,
      "mid_max": 43186
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "39-7012.00",
      "19-1031.03",
      "39-3031.00"
    ],
    "training_paths": [],
    "description": "Escort individuals or groups on sightseeing tours or through places of interest, such as industrial establishments, public buildings, and art galleries.",
    "dailyActivities": [
      "Describe tour points of interest to group members, and respond to questions.",
      "Escort individuals or groups on cruises, sightseeing tours, or through places of interest, such as industrial establishments, public buildings, or art galleries.",
      "Monitor visitors' activities to ensure compliance with establishment or tour regulations and safety practices.",
      "Conduct educational activities for school children.",
      "Research various topics, including site history, environmental conditions, and clients' skills and abilities to plan appropriate expeditions, instruction, and commentary.",
      "Provide directions and other pertinent information to visitors."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "travel_guides",
    "onet_code": "39-7012.00",
    "title": "Travel Guides",
    "category": "Personal Care",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "physical",
      "problem_solving",
      "personal_care",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 21177,
      "entry_max": 28237,
      "mid_min": 28237,
      "mid_max": 36708
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "39-7011.00",
      "41-3041.00",
      "43-4181.00"
    ],
    "training_paths": [],
    "description": "Plan, organize, and conduct long-distance travel, tours, and expeditions for individuals and groups.",
    "dailyActivities": [
      "Arrange for tour or expedition details such as accommodations, transportation, equipment, and the availability of medical personnel.",
      "Plan tour itineraries, applying knowledge of travel routes and destination sites.",
      "Resolve any problems with itineraries, service, or accommodations.",
      "Attend to special needs of tour participants.",
      "Sell travel packages.",
      "Evaluate services received on the tour, and report findings to tour organizers."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "ushers_lobby_attendants_and_ticket_takers",
    "onet_code": "39-3031.00",
    "title": "Ushers, Lobby Attendants, and Ticket Takers",
    "category": "Personal Care",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Social Perceptiveness",
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Expression",
      "Near Vision",
      "Speech Recognition"
    ],
    "keywords": [
      "personal_care",
      "customer_service",
      "hands_on",
      "leadership"
    ],
    "salary": {
      "entry_min": 21177,
      "entry_max": 28237,
      "mid_min": 28237,
      "mid_max": 36708
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "35-9031.00",
      "39-6011.00",
      "43-4081.00"
    ],
    "training_paths": [],
    "description": "Assist patrons at entertainment events by performing duties, such as collecting admission tickets and passes from patrons, assisting in finding seats, searching for lost articles, and helping patrons locate such facilities as restrooms and telephones.",
    "dailyActivities": [
      "Greet patrons attending entertainment events.",
      "Sell or collect admission tickets, passes, or facility memberships from patrons at entertainment events.",
      "Clean facilities.",
      "Settle seating disputes or help solve other customer concerns.",
      "Examine tickets or passes to verify authenticity, using criteria such as color or date issued.",
      "Provide assistance with patrons' special needs, such as helping those with wheelchairs."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "adhesive_bonding_machine_operators_and_tenders",
    "onet_code": "51-9191.00",
    "title": "Adhesive Bonding Machine Operators and Tenders",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Monitoring",
      "Coordination",
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance",
      "Troubleshooting",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Information Ordering"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "hands_on",
      "physical",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9196.00",
      "51-9032.00",
      "53-7063.00"
    ],
    "training_paths": [],
    "description": "Operate or tend bonding machines that use adhesives to join items for further processing or to form a completed product. Processes include joining veneer sheets into plywood; gluing paper; or joining rubber and rubberized fabric parts, plastic, simulated leather, or other materials.",
    "dailyActivities": [
      "Align and position materials being joined to ensure accurate application of adhesive or heat sealing.",
      "Adjust machine components according to specifications such as widths, lengths, and thickness of materials and amounts of glue, cement, or adhesive required.",
      "Monitor machine operations to detect malfunctions and report or resolve problems.",
      "Start machines, and turn valves or move controls to feed, admit, apply, or transfer materials and adhesives, and to adjust temperature, pressure, and time settings.",
      "Fill machines with glue, cement, or adhesives.",
      "Perform test production runs and make adjustments as necessary to ensure that completed products meet standards and specifications."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "aircraft_structure_surfaces_rigging_and_systems_assemblers",
    "onet_code": "51-2011.00",
    "title": "Aircraft Structure, Surfaces, Rigging, and Systems Assemblers",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Installation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-2031.00",
      "51-2041.00",
      "51-2023.00"
    ],
    "training_paths": [],
    "description": "Assemble, fit, fasten, and install parts of airplanes, space vehicles, or missiles, such as tails, wings, fuselage, bulkheads, stabilizers, landing gear, rigging and control equipment, or heating and ventilating systems.",
    "dailyActivities": [
      "Assemble parts, fittings, or subassemblies on aircraft, using layout tools, hand tools, power tools, or fasteners, such as bolts, screws, rivets, or clamps.",
      "Read blueprints, illustrations, or specifications to determine layouts, sequences of operations, or identities or relationships of parts.",
      "Attach brackets, hinges, or clips to secure or support components or subassemblies, using bolts, screws, rivets, chemical bonding, or welding.",
      "Inspect or test installed units, parts, systems, or assemblies for fit, alignment, performance, defects, or compliance with standards, using measuring instruments or test equipment.",
      "Adjust, repair, rework, or replace parts or assemblies to ensure proper operation.",
      "Cut, trim, file, bend, or smooth parts to ensure proper fit and clearance."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "assemblers_and_fabricators_all_other",
    "onet_code": "51-2099.00",
    "title": "Assemblers and Fabricators, All Other",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "production"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All assemblers and fabricators not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "bakers",
    "onet_code": "51-3011.00",
    "title": "Bakers",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Critical Thinking",
      "Active Learning"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Information Ordering",
      "Category Flexibility",
      "Perceptual Speed"
    ],
    "keywords": [
      "customer_service",
      "production",
      "hands_on",
      "physical",
      "problem_solving"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-3092.00",
      "35-1011.00",
      "35-2014.00"
    ],
    "training_paths": [],
    "description": "Mix and bake ingredients to produce breads, rolls, cookies, cakes, pies, pastries, or other baked goods.",
    "dailyActivities": [
      "Check products for quality, and identify damaged or expired goods.",
      "Set oven temperatures, and place items into hot ovens for baking.",
      "Combine measured ingredients in bowls of mixing, blending, or cooking machinery.",
      "Place dough in pans, molds, or on sheets, and bake in production ovens or on grills.",
      "Set time and speed controls for mixing machines, blending machines, or steam kettles so that ingredients will be mixed or cooked according to instructions.",
      "Measure or weigh flour or other ingredients to prepare batters, doughs, fillings, or icings, using scales or graduated containers."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "biofuels_processing_technicians",
    "onet_code": "51-8099.01",
    "title": "Biofuels Processing Technicians",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Social Perceptiveness",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-8013.03",
      "51-8091.00",
      "51-8093.00"
    ],
    "training_paths": [],
    "description": "Calculate, measure, load, mix, and process refined feedstock with additives in fermentation or reaction process vessels and monitor production process. Perform, and keep records of, plant maintenance, repairs, and safety inspections.",
    "dailyActivities": [
      "Monitor batch, continuous flow, or hybrid biofuels production processes.",
      "Operate valves, pumps, engines, or generators to control and adjust biofuels production.",
      "Monitor and record biofuels processing data.",
      "Collect biofuels samples and perform routine laboratory tests or analyses to assess biofuels quality.",
      "Operate equipment, such as a centrifuge, to extract biofuels products and secondary by-products or reusable fractions.",
      "Process refined feedstock with additives in fermentation or reaction process vessels."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "biomass_plant_technicians",
    "onet_code": "51-8013.03",
    "title": "Biomass Plant Technicians",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "11-3051.04",
      "51-8099.01",
      "51-8013.00"
    ],
    "training_paths": [],
    "description": "Control and monitor biomass plant activities and perform maintenance as needed.",
    "dailyActivities": [
      "Operate biomass fuel-burning boiler or biomass fuel gasification system equipment in accordance with specifications or instructions.",
      "Perform tests of water chemistry in boilers.",
      "Operate high-pressure steam boiler or water chiller equipment for electrical cogeneration operations.",
      "Operate equipment to heat biomass, using knowledge of controls, combustion, and firing mechanisms.",
      "Operate equipment to start, stop, or regulate biomass-fueled generators, generator units, boilers, engines, or auxiliary systems.",
      "Inspect biomass power plant or processing equipment, recording or reporting damage and mechanical problems."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "butchers_and_meat_cutters",
    "onet_code": "51-3021.00",
    "title": "Butchers and Meat Cutters",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Time Management",
      "Management of Personnel Resources"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Information Ordering",
      "Category Flexibility",
      "Arm-Hand Steadiness"
    ],
    "keywords": [
      "customer_service",
      "production",
      "hands_on",
      "physical",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-3022.00",
      "51-3023.00",
      "35-2014.00"
    ],
    "training_paths": [],
    "description": "Cut, trim, or prepare consumer-sized portions of meat for use or sale in retail establishments.",
    "dailyActivities": [
      "Prepare and place meat cuts and products in display counter to appear attractive and catch the shopper's eye.",
      "Wrap, weigh, label, and price cuts of meat.",
      "Cut, trim, bone, tie, and grind meats, such as beef, pork, poultry, and fish, to prepare in cooking form.",
      "Prepare special cuts of meat ordered by customers.",
      "Receive, inspect, and store meat upon delivery to ensure meat quality.",
      "Estimate requirements and order or requisition meat supplies to maintain inventories."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "cabinetmakers_and_bench_carpenters",
    "onet_code": "51-7011.00",
    "title": "Cabinetmakers and Bench Carpenters",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Mathematics",
      "Critical Thinking",
      "Monitoring",
      "Operations Monitoring",
      "Quality Control Analysis",
      "Time Management"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Information Ordering",
      "Visualization"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-7031.00",
      "51-7021.00",
      "51-7042.00"
    ],
    "training_paths": [],
    "description": "Cut, shape, and assemble wooden articles or set up and operate a variety of woodworking machines, such as power saws, jointers, and mortisers to surface, cut, or shape lumber or to fabricate parts for wood products.",
    "dailyActivities": [
      "Verify dimensions or check the quality or fit of pieces to ensure adherence to specifications.",
      "Produce or assemble components of articles, such as store fixtures, office equipment, cabinets, or high-grade furniture.",
      "Measure and mark dimensions of parts on paper or lumber stock prior to cutting, following blueprints, to ensure a tight fit and quality product.",
      "Set up or operate machines, including power saws, jointers, mortisers, tenoners, molders, or shapers, to cut, mold, or shape woodstock or wood substitutes.",
      "Establish the specifications of articles to be constructed or repaired, or plan the methods or operations for shaping or assembling parts, based on blueprints, drawings, diagrams, or oral or written instructions.",
      "Attach parts or subassemblies together to form completed units, using glue, dowels, nails, screws, or clamps."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "chemical_equipment_operators_and_tenders",
    "onet_code": "51-9011.00",
    "title": "Chemical Equipment Operators and Tenders",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Coordination",
      "Operations Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-8091.00",
      "51-9012.00",
      "51-8031.00"
    ],
    "training_paths": [],
    "description": "Operate or tend equipment to control chemical changes or reactions in the processing of industrial or consumer products. Equipment used includes devulcanizers, steam-jacketed kettles, and reactor vessels.",
    "dailyActivities": [
      "Observe safety precautions to prevent fires or explosions.",
      "Record operational data, such as temperatures, pressures, ingredients used, processing times, or test results.",
      "Control or operate equipment in which chemical changes or reactions take place during the processing of industrial or consumer products.",
      "Patrol work areas to detect leaks or equipment malfunctions or to monitor operating conditions.",
      "Draw samples of products at specified stages so that analyses can be performed.",
      "Adjust controls to regulate temperature, pressure, feed, or flow of liquids or gases and times of prescribed reactions, according to knowledge of equipment and processes."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "chemical_plant_and_system_operators",
    "onet_code": "51-8091.00",
    "title": "Chemical Plant and System Operators",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Complex Problem Solving"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "detail_oriented",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9011.00",
      "51-9012.00",
      "51-8031.00"
    ],
    "training_paths": [],
    "description": "Control or operate entire chemical processes or system of machines.",
    "dailyActivities": [
      "Monitor recording instruments, flowmeters, panel lights, or other indicators and listen for warning signals to verify conformity of process conditions.",
      "Regulate or shut down equipment during emergency situations, as directed by supervisory personnel.",
      "Control or operate chemical processes or systems of machines, using panelboards, control boards, or semi-automatic equipment.",
      "Move control settings to make necessary adjustments on equipment units affecting speeds of chemical reactions, quality, or yields.",
      "Inspect operating units, such as towers, soap-spray storage tanks, scrubbers, collectors, or driers to ensure that all are functioning and to maintain maximum efficiency.",
      "Draw samples of products and conduct quality control tests to monitor processing and to ensure that standards are met."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "cleaning_washing_and_metal_pickling_equipment_operators_and_tenders",
    "onet_code": "51-9192.00",
    "title": "Cleaning, Washing, and Metal Pickling Equipment Operators and Tenders",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Perceptual Speed",
      "Arm-Hand Steadiness",
      "Control Precision",
      "Trunk Strength",
      "Extent Flexibility"
    ],
    "keywords": [
      "customer_service",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9012.00",
      "51-9023.00",
      "51-9051.00"
    ],
    "training_paths": [],
    "description": "Operate or tend machines to wash or clean products, such as barrels or kegs, glass items, tin plate, food, pulp, coal, plastic, or rubber, to remove impurities.",
    "dailyActivities": [
      "Add specified amounts of chemicals to equipment at required times to maintain solution levels and concentrations.",
      "Observe machine operations, gauges, or thermometers, and adjust controls to maintain specified conditions.",
      "Set controls to regulate temperature and length of cycles, and start conveyors, pumps, agitators, and machines.",
      "Drain, clean, and refill machines or tanks at designated intervals, using cleaning solutions or water.",
      "Operate or tend machines to wash and remove impurities from items such as barrels or kegs, glass products, tin plate surfaces, dried fruit, pulp, animal stock, coal, manufactured articles, plastic, or rubber.",
      "Record gauge readings, materials used, processing times, or test results in production logs."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "coating_painting_and_spraying_machine_setters_operators_and_tenders",
    "onet_code": "51-9124.00",
    "title": "Coating, Painting, and Spraying Machine Setters, Operators, and Tenders",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Information Ordering",
      "Flexibility of Closure",
      "Perceptual Speed",
      "Visualization"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9123.00",
      "51-4193.00",
      "51-9195.00"
    ],
    "training_paths": [],
    "description": "Set up, operate, or tend spraying or rolling machines to coat or paint any of a wide variety of products, including glassware, cloth, ceramics, metal, plastic, paper, or wood, with lacquer, silver, copper, rubber, varnish, glaze, enamel, oil, or rust-proofing materials. Includes painters of transportation vehicles such as painters in auto body repair facilities.",
    "dailyActivities": [
      "Dispose of hazardous waste in an appropriate manner.",
      "Hold or position spray guns to direct spray onto articles.",
      "Spray prepared surfaces with specified amounts of primers and decorative or finish coatings.",
      "Monitor painting operations to identify flaws, such as blisters or streaks, and correct their causes.",
      "Disassemble, clean, and reassemble sprayers or power equipment, using solvents, wire brushes, and cloths.",
      "Fill hoppers, reservoirs, troughs, or pans with material used to coat, paint, or spray, using conveyors or pails."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "coil_winders_tapers_and_finishers",
    "onet_code": "51-2021.00",
    "title": "Coil Winders, Tapers, and Finishers",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Problem Sensitivity",
      "Selective Attention",
      "Arm-Hand Steadiness",
      "Manual Dexterity",
      "Finger Dexterity"
    ],
    "keywords": [
      "customer_service",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-2022.00",
      "51-4034.00",
      "51-6091.00"
    ],
    "training_paths": [],
    "description": "Wind wire coils used in electrical components, such as resistors and transformers, and in electrical equipment and instruments, such as field cores, bobbins, armature cores, electrical motors, generators, and control equipment.",
    "dailyActivities": [
      "Operate or tend wire-coiling machines to wind wire coils used in electrical components such as resistors and transformers, and in electrical equipment and instruments such as bobbins and generators.",
      "Attach, alter, and trim materials such as wire, insulation, and coils, using hand tools.",
      "Cut, strip, and bend wire leads at ends of coils, using pliers and wire scrapers.",
      "Review work orders and specifications to determine materials needed and types of parts to be processed.",
      "Select and load materials such as workpieces, objects, and machine parts onto equipment used in coiling processes.",
      "Record production and operational data on specified forms."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "computer_numerically_controlled_tool_operators",
    "onet_code": "51-9161.00",
    "title": "Computer Numerically Controlled Tool Operators",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Complex Problem Solving",
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-4035.00",
      "51-4041.00",
      "51-4034.00"
    ],
    "training_paths": [],
    "description": "Operate computer-controlled tools, machines, or robots to machine or process parts, tools, or other work pieces made of metal, plastic, wood, stone, or other materials. May also set up and maintain equipment.",
    "dailyActivities": [
      "Measure dimensions of finished workpieces to ensure conformance to specifications, using precision measuring instruments, templates, and fixtures.",
      "Set up and operate computer-controlled machines or robots to perform one or more machine functions on metal or plastic workpieces.",
      "Mount, install, align, and secure tools, attachments, fixtures, and workpieces on machines, using hand tools and precision measuring instruments.",
      "Review program specifications or blueprints to determine and set machine operations and sequencing, finished workpiece dimensions, or numerical control sequences.",
      "Stop machines to remove finished workpieces or to change tooling, setup, or workpiece placement, according to required machining sequences.",
      "Listen to machines during operation to detect sounds such as those made by dull cutting tools or excessive vibration, and adjust machines to compensate for problems."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "computer_numerically_controlled_tool_programmers",
    "onet_code": "51-9162.00",
    "title": "Computer Numerically Controlled Tool Programmers",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9161.00",
      "51-4041.00",
      "17-3024.01"
    ],
    "training_paths": [],
    "description": "Develop programs to control machining or processing of materials by automatic machine tools, equipment, or systems. May also set up, operate, or maintain equipment.",
    "dailyActivities": [
      "Determine the sequence of machine operations, and select the proper cutting tools needed to machine workpieces into the desired shapes.",
      "Analyze job orders, drawings, blueprints, specifications, printed circuit board pattern films, and design data to calculate dimensions, tool selection, machine speeds, and feed rates.",
      "Observe machines on trial runs or conduct computer simulations to ensure that programs and machinery will function properly and produce items that meet specifications.",
      "Write programs in the language of a machine's controller and store programs on media, such as punch tapes, magnetic tapes, or disks.",
      "Determine reference points, machine cutting paths, or hole locations, and compute angular and linear dimensions, radii, and curvatures.",
      "Enter computer commands to store or retrieve parts patterns, graphic displays, or programs that transfer data to other media."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "cooling_and_freezing_equipment_operators_and_tenders",
    "onet_code": "51-9193.00",
    "title": "Cooling and Freezing Equipment Operators and Tenders",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Complex Problem Solving",
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "technical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9192.00",
      "51-9012.00",
      "51-9051.00"
    ],
    "training_paths": [],
    "description": "Operate or tend equipment such as cooling and freezing units, refrigerators, batch freezers, and freezing tunnels, to cool or freeze products, food, blood plasma, and chemicals.",
    "dailyActivities": [
      "Record temperatures, amounts of materials processed, or test results on report forms.",
      "Monitor pressure gauges, ammeters, flowmeters, thermometers, or products, and adjust controls to maintain specified conditions, such as feed rate, product consistency, temperature, air pressure, and machine speed.",
      "Read dials and gauges on panel control boards to ascertain temperatures, alkalinities, and densities of mixtures, and turn valves to obtain specified mixtures.",
      "Start machinery, such as pumps, feeders, or conveyors, and turn valves to heat, admit, or transfer products, refrigerants, or mixes.",
      "Correct machinery malfunctions by performing actions such as removing jams, and inform supervisors of malfunctions as necessary.",
      "Assemble equipment, and attach pipes, fittings, or valves, using hand tools."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "crushing_grinding_and_polishing_machine_setters_operators_and_tenders",
    "onet_code": "51-9021.00",
    "title": "Crushing, Grinding, and Polishing Machine Setters, Operators, and Tenders",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Critical Thinking",
      "Monitoring",
      "Coordination",
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "detail_oriented",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-4033.00",
      "51-9022.00",
      "53-7063.00"
    ],
    "training_paths": [],
    "description": "Set up, operate, or tend machines to crush, grind, or polish materials, such as coal, glass, grain, stone, food, or rubber.",
    "dailyActivities": [
      "Observe operation of equipment to ensure continuity of flow, safety, and efficient operation, and to detect malfunctions.",
      "Clean, adjust, and maintain equipment, using hand tools.",
      "Tend accessory equipment, such as pumps and conveyors, to move materials or ingredients through production processes.",
      "Move controls to start, stop, or adjust machinery and equipment that crushes, grinds, polishes, or blends materials.",
      "Notify supervisors of needed repairs.",
      "Weigh or measure materials, ingredients, or products at specified intervals to ensure conformance to requirements."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "cutters_and_trimmers_hand",
    "onet_code": "51-9031.00",
    "title": "Cutters and Trimmers, Hand",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Oral Comprehension",
      "Information Ordering",
      "Selective Attention",
      "Arm-Hand Steadiness",
      "Manual Dexterity"
    ],
    "keywords": [
      "production",
      "hands_on",
      "physical"
    ],
    "salary": {
      "entry_min": 21021,
      "entry_max": 28028,
      "mid_min": 28028,
      "mid_max": 36436
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9032.00",
      "51-9022.00",
      "51-6031.00"
    ],
    "training_paths": [],
    "description": "Use hand tools or hand-held power tools to cut and trim a variety of manufactured items, such as carpet, fabric, stone, glass, or rubber.",
    "dailyActivities": [
      "Mark or discard items with defects such as spots, stains, scars, snags, chips, scratches, or unacceptable shapes or finishes.",
      "Trim excess material or cut threads off finished products, such as cutting loose ends of plastic off a manufactured toy for a smoother finish.",
      "Cut, shape, and trim materials, such as textiles, food, glass, stone, and metal, using knives, scissors, and other hand tools, portable power tools, or bench-mounted tools.",
      "Position templates or measure materials to locate specified points of cuts or to obtain maximum yields, using rules, scales, or patterns.",
      "Read work orders to determine dimensions, cutting locations, and quantities to cut.",
      "Mark cutting lines around patterns or templates, or follow layout points, using squares, rules, and straightedges, and chalk, pencils, or scribes."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "cutting_and_slicing_machine_setters_operators_and_tenders",
    "onet_code": "51-9032.00",
    "title": "Cutting and Slicing Machine Setters, Operators, and Tenders",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Monitoring",
      "Coordination",
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance",
      "Troubleshooting",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Information Ordering",
      "Perceptual Speed"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-7042.00",
      "51-4033.00",
      "51-6062.00"
    ],
    "training_paths": [],
    "description": "Set up, operate, or tend machines that cut or slice materials, such as glass, stone, cork, rubber, tobacco, food, paper, or insulating material.",
    "dailyActivities": [
      "Set up, operate, or tend machines that cut or slice materials, such as glass, stone, cork, rubber, tobacco, food, paper, or insulating material.",
      "Review work orders, blueprints, specifications, or job samples to determine components, settings, and adjustments for cutting and slicing machines.",
      "Examine, measure, and weigh materials or products to verify conformance to specifications, using measuring devices, such as rulers, micrometers, or scales.",
      "Press buttons, pull levers, or depress pedals to start and operate cutting and slicing machines.",
      "Start machines to verify setups, and make any necessary adjustments.",
      "Feed stock into cutting machines, onto conveyors, or under cutting blades, by threading, guiding, pushing, or turning handwheels."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "cutting_punching_and_press_machine_setters_operators_and_tenders_metal_and_plastic",
    "onet_code": "51-4031.00",
    "title": "Cutting, Punching, and Press Machine Setters, Operators, and Tenders, Metal and Plastic",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Critical Thinking",
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control",
      "Troubleshooting",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "detail_oriented",
      "production",
      "hands_on",
      "physical",
      "technical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9032.00",
      "51-7042.00",
      "51-4035.00"
    ],
    "training_paths": [],
    "description": "Set up, operate, or tend machines to saw, cut, shear, slit, punch, crimp, notch, bend, or straighten metal or plastic material.",
    "dailyActivities": [
      "Measure completed workpieces to verify conformance to specifications, using micrometers, gauges, calipers, templates, or rulers.",
      "Examine completed workpieces for defects, such as chipped edges or marred surfaces and sort defective pieces according to types of flaws.",
      "Read work orders or production schedules to determine specifications, such as materials to be used, locations of cutting lines, or dimensions and tolerances.",
      "Start machines, monitor their operations, and record operational data.",
      "Set up, operate, or tend machines to saw, cut, shear, slit, punch, crimp, notch, bend, or straighten metal or plastic material.",
      "Test and adjust machine speeds or actions, according to product specifications, using gauges and hand tools."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "dental_laboratory_technicians",
    "onet_code": "51-9081.00",
    "title": "Dental Laboratory Technicians",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring",
      "Operations Monitoring",
      "Time Management"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Information Ordering",
      "Category Flexibility"
    ],
    "keywords": [
      "customer_service",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9082.00",
      "31-9091.00",
      "51-9083.00"
    ],
    "training_paths": [],
    "description": "Construct and repair full or partial dentures or dental appliances.",
    "dailyActivities": [
      "Read prescriptions or specifications and examine models or impressions to determine the design of dental products to be constructed.",
      "Test appliances for conformance to specifications and accuracy of occlusion, using articulators and micrometers.",
      "Fabricate, alter, or repair dental devices, such as dentures, crowns, bridges, inlays, or appliances for straightening teeth.",
      "Place tooth models on an apparatus that mimics bite and movement of patient's jaw to evaluate functionality of model.",
      "Remove excess metal or porcelain and polish surfaces of prostheses or frameworks, using polishing machines.",
      "Train or supervise other dental technicians or dental laboratory bench workers."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "drilling_and_boring_machine_tool_setters_operators_and_tenders_metal_and_plastic",
    "onet_code": "51-4032.00",
    "title": "Drilling and Boring Machine Tool Setters, Operators, and Tenders, Metal and Plastic",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Inductive Reasoning",
      "Information Ordering"
    ],
    "keywords": [
      "customer_service",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-4035.00",
      "51-4034.00",
      "51-7042.00"
    ],
    "training_paths": [],
    "description": "Set up, operate, or tend drilling machines to drill, bore, ream, mill, or countersink metal or plastic work pieces.",
    "dailyActivities": [
      "Verify conformance of machined work to specifications, using measuring instruments, such as calipers, micrometers, or fixed or telescoping gauges.",
      "Study machining instructions, job orders, or blueprints to determine dimensional or finish specifications, sequences of operations, setups, or tooling requirements.",
      "Move machine controls to lower tools to workpieces and to engage automatic feeds.",
      "Verify that workpiece reference lines are parallel to the axis of table rotation, using dial indicators mounted in spindles.",
      "Establish zero reference points on workpieces, such as at the intersections of two edges or over hole locations.",
      "Change worn cutting tools, using wrenches."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "electrical_and_electronic_equipment_assemblers",
    "onet_code": "51-2022.00",
    "title": "Electrical and Electronic Equipment Assemblers",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Critical Thinking",
      "Operations Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "production",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-2023.00",
      "51-2011.00",
      "51-2031.00"
    ],
    "training_paths": [],
    "description": "Assemble or modify electrical or electronic equipment, such as computers, test equipment telemetering systems, electric motors, and batteries.",
    "dailyActivities": [
      "Read and interpret schematic drawings, diagrams, blueprints, specifications, work orders, or reports to determine materials requirements or assembly instructions.",
      "Assemble electrical or electronic systems or support structures and install components, units, subassemblies, wiring, or assembly casings, using rivets, bolts, soldering or micro-welding equipment.",
      "Adjust, repair, or replace electrical or electronic components to correct defects and to ensure conformance to specifications.",
      "Position, align, or adjust workpieces or electrical parts to facilitate wiring or assembly.",
      "Explain assembly procedures or techniques to other workers.",
      "Clean parts, using cleaning solutions, air hoses, and cloths."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "electromechanical_equipment_assemblers",
    "onet_code": "51-2023.00",
    "title": "Electromechanical Equipment Assemblers",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Operations Monitoring",
      "Troubleshooting",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Inductive Reasoning",
      "Information Ordering"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-2022.00",
      "51-2031.00",
      "51-2011.00"
    ],
    "training_paths": [],
    "description": "Assemble or modify electromechanical equipment or devices, such as servomechanisms, gyros, dynamometers, magnetic drums, tape drives, brakes, control linkage, actuators, and appliances.",
    "dailyActivities": [
      "Inspect, test, and adjust completed units to ensure that units meet specifications, tolerances, and customer order requirements.",
      "Position, align, and adjust parts for proper fit and assembly.",
      "Assemble parts or units, and position, align, and fasten units to assemblies, subassemblies, or frames, using hand tools and power tools.",
      "Connect cables, tubes, and wiring, according to specifications.",
      "Measure parts to determine tolerances, using precision measuring instruments such as micrometers, calipers, and verniers.",
      "Read blueprints and specifications to determine component parts and assembly sequences of electromechanical units."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "engine_and_other_machine_assemblers",
    "onet_code": "51-2031.00",
    "title": "Engine and Other Machine Assemblers",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Critical Thinking",
      "Monitoring",
      "Operations Monitoring",
      "Troubleshooting",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "hands_on",
      "physical",
      "technical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-2011.00",
      "51-2023.00",
      "49-2092.00"
    ],
    "training_paths": [],
    "description": "Construct, assemble, or rebuild machines, such as engines, turbines, and similar equipment used in such industries as construction, extraction, textiles, and paper manufacturing.",
    "dailyActivities": [
      "Read and interpret assembly blueprints or specifications manuals, and plan assembly or building operations.",
      "Inspect, operate, and test completed products to verify functioning, machine capabilities, or conformance to customer specifications.",
      "Position or align components for assembly, manually or using hoists.",
      "Set and verify parts clearances.",
      "Verify conformance of parts to stock lists or blueprints, using measuring instruments such as calipers, gauges, or micrometers.",
      "Fasten or install piping, fixtures, or wiring and electrical components to form assemblies or subassemblies, using hand tools, rivet guns, or welding equipment."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "etchers_and_engravers",
    "onet_code": "51-9194.00",
    "title": "Etchers and Engravers",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Critical Thinking",
      "Operations Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "production",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9123.00",
      "51-4062.00",
      "51-9022.00"
    ],
    "training_paths": [],
    "description": "Engrave or etch metal, wood, rubber, or other materials. Includes such workers as etcher-circuit processors, pantograph engravers, and silk screen etchers.",
    "dailyActivities": [
      "Inspect etched work for depth of etching, uniformity, and defects, using calibrated microscopes, gauges, fingers, or magnifying lenses.",
      "Examine sketches, diagrams, samples, blueprints, or photographs to decide how designs are to be etched, cut, or engraved onto workpieces.",
      "Clean and polish engraved areas.",
      "Prepare workpieces for etching or engraving by cutting, sanding, cleaning, polishing, or treating them with wax, acid resist, lime, etching powder, or light-sensitive enamel.",
      "Engrave and print patterns, designs, etchings, trademarks, or lettering onto flat or curved surfaces of a wide variety of metal, glass, plastic, or paper items, using hand tools or hand-held power tools.",
      "Prepare etching chemicals according to formulas, diluting acid with water to obtain solutions of specified concentration."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "extruding_and_drawing_machine_setters_operators_and_tenders_metal_and_plastic",
    "onet_code": "51-4021.00",
    "title": "Extruding and Drawing Machine Setters, Operators, and Tenders, Metal and Plastic",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Monitoring",
      "Coordination",
      "Operations Monitoring",
      "Operation and Control",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Deductive Reasoning",
      "Information Ordering",
      "Perceptual Speed",
      "Visualization"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-6091.00",
      "51-4072.00",
      "51-4031.00"
    ],
    "training_paths": [],
    "description": "Set up, operate, or tend machines to extrude or draw thermoplastic or metal materials into tubes, rods, hoses, wire, bars, or structural shapes.",
    "dailyActivities": [
      "Measure and examine extruded products to locate defects and to check for conformance to specifications, adjusting controls as necessary to alter products.",
      "Determine setup procedures and select machine dies and parts, according to specifications.",
      "Start machines and set controls to regulate vacuum, air pressure, sizing rings, and temperature, and to synchronize speed of extrusion.",
      "Reel extruded products into rolls of specified lengths and weights.",
      "Install dies, machine screws, and sizing rings on machines that extrude thermoplastic or metal materials.",
      "Change dies on extruding machines, according to production line changes."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "extruding_and_forming_machine_setters_operators_and_tenders_synthetic_and_glass_fibers",
    "onet_code": "51-6091.00",
    "title": "Extruding and Forming Machine Setters, Operators, and Tenders, Synthetic and Glass Fibers",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Critical Thinking",
      "Monitoring",
      "Coordination",
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-4021.00",
      "51-9041.00",
      "51-9196.00"
    ],
    "training_paths": [],
    "description": "Set up, operate, or tend machines that extrude and form continuous filaments from synthetic materials, such as liquid polymer, rayon, and fiberglass.",
    "dailyActivities": [
      "Set up, operate, or tend machines that extrude and form filaments from synthetic materials such as rayon, fiberglass, or liquid polymers.",
      "Press buttons to stop machines when processes are complete or when malfunctions are detected.",
      "Notify other workers of defects, and direct them to adjust extruding and forming machines.",
      "Observe machine operations, control boards, and gauges to detect malfunctions such as clogged bushings and defective binder applicators.",
      "Load materials into extruding and forming machines, using hand tools, and adjust feed mechanisms to set feed rates.",
      "Move controls to activate and adjust extruding and forming machines."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "extruding_forming_pressing_and_compacting_machine_setters_operators_and_tenders",
    "onet_code": "51-9041.00",
    "title": "Extruding, Forming, Pressing, and Compacting Machine Setters, Operators, and Tenders",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Information Ordering",
      "Category Flexibility",
      "Perceptual Speed",
      "Visualization"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-6091.00",
      "53-7063.00",
      "51-9032.00"
    ],
    "training_paths": [],
    "description": "Set up, operate, or tend machines, such as glass-forming machines, plodder machines, and tuber machines, to shape and form products such as glassware, food, rubber, soap, brick, tile, clay, wax, tobacco, or cosmetics.",
    "dailyActivities": [
      "Adjust machine components to regulate speeds, pressures, and temperatures, and amounts, dimensions, and flow of materials or ingredients.",
      "Press control buttons to activate machinery and equipment.",
      "Examine, measure, and weigh materials or products to verify conformance to standards, using measuring devices such as templates, micrometers, or scales.",
      "Monitor machine operations and observe lights and gauges to detect malfunctions.",
      "Clear jams, and remove defective or substandard materials or products.",
      "Notify supervisors when extruded filaments fail to meet standards."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "fabric_and_apparel_patternmakers",
    "onet_code": "51-6092.00",
    "title": "Fabric and Apparel Patternmakers",
    "category": "Production",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "detail_oriented",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 30030,
      "entry_max": 40040,
      "mid_min": 40040,
      "mid_max": 52052
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-4062.00",
      "51-6051.00",
      "51-7032.00"
    ],
    "training_paths": [],
    "description": "Draw and construct sets of precision master fabric patterns or layouts. May also mark and cut fabrics and apparel.",
    "dailyActivities": [
      "Create a master pattern for each size within a range of garment sizes, using charts, drafting instruments, computers, or grading devices.",
      "Input specifications into computers to assist with pattern design and pattern cutting.",
      "Draw details on outlined parts to indicate where parts are to be joined, as well as the positions of pleats, pockets, buttonholes, and other features, using computers or drafting instruments.",
      "Make adjustments to patterns after fittings.",
      "Compute dimensions of patterns according to sizes, considering stretching of material.",
      "Mark samples and finished patterns with information, such as garment size, section, style, identification, and sewing instructions."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "fiberglass_laminators_and_fabricators",
    "onet_code": "51-2051.00",
    "title": "Fiberglass Laminators and Fabricators",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Information Ordering",
      "Category Flexibility",
      "Flexibility of Closure"
    ],
    "keywords": [
      "customer_service",
      "production",
      "hands_on",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9195.00",
      "51-4071.00",
      "47-2131.00"
    ],
    "training_paths": [],
    "description": "Laminate layers of fiberglass on molds to form boat decks and hulls, bodies for golf carts, automobiles, or other products.",
    "dailyActivities": [
      "Release air bubbles and smooth seams, using rollers.",
      "Spray chopped fiberglass, resins, and catalysts onto prepared molds or dies using pneumatic spray guns with chopper attachments.",
      "Mix catalysts into resins, and saturate cloth and mats with mixtures, using brushes.",
      "Check completed products for conformance to specifications and for defects by measuring with rulers or micrometers, by checking them visually, or by tapping them to detect bubbles or dead spots.",
      "Pat or press layers of saturated mat or cloth into place on molds, using brushes or hands, and smooth out wrinkles and air bubbles with hands or squeegees.",
      "Select precut fiberglass mats, cloth, and wood-bracing materials as required by projects being assembled."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "first_line_supervisors_of_production_and_operating_workers",
    "onet_code": "51-1011.00",
    "title": "First-Line Supervisors of Production and Operating Workers",
    "category": "Production",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 30030,
      "entry_max": 40040,
      "mid_min": 40040,
      "mid_max": 52052
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-1011.00",
      "47-1011.00",
      "53-1042.00"
    ],
    "training_paths": [],
    "description": "Directly supervise and coordinate the activities of production and operating workers, such as inspectors, precision workers, machine setters and operators, assemblers, fabricators, and plant and system operators. Excludes team or work leaders.",
    "dailyActivities": [
      "Enforce safety and sanitation regulations.",
      "Keep records of employees' attendance and hours worked.",
      "Inspect materials, products, or equipment to detect defects or malfunctions.",
      "Read and analyze charts, work orders, production schedules, and other records and reports to determine production requirements and to evaluate current production estimates and outputs.",
      "Plan and establish work schedules, assignments, and production sequences to meet production goals.",
      "Confer with other supervisors to coordinate operations and activities within or between departments."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "food_batchmakers",
    "onet_code": "51-3092.00",
    "title": "Food Batchmakers",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Monitoring",
      "Coordination",
      "Operations Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Information Ordering"
    ],
    "keywords": [
      "customer_service",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-3093.00",
      "51-3091.00",
      "51-9023.00"
    ],
    "training_paths": [],
    "description": "Set up and operate equipment that mixes or blends ingredients used in the manufacturing of food products. Includes candy makers and cheese makers.",
    "dailyActivities": [
      "Record production and test data for each food product batch, such as the ingredients used, temperature, test results, and time cycle.",
      "Clean and sterilize vats and factory processing areas.",
      "Set up, operate, and tend equipment that cooks, mixes, blends, or processes ingredients in the manufacturing of food products, according to formulas or recipes.",
      "Mix or blend ingredients, according to recipes, using a paddle or an agitator, or by controlling vats that heat and mix ingredients.",
      "Follow recipes to produce food products of specified flavor, texture, clarity, bouquet, or color.",
      "Give directions to other workers who are assisting in the batchmaking process."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "food_cooking_machine_operators_and_tenders",
    "onet_code": "51-3093.00",
    "title": "Food Cooking Machine Operators and Tenders",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Operations Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Problem Sensitivity",
      "Information Ordering",
      "Reaction Time",
      "Near Vision"
    ],
    "keywords": [
      "customer_service",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-3092.00",
      "51-3091.00",
      "51-9012.00"
    ],
    "training_paths": [],
    "description": "Operate or tend cooking equipment, such as steam cooking vats, deep fry cookers, pressure cookers, kettles, and boilers, to prepare food products.",
    "dailyActivities": [
      "Clean, wash, and sterilize equipment and cooking area, using water hoses, cleaning or sterilizing solutions, or rinses.",
      "Read work orders, recipes, or formulas to determine cooking times and temperatures, and ingredient specifications.",
      "Observe gauges, dials, and product characteristics, and adjust controls to maintain appropriate temperature, pressure, and flow of ingredients.",
      "Measure or weigh ingredients, using scales or measuring containers.",
      "Tend or operate and control equipment, such as kettles, cookers, vats and tanks, and boilers, to cook ingredients or prepare products for further processing.",
      "Record production and test data, such as processing steps, temperature and steam readings, cooking time, batches processed, and test results."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "food_processing_workers_all_other",
    "onet_code": "51-3099.00",
    "title": "Food Processing Workers, All Other",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "production"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All food processing workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "food_and_tobacco_roasting_baking_and_drying_machine_operators_and_tenders",
    "onet_code": "51-3091.00",
    "title": "Food and Tobacco Roasting, Baking, and Drying Machine Operators and Tenders",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Critical Thinking",
      "Monitoring",
      "Coordination",
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Information Ordering",
      "Category Flexibility"
    ],
    "keywords": [
      "production",
      "hands_on",
      "physical",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-3092.00",
      "51-3093.00",
      "51-9012.00"
    ],
    "training_paths": [],
    "description": "Operate or tend food or tobacco roasting, baking, or drying equipment, including hearth ovens, kiln driers, roasters, char kilns, and vacuum drying equipment.",
    "dailyActivities": [
      "Observe, feel, taste, or otherwise examine products during and after processing to ensure conformance to standards.",
      "Set temperature and time controls, light ovens, burners, driers, or roasters, and start equipment, such as conveyors, cylinders, blowers, driers, or pumps.",
      "Observe temperature, humidity, pressure gauges, and product samples and adjust controls, such as thermostats and valves, to maintain prescribed operating conditions for specific stages.",
      "Observe flow of materials and listen for machine malfunctions, such as jamming or spillage, and notify supervisors if corrective actions fail.",
      "Record production data, such as weight and amount of product processed, type of product, and time and temperature of processing.",
      "Weigh or measure products, using scale hoppers or scale conveyors."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "forging_machine_setters_operators_and_tenders_metal_and_plastic",
    "onet_code": "51-4022.00",
    "title": "Forging Machine Setters, Operators, and Tenders, Metal and Plastic",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "production",
      "hands_on",
      "analytical",
      "physical",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-4031.00",
      "51-7042.00",
      "51-4111.00"
    ],
    "training_paths": [],
    "description": "Set up, operate, or tend forging machines to taper, shape, or form metal or plastic parts.",
    "dailyActivities": [
      "Read work orders or blueprints to determine specified tolerances and sequences of operations for machine setup.",
      "Position and move metal wires or workpieces through a series of dies that compress and shape stock to form die impressions.",
      "Measure and inspect machined parts to ensure conformance to product specifications.",
      "Set up, operate, or tend presses and forging machines to perform hot or cold forging by flattening, straightening, bending, cutting, piercing, or other operations to taper, shape, or form metal.",
      "Turn handles or knobs to set pressures and depths of ram strokes and to synchronize machine operations.",
      "Install, adjust, and remove dies, synchronizing cams, forging hammers, and stop guides, using overhead cranes or other hoisting devices, and hand tools."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "foundry_mold_and_coremakers",
    "onet_code": "51-4071.00",
    "title": "Foundry Mold and Coremakers",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Visualization",
      "Arm-Hand Steadiness",
      "Manual Dexterity",
      "Finger Dexterity",
      "Control Precision"
    ],
    "keywords": [
      "customer_service",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9195.00",
      "51-4072.00",
      "51-2051.00"
    ],
    "training_paths": [],
    "description": "Make or form wax or sand cores or molds used in the production of metal castings in foundries.",
    "dailyActivities": [
      "Clean and smooth molds, cores, and core boxes, and repair surface imperfections.",
      "Sift and pack sand into mold sections, core boxes, and pattern contours, using hand or pneumatic ramming tools.",
      "Position patterns inside mold sections, and clamp sections together.",
      "Position cores into lower sections of molds, and reassemble molds for pouring.",
      "Sprinkle or spray parting agents onto patterns and mold sections to facilitate removal of patterns from molds.",
      "Form and assemble slab cores around patterns, and position wire in mold sections to reinforce molds, using hand tools and glue."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "furnace_kiln_oven_drier_and_kettle_operators_and_tenders",
    "onet_code": "51-9051.00",
    "title": "Furnace, Kiln, Oven, Drier, and Kettle Operators and Tenders",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Information Ordering"
    ],
    "keywords": [
      "customer_service",
      "production",
      "hands_on",
      "physical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9012.00",
      "51-9041.00",
      "51-4051.00"
    ],
    "training_paths": [],
    "description": "Operate or tend heating equipment other than basic metal, plastic, or food processing equipment. Includes activities such as annealing glass, drying lumber, curing rubber, removing moisture from materials, or boiling soap.",
    "dailyActivities": [
      "Monitor equipment operation, gauges, and panel lights to detect deviations from standards.",
      "Confer with supervisors or other equipment operators to report equipment malfunctions or to resolve production problems.",
      "Press and adjust controls to activate, set, and regulate equipment according to specifications.",
      "Record gauge readings, test results, and shift production in log books.",
      "Read and interpret work orders and instructions to determine work assignments, process specifications, and production schedules.",
      "Examine or test samples of processed substances, or collect samples for laboratory testing, to ensure conformance to specifications."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "furniture_finishers",
    "onet_code": "51-7021.00",
    "title": "Furniture Finishers",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Critical Thinking",
      "Operations Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Deductive Reasoning",
      "Inductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-6093.00",
      "51-9123.00",
      "51-7011.00"
    ],
    "training_paths": [],
    "description": "Shape, finish, and refinish damaged, worn, or used furniture or new high-grade furniture to specified color or finish.",
    "dailyActivities": [
      "Brush, spray, or hand-rub finishing ingredients, such as paint, oil, stain, or wax, onto and into wood grain and apply lacquer or other sealers.",
      "Fill and smooth cracks or depressions, remove marks and imperfections, and repair broken parts, using plastic or wood putty, glue, nails, or screws.",
      "Smooth, shape, and touch up surfaces to prepare them for finishing, using sandpaper, pumice stones, steel wool, chisels, sanders, or grinders.",
      "Remove accessories prior to finishing, and mask areas that should not be exposed to finishing processes or substances.",
      "Remove old finishes and damaged or deteriorated parts, using hand tools, stripping tools, sandpaper, steel wool, abrasives, solvents, or dip baths.",
      "Treat warped or stained surfaces to restore original contours and colors."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "gas_plant_operators",
    "onet_code": "51-8092.00",
    "title": "Gas Plant Operators",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-8013.00",
      "51-8093.00",
      "53-7071.00"
    ],
    "training_paths": [],
    "description": "Distribute or process gas for utility companies and others by controlling compressors to maintain specified pressures on main pipelines.",
    "dailyActivities": [
      "Monitor equipment functioning, observe temperature, level, and flow gauges, and perform regular unit checks to ensure that all equipment is operating as it should.",
      "Distribute or process gas for utility companies or industrial plants, using panel boards, control boards, and semi-automatic equipment.",
      "Control operation of compressors, scrubbers, evaporators, and refrigeration equipment to liquefy, compress, or regasify natural gas.",
      "Control equipment to regulate flow and pressure of gas to feedlines of boilers, furnaces, and related steam-generating or heating equipment.",
      "Record, review, and compile operations records, test results, and gauge readings such as temperatures, pressures, concentrations, and flows.",
      "Determine causes of abnormal pressure variances, and make corrective recommendations, such as installation of pipes to relieve overloading."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "gem_and_diamond_workers",
    "onet_code": "51-9071.06",
    "title": "Gem and Diamond Workers",
    "category": "Production",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Service Orientation",
      "Quality Control Analysis",
      "Judgment and Decision Making"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Deductive Reasoning",
      "Inductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 30030,
      "entry_max": 40040,
      "mid_min": 40040,
      "mid_max": 52052
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9071.00",
      "51-9022.00",
      "51-9194.00"
    ],
    "training_paths": [],
    "description": "Fabricate, finish, or evaluate the quality of gems and diamonds used in jewelry or industrial tools.",
    "dailyActivities": [
      "Examine gems during processing to ensure accuracy of angles and positions of cuts or bores, using magnifying glasses, loupes, or shadowgraphs.",
      "Assign polish, symmetry, and clarity grades to stones, according to established grading systems.",
      "Estimate wholesale and retail value of gems, following pricing guides, market fluctuations, and other relevant economic factors.",
      "Examine gem surfaces and internal structures, using polariscopes, refractometers, microscopes, and other optical instruments, to differentiate between stones, to identify rare specimens, or to detect flaws, defects, or peculiarities affecting gem values.",
      "Identify and document stones' clarity characteristics, using plot diagrams.",
      "Advise customers and others on the best use of gems to create attractive jewelry items."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "glass_blowers_molders_benders_and_finishers",
    "onet_code": "51-9195.04",
    "title": "Glass Blowers, Molders, Benders, and Finishers",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Critical Thinking",
      "Monitoring",
      "Operations Monitoring",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Information Ordering"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9195.00",
      "51-9041.00",
      "51-4072.00"
    ],
    "training_paths": [],
    "description": "Shape molten glass according to patterns.",
    "dailyActivities": [
      "Heat glass to pliable stage, using gas flames or ovens and rotating glass to heat it uniformly.",
      "Inspect, weigh, and measure products to verify conformance to specifications, using instruments such as micrometers, calipers, magnifiers, or rulers.",
      "Record manufacturing information, such as quantities, sizes, or types of goods produced.",
      "Place glass into dies or molds of presses and control presses to form products, such as glassware components or optical blanks.",
      "Spray or swab molds with oil solutions to prevent adhesion of glass.",
      "Blow tubing into specified shapes to prevent glass from collapsing, using compressed air or own breath, or blow and rotate gathers in molds or on boards to obtain final shapes."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "grinding_and_polishing_workers_hand",
    "onet_code": "51-9022.00",
    "title": "Grinding and Polishing Workers, Hand",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Operations Monitoring",
      "Operation and Control",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Information Ordering",
      "Category Flexibility",
      "Arm-Hand Steadiness"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-4033.00",
      "51-4194.00",
      "51-7042.00"
    ],
    "training_paths": [],
    "description": "Grind, sand, or polish, using hand tools or hand-held power tools, a variety of metal, wood, stone, clay, plastic, or glass objects. Includes chippers, buffers, and finishers.",
    "dailyActivities": [
      "Verify quality of finished workpieces by inspecting them, comparing them to templates, measuring their dimensions, or testing them in working machinery.",
      "Grind, sand, clean, or polish objects or parts to correct defects or to prepare surfaces for further finishing, using hand tools and power tools.",
      "Measure and mark equipment, objects, or parts to ensure grinding and polishing standards are met.",
      "Trim, scrape, or deburr objects or parts, using chisels, scrapers, and other hand tools and equipment.",
      "Mark defects, such as knotholes, cracks, and splits, for repair.",
      "Study blueprints or layouts to determine how to lay out workpieces or saw out templates."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "grinding_lapping_polishing_and_buffing_machine_tool_setters_operators_and_tenders_metal_and_plastic",
    "onet_code": "51-4033.00",
    "title": "Grinding, Lapping, Polishing, and Buffing Machine Tool Setters, Operators, and Tenders, Metal and Plastic",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Mathematics",
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Problem Sensitivity",
      "Information Ordering",
      "Category Flexibility"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-4194.00",
      "51-9022.00",
      "51-7042.00"
    ],
    "training_paths": [],
    "description": "Set up, operate, or tend grinding and related tools that remove excess material or burrs from surfaces, sharpen edges or corners, or buff, hone, or polish metal or plastic work pieces.",
    "dailyActivities": [
      "Inspect or measure finished workpieces to determine conformance to specifications, using measuring instruments, such as gauges or micrometers.",
      "Measure workpieces and lay out work, using precision measuring devices.",
      "Observe machine operations to detect any problems, making necessary adjustments to correct problems.",
      "Move machine controls to index workpieces, and to adjust machines for pre-selected operational settings.",
      "Study blueprints, work orders, or machining instructions to determine product specifications, tool requirements, and operational sequences.",
      "Select machine tooling to be used, using knowledge of machine and production requirements."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "heat_treating_equipment_setters_operators_and_tenders_metal_and_plastic",
    "onet_code": "51-4191.00",
    "title": "Heat Treating Equipment Setters, Operators, and Tenders, Metal and Plastic",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Critical Thinking",
      "Monitoring",
      "Instructing",
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "detail_oriented",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-4051.00",
      "51-9051.00",
      "51-4072.00"
    ],
    "training_paths": [],
    "description": "Set up, operate, or tend heating equipment, such as heat-treating furnaces, flame-hardening machines, induction machines, soaking pits, or vacuum equipment to temper, harden, anneal, or heat treat metal or plastic objects.",
    "dailyActivities": [
      "Read production schedules and work orders to determine processing sequences, furnace temperatures, and heat cycle requirements for objects to be heat-treated.",
      "Record times that parts are removed from furnaces to document that objects have attained specified temperatures for specified times.",
      "Adjust controls to maintain temperatures and heating times, using thermal instruments and charts, dials and gauges of furnaces, and color of stock in furnaces to make setting determinations.",
      "Start conveyors and open furnace doors to load stock, or signal crane operators to uncover soaking pits and lower ingots into them.",
      "Set up and operate or tend machines, such as furnaces, baths, flame-hardening machines, and electronic induction machines, that harden, anneal, and heat-treat metal.",
      "Remove parts from furnaces after specified times, and air dry or cool parts in water, oil brine, or other baths."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "helpers_production_workers",
    "onet_code": "51-9198.00",
    "title": "Helpers--Production Workers",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Perceptual Speed",
      "Arm-Hand Steadiness",
      "Manual Dexterity",
      "Finger Dexterity",
      "Control Precision"
    ],
    "keywords": [
      "production",
      "hands_on",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-9098.00",
      "47-5081.00",
      "53-7063.00"
    ],
    "training_paths": [],
    "description": "Help production workers by performing duties requiring less skill. Duties include supplying or holding materials or tools, and cleaning work area and equipment.",
    "dailyActivities": [
      "Load and unload items from machines, conveyors, and conveyances.",
      "Operate machinery used in the production process, or assist machine operators.",
      "Place products in equipment or on work surfaces for further processing, inspecting, or wrapping.",
      "Examine products to verify conformance to quality standards.",
      "Start machines or equipment to begin production processes.",
      "Observe equipment operations so that malfunctions can be detected, and notify operators of any malfunctions."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "hydroelectric_plant_technicians",
    "onet_code": "51-8013.04",
    "title": "Hydroelectric Plant Technicians",
    "category": "Production",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 30030,
      "entry_max": 40040,
      "mid_min": 40040,
      "mid_max": 52052
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "11-3051.06",
      "51-8013.00",
      "49-9099.01"
    ],
    "training_paths": [],
    "description": "Monitor and control activities associated with hydropower generation. Operate plant equipment, such as turbines, pumps, valves, gates, fans, electric control boards, and battery banks. Monitor equipment operation and performance and make necessary adjustments to ensure optimal performance. Perform equipment maintenance and repair as necessary.",
    "dailyActivities": [
      "Monitor hydroelectric power plant equipment operation and performance, adjusting to performance specifications, as necessary.",
      "Identify or address malfunctions of hydroelectric plant operational equipment, such as generators, transformers, or turbines.",
      "Start, adjust, or stop generating units, operating valves, gates, or auxiliary equipment in hydroelectric power generating plants.",
      "Perform preventive or corrective containment or cleanup measures in hydroelectric plants to prevent environmental contamination.",
      "Inspect water-powered electric generators or auxiliary equipment in hydroelectric plants to verify proper operation or to determine maintenance or repair needs.",
      "Communicate status of hydroelectric operating equipment to dispatchers or supervisors."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "inspectors_testers_sorters_samplers_and_weighers",
    "onet_code": "51-9061.00",
    "title": "Inspectors, Testers, Sorters, Samplers, and Weighers",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Operations Monitoring",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "17-3028.00",
      "49-9041.00",
      "51-2022.00"
    ],
    "training_paths": [],
    "description": "Inspect, test, sort, sample, or weigh nonagricultural raw materials or processed, machined, fabricated, or assembled parts or products for defects, wear, and deviations from specifications. May use precision measuring instruments and complex test equipment.",
    "dailyActivities": [
      "Discard or reject products, materials, or equipment not meeting specifications.",
      "Mark items with details, such as grade or acceptance-rejection status.",
      "Measure dimensions of products to verify conformance to specifications, using measuring instruments, such as rulers, calipers, gauges, or micrometers.",
      "Notify supervisors or other personnel of production problems.",
      "Inspect, test, or measure materials, products, installations, or work for conformance to specifications.",
      "Write test or inspection reports describing results, recommendations, or needed repairs."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "jewelers_and_precious_stone_and_metal_workers",
    "onet_code": "51-9071.00",
    "title": "Jewelers and Precious Stone and Metal Workers",
    "category": "Production",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Critical Thinking",
      "Monitoring",
      "Judgment and Decision Making"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Originality",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 30030,
      "entry_max": 40040,
      "mid_min": 40040,
      "mid_max": 52052
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9071.06",
      "51-9194.00",
      "51-9022.00"
    ],
    "training_paths": [],
    "description": "Design, fabricate, adjust, repair, or appraise jewelry, gold, silver, other precious metals, or gems.",
    "dailyActivities": [
      "Clean and polish metal items and jewelry pieces, using jewelers' tools, polishing wheels, and chemical baths.",
      "Smooth soldered joints and rough spots, using hand files and emery paper, and polish smoothed areas with polishing wheels or buffing wire.",
      "Create jewelry from materials such as gold, silver, platinum, and precious or semiprecious stones.",
      "Cut and file pieces of jewelry such as rings, brooches, bracelets, and lockets.",
      "Examine assembled or finished products to ensure conformance to specifications, using magnifying glasses or precision measuring instruments.",
      "Make repairs, such as enlarging or reducing ring sizes, soldering pieces of jewelry together, and replacing broken clasps and mountings."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "lathe_and_turning_machine_tool_setters_operators_and_tenders_metal_and_plastic",
    "onet_code": "51-4034.00",
    "title": "Lathe and Turning Machine Tool Setters, Operators, and Tenders, Metal and Plastic",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-4035.00",
      "51-4033.00",
      "51-4081.00"
    ],
    "training_paths": [],
    "description": "Set up, operate, or tend lathe and turning machines to turn, bore, thread, form, or face metal or plastic materials, such as wire, rod, or bar stock.",
    "dailyActivities": [
      "Adjust machine controls and change tool settings to keep dimensions within specified tolerances.",
      "Move controls to set cutting speeds and depths and feed rates, and to position tools in relation to workpieces.",
      "Study blueprints, layouts or charts, and job orders for information on specifications and tooling instructions, and to determine material requirements and operational sequences.",
      "Inspect sample workpieces to verify conformance with specifications, using instruments such as gauges, micrometers, and dial indicators.",
      "Replace worn tools, and sharpen dull cutting tools and dies, using bench grinders or cutter-grinding machines.",
      "Move toolholders manually or by turning handwheels, or engage automatic feeding mechanisms to feed tools to and along workpieces."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "laundry_and_dry_cleaning_workers",
    "onet_code": "51-6011.00",
    "title": "Laundry and Dry-Cleaning Workers",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Oral Expression",
      "Finger Dexterity",
      "Control Precision",
      "Trunk Strength",
      "Near Vision"
    ],
    "keywords": [
      "production",
      "hands_on",
      "physical"
    ],
    "salary": {
      "entry_min": 21021,
      "entry_max": 28028,
      "mid_min": 28028,
      "mid_max": 36436
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-7061.00",
      "51-6021.00",
      "51-9192.00"
    ],
    "training_paths": [],
    "description": "Operate or tend washing or dry-cleaning machines to wash or dry-clean industrial or household articles, such as cloth garments, suede, leather, furs, blankets, draperies, linens, rugs, and carpets. Includes spotters and dyers of these articles.",
    "dailyActivities": [
      "Load articles into washers or dry-cleaning machines, or direct other workers to perform loading.",
      "Start washers, dry cleaners, driers, or extractors, and turn valves or levers to regulate machine processes and the volume of soap, detergent, water, bleach, starch, and other additives.",
      "Operate extractors and driers, or direct their operation.",
      "Remove items from washers or dry-cleaning machines, or direct other workers to do so.",
      "Sort and count articles removed from dryers, and fold, wrap, or hang them.",
      "Clean machine filters, and lubricate equipment."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "layout_workers_metal_and_plastic",
    "onet_code": "51-4192.00",
    "title": "Layout Workers, Metal and Plastic",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Mathematics",
      "Critical Thinking",
      "Monitoring",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-2041.00",
      "51-2011.00",
      "51-4062.00"
    ],
    "training_paths": [],
    "description": "Lay out reference points and dimensions on metal or plastic stock or workpieces, such as sheets, plates, tubes, structural shapes, castings, or machine parts, for further processing. Includes shipfitters.",
    "dailyActivities": [
      "Mark curves, lines, holes, dimensions, and welding symbols onto workpieces, using scribes, soapstones, punches, and hand drills.",
      "Plan locations and sequences of cutting, drilling, bending, rolling, punching, and welding operations, using compasses, protractors, dividers, and rules.",
      "Fit and align fabricated parts to be welded or assembled.",
      "Locate center lines and verify template positions, using measuring instruments such as gauge blocks, height gauges, and dial indicators.",
      "Plan and develop layouts from blueprints and templates, applying knowledge of trigonometry, design, effects of heat, and properties of metals.",
      "Lay out and fabricate metal structural parts such as plates, bulkheads, and frames."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "machinists",
    "onet_code": "51-4041.00",
    "title": "Machinists",
    "category": "Production",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Coordination",
      "Complex Problem Solving",
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 30030,
      "entry_max": 40040,
      "mid_min": 40040,
      "mid_max": 52052
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9161.00",
      "51-4035.00",
      "51-4111.00"
    ],
    "training_paths": [],
    "description": "Set up and operate a variety of machine tools to produce precision parts and instruments out of metal. Includes precision instrument makers who fabricate, modify, or repair mechanical instruments. May also fabricate and modify parts to make or repair machine tools or maintain industrial machines, applying knowledge of mechanics, mathematics, metal properties, layout, and machining procedures.",
    "dailyActivities": [
      "Calculate dimensions or tolerances, using instruments, such as micrometers or vernier calipers.",
      "Machine parts to specifications, using machine tools, such as lathes, milling machines, shapers, or grinders.",
      "Measure, examine, or test completed units to check for defects and ensure conformance to specifications, using precision instruments, such as micrometers.",
      "Set up, adjust, or operate basic or specialized machine tools used to perform precision machining operations.",
      "Program computers or electronic instruments, such as numerically controlled machine tools.",
      "Study sample parts, blueprints, drawings, or engineering information to determine methods or sequences of operations needed to fabricate products."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "meat_poultry_and_fish_cutters_and_trimmers",
    "onet_code": "51-3022.00",
    "title": "Meat, Poultry, and Fish Cutters and Trimmers",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Arm-Hand Steadiness",
      "Control Precision",
      "Trunk Strength"
    ],
    "keywords": [
      "customer_service",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 21021,
      "entry_max": 28028,
      "mid_min": 28028,
      "mid_max": 36436
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-3023.00",
      "45-2041.00",
      "51-3021.00"
    ],
    "training_paths": [],
    "description": "Use hands or hand tools to perform routine cutting and trimming of meat, poultry, and seafood.",
    "dailyActivities": [
      "Use knives, cleavers, meat saws, bandsaws, or other equipment to perform meat cutting and trimming.",
      "Weigh meats and tag containers for weight and contents.",
      "Inspect meat products for defects, bruises or blemishes and remove them along with any excess fat.",
      "Cut and trim meat to prepare for packing.",
      "Separate meats and byproducts into specified containers and seal containers.",
      "Process primal parts into cuts that are ready for retail use."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "medical_appliance_technicians",
    "onet_code": "51-9082.00",
    "title": "Medical Appliance Technicians",
    "category": "Production",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 30030,
      "entry_max": 40040,
      "mid_min": 40040,
      "mid_max": 52052
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9081.00",
      "49-9062.00",
      "51-9083.00"
    ],
    "training_paths": [],
    "description": "Construct, maintain, or repair medical supportive devices such as braces, orthotics and prosthetic devices, joints, arch supports, and other surgical and medical appliances.",
    "dailyActivities": [
      "Drill and tap holes for rivets, and glue, weld, bolt, or rivet parts together to form prosthetic or orthotic devices.",
      "Read prescriptions or specifications to determine the type of product or device to be fabricated and the materials and tools required.",
      "Make orthotic or prosthetic devices, using materials such as thermoplastic and thermosetting materials, metal alloys and leather, and hand or power tools.",
      "Bend, form, and shape fabric or material to conform to prescribed contours of structural components.",
      "Construct or receive casts or impressions of patients' torsos or limbs for use as cutting and fabrication patterns.",
      "Repair, modify, or maintain medical supportive devices, such as artificial limbs, braces, or surgical supports, according to specifications."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "metal_workers_and_plastic_workers_all_other",
    "onet_code": "51-4199.00",
    "title": "Metal Workers and Plastic Workers, All Other",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "production"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All metal workers and plastic workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "metal_refining_furnace_operators_and_tenders",
    "onet_code": "51-4051.00",
    "title": "Metal-Refining Furnace Operators and Tenders",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Critical Thinking",
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Information Ordering",
      "Perceptual Speed"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-4191.00",
      "51-9051.00",
      "51-9012.00"
    ],
    "training_paths": [],
    "description": "Operate or tend furnaces, such as gas, oil, coal, electric-arc or electric induction, open-hearth, or oxygen furnaces, to melt and refine metal before casting or to produce specified types of steel.",
    "dailyActivities": [
      "Regulate supplies of fuel and air, or control flow of electric current and water coolant to heat furnaces and adjust temperatures.",
      "Draw smelted metal samples from furnaces or kettles for analysis, and calculate types and amounts of materials needed to ensure that materials meet specifications.",
      "Weigh materials to be charged into furnaces, using scales.",
      "Record production data, and maintain production logs.",
      "Observe air and temperature gauges or metal color and fluidity, and turn fuel valves or adjust controls to maintain required temperatures.",
      "Operate controls to move or discharge metal workpieces from furnaces."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "milling_and_planing_machine_setters_operators_and_tenders_metal_and_plastic",
    "onet_code": "51-4035.00",
    "title": "Milling and Planing Machine Setters, Operators, and Tenders, Metal and Plastic",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Critical Thinking",
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-4034.00",
      "51-4033.00",
      "51-7042.00"
    ],
    "training_paths": [],
    "description": "Set up, operate, or tend milling or planing machines to mill, plane, shape, groove, or profile metal or plastic work pieces.",
    "dailyActivities": [
      "Remove workpieces from machines, and check to ensure that they conform to specifications, using measuring instruments such as microscopes, gauges, calipers, and micrometers.",
      "Verify alignment of workpieces on machines, using measuring instruments such as rules, gauges, or calipers.",
      "Move controls to set cutting specifications, to position cutting tools and workpieces in relation to each other, and to start machines.",
      "Observe milling or planing machine operation, and adjust controls to ensure conformance with specified tolerances.",
      "Select and install cutting tools and other accessories according to specifications, using hand tools or power tools.",
      "Position and secure workpieces on machines, using holding devices, measuring instruments, hand tools, and hoists."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "mixing_and_blending_machine_setters_operators_and_tenders",
    "onet_code": "51-9023.00",
    "title": "Mixing and Blending Machine Setters, Operators, and Tenders",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Monitoring",
      "Coordination",
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance",
      "Repairing",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "detail_oriented",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9012.00",
      "51-3092.00",
      "51-9192.00"
    ],
    "training_paths": [],
    "description": "Set up, operate, or tend machines to mix or blend materials, such as chemicals, tobacco, liquids, color pigments, or explosive ingredients.",
    "dailyActivities": [
      "Weigh or measure materials, ingredients, or products to ensure conformance to requirements.",
      "Read work orders to determine production specifications or information.",
      "Observe production or monitor equipment to ensure safe and efficient operation.",
      "Mix or blend ingredients by starting machines and mixing for specified times.",
      "Stop mixing or blending machines when specified product qualities are obtained and open valves and start pumps to transfer mixtures.",
      "Compound or process ingredients or dyes, according to formulas."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "model_makers_metal_and_plastic",
    "onet_code": "51-4061.00",
    "title": "Model Makers, Metal and Plastic",
    "category": "Production",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Critical Thinking",
      "Monitoring",
      "Equipment Selection",
      "Operations Monitoring",
      "Operation and Control",
      "Troubleshooting",
      "Quality Control Analysis",
      "Time Management"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "technical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 30030,
      "entry_max": 40040,
      "mid_min": 40040,
      "mid_max": 52052
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-4111.00",
      "51-4192.00",
      "51-4041.00"
    ],
    "training_paths": [],
    "description": "Set up and operate machines, such as lathes, milling and engraving machines, and jig borers to make working models of metal or plastic objects. Includes template makers.",
    "dailyActivities": [
      "Study blueprints, drawings, and sketches to determine material dimensions, required equipment, and operations sequences.",
      "Set up and operate machines, such as lathes, drill presses, punch presses, or bandsaws, to fabricate prototypes or models.",
      "Program computer numerical control (CNC) machines to fabricate model parts.",
      "Inspect and test products to verify conformance to specifications, using precision measuring instruments or circuit testers.",
      "Cut, shape, and form metal parts, using lathes, power saws, snips, power brakes and shears, files, and mallets.",
      "Rework or alter component model or parts as required to ensure that products meet standards."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "model_makers_wood",
    "onet_code": "51-7031.00",
    "title": "Model Makers, Wood",
    "category": "Production",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Critical Thinking",
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Fluency of Ideas",
      "Originality"
    ],
    "keywords": [
      "production",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 30030,
      "entry_max": 40040,
      "mid_min": 40040,
      "mid_max": 52052
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-7011.00",
      "51-4192.00",
      "51-7032.00"
    ],
    "training_paths": [],
    "description": "Construct full-size and scale wooden precision models of products. Includes wood jig builders and loft workers.",
    "dailyActivities": [
      "Read blueprints, drawings, or written specifications, and consult with designers to determine sizes and shapes of patterns and required machine setups.",
      "Fit, fasten, and assemble wood parts together to form patterns, models, or sections, using glue, nails, dowels, bolts, screws, and other fasteners.",
      "Verify dimensions and contours of models during hand-forming processes, using templates and measuring devices.",
      "Trim, smooth, and shape surfaces, and plane, shave, file, scrape, and sand models to attain specified shapes, using hand tools.",
      "Plan, lay out, and draw outlines of units, sectional patterns, or full-scale mock-ups of products.",
      "Construct wooden models, patterns, templates, full scale mock-ups, and molds for parts of products and production tools."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "molders_shapers_and_casters_except_metal_and_plastic",
    "onet_code": "51-9195.00",
    "title": "Molders, Shapers, and Casters, Except Metal and Plastic",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Information Ordering",
      "Visualization"
    ],
    "keywords": [
      "customer_service",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-4071.00",
      "51-9022.00",
      "51-4072.00"
    ],
    "training_paths": [],
    "description": "Mold, shape, form, cast, or carve products such as food products, figurines, tile, pipes, and candles consisting of clay, glass, plaster, concrete, stone, or combinations of materials.",
    "dailyActivities": [
      "Read work orders or examine parts to determine parts or sections of products to be produced.",
      "Trim or remove excess material, using scrapers, knives, or band saws.",
      "Brush or spray mold surfaces with parting agents or insert paper into molds to ensure smoothness and prevent sticking or seepage.",
      "Engrave or stamp identifying symbols, letters, or numbers on products.",
      "Assemble, insert, and adjust wires, tubes, cores, fittings, rods, or patterns into molds, using hand tools and depth gauges.",
      "Clean, finish, and lubricate molds and mold parts."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "molding_coremaking_and_casting_machine_setters_operators_and_tenders_metal_and_plastic",
    "onet_code": "51-4072.00",
    "title": "Molding, Coremaking, and Casting Machine Setters, Operators, and Tenders, Metal and Plastic",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Information Ordering"
    ],
    "keywords": [
      "detail_oriented",
      "production",
      "hands_on",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-4021.00",
      "51-9195.00",
      "51-6091.00"
    ],
    "training_paths": [],
    "description": "Set up, operate, or tend metal or plastic molding, casting, or coremaking machines to mold or cast metal or thermoplastic parts or products.",
    "dailyActivities": [
      "Measure and visually inspect products for surface and dimension defects to ensure conformance to specifications, using precision measuring instruments.",
      "Observe continuous operation of automatic machines to ensure that products meet specifications and to detect jams or malfunctions, making adjustments as necessary.",
      "Set up, operate, or tend metal or plastic molding, casting, or coremaking machines to mold or cast metal or thermoplastic parts or products.",
      "Turn valves and dials of machines to regulate pressure, temperature, and speed and feed rates, and to set cycle times.",
      "Read specifications, blueprints, and work orders to determine setups, temperatures, and time settings required to mold, form, or cast plastic materials, as well as to plan production sequences.",
      "Observe meters and gauges to verify and record temperatures, pressures, and press-cycle times."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "multiple_machine_tool_setters_operators_and_tenders_metal_and_plastic",
    "onet_code": "51-4081.00",
    "title": "Multiple Machine Tool Setters, Operators, and Tenders, Metal and Plastic",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Critical Thinking",
      "Monitoring",
      "Complex Problem Solving",
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "technical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-4034.00",
      "51-4035.00",
      "51-4033.00"
    ],
    "training_paths": [],
    "description": "Set up, operate, or tend more than one type of cutting or forming machine tool or robot.",
    "dailyActivities": [
      "Inspect workpieces for defects, and measure workpieces to determine accuracy of machine operation, using rules, templates, or other measuring instruments.",
      "Position, adjust, and secure stock material or workpieces against stops, on arbors, or in chucks, fixtures, or automatic feeding mechanisms, manually or using hoists.",
      "Read blueprints or job orders to determine product specifications and tooling instructions and to plan operational sequences.",
      "Select, install, and adjust alignment of drills, cutters, dies, guides, and holding devices, using templates, measuring instruments, and hand tools.",
      "Observe machine operation to detect workpiece defects or machine malfunctions, adjusting machines as necessary.",
      "Set up and operate machines, such as lathes, cutters, shears, borers, millers, grinders, presses, drills, or auxiliary machines, to make metallic and plastic workpieces."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "nuclear_power_reactor_operators",
    "onet_code": "51-8011.00",
    "title": "Nuclear Power Reactor Operators",
    "category": "Production",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Science",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "analytical",
      "hands_on",
      "technical",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 30030,
      "entry_max": 40040,
      "mid_min": 40040,
      "mid_max": 52052
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "19-4051.00",
      "51-8013.00",
      "51-8013.04"
    ],
    "training_paths": [],
    "description": "Operate or control nuclear reactors. Move control rods, start and stop equipment, monitor and adjust controls, and record data in logs. Implement emergency procedures when needed. May respond to abnormalities, determine cause, and recommend corrective action.",
    "dailyActivities": [
      "Operate nuclear power reactors in accordance with policies and procedures to protect workers from radiation and to ensure environmental safety.",
      "Adjust controls to position rod and to regulate flux level, reactor period, coolant temperature, or rate of power flow, following standard procedures.",
      "Develop or implement actions such as lockouts, tagouts, or clearances to allow equipment to be safely repaired.",
      "Respond to system or unit abnormalities, diagnosing the cause, and recommending or taking corrective action.",
      "Monitor all systems for normal running conditions, performing activities such as checking gauges to assess output or the effects of generator loading on other equipment.",
      "Monitor or operate boilers, turbines, wells, or auxiliary power plant equipment."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "ophthalmic_laboratory_technicians",
    "onet_code": "51-9083.00",
    "title": "Ophthalmic Laboratory Technicians",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Operation and Control",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "technical"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9022.00",
      "51-4033.00",
      "51-4194.00"
    ],
    "training_paths": [],
    "description": "Cut, grind, and polish eyeglasses, contact lenses, or other precision optical elements. Assemble and mount lenses into frames or process other optical elements. Includes precision lens polishers or grinders, centerer-edgers, and lens mounters.",
    "dailyActivities": [
      "Mount and secure lens blanks or optical lenses in holding tools or chucks of cutting, polishing, grinding, or coating machines.",
      "Inspect lens blanks to detect flaws, verify smoothness of surface, and ensure thickness of coating on lenses.",
      "Set up machines to polish, bevel, edge, or grind lenses, flats, blanks, or other precision optical elements.",
      "Inspect, weigh, and measure mounted or unmounted lenses after completion to verify alignment and conformance to specifications, using precision instruments.",
      "Shape lenses appropriately so that they can be inserted into frames.",
      "Clean finished lenses and eyeglasses, using cloths and solvents."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "packaging_and_filling_machine_operators_and_tenders",
    "onet_code": "51-9111.00",
    "title": "Packaging and Filling Machine Operators and Tenders",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Coordination",
      "Operations Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Information Ordering",
      "Category Flexibility"
    ],
    "keywords": [
      "customer_service",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-7064.00",
      "53-7063.00",
      "51-9191.00"
    ],
    "training_paths": [],
    "description": "Operate or tend machines to prepare industrial or consumer products for storage or shipment. Includes cannery workers who pack food products.",
    "dailyActivities": [
      "Attach identification labels to finished packaged items, or cut stencils and stencil information on containers, such as lot numbers or shipping destinations.",
      "Sort, grade, weigh, and inspect products, verifying and adjusting product weight or measurement to meet specifications.",
      "Stop or reset machines when malfunctions occur, clear machine jams, and report malfunctions to a supervisor.",
      "Observe machine operations to ensure quality and conformity of filled or packaged products to standards.",
      "Remove finished packaged items from machine and separate rejected items.",
      "Monitor the production line, watching for problems such as pile-ups, jams, or glue that isn't sticking properly."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "painting_coating_and_decorating_workers",
    "onet_code": "51-9123.00",
    "title": "Painting, Coating, and Decorating Workers",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Arm-Hand Steadiness",
      "Finger Dexterity",
      "Near Vision"
    ],
    "keywords": [
      "production",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 21021,
      "entry_max": 28028,
      "mid_min": 28028,
      "mid_max": 36436
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9124.00",
      "51-9194.00",
      "47-2141.00"
    ],
    "training_paths": [],
    "description": "Paint, coat, or decorate articles, such as furniture, glass, plateware, pottery, jewelry, toys, books, or leather.",
    "dailyActivities": [
      "Apply coatings, such as paint, ink, or lacquer, to protect or decorate workpiece surfaces, using spray guns, pens, or brushes.",
      "Examine finished surfaces of workpieces to verify conformance to specifications and retouch any defective areas.",
      "Clean and maintain tools and equipment, using solvents, brushes, and rags.",
      "Read job orders and inspect workpieces to determine work procedures and materials required.",
      "Select and mix ingredients to prepare coating substances according to specifications, using paddles or mechanical mixers.",
      "Place coated workpieces in ovens or dryers for specified times to dry or harden finishes."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "paper_goods_machine_setters_operators_and_tenders",
    "onet_code": "51-9196.00",
    "title": "Paper Goods Machine Setters, Operators, and Tenders",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Information Ordering",
      "Category Flexibility",
      "Selective Attention"
    ],
    "keywords": [
      "customer_service",
      "production",
      "hands_on",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9191.00",
      "51-9032.00",
      "51-6062.00"
    ],
    "training_paths": [],
    "description": "Set up, operate, or tend paper goods machines that perform a variety of functions, such as converting, sawing, corrugating, banding, wrapping, boxing, stitching, forming, or sealing paper or paperboard sheets into products.",
    "dailyActivities": [
      "Examine completed work to detect defects and verify conformance to work orders, and adjust machinery as necessary to correct production problems.",
      "Observe operation of various machines to detect and correct machine malfunctions such as improper forming, glue flow, or pasteboard tension.",
      "Start machines and move controls to regulate tension on pressure rolls, to synchronize speed of machine components, and to adjust temperatures of glue or paraffin.",
      "Disassemble machines to maintain, repair, or replace broken or worn parts, using hand or power tools.",
      "Install attachments to machines for gluing, folding, printing, or cutting.",
      "Cut products to specified dimensions, using hand or power cutters."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "patternmakers_metal_and_plastic",
    "onet_code": "51-4062.00",
    "title": "Patternmakers, Metal and Plastic",
    "category": "Production",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Critical Thinking",
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 30030,
      "entry_max": 40040,
      "mid_min": 40040,
      "mid_max": 52052
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-6092.00",
      "51-7032.00",
      "51-4111.00"
    ],
    "training_paths": [],
    "description": "Lay out, machine, fit, and assemble castings and parts to metal or plastic foundry patterns, core boxes, or match plates.",
    "dailyActivities": [
      "Verify conformance of patterns or template dimensions to specifications, using measuring instruments such as calipers, scales, and micrometers.",
      "Set up and operate machine tools, such as milling machines, lathes, drill presses, and grinders, to machine castings or patterns.",
      "Repair and rework templates and patterns.",
      "Assemble pattern sections, using hand tools, bolts, screws, rivets, glue, or welding equipment.",
      "Read and interpret blueprints or drawings of parts to be cast or patterns to be made, compute dimensions, and plan operational sequences.",
      "Construct platforms, fixtures, and jigs for holding and placing patterns."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "patternmakers_wood",
    "onet_code": "51-7032.00",
    "title": "Patternmakers, Wood",
    "category": "Production",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Mathematics",
      "Critical Thinking",
      "Monitoring",
      "Complex Problem Solving",
      "Operations Analysis",
      "Operations Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 30030,
      "entry_max": 40040,
      "mid_min": 40040,
      "mid_max": 52052
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-4062.00",
      "51-7031.00",
      "51-4192.00"
    ],
    "training_paths": [],
    "description": "Plan, lay out, and construct wooden unit or sectional patterns used in forming sand molds for castings.",
    "dailyActivities": [
      "Read blueprints, drawings, or written specifications to determine sizes and shapes of patterns and required machine setups.",
      "Fit, fasten, and assemble wood parts together to form patterns, models, or sections, using glue, nails, dowels, bolts, and screws.",
      "Lay out patterns on wood stock and draw outlines of units, sectional patterns, or full-scale mock-ups of products, based on blueprint specifications and sketches, and using marking and measuring devices.",
      "Trim, smooth, and shape surfaces, and plane, shave, file, scrape, and sand models to attain specified shapes, using hand tools.",
      "Divide patterns into sections according to shapes of castings to facilitate removal of patterns from molds.",
      "Verify dimensions of completed patterns, using templates, straightedges, calipers, or protractors."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "petroleum_pump_system_operators_refinery_operators_and_gaugers",
    "onet_code": "51-8093.00",
    "title": "Petroleum Pump System Operators, Refinery Operators, and Gaugers",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-8092.00",
      "53-7071.00",
      "53-7073.00"
    ],
    "training_paths": [],
    "description": "Operate or control petroleum refining or processing units. May specialize in controlling manifold and pumping systems, gauging or testing oil in storage tanks, or regulating the flow of oil into pipelines.",
    "dailyActivities": [
      "Signal other workers by telephone or radio to operate pumps, open and close valves, and check temperatures.",
      "Maintain and repair equipment, or report malfunctioning equipment to supervisors so that repairs can be scheduled.",
      "Monitor process indicators, instruments, gauges, and meters to detect and report any possible problems.",
      "Start pumps and open valves or use automated equipment to regulate the flow of oil in pipelines and into and out of tanks.",
      "Operate control panels to coordinate and regulate process variables such as temperature and pressure, and to direct product flow rate, according to process schedules.",
      "Verify that incoming and outgoing products are moving through the correct meters, and that meters are working properly."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "photographic_process_workers_and_processing_machine_operators",
    "onet_code": "51-9151.00",
    "title": "Photographic Process Workers and Processing Machine Operators",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Social Perceptiveness",
      "Service Orientation",
      "Operations Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "production",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-5111.00",
      "49-9061.00",
      "51-5112.00"
    ],
    "training_paths": [],
    "description": "Perform work involved in developing and processing photographic images from film or digital media. May perform precision tasks such as editing photographic negatives and prints.",
    "dailyActivities": [
      "Select digital images for printing, specify number of images to be printed, and direct to printer, using computer software.",
      "Create prints according to customer specifications and laboratory protocols.",
      "Produce color or black-and-white photographs, negatives, or slides, applying standard photographic reproduction techniques and procedures.",
      "Set or adjust machine controls, according to specifications, type of operation, or material requirements.",
      "Review computer-processed digital images for quality.",
      "Operate scanners or related computer equipment to digitize negatives, photographic prints, or other images."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "plant_and_system_operators_all_other",
    "onet_code": "51-8099.00",
    "title": "Plant and System Operators, All Other",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "production"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All plant and system operators not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "plating_machine_setters_operators_and_tenders_metal_and_plastic",
    "onet_code": "51-4193.00",
    "title": "Plating Machine Setters, Operators, and Tenders, Metal and Plastic",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9124.00",
      "51-4191.00",
      "51-4122.00"
    ],
    "training_paths": [],
    "description": "Set up, operate, or tend plating machines to coat metal or plastic products with chromium, zinc, copper, cadmium, nickel, or other metal to protect or decorate surfaces. Typically, the product being coated is immersed in molten metal or an electrolytic solution.",
    "dailyActivities": [
      "Immerse workpieces in coating solutions or liquid metal or plastic for specified times.",
      "Adjust dials to regulate flow of current and voltage supplied to terminals to control plating processes.",
      "Inspect coated or plated areas for defects, such as air bubbles or uneven coverage.",
      "Set up, operate, or tend plating or coating machines to coat metal or plastic products with chromium, zinc, copper, cadmium, nickel, or other metal to protect or decorate surfaces.",
      "Observe gauges to ensure that machines are operating properly, making adjustments or stopping machines when problems occur.",
      "Remove objects from solutions at periodic intervals and observe objects to verify conformance to specifications."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "potters_manufacturing",
    "onet_code": "51-9195.05",
    "title": "Potters, Manufacturing",
    "category": "Production",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Critical Thinking",
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Originality",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 30030,
      "entry_max": 40040,
      "mid_min": 40040,
      "mid_max": 52052
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9195.00",
      "51-9071.00",
      "27-1012.00"
    ],
    "training_paths": [],
    "description": "Operate production machines such as pug mill, jigger machine, or potter's wheel to process clay in manufacture of ceramic, pottery and stoneware products.",
    "dailyActivities": [
      "Operate gas or electric kilns to fire pottery pieces.",
      "Mix and apply glazes to pottery pieces, using tools, such as spray guns.",
      "Raise and shape clay into wares, such as vases and pitchers, on revolving wheels, using hands, fingers, and thumbs.",
      "Adjust wheel speeds according to the feel of the clay as pieces enlarge and walls become thinner.",
      "Position balls of clay in centers of potters' wheels, and start motors or pump treadles with feet to revolve wheels.",
      "Move pieces from wheels so that they can dry."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "pourers_and_casters_metal",
    "onet_code": "51-4052.00",
    "title": "Pourers and Casters, Metal",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Critical Thinking",
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control",
      "Judgment and Decision Making"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Problem Sensitivity",
      "Category Flexibility",
      "Perceptual Speed",
      "Selective Attention"
    ],
    "keywords": [
      "customer_service",
      "production",
      "hands_on",
      "physical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9195.00",
      "51-4023.00",
      "51-4022.00"
    ],
    "training_paths": [],
    "description": "Operate hand-controlled mechanisms to pour and regulate the flow of molten metal into molds to produce castings or ingots.",
    "dailyActivities": [
      "Pour and regulate the flow of molten metal into molds and forms to produce ingots or other castings, using ladles or hand-controlled mechanisms.",
      "Read temperature gauges and observe color changes, adjusting furnace flames, torches, or electrical heating units as necessary to melt metal to specifications.",
      "Remove solidified steel or slag from pouring nozzles, using long bars or oxygen burners.",
      "Examine molds to ensure they are clean, smooth, and properly coated.",
      "Collect samples, or signal workers to sample metal for analysis.",
      "Load specified amounts of metal and flux into furnaces or clay crucibles."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "power_distributors_and_dispatchers",
    "onet_code": "51-8012.00",
    "title": "Power Distributors and Dispatchers",
    "category": "Production",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "production",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 30030,
      "entry_max": 40040,
      "mid_min": 40040,
      "mid_max": 52052
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-8013.00",
      "49-2095.00",
      "51-8021.00"
    ],
    "training_paths": [],
    "description": "Coordinate, regulate, or distribute electricity or steam.",
    "dailyActivities": [
      "Coordinate with engineers, planners, field personnel, or other utility workers to provide information such as clearances, switching orders, or distribution process changes.",
      "Respond to emergencies, such as transformer or transmission line failures, and route current around affected areas.",
      "Control, monitor, or operate equipment that regulates or distributes electricity or steam, using data obtained from instruments or computers.",
      "Direct personnel engaged in controlling or operating distribution equipment or machinery, such as instructing control room operators to start boilers or generators.",
      "Distribute or regulate the flow of power between entities, such as generating stations, substations, distribution lines, or users, keeping track of the status of circuits or connections.",
      "Manipulate controls to adjust or activate power distribution equipment or machines."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "power_plant_operators",
    "onet_code": "51-8013.00",
    "title": "Power Plant Operators",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-8013.04",
      "51-8013.03",
      "51-8092.00"
    ],
    "training_paths": [],
    "description": "Control, operate, or maintain machinery to generate electric power. Includes auxiliary equipment operators.",
    "dailyActivities": [
      "Control generator output to match the phase, frequency, or voltage of electricity supplied to panels.",
      "Take regulatory action, based on readings from charts, meters and gauges, at established intervals.",
      "Control power generating equipment, including boilers, turbines, generators, or reactors, using control boards or semi-automatic equipment.",
      "Start or stop generators, auxiliary pumping equipment, turbines, or other power plant equipment as necessary.",
      "Monitor power plant equipment and indicators to detect evidence of operating problems.",
      "Operate or maintain distributed power generation equipment, including fuel cells or microturbines, to produce energy on-site for manufacturing or other commercial purposes."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "prepress_technicians_and_workers",
    "onet_code": "51-5111.00",
    "title": "Prepress Technicians and Workers",
    "category": "Production",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Operations Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Originality"
    ],
    "keywords": [
      "customer_service",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 30030,
      "entry_max": 40040,
      "mid_min": 40040,
      "mid_max": 52052
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9151.00",
      "51-5112.00",
      "51-9194.00"
    ],
    "training_paths": [],
    "description": "Format and proof text and images submitted by designers and clients into finished pages that can be printed. Includes digital and photo typesetting. May produce printing plates.",
    "dailyActivities": [
      "Generate prepress proofs in digital or other format to approximate the appearance of the final printed piece.",
      "Proofread and perform quality control of text and images.",
      "Enter, position, and alter text size, using computers, to make up and arrange pages so that printed materials can be produced.",
      "Perform \"preflight\" check of required font, graphic, text and image files to ensure completeness prior to delivery to printer.",
      "Operate and maintain laser plate-making equipment that converts electronic data to plates without the use of film.",
      "Enter, store, and retrieve information on computer-aided equipment."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "pressers_textile_garment_and_related_materials",
    "onet_code": "51-6021.00",
    "title": "Pressers, Textile, Garment, and Related Materials",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Arm-Hand Steadiness",
      "Manual Dexterity",
      "Finger Dexterity",
      "Control Precision",
      "Multilimb Coordination"
    ],
    "keywords": [
      "communication",
      "production",
      "physical",
      "customer_service"
    ],
    "salary": {
      "entry_min": 21021,
      "entry_max": 28028,
      "mid_min": 28028,
      "mid_max": 36436
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-6031.00",
      "51-6011.00",
      "51-6042.00"
    ],
    "training_paths": [],
    "description": "Press or shape articles by hand or machine.",
    "dailyActivities": [
      "Hang, fold, package, and tag finished articles for delivery to customers.",
      "Operate steam, hydraulic, or other pressing machines to remove wrinkles from garments and flatwork items, or to shape, form, or patch articles.",
      "Straighten, smooth, or shape materials to prepare them for pressing.",
      "Remove finished pieces from pressing machines and hang or stack them for cooling, or forward them for additional processing.",
      "Finish pleated garments, determining sizes of pleats from evidence of old pleats or from work orders, using machine presses or hand irons.",
      "Lower irons, rams, or pressing heads of machines into position over material to be pressed."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "print_binding_and_finishing_workers",
    "onet_code": "51-5113.00",
    "title": "Print Binding and Finishing Workers",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Critical Thinking",
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Information Ordering",
      "Category Flexibility"
    ],
    "keywords": [
      "customer_service",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9196.00",
      "51-9032.00",
      "51-9191.00"
    ],
    "training_paths": [],
    "description": "Bind books and other publications or finish printed products by hand or machine. May set up binding and finishing machines.",
    "dailyActivities": [
      "Examine stitched, collated, bound, or unbound product samples for defects, such as imperfect bindings, ink spots, torn pages, loose pages, or loose or uncut threads.",
      "Read work orders to determine instructions and specifications for machine set-up.",
      "Install or adjust bindery machine devices, such as knives, guides, rollers, rounding forms, creasing rams, or clamps, to accommodate sheets, signatures, or books of specified sizes.",
      "Trim edges of books to size, using cutting machines, book trimming machines, or hand cutters.",
      "Stitch or glue endpapers, bindings, backings, or signatures, using sewing machines, glue machines, or glue and brushes.",
      "Monitor machine operations to detect malfunctions or to determine whether adjustments are needed."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "printing_press_operators",
    "onet_code": "51-5112.00",
    "title": "Printing Press Operators",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Coordination",
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9196.00",
      "51-5111.00",
      "51-9151.00"
    ],
    "training_paths": [],
    "description": "Set up and operate digital, letterpress, lithographic, flexographic, gravure, or other printing machines. Includes short-run offset printing presses.",
    "dailyActivities": [
      "Start presses and pull proofs to check for ink coverage and density, alignment, and registration.",
      "Examine job orders to determine quantities to be printed, stock specifications, colors, or special printing instructions.",
      "Adjust ink fountain flow rates.",
      "Verify that paper and ink meet the specifications for a given job.",
      "Collect and inspect random samples during print runs to identify any necessary adjustments.",
      "Feed paper through press cylinders and adjust feed and tension controls."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "production_workers_all_other",
    "onet_code": "51-9199.00",
    "title": "Production Workers, All Other",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "production"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All production workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "rolling_machine_setters_operators_and_tenders_metal_and_plastic",
    "onet_code": "51-4023.00",
    "title": "Rolling Machine Setters, Operators, and Tenders, Metal and Plastic",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Coordination",
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance",
      "Troubleshooting"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "technical",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9032.00",
      "51-4031.00",
      "51-4033.00"
    ],
    "training_paths": [],
    "description": "Set up, operate, or tend machines to roll steel or plastic forming bends, beads, knurls, rolls, or plate, or to flatten, temper, or reduce gauge of material.",
    "dailyActivities": [
      "Monitor machine cycles and mill operation to detect jamming and to ensure that products conform to specifications.",
      "Adjust and correct machine set-ups to reduce thicknesses, reshape products, and eliminate product defects.",
      "Start operation of rolling and milling machines to flatten, temper, form, and reduce sheet metal sections and to produce steel strips.",
      "Examine, inspect, and measure raw materials and finished products to verify conformance to specifications.",
      "Read rolling orders, blueprints, and mill schedules to determine setup specifications, work sequences, product dimensions, and installation procedures.",
      "Manipulate controls and observe dial indicators to monitor, adjust, and regulate speeds of machine mechanisms."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "sawing_machine_setters_operators_and_tenders_wood",
    "onet_code": "51-7041.00",
    "title": "Sawing Machine Setters, Operators, and Tenders, Wood",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Visualization",
      "Selective Attention",
      "Arm-Hand Steadiness",
      "Manual Dexterity"
    ],
    "keywords": [
      "production",
      "hands_on",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-7042.00",
      "51-9032.00",
      "51-9022.00"
    ],
    "training_paths": [],
    "description": "Set up, operate, or tend wood sawing machines. May operate computer numerically controlled (CNC) equipment. Includes lead sawyers.",
    "dailyActivities": [
      "Inspect and measure workpieces to mark for cuts and to verify the accuracy of cuts, using rulers, squares, or caliper rules.",
      "Adjust saw blades, using wrenches and rulers, or by turning handwheels or pressing pedals, levers, or panel buttons.",
      "Mount and bolt sawing blades or attachments to machine shafts.",
      "Set up, operate, or tend saws or machines that cut or trim wood to specified dimensions, such as circular saws, band saws, multiple-blade sawing machines, scroll saws, ripsaws, or crozer machines.",
      "Inspect stock for imperfections or to estimate grades or qualities of stock or workpieces.",
      "Monitor sawing machines, adjusting speed and tension and clearing jams to ensure proper operation."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "semiconductor_processing_technicians",
    "onet_code": "51-9141.00",
    "title": "Semiconductor Processing Technicians",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Monitoring",
      "Operations Monitoring",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-8091.00",
      "51-4193.00",
      "51-2022.00"
    ],
    "training_paths": [],
    "description": "Perform any or all of the following functions in the manufacture of electronic semiconductors: load semiconductor material into furnace; saw formed ingots into segments; load individual segment into crystal growing chamber and monitor controls; locate crystal axis in ingot using x-ray equipment and saw ingots into wafers; and clean, polish, and load wafers into series of special purpose furnaces, chemical baths, and equipment used to form circuitry and change conductive properties.",
    "dailyActivities": [
      "Manipulate valves, switches, and buttons, or key commands into control panels to start semiconductor processing cycles.",
      "Maintain processing, production, and inspection information and reports.",
      "Inspect materials, components, or products for surface defects and measure circuitry, using electronic test equipment, precision measuring instruments, microscope, and standard procedures.",
      "Clean semiconductor wafers using cleaning equipment, such as chemical baths, automatic wafer cleaners, or blow-off wands.",
      "Study work orders, instructions, formulas, and processing charts to determine specifications and sequence of operations.",
      "Load and unload equipment chambers and transport finished product to storage or to area for further processing."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "separating_filtering_clarifying_precipitating_and_still_machine_setters_operators_and_tenders",
    "onet_code": "51-9012.00",
    "title": "Separating, Filtering, Clarifying, Precipitating, and Still Machine Setters, Operators, and Tenders",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Critical Thinking",
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Inductive Reasoning"
    ],
    "keywords": [
      "production",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9192.00",
      "51-9023.00",
      "51-9051.00"
    ],
    "training_paths": [],
    "description": "Set up, operate, or tend continuous flow or vat-type equipment; filter presses; shaker screens; centrifuges; condenser tubes; precipitating, fermenting, or evaporating tanks; scrubbing towers; or batch stills. These machines extract, sort, or separate liquids, gases, or solids from other materials to recover a refined product. Includes dairy processing equipment operators.",
    "dailyActivities": [
      "Dump, pour, or load specified amounts of refined or unrefined materials into equipment or containers for further processing or storage.",
      "Operate machines to process materials in compliance with applicable safety, energy, or environmental regulations.",
      "Monitor material flow or instruments, such as temperature or pressure gauges, indicators, or meters, to ensure optimal processing conditions.",
      "Turn valves or move controls to admit, drain, separate, filter, clarify, mix, or transfer materials.",
      "Set up or adjust machine controls to regulate conditions such as material flow, temperature, or pressure.",
      "Examine samples to verify qualities such as clarity, cleanliness, consistency, dryness, or texture."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "sewers_hand",
    "onet_code": "51-6051.00",
    "title": "Sewers, Hand",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Information Ordering",
      "Category Flexibility",
      "Visualization",
      "Arm-Hand Steadiness",
      "Manual Dexterity"
    ],
    "keywords": [
      "production",
      "physical",
      "customer_service"
    ],
    "salary": {
      "entry_min": 21021,
      "entry_max": 28028,
      "mid_min": 28028,
      "mid_max": 36436
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-6031.00",
      "51-6052.00",
      "51-6041.00"
    ],
    "training_paths": [],
    "description": "Sew, join, reinforce, or finish, usually with needle and thread, a variety of manufactured items. Includes weavers and stitchers.",
    "dailyActivities": [
      "Select thread, twine, cord, or yarn to be used, and thread needles.",
      "Measure and align parts, fasteners, or trimmings, following seams, edges, or markings on parts.",
      "Trim excess threads or edges of parts, using scissors or knives.",
      "Sew, join, reinforce, or finish parts of articles, such as garments, books, mattresses, toys, and wigs, using needles and thread or other materials.",
      "Use different sewing techniques such as felling, tacking, basting, embroidery, and fagoting.",
      "Fit garments on clients, altering as needed."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "sewing_machine_operators",
    "onet_code": "51-6031.00",
    "title": "Sewing Machine Operators",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Visualization",
      "Arm-Hand Steadiness",
      "Manual Dexterity",
      "Finger Dexterity",
      "Control Precision"
    ],
    "keywords": [
      "production",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 21021,
      "entry_max": 28028,
      "mid_min": 28028,
      "mid_max": 36436
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-6042.00",
      "51-6051.00",
      "51-6021.00"
    ],
    "training_paths": [],
    "description": "Operate or tend sewing machines to join, reinforce, decorate, or perform related sewing operations in the manufacture of garment or nongarment products.",
    "dailyActivities": [
      "Monitor machine operation to detect problems such as defective stitching, breaks in thread, or machine malfunctions.",
      "Place spools of thread, cord, or other materials on spindles, insert bobbins, and thread ends through machine guides and components.",
      "Position items under needles, using marks on machines, clamps, templates, or cloth as guides.",
      "Guide garments or garment parts under machine needles and presser feet to sew parts together.",
      "Remove holding devices and finished items from machines.",
      "Match cloth pieces in correct sequences prior to sewing them, and verify that dye lots and patterns match."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "shoe_machine_operators_and_tenders",
    "onet_code": "51-6042.00",
    "title": "Shoe Machine Operators and Tenders",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Expression",
      "Information Ordering",
      "Category Flexibility",
      "Perceptual Speed",
      "Selective Attention"
    ],
    "keywords": [
      "production",
      "physical"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-6031.00",
      "51-9032.00",
      "51-6041.00"
    ],
    "training_paths": [],
    "description": "Operate or tend a variety of machines to join, decorate, reinforce, or finish shoes and shoe parts.",
    "dailyActivities": [
      "Inspect finished products to ensure that shoes have been completed according to specifications.",
      "Align parts to be stitched, following seams, edges, or markings, before positioning them under needles.",
      "Operate or tend machines to join, decorate, reinforce, or finish shoes and shoe parts.",
      "Remove and examine shoes, shoe parts, and designs to verify conformance to specifications such as proper embedding of stitches in channels.",
      "Switch on machines, lower pressure feet or rollers to secure parts, and start machine stitching, using hand, foot, or knee controls.",
      "Draw thread through machine guide slots, needles, and presser feet in preparation for stitching, or load rolls of wire through machine axles."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "shoe_and_leather_workers_and_repairers",
    "onet_code": "51-6041.00",
    "title": "Shoe and Leather Workers and Repairers",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Oral Comprehension",
      "Information Ordering",
      "Category Flexibility",
      "Visualization",
      "Arm-Hand Steadiness"
    ],
    "keywords": [
      "production",
      "hands_on",
      "physical",
      "customer_service"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-6042.00",
      "51-6051.00",
      "51-6031.00"
    ],
    "training_paths": [],
    "description": "Construct, decorate, or repair leather and leather-like products, such as luggage, shoes, and saddles. May use hand tools.",
    "dailyActivities": [
      "Dye, soak, polish, paint, stamp, stitch, stain, buff, or engrave leather or other materials to obtain desired effects, decorations, or shapes.",
      "Cut out parts, following patterns or outlines, using knives, shears, scissors, or machine presses.",
      "Construct, decorate, or repair leather products according to specifications, using sewing machines, needles and thread, leather lacing, glue, clamps, hand tools, or rivets.",
      "Repair and recondition leather products such as trunks, luggage, shoes, saddles, belts, purses, and baseball gloves.",
      "Align and stitch or glue materials such as fabric, fleece, leather, or wood, to join parts.",
      "Inspect articles for defects, and remove damaged or worn parts, using hand tools."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "slaughterers_and_meat_packers",
    "onet_code": "51-3023.00",
    "title": "Slaughterers and Meat Packers",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Arm-Hand Steadiness",
      "Manual Dexterity",
      "Finger Dexterity",
      "Control Precision",
      "Reaction Time"
    ],
    "keywords": [
      "production",
      "customer_service",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-3022.00",
      "51-3021.00",
      "45-2093.00"
    ],
    "training_paths": [],
    "description": "Perform nonroutine or precision functions involving the preparation of large portions of meat. Work may include specialized slaughtering tasks, cutting standard or premium cuts of meat for marketing, making sausage, or wrapping meats. Work typically occurs in slaughtering, meat packing, or wholesale establishments.",
    "dailyActivities": [
      "Remove bones, and cut meat into standard cuts in preparation for marketing.",
      "Sever jugular veins to drain blood and facilitate slaughtering.",
      "Tend assembly lines, performing a few of the many cuts needed to process a carcass.",
      "Shackle hind legs of animals to raise them for slaughtering or skinning.",
      "Slit open, eviscerate, and trim carcasses of slaughtered animals.",
      "Stun animals prior to slaughtering."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "stationary_engineers_and_boiler_operators",
    "onet_code": "51-8021.00",
    "title": "Stationary Engineers and Boiler Operators",
    "category": "Production",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 30030,
      "entry_max": 40040,
      "mid_min": 40040,
      "mid_max": 52052
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-8013.00",
      "51-8013.03",
      "49-9012.00"
    ],
    "training_paths": [],
    "description": "Operate or maintain stationary engines, boilers, or other mechanical equipment to provide utilities for buildings or industrial processes. Operate equipment such as steam engines, generators, motors, turbines, and steam boilers.",
    "dailyActivities": [
      "Operate or tend stationary engines, boilers, and auxiliary equipment, such as pumps, compressors, or air-conditioning equipment, to supply and maintain steam or heat for buildings, marine vessels, or pneumatic tools.",
      "Activate valves to maintain required amounts of water in boilers, to adjust supplies of combustion air, and to control the flow of fuel into burners.",
      "Monitor boiler water, chemical, and fuel levels, and make adjustments to maintain required levels.",
      "Analyze problems and take appropriate action to ensure continuous and reliable operation of equipment and systems.",
      "Observe and interpret readings on gauges, meters, and charts registering various aspects of boiler operation to ensure that boilers are operating properly.",
      "Maintain daily logs of operation, maintenance, and safety activities, including test results, instrument readings, and details of equipment malfunctions and maintenance work."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "stone_cutters_and_carvers_manufacturing",
    "onet_code": "51-9195.03",
    "title": "Stone Cutters and Carvers, Manufacturing",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Problem Sensitivity",
      "Category Flexibility",
      "Visualization",
      "Selective Attention",
      "Arm-Hand Steadiness"
    ],
    "keywords": [
      "customer_service",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "47-2022.00",
      "47-2044.00",
      "51-9195.00"
    ],
    "training_paths": [],
    "description": "Cut or carve stone according to diagrams and patterns.",
    "dailyActivities": [
      "Verify depths and dimensions of cuts or carvings to ensure adherence to specifications, blueprints, or models, using measuring instruments.",
      "Move fingers over surfaces of carvings to ensure smoothness of finish.",
      "Shape, trim, or touch up roughed-out designs with appropriate tools to finish carvings.",
      "Lay out designs or dimensions from sketches or blueprints on stone surfaces, freehand or by transferring them from tracing paper, using scribes or chalk and measuring instruments.",
      "Cut, shape, and finish rough blocks of building or monumental stone, according to diagrams or patterns.",
      "Drill holes and cut or carve moldings and grooves in stone, according to diagrams and patterns."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "structural_metal_fabricators_and_fitters",
    "onet_code": "51-2041.00",
    "title": "Structural Metal Fabricators and Fitters",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-2011.00",
      "51-4192.00",
      "47-2211.00"
    ],
    "training_paths": [],
    "description": "Fabricate, position, align, and fit parts of structural metal products.",
    "dailyActivities": [
      "Verify conformance of workpieces to specifications, using squares, rulers, and measuring tapes.",
      "Study engineering drawings and blueprints to determine materials requirements and task sequences.",
      "Position, align, fit, and weld parts to form complete units or subunits, following blueprints and layout specifications, and using jigs, welding torches, and hand tools.",
      "Lay out and examine metal stock or workpieces to be processed to ensure that specifications are met.",
      "Tack-weld fitted parts together.",
      "Move parts into position, manually or with hoists or cranes."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "tailors_dressmakers_and_custom_sewers",
    "onet_code": "51-6052.00",
    "title": "Tailors, Dressmakers, and Custom Sewers",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Critical Thinking"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Fluency of Ideas",
      "Originality",
      "Information Ordering"
    ],
    "keywords": [
      "production",
      "customer_service",
      "communication",
      "problem_solving"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-6051.00",
      "51-6092.00",
      "51-6031.00"
    ],
    "training_paths": [],
    "description": "Design, make, alter, repair, or fit garments.",
    "dailyActivities": [
      "Measure parts, such as sleeves or pant legs, and mark or pin-fold alteration lines.",
      "Remove stitches from garments to be altered, using rippers or razor blades.",
      "Sew garments, using needles and thread or sewing machines.",
      "Let out or take in seams in suits and other garments to improve fit.",
      "Measure customers, using tape measures, and record measurements.",
      "Fit and study garments on customers to determine required alterations."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "team_assemblers",
    "onet_code": "51-2092.00",
    "title": "Team Assemblers",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Speaking",
      "Monitoring",
      "Social Perceptiveness",
      "Coordination",
      "Operations Monitoring",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Information Ordering"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-2022.00",
      "51-2031.00",
      "51-2023.00"
    ],
    "training_paths": [],
    "description": "Work as part of a team having responsibility for assembling an entire product or component of a product. Team assemblers can perform all tasks conducted by the team in the assembly process and rotate through all or most of them, rather than being assigned to a specific task on a permanent basis. May participate in making management decisions affecting the work. Includes team leaders who work as part of the team.",
    "dailyActivities": [
      "Perform quality checks on products and parts.",
      "Review work orders and blueprints to ensure work is performed according to specifications.",
      "Rotate through all the tasks required in a particular production process.",
      "Determine work assignments and procedures.",
      "Supervise assemblers and train employees on job procedures.",
      "Shovel, sweep, or otherwise clean work areas."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "textile_bleaching_and_dyeing_machine_operators_and_tenders",
    "onet_code": "51-6061.00",
    "title": "Textile Bleaching and Dyeing Machine Operators and Tenders",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Operations Monitoring",
      "Operation and Control",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Information Ordering",
      "Category Flexibility"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "analytical",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9192.00",
      "51-9191.00",
      "53-7063.00"
    ],
    "training_paths": [],
    "description": "Operate or tend machines to bleach, shrink, wash, dye, or finish textiles or synthetic or glass fibers.",
    "dailyActivities": [
      "Weigh ingredients, such as dye, to be mixed together for use in textile processing.",
      "Start and control machines and equipment to wash, bleach, dye, or otherwise process and finish fabric, yarn, thread, or other textile goods.",
      "Observe display screens, control panels, equipment, and cloth entering or exiting processes to determine if equipment is operating correctly.",
      "Notify supervisors or mechanics of equipment malfunctions.",
      "Monitor factors such as temperatures and dye flow rates to ensure that they are within specified ranges.",
      "Add dyes, water, detergents, or chemicals to tanks to dilute or strengthen solutions, according to established formulas and solution test results."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "textile_cutting_machine_setters_operators_and_tenders",
    "onet_code": "51-6062.00",
    "title": "Textile Cutting Machine Setters, Operators, and Tenders",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance",
      "Troubleshooting",
      "Repairing",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Information Ordering"
    ],
    "keywords": [
      "detail_oriented",
      "production",
      "hands_on",
      "physical",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9032.00",
      "51-9196.00",
      "51-7042.00"
    ],
    "training_paths": [],
    "description": "Set up, operate, or tend machines that cut textiles.",
    "dailyActivities": [
      "Inspect products to ensure that the quality standards and specifications are met.",
      "Place patterns on top of layers of fabric and cut fabric following patterns, using electric or manual knives, cutters, or computer numerically controlled cutting devices.",
      "Start machines, monitor operations, and make adjustments as needed.",
      "Adjust machine controls, such as heating mechanisms, tensions, or speeds, to produce specified products.",
      "Record information about work completed and machine settings.",
      "Notify supervisors of mechanical malfunctions."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "textile_knitting_and_weaving_machine_setters_operators_and_tenders",
    "onet_code": "51-6063.00",
    "title": "Textile Knitting and Weaving Machine Setters, Operators, and Tenders",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Visualization",
      "Selective Attention"
    ],
    "keywords": [
      "customer_service",
      "production",
      "hands_on",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-6064.00",
      "51-6031.00",
      "51-6062.00"
    ],
    "training_paths": [],
    "description": "Set up, operate, or tend machines that knit, loop, weave, or draw in textiles.",
    "dailyActivities": [
      "Observe woven cloth to detect weaving defects.",
      "Thread yarn, thread, and fabric through guides, needles, and rollers of machines for weaving, knitting, or other processing.",
      "Remove defects in cloth by cutting and pulling out filling.",
      "Examine looms to determine causes of loom stoppage, such as warp filling, harness breaks, or mechanical defects.",
      "Inspect products to ensure that specifications are met and to determine if machines need adjustment.",
      "Notify supervisors or repair staff of mechanical malfunctions."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "textile_winding_twisting_and_drawing_out_machine_setters_operators_and_tenders",
    "onet_code": "51-6064.00",
    "title": "Textile Winding, Twisting, and Drawing Out Machine Setters, Operators, and Tenders",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Critical Thinking",
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Problem Sensitivity",
      "Perceptual Speed",
      "Selective Attention",
      "Arm-Hand Steadiness",
      "Manual Dexterity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-6063.00",
      "51-9196.00",
      "51-6091.00"
    ],
    "training_paths": [],
    "description": "Set up, operate, or tend machines that wind or twist textiles; or draw out and combine sliver, such as wool, hemp, or synthetic fibers. Includes slubber machine and drawing frame operators.",
    "dailyActivities": [
      "Notify supervisors or mechanics of equipment malfunctions.",
      "Thread yarn, thread, or fabric through guides, needles, and rollers of machines.",
      "Start machines, monitor operation, and make adjustments as needed.",
      "Inspect machinery to determine whether repairs are needed.",
      "Record production data such as numbers and types of bobbins wound.",
      "Replace depleted supply packages with full packages."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "textile_apparel_and_furnishings_workers_all_other",
    "onet_code": "51-6099.00",
    "title": "Textile, Apparel, and Furnishings Workers, All Other",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "production"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All textile, apparel, and furnishings workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "timing_device_assemblers_and_adjusters",
    "onet_code": "51-2061.00",
    "title": "Timing Device Assemblers and Adjusters",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Repairing"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Information Ordering",
      "Visualization"
    ],
    "keywords": [
      "customer_service",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-9064.00",
      "51-2023.00",
      "51-2031.00"
    ],
    "training_paths": [],
    "description": "Perform precision assembling or adjusting, within narrow tolerances, of timing devices such as digital clocks or timing devices with electrical or electronic components.",
    "dailyActivities": [
      "Assemble and install components of timepieces to complete mechanisms, using watchmakers' tools and loupes.",
      "Observe operation of timepiece parts and subassemblies to determine accuracy of movement, and to diagnose causes of defects.",
      "Test operation and fit of timepiece parts and subassemblies, using electronic testing equipment, tweezers, watchmakers' tools, and loupes.",
      "Replace specified parts to repair malfunctioning timepieces, using watchmakers' tools, loupes, and holding fixtures.",
      "Disassemble timepieces such as watches, clocks, and chronometers so that repairs can be made.",
      "Clean and lubricate timepiece parts and assemblies, using solvents, buff sticks, and oil."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "tire_builders",
    "onet_code": "51-9197.00",
    "title": "Tire Builders",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Selective Attention",
      "Arm-Hand Steadiness",
      "Manual Dexterity",
      "Finger Dexterity",
      "Control Precision"
    ],
    "keywords": [
      "customer_service",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-3093.00",
      "51-9195.00",
      "51-4072.00"
    ],
    "training_paths": [],
    "description": "Operate machines to build tires.",
    "dailyActivities": [
      "Build semi-raw rubber treads onto buffed tire casings to prepare tires for vulcanization in recapping or retreading processes.",
      "Trim excess rubber and imperfections during retreading processes.",
      "Fill cuts and holes in tires, using hot rubber.",
      "Place tires into molds for new tread.",
      "Fit inner tubes and final layers of rubber onto tires.",
      "Buff tires according to specifications for width and undertread depth."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "tool_grinders_filers_and_sharpeners",
    "onet_code": "51-4194.00",
    "title": "Tool Grinders, Filers, and Sharpeners",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance",
      "Repairing",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-4033.00",
      "51-9022.00",
      "51-4035.00"
    ],
    "training_paths": [],
    "description": "Perform precision smoothing, sharpening, polishing, or grinding of metal objects.",
    "dailyActivities": [
      "Monitor machine operations to determine whether adjustments are necessary, stopping machines when problems occur.",
      "Inspect, feel, and measure workpieces to ensure that surfaces and dimensions meet specifications.",
      "Study blueprints or layouts of metal workpieces to determine grinding procedures, and to plan machine setups and operational sequences.",
      "Select and mount grinding wheels on machines, according to specifications, using hand tools and applying knowledge of abrasives and grinding procedures.",
      "Compute numbers, widths, and angles of cutting tools, micrometers, scales, and gauges, and adjust tools to produce specified cuts.",
      "Turn valves to direct flow of coolant against cutting wheels and workpieces during grinding."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "tool_and_die_makers",
    "onet_code": "51-4111.00",
    "title": "Tool and Die Makers",
    "category": "Production",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Complex Problem Solving",
      "Operations Analysis",
      "Equipment Selection"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "technical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 30030,
      "entry_max": 40040,
      "mid_min": 40040,
      "mid_max": 52052
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-4194.00",
      "51-4061.00",
      "51-9022.00"
    ],
    "training_paths": [],
    "description": "Analyze specifications, lay out metal stock, set up and operate machine tools, and fit and assemble parts to make and repair dies, cutting tools, jigs, fixtures, gauges, and machinists' hand tools.",
    "dailyActivities": [
      "Verify dimensions, alignments, and clearances of finished parts for conformance to specifications, using measuring instruments such as calipers, gauge blocks, micrometers, or dial indicators.",
      "Set up and operate conventional or computer numerically controlled machine tools such as lathes, milling machines, or grinders to cut, bore, grind, or otherwise shape parts to prescribed dimensions and finishes.",
      "Visualize and compute dimensions, sizes, shapes, and tolerances of assemblies, based on specifications.",
      "Study blueprints, sketches, models, or specifications to plan sequences of operations for fabricating tools, dies, or assemblies.",
      "Fit and assemble parts to make, repair, or modify dies, jigs, gauges, and tools, using machine tools, hand tools, or welders.",
      "Inspect finished dies for smoothness, contour conformity, and defects."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "upholsterers",
    "onet_code": "51-6093.00",
    "title": "Upholsterers",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Critical Thinking",
      "Monitoring",
      "Complex Problem Solving",
      "Time Management"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Originality",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-7021.00",
      "51-7011.00",
      "51-6051.00"
    ],
    "training_paths": [],
    "description": "Make, repair, or replace upholstery for household furniture or transportation vehicles.",
    "dailyActivities": [
      "Fit, install, and secure material on frames, using hand tools, power tools, glue, cement, or staples.",
      "Measure and cut new covering materials, using patterns and measuring and cutting instruments, following sketches and design specifications.",
      "Build furniture up with loose fiber stuffing, cotton, felt, or foam padding to form smooth, rounded surfaces.",
      "Make, restore, or create custom upholstered furniture, using hand tools and knowledge of fabrics and upholstery methods.",
      "Read work orders, and apply knowledge and experience with materials to determine types and amounts of materials required to cover workpieces.",
      "Examine furniture frames, upholstery, springs, and webbing to locate defects."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "water_and_wastewater_treatment_plant_and_system_operators",
    "onet_code": "51-8031.00",
    "title": "Water and Wastewater Treatment Plant and System Operators",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Coordination",
      "Complex Problem Solving",
      "Operations Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "production",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-8091.00",
      "51-8013.03",
      "51-8013.00"
    ],
    "training_paths": [],
    "description": "Operate or control an entire process or system of machines, often through the use of control boards, to transfer or treat water or wastewater.",
    "dailyActivities": [
      "Collect and test water and sewage samples, using test equipment and color analysis standards.",
      "Operate and adjust controls on equipment to purify and clarify water, process or dispose of sewage, and generate power.",
      "Record operational data, personnel attendance, or meter and gauge readings on specified forms.",
      "Add chemicals, such as ammonia, chlorine, or lime, to disinfect and deodorize water and other liquids.",
      "Inspect equipment or monitor operating conditions, meters, and gauges to determine load requirements and detect malfunctions.",
      "Direct and coordinate plant workers engaged in routine operations and maintenance activities."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "welders_cutters_solderers_and_brazers",
    "onet_code": "51-4121.00",
    "title": "Welders, Cutters, Solderers, and Brazers",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Category Flexibility",
      "Visualization"
    ],
    "keywords": [
      "production",
      "hands_on",
      "physical",
      "detail_oriented"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-4122.00",
      "51-2041.00",
      "51-2011.00"
    ],
    "training_paths": [],
    "description": "Use hand-welding, flame-cutting, hand-soldering, or brazing equipment to weld or join metal components or to fill holes, indentations, or seams of fabricated metal products.",
    "dailyActivities": [
      "Operate safety equipment and use safe work habits.",
      "Examine workpieces for defects and measure workpieces with straightedges or templates to ensure conformance with specifications.",
      "Weld components in flat, vertical, or overhead positions.",
      "Detect faulty operation of equipment or defective materials and notify supervisors.",
      "Recognize, set up, and operate hand and power tools common to the welding trade, such as shielded metal arc and gas metal arc welding equipment.",
      "Select and install torches, torch tips, filler rods, and flux, according to welding chart specifications or types and thicknesses of metals."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "welding_soldering_and_brazing_machine_setters_operators_and_tenders",
    "onet_code": "51-4122.00",
    "title": "Welding, Soldering, and Brazing Machine Setters, Operators, and Tenders",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Critical Thinking",
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Inductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "production",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "communication"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-4121.00",
      "51-4035.00",
      "51-2041.00"
    ],
    "training_paths": [],
    "description": "Set up, operate, or tend welding, soldering, or brazing machines or robots that weld, braze, solder, or heat treat metal products, components, or assemblies. Includes workers who operate laser cutters or laser-beam machines.",
    "dailyActivities": [
      "Read blueprints, work orders, or production schedules to determine product or job instructions or specifications.",
      "Inspect, measure, or test completed metal workpieces to ensure conformance to specifications, using measuring and testing devices.",
      "Record operational information on specified production reports.",
      "Correct problems by adjusting controls or by stopping machines and opening holding devices.",
      "Set up, operate, or tend welding machines that join or bond components to fabricate metal products or assemblies.",
      "Select torch tips, alloys, flux, coil, tubing, or wire, according to metal types or thicknesses, data charts, or records."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "woodworkers_all_other",
    "onet_code": "51-7099.00",
    "title": "Woodworkers, All Other",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "production"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All woodworkers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "woodworking_machine_setters_operators_and_tenders_except_sawing",
    "onet_code": "51-7042.00",
    "title": "Woodworking Machine Setters, Operators, and Tenders, Except Sawing",
    "category": "Production",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance",
      "Troubleshooting",
      "Repairing",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Perceptual Speed",
      "Visualization",
      "Selective Attention"
    ],
    "keywords": [
      "detail_oriented",
      "production",
      "hands_on",
      "physical",
      "technical"
    ],
    "salary": {
      "entry_min": 25525,
      "entry_max": 34034,
      "mid_min": 34034,
      "mid_max": 44244
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-7041.00",
      "51-9032.00",
      "51-4033.00"
    ],
    "training_paths": [],
    "description": "Set up, operate, or tend woodworking machines, such as drill presses, lathes, shapers, routers, sanders, planers, and wood nailing machines. May operate computer numerically controlled (CNC) equipment.",
    "dailyActivities": [
      "Set up, program, operate, or tend computerized or manual woodworking machines, such as drill presses, lathes, shapers, routers, sanders, planers, or wood-nailing machines.",
      "Examine finished workpieces for smoothness, shape, angle, depth-of-cut, or conformity to specifications and verify dimensions, visually and using hands, rules, calipers, templates, or gauges.",
      "Start machines, adjust controls, and make trial cuts to ensure that machinery is operating properly.",
      "Monitor operation of machines and make adjustments to correct problems and ensure conformance to specifications.",
      "Examine raw woodstock for defects and to ensure conformity to size and other specification standards.",
      "Adjust machine tables or cutting devices and set controls on machines to produce specified cuts or operations."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "animal_control_workers",
    "onet_code": "33-9011.00",
    "title": "Animal Control Workers",
    "category": "Protective Services",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Social Perceptiveness",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "protective_services",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31581,
      "entry_max": 42109,
      "mid_min": 42109,
      "mid_max": 54741
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "39-2021.00",
      "31-9096.00",
      "33-3031.00"
    ],
    "training_paths": [],
    "description": "Handle animals for the purpose of investigations of mistreatment, or control of abandoned, dangerous, or unattended animals.",
    "dailyActivities": [
      "Write reports of activities, and maintain files of impoundments and dispositions of animals.",
      "Investigate reports of animal attacks or animal cruelty, interviewing witnesses, collecting evidence, and writing reports.",
      "Examine animals for injuries or malnutrition, and arrange for any necessary medical treatment.",
      "Contact animal owners to inform them that their pets are at animal holding facilities.",
      "Educate the public about animal welfare, and animal control laws and regulations.",
      "Remove captured animals from animal-control service vehicles and place animals in shelter cages or other enclosures."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "bailiffs",
    "onet_code": "33-3011.00",
    "title": "Bailiffs",
    "category": "Protective Services",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Social Perceptiveness",
      "Judgment and Decision Making"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "protective_services",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37155,
      "entry_max": 49540,
      "mid_min": 49540,
      "mid_max": 64402
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "33-3051.00",
      "33-3012.00",
      "33-1012.00"
    ],
    "training_paths": [],
    "description": "Maintain order in courts of law.",
    "dailyActivities": [
      "Screen persons entering courthouse using magnetometers, x-ray machines, and other devices to collect and retain unauthorized firearms and other contraband.",
      "Escort prisoners to and from courthouse and maintain custody of prisoners during court proceedings.",
      "Maintain order in courtroom during trial and guard jury from outside contact.",
      "Provide security by patrolling interior and exterior of courthouse and escorting judges and other court employees.",
      "Guard lodging of sequestered jury.",
      "Enforce courtroom rules of behavior and warn persons not to smoke or disturb court procedure."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "correctional_officers_and_jailers",
    "onet_code": "33-3012.00",
    "title": "Correctional Officers and Jailers",
    "category": "Protective Services",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "protective_services",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31581,
      "entry_max": 42109,
      "mid_min": 42109,
      "mid_max": 54741
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "33-1011.00",
      "21-1092.00",
      "33-3051.00"
    ],
    "training_paths": [],
    "description": "Guard inmates in penal or rehabilitative institutions in accordance with established regulations and procedures. May guard prisoners in transit between jail, courtroom, prison, or other point. Includes deputy sheriffs and police who spend the majority of their time guarding prisoners in correctional institutions.",
    "dailyActivities": [
      "Conduct head counts to ensure that each prisoner is present.",
      "Inspect conditions of locks, window bars, grills, doors, and gates at correctional facilities to ensure security and help prevent escapes.",
      "Monitor conduct of prisoners in housing unit, or during work or recreational activities, according to established policies, regulations, and procedures, to prevent escape or violence.",
      "Search prisoners and vehicles and conduct shakedowns of cells for valuables and contraband, such as weapons or drugs.",
      "Guard facility entrances to screen visitors.",
      "Record information, such as prisoner identification, charges, and incidents of inmate disturbance, keeping daily logs of prisoner activities."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "military_mos_relevant": [
      "31B"
    ],
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "crossing_guards_and_flaggers",
    "onet_code": "33-9091.00",
    "title": "Crossing Guards and Flaggers",
    "category": "Protective Services",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Far Vision",
      "Speech Recognition"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "physical",
      "protective_services",
      "communication"
    ],
    "salary": {
      "entry_min": 31581,
      "entry_max": 42109,
      "mid_min": 42109,
      "mid_max": 54741
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "33-3052.00",
      "53-4041.00",
      "53-4031.00"
    ],
    "training_paths": [],
    "description": "Guide or control vehicular or pedestrian traffic at such places as streets, schools, railroad crossings, or construction sites.",
    "dailyActivities": [
      "Direct or escort pedestrians across streets, stopping traffic, as necessary.",
      "Guide or control vehicular or pedestrian traffic at such places as street and railroad crossings and construction sites.",
      "Monitor traffic flow to locate safe gaps through which pedestrians can cross streets.",
      "Communicate traffic and crossing rules and other information to students and adults.",
      "Direct traffic movement or warn of hazards, using signs, flags, lanterns, and hand signals.",
      "Report unsafe behavior of children to school officials."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "customs_and_border_protection_officers",
    "onet_code": "33-3051.04",
    "title": "Customs and Border Protection Officers",
    "category": "Protective Services",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "protective_services",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37155,
      "entry_max": 49540,
      "mid_min": 49540,
      "mid_max": 64402
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "13-1041.08",
      "33-3021.00",
      "33-3051.00"
    ],
    "training_paths": [],
    "description": "Investigate and inspect persons, common carriers, goods, and merchandise, arriving in or departing from the United States or between states to detect violations of immigration and customs laws and regulations.",
    "dailyActivities": [
      "Examine immigration applications, visas, and passports and interview persons to determine eligibility for admission, residence, and travel in the U.S.",
      "Detain persons found to be in violation of customs or immigration laws and arrange for legal action, such as deportation.",
      "Inspect cargo, baggage, and personal articles entering or leaving U.S. for compliance with revenue laws and U.S. customs regulations.",
      "Locate and seize contraband, undeclared merchandise, and vehicles, aircraft, or boats that contain such merchandise.",
      "Interpret and explain laws and regulations to travelers, prospective immigrants, shippers, and manufacturers.",
      "Institute civil and criminal prosecutions and cooperate with other law enforcement agencies in the investigation and prosecution of those in violation of immigration or customs laws."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "detectives_and_criminal_investigators",
    "onet_code": "33-3021.00",
    "title": "Detectives and Criminal Investigators",
    "category": "Protective Services",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "protective_services",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37155,
      "entry_max": 49540,
      "mid_min": 49540,
      "mid_max": 64402
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "33-9021.00",
      "33-3051.00",
      "33-3021.02"
    ],
    "training_paths": [],
    "description": "Conduct investigations related to suspected violations of federal, state, or local laws to prevent or solve crimes.",
    "dailyActivities": [
      "Check victims for signs of life, such as breathing and pulse.",
      "Obtain facts or statements from complainants, witnesses, and accused persons and record interviews, using recording device.",
      "Secure deceased body and obtain evidence from it, preventing bystanders from tampering with it prior to medical examiner's arrival.",
      "Record progress of investigation, maintain informational files on suspects, and submit reports to commanding officer or magistrate to authorize warrants.",
      "Prepare reports that detail investigation findings.",
      "Prepare charges or responses to charges, or information for court cases, according to formalized procedures."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "fire_inspectors_and_investigators",
    "onet_code": "33-2021.00",
    "title": "Fire Inspectors and Investigators",
    "category": "Protective Services",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "protective_services",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37155,
      "entry_max": 49540,
      "mid_min": 49540,
      "mid_max": 64402
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "17-2111.02",
      "33-2011.00",
      "33-2022.00"
    ],
    "training_paths": [],
    "description": "Inspect buildings to detect fire hazards and enforce local ordinances and state laws, or investigate and gather facts to determine cause of fires and explosions.",
    "dailyActivities": [
      "Prepare and maintain reports of investigation results, and records of convicted arsonists and arson suspects.",
      "Testify in court cases involving fires, suspected arson, and false alarms.",
      "Package collected pieces of evidence in securely closed containers, such as bags, crates, or boxes, to protect them.",
      "Conduct inspections and acceptance testing of newly installed fire protection systems.",
      "Analyze evidence and other information to determine probable cause of fire or explosion.",
      "Photograph damage and evidence related to causes of fires or explosions to document investigation findings."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "firefighters",
    "onet_code": "33-2011.00",
    "title": "Firefighters",
    "category": "Protective Services",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "protective_services",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37155,
      "entry_max": 49540,
      "mid_min": 49540,
      "mid_max": 64402
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "33-1021.00",
      "33-2022.00",
      "33-2021.00"
    ],
    "training_paths": [],
    "description": "Control and extinguish fires or respond to emergency situations where life, property, or the environment is at risk. Duties may include fire prevention, emergency medical service, hazardous material response, search and rescue, and disaster assistance.",
    "dailyActivities": [
      "Rescue survivors from burning buildings, accident sites, and water hazards.",
      "Dress with equipment such as fire-resistant clothing and breathing apparatus.",
      "Assess fires and situations and report conditions to superiors to receive instructions, using two-way radios.",
      "Move toward the source of a fire, using knowledge of types of fires, construction design, building materials, and physical layout of properties.",
      "Respond to fire alarms and other calls for assistance, such as automobile and industrial accidents.",
      "Create openings in buildings for ventilation or entrance, using axes, chisels, crowbars, electric saws, or core cutters."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "first_line_supervisors_of_correctional_officers",
    "onet_code": "33-1011.00",
    "title": "First-Line Supervisors of Correctional Officers",
    "category": "Protective Services",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "protective_services",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37155,
      "entry_max": 49540,
      "mid_min": 49540,
      "mid_max": 64402
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "33-3012.00",
      "21-1092.00",
      "33-1091.00"
    ],
    "training_paths": [],
    "description": "Directly supervise and coordinate activities of correctional officers and jailers.",
    "dailyActivities": [
      "Take, receive, or check periodic inmate counts.",
      "Maintain order, discipline, and security within assigned areas in accordance with relevant rules, regulations, policies, and laws.",
      "Maintain knowledge of, comply with, and enforce all institutional policies, rules, procedures, and regulations.",
      "Respond to emergencies, such as escapes.",
      "Supervise and direct the work of correctional officers to ensure the safe custody, discipline, and welfare of inmates.",
      "Supervise or perform searches of inmates or their quarters to locate contraband items."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "first_line_supervisors_of_firefighting_and_prevention_workers",
    "onet_code": "33-1021.00",
    "title": "First-Line Supervisors of Firefighting and Prevention Workers",
    "category": "Protective Services",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "protective_services",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37155,
      "entry_max": 49540,
      "mid_min": 49540,
      "mid_max": 64402
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "33-2011.00",
      "33-2022.00",
      "33-2021.00"
    ],
    "training_paths": [],
    "description": "Directly supervise and coordinate activities of workers engaged in firefighting and fire prevention and control.",
    "dailyActivities": [
      "Assign firefighters to jobs at strategic locations to facilitate rescue of persons and maximize application of extinguishing agents.",
      "Provide emergency medical services as required, and perform light to heavy rescue functions at emergencies.",
      "Assess nature and extent of fire, condition of building, danger to adjacent buildings, and water supply status to determine crew or company requirements.",
      "Communicate fire details to superiors, subordinates, or interagency dispatch centers, using two-way radios.",
      "Serve as a working leader of an engine, hand, helicopter, or prescribed fire crew of three or more firefighters.",
      "Instruct and drill fire department personnel in assigned duties, including firefighting, medical care, hazardous materials response, fire prevention, and related subjects."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "first_line_supervisors_of_police_and_detectives",
    "onet_code": "33-1012.00",
    "title": "First-Line Supervisors of Police and Detectives",
    "category": "Protective Services",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "protective_services",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31581,
      "entry_max": 42109,
      "mid_min": 42109,
      "mid_max": 54741
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "33-3051.00",
      "33-3021.00",
      "33-1011.00"
    ],
    "training_paths": [],
    "description": "Directly supervise and coordinate activities of members of police force.",
    "dailyActivities": [
      "Supervise and coordinate the investigation of criminal cases, offering guidance and expertise to investigators, and ensuring that procedures are conducted in accordance with laws and regulations.",
      "Prepare work schedules and assign duties to subordinates.",
      "Direct collection, preparation, and handling of evidence and personal property of prisoners.",
      "Investigate and resolve personnel problems within organization and charges of misconduct against staff.",
      "Explain police operations to subordinates to assist them in performing their job duties.",
      "Maintain logs, prepare reports, and direct the preparation, handling, and maintenance of departmental records."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "military_mos_relevant": [
      "31B"
    ],
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "first_line_supervisors_of_protective_service_workers_all_other",
    "onet_code": "33-1099.00",
    "title": "First-Line Supervisors of Protective Service Workers, All Other",
    "category": "Protective Services",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "protective_services"
    ],
    "salary": {
      "entry_min": 31581,
      "entry_max": 42109,
      "mid_min": 42109,
      "mid_max": 54741
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All protective service supervisors not listed separately above.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "first_line_supervisors_of_security_workers",
    "onet_code": "33-1091.00",
    "title": "First-Line Supervisors of Security Workers",
    "category": "Protective Services",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "protective_services",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31581,
      "entry_max": 42109,
      "mid_min": 42109,
      "mid_max": 54741
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "11-3013.01",
      "43-1011.00",
      "53-1044.00"
    ],
    "training_paths": [],
    "description": "Directly supervise and coordinate activities of security workers and security guards.",
    "dailyActivities": [
      "Investigate disturbances on the premises, such as security alarms, altercations, and suspicious activity.",
      "Patrol the premises to prevent or detect intrusion, protect property, or preserve order.",
      "Monitor and authorize entry of employees, visitors, or other persons.",
      "Secure entrances and exits by locking doors and gates.",
      "Write reports documenting observations made while on patrol.",
      "Monitor the behavior of security employees to ensure adherence to quality standards, deadlines, or procedures."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "forest_fire_inspectors_and_prevention_specialists",
    "onet_code": "33-2022.00",
    "title": "Forest Fire Inspectors and Prevention Specialists",
    "category": "Protective Services",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Originality"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "protective_services",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37155,
      "entry_max": 49540,
      "mid_min": 49540,
      "mid_max": 64402
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "33-1021.00",
      "33-2011.00",
      "33-2021.00"
    ],
    "training_paths": [],
    "description": "Enforce fire regulations, inspect forest for fire hazards, and recommend forest fire prevention or control measures. May report forest fires and weather conditions.",
    "dailyActivities": [
      "Relay messages about emergencies, accidents, locations of crew and personnel, and fire hazard conditions.",
      "Conduct wildland firefighting training.",
      "Estimate sizes and characteristics of fires, and report findings to base camps by radio or telephone.",
      "Direct crews working on firelines during forest fires.",
      "Locate forest fires on area maps, using azimuth sighters and known landmarks.",
      "Extinguish smaller fires with portable extinguishers, shovels, and axes."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "gambling_surveillance_officers_and_gambling_investigators",
    "onet_code": "33-9031.00",
    "title": "Gambling Surveillance Officers and Gambling Investigators",
    "category": "Protective Services",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "protective_services",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31581,
      "entry_max": 42109,
      "mid_min": 42109,
      "mid_max": 54741
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "13-1199.07",
      "11-3013.01",
      "15-1299.06"
    ],
    "training_paths": [],
    "description": "Observe gambling operation for irregular activities such as cheating or theft by either employees or patrons. Investigate potential threats to gambling assets such as money, chips, and gambling equipment. Act as oversight and security agent for management and customers.",
    "dailyActivities": [
      "Monitor establishment activities to ensure adherence to all state gaming regulations and company policies and procedures.",
      "Observe casino or casino hotel operations for irregular activities, such as cheating or theft by employees or patrons, using audio and video equipment and one-way mirrors.",
      "Report all violations and suspicious behaviors to supervisors, verbally or in writing.",
      "Develop and maintain log of surveillance observations.",
      "Inspect and monitor audio or video surveillance equipment to ensure it is working appropriately.",
      "Review video surveillance footage."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "lifeguards_ski_patrol_and_other_recreational_protective_service_workers",
    "onet_code": "33-9092.00",
    "title": "Lifeguards, Ski Patrol, and Other Recreational Protective Service Workers",
    "category": "Protective Services",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Learning Strategies",
      "Monitoring",
      "Social Perceptiveness",
      "Service Orientation",
      "Judgment and Decision Making"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Inductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "physical",
      "protective_services",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31581,
      "entry_max": 42109,
      "mid_min": 42109,
      "mid_max": 54741
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "33-2011.00",
      "53-3011.00",
      "29-2042.00"
    ],
    "training_paths": [],
    "description": "Monitor recreational areas, such as pools, beaches, or ski slopes, to provide assistance and protection to participants.",
    "dailyActivities": [
      "Patrol or monitor recreational areas, such as trails, slopes, or swimming areas, on foot, in vehicles, or from towers.",
      "Rescue distressed persons, using rescue techniques and equipment.",
      "Contact emergency medical personnel in case of serious injury.",
      "Examine injured persons and administer first aid or cardiopulmonary resuscitation, if necessary, using training and medical supplies and equipment.",
      "Warn recreational participants of inclement weather, unsafe areas, or illegal conduct.",
      "Maintain quality of pool water by testing chemical levels."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "parking_enforcement_workers",
    "onet_code": "33-3041.00",
    "title": "Parking Enforcement Workers",
    "category": "Protective Services",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "protective_services",
      "problem_solving",
      "technical",
      "communication"
    ],
    "salary": {
      "entry_min": 31581,
      "entry_max": 42109,
      "mid_min": 42109,
      "mid_max": 54741
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-6021.00",
      "33-9032.00",
      "33-3052.00"
    ],
    "training_paths": [],
    "description": "Patrol assigned area, such as public parking lot or city streets to issue tickets to overtime parking violators and illegally parked vehicles.",
    "dailyActivities": [
      "Enter and retrieve information pertaining to vehicle registration, identification, and status, using hand-held computers.",
      "Patrol an assigned area by vehicle or on foot to ensure public compliance with existing parking ordinance.",
      "Write warnings and citations for illegally parked vehicles.",
      "Appear in court at hearings regarding contested traffic citations.",
      "Maintain assigned equipment and supplies, such as hand-held citation computers, citation books, rain gear, tire-marking chalk, and street cones.",
      "Respond to and make radio dispatch calls regarding parking violations and complaints."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "police_identification_and_records_officers",
    "onet_code": "33-3021.02",
    "title": "Police Identification and Records Officers",
    "category": "Protective Services",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "protective_services",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37155,
      "entry_max": 49540,
      "mid_min": 49540,
      "mid_max": 64402
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "19-4092.00",
      "33-3021.00",
      "33-9021.00"
    ],
    "training_paths": [],
    "description": "Collect evidence at crime scene, classify and identify fingerprints, and photograph evidence for use in criminal and civil cases.",
    "dailyActivities": [
      "Photograph crime or accident scenes for evidence records.",
      "Maintain records of evidence and write and review reports.",
      "Submit evidence to supervisors, crime labs, or court officials for legal proceedings.",
      "Testify in court and present evidence.",
      "Look for trace evidence, such as fingerprints, hairs, fibers, or shoe impressions, using alternative light sources when necessary.",
      "Dust selected areas of crime scene and lift latent fingerprints, adhering to proper preservation procedures."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "police_and_sheriff's_patrol_officers",
    "onet_code": "33-3051.00",
    "title": "Police and Sheriff's Patrol Officers",
    "category": "Protective Services",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "protective_services",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37155,
      "entry_max": 49540,
      "mid_min": 49540,
      "mid_max": 64402
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "33-3021.00",
      "33-1012.00",
      "33-3052.00"
    ],
    "training_paths": [],
    "description": "Maintain order and protect life and property by enforcing local, tribal, state, or federal laws and ordinances. Perform a combination of the following duties: patrol a specific area; direct traffic; issue traffic summonses; investigate accidents; apprehend and arrest suspects, or serve legal processes of courts. Includes police officers working at educational institutions.",
    "dailyActivities": [
      "Identify, pursue, and arrest suspects and perpetrators of criminal acts.",
      "Provide for public safety by maintaining order, responding to emergencies, protecting people and property, enforcing motor vehicle and criminal laws, and promoting good community relations.",
      "Record facts to prepare reports that document incidents and activities.",
      "Render aid to accident survivors and other persons requiring first aid for physical injuries.",
      "Review facts of incidents to determine if criminal act or statute violations were involved.",
      "Investigate illegal or suspicious activities."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "military_mos_relevant": [
      "11B",
      "MA",
      "0311"
    ],
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "private_detectives_and_investigators",
    "onet_code": "33-9021.00",
    "title": "Private Detectives and Investigators",
    "category": "Protective Services",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "protective_services",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37155,
      "entry_max": 49540,
      "mid_min": 49540,
      "mid_max": 64402
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "33-3021.00",
      "13-2099.04",
      "33-3021.06"
    ],
    "training_paths": [],
    "description": "Gather, analyze, compile, and report information regarding individuals or organizations to clients, or detect occurrences of unlawful acts or infractions of rules in private establishment.",
    "dailyActivities": [
      "Write reports or case summaries to document investigations.",
      "Conduct private investigations on a paid basis.",
      "Search computer databases, credit reports, public records, tax or legal filings, or other resources to locate persons or to compile information for investigations.",
      "Conduct personal background investigations, such as pre-employment checks, to obtain information about an individual's character, financial status, or personal history.",
      "Expose fraudulent insurance claims or stolen funds.",
      "Obtain and analyze information on suspects, crimes, or disturbances to solve cases, to identify criminal activity, or to gather information for court cases."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "protective_service_workers_all_other",
    "onet_code": "33-9099.00",
    "title": "Protective Service Workers, All Other",
    "category": "Protective Services",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "protective_services"
    ],
    "salary": {
      "entry_min": 31581,
      "entry_max": 42109,
      "mid_min": 42109,
      "mid_max": 54741
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All protective service workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "retail_loss_prevention_specialists",
    "onet_code": "33-9099.02",
    "title": "Retail Loss Prevention Specialists",
    "category": "Protective Services",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "protective_services",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31581,
      "entry_max": 42109,
      "mid_min": 42109,
      "mid_max": 54741
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "11-9199.08",
      "33-9021.00",
      "11-3013.01"
    ],
    "training_paths": [],
    "description": "Implement procedures and systems to prevent merchandise loss. Conduct audits and investigations of employee activity. May assist in developing policies, procedures, and systems for safeguarding assets.",
    "dailyActivities": [
      "Investigate known or suspected internal theft, external theft, or vendor fraud.",
      "Implement or monitor processes to reduce property or financial losses.",
      "Identify and report merchandise or stock shortages.",
      "Maintain documentation or reports on security-related incidents or investigations.",
      "Apprehend shoplifters in accordance with guidelines.",
      "Verify proper functioning of physical security systems, such as closed-circuit televisions, alarms, sensor tag systems, or locks."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "school_bus_monitors",
    "onet_code": "33-9094.00",
    "title": "School Bus Monitors",
    "category": "Protective Services",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "protective_services"
    ],
    "salary": {
      "entry_min": 31581,
      "entry_max": 42109,
      "mid_min": 42109,
      "mid_max": 54741
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-3051.00",
      "53-3052.00",
      "53-3053.00"
    ],
    "training_paths": [],
    "description": "Maintain order among students on a school bus. Duties include helping students safely board and exit and communicating behavioral problems. May perform pretrip and posttrip inspections and prepare for and assist in emergency evacuations.",
    "dailyActivities": [
      "Announce routes or stops.",
      "Assist children with disabilities or children with psychological, emotional, or behavioral issues with boarding and exiting the school bus.",
      "Buckle seatbelts or fasten wheelchair tie-down straps to secure passengers for transportation.",
      "Clean school bus interiors by picking up waste, wiping down windows, or vacuuming.",
      "Direct students boarding and exiting the school bus.",
      "Direct students evacuating the bus during safety drills."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "security_guards",
    "onet_code": "33-9032.00",
    "title": "Security Guards",
    "category": "Protective Services",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Social Perceptiveness",
      "Coordination",
      "Persuasion"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "protective_services",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31581,
      "entry_max": 42109,
      "mid_min": 42109,
      "mid_max": 54741
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "33-1091.00",
      "33-3052.00",
      "33-9093.00"
    ],
    "training_paths": [],
    "description": "Guard, patrol, or monitor premises to prevent theft, violence, or infractions of rules. May operate x-ray and metal detector equipment.",
    "dailyActivities": [
      "Lock doors and gates of entrances and exits to secure buildings.",
      "Patrol industrial or commercial premises to prevent and detect signs of intrusion and ensure security of doors, windows, and gates.",
      "Respond to medical emergencies by administering basic first aid or by obtaining assistance from paramedics.",
      "Answer alarms and investigate disturbances.",
      "Circulate among visitors, patrons, or employees to preserve order and protect property.",
      "Monitor and authorize entrance and departure of employees, visitors, and other persons to guard against theft and maintain security of premises."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "military_mos_relevant": [
      "11B",
      "MA",
      "0311"
    ],
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "transit_and_railroad_police",
    "onet_code": "33-3052.00",
    "title": "Transit and Railroad Police",
    "category": "Protective Services",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "protective_services",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 37155,
      "entry_max": 49540,
      "mid_min": 49540,
      "mid_max": 64402
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "33-3051.00",
      "33-9032.00",
      "33-1012.00"
    ],
    "training_paths": [],
    "description": "Protect and police railroad and transit property, employees, or passengers.",
    "dailyActivities": [
      "Prepare reports documenting investigation activities and results.",
      "Monitor transit areas and conduct security checks to protect railroad properties, patrons, and employees.",
      "Apprehend or remove trespassers or thieves from railroad property or coordinate with law enforcement agencies in apprehensions and removals.",
      "Direct security activities at derailments, fires, floods, or strikes involving railroad property.",
      "Patrol railroad yards, cars, stations, or other facilities to protect company property or shipments and to maintain order.",
      "Investigate or direct investigations of freight theft, suspicious damage or loss of passengers' valuables, or other crimes on railroad property."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "transportation_security_screeners",
    "onet_code": "33-9093.00",
    "title": "Transportation Security Screeners",
    "category": "Protective Services",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "protective_services",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 31581,
      "entry_max": 42109,
      "mid_min": 42109,
      "mid_max": 54741
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Variable shifts including nights/weekends"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "33-9032.00",
      "33-3052.00",
      "53-2031.00"
    ],
    "training_paths": [],
    "description": "Conduct screening of passengers, baggage, or cargo to ensure compliance with Transportation Security Administration (TSA) regulations. May operate basic security equipment such as x-ray machines and hand wands at screening checkpoints.",
    "dailyActivities": [
      "Inspect carry-on items, using x-ray viewing equipment, to determine whether items contain objects that warrant further investigation.",
      "Search carry-on or checked baggage by hand when it is suspected to contain prohibited items such as weapons.",
      "Check passengers' tickets to ensure that they are valid, and to determine whether passengers have designations that require special handling, such as providing photo identification.",
      "Test baggage for any explosive materials, using equipment such as explosive detection machines or chemical swab systems.",
      "Perform pat-down or hand-held wand searches of passengers who have triggered machine alarms, who are unable to pass through metal detectors, or who have been randomly identified for such searches.",
      "Notify supervisors or other appropriate personnel when security breaches occur."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "veteran_preference": true,
    "last_updated": new Date()
  },
  {
    "id": "cashiers",
    "onet_code": "41-2011.00",
    "title": "Cashiers",
    "category": "Sales",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Near Vision",
      "Speech Recognition"
    ],
    "keywords": [
      "customer_service",
      "sales",
      "hands_on",
      "physical",
      "technical"
    ],
    "salary": {
      "entry_min": 23389,
      "entry_max": 31186,
      "mid_min": 31186,
      "mid_max": 40541
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "41-2021.00",
      "43-3071.00",
      "43-4051.00"
    ],
    "training_paths": [],
    "description": "Receive and disburse money in establishments other than financial institutions. May use electronic scanners, cash registers, or related equipment. May process credit or debit card transactions and validate checks.",
    "dailyActivities": [
      "Receive payment by cash, check, credit cards, vouchers, or automatic debits.",
      "Greet customers entering establishments.",
      "Issue receipts, refunds, credits, or change due to customers.",
      "Assist customers by providing information and resolving their complaints.",
      "Monitor checkout stations to ensure they have adequate cash available and are staffed appropriately.",
      "Establish or identify prices of goods, services, or admission, and tabulate bills, using calculators, cash registers, or optical price scanners."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "counter_and_rental_clerks",
    "onet_code": "41-2021.00",
    "title": "Counter and Rental Clerks",
    "category": "Sales",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Coordination",
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Information Ordering"
    ],
    "keywords": [
      "customer_service",
      "sales",
      "hands_on",
      "physical",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 23389,
      "entry_max": 31186,
      "mid_min": 31186,
      "mid_max": 40541
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "41-2031.00",
      "41-2011.00",
      "41-9091.00"
    ],
    "training_paths": [],
    "description": "Receive orders, generally in person, for repairs, rentals, and services. May describe available options, compute cost, and accept payment.",
    "dailyActivities": [
      "Compute charges for merchandise or services and receive payments.",
      "Receive orders for services, such as rentals, repairs, dry cleaning, and storage.",
      "Explain rental fees, policies, and procedures.",
      "Provide information about rental items, such as availability, operation, or description.",
      "Advise customers on use and care of merchandise.",
      "Greet customers and discuss the type, quality, and quantity of merchandise sought for rental."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "demonstrators_and_product_promoters",
    "onet_code": "41-9011.00",
    "title": "Demonstrators and Product Promoters",
    "category": "Sales",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "sales",
      "hands_on",
      "physical",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 23389,
      "entry_max": 31186,
      "mid_min": 31186,
      "mid_max": 40541
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "41-9091.00",
      "41-3091.00",
      "41-2031.00"
    ],
    "training_paths": [],
    "description": "Demonstrate merchandise and answer questions for the purpose of creating public interest in buying the product. May sell demonstrated merchandise.",
    "dailyActivities": [
      "Provide product samples, coupons, informational brochures, or other incentives to persuade people to buy products.",
      "Sell products being promoted and keep records of sales.",
      "Keep areas neat while working and return items to correct locations following demonstrations.",
      "Demonstrate or explain products, methods, or services to persuade customers to purchase products or use services.",
      "Record and report demonstration-related information, such as the number of questions asked by the audience or the number of coupons distributed.",
      "Suggest specific product purchases to meet customers' needs."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "door_to_door_sales_workers_news_and_street_vendors_and_related_workers",
    "onet_code": "41-9091.00",
    "title": "Door-to-Door Sales Workers, News and Street Vendors, and Related Workers",
    "category": "Sales",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Social Perceptiveness",
      "Coordination",
      "Persuasion",
      "Negotiation",
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Fluency of Ideas",
      "Originality"
    ],
    "keywords": [
      "customer_service",
      "sales",
      "hands_on",
      "physical",
      "problem_solving",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 19262,
      "entry_max": 25683,
      "mid_min": 25683,
      "mid_max": 33387
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "41-2031.00",
      "41-2021.00",
      "41-9011.00"
    ],
    "training_paths": [],
    "description": "Sell goods or services door-to-door or on the street.",
    "dailyActivities": [
      "Explain products or services and prices and demonstrate use of products.",
      "Develop prospect lists.",
      "Deliver merchandise and collect payment.",
      "Write and record orders for merchandise or enter orders into computers.",
      "Arrange buying parties and solicit sponsorship of such parties to sell merchandise.",
      "Answer questions about product features and benefits."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "first_line_supervisors_of_retail_sales_workers",
    "onet_code": "41-1011.00",
    "title": "First-Line Supervisors of Retail Sales Workers",
    "category": "Sales",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "sales",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 23389,
      "entry_max": 31186,
      "mid_min": 31186,
      "mid_max": 40541
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "41-1012.00",
      "43-1011.00",
      "35-1012.00"
    ],
    "training_paths": [],
    "description": "Directly supervise and coordinate activities of retail sales workers in an establishment or department. Duties may include management functions, such as purchasing, budgeting, accounting, and personnel work, in addition to supervisory duties.",
    "dailyActivities": [
      "Provide customer service by greeting and assisting customers and responding to customer inquiries and complaints.",
      "Direct and supervise employees engaged in sales, inventory-taking, reconciling cash receipts, or in performing services for customers.",
      "Examine merchandise to ensure that it is correctly priced and displayed and that it functions as advertised.",
      "Monitor sales activities to ensure that customers receive satisfactory service and quality goods.",
      "Instruct staff on how to handle difficult and complicated sales.",
      "Assign employees to specific duties."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "gambling_change_persons_and_booth_cashiers",
    "onet_code": "41-2012.00",
    "title": "Gambling Change Persons and Booth Cashiers",
    "category": "Sales",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Information Ordering",
      "Category Flexibility"
    ],
    "keywords": [
      "customer_service",
      "sales",
      "analytical",
      "hands_on",
      "physical",
      "communication"
    ],
    "salary": {
      "entry_min": 23389,
      "entry_max": 31186,
      "mid_min": 31186,
      "mid_max": 40541
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-3041.00",
      "43-3071.00",
      "39-1013.00"
    ],
    "training_paths": [],
    "description": "Exchange coins, tokens, and chips for patrons' money. May issue payoffs and obtain customer's signature on receipt. May operate a booth in the slot machine area and furnish change persons with money bank at the start of the shift, or count and audit money in drawers.",
    "dailyActivities": [
      "Keep accurate records of monetary exchanges, authorization forms, and transaction reconciliations.",
      "Exchange money, credit, tickets, or casino chips and make change for customers.",
      "Count money and audit money drawers.",
      "Check identifications to verify age of players.",
      "Maintain cage security according to rules.",
      "Reconcile daily summaries of transactions to balance books."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "models",
    "onet_code": "41-9012.00",
    "title": "Models",
    "category": "Sales",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Oral Comprehension"
    ],
    "keywords": [
      "sales",
      "hands_on",
      "physical"
    ],
    "salary": {
      "entry_min": 23389,
      "entry_max": 31186,
      "mid_min": 31186,
      "mid_max": 40541
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "27-1013.00",
      "39-5091.00",
      "27-4021.00"
    ],
    "training_paths": [],
    "description": "Model garments or other apparel and accessories for prospective buyers at fashion shows, private showings, or retail establishments. May pose for photos to be used in magazines or advertisements. May pose as subject for paintings, sculptures, and other types of artistic expression.",
    "dailyActivities": [
      "Pose for artists and photographers.",
      "Record rates of pay and durations of jobs on vouchers.",
      "Gather information from agents concerning the pay, dates, times, provisions, and lengths of jobs.",
      "Report job completions to agencies and obtain information about future appointments.",
      "Assemble and maintain portfolios, print composite cards, and travel to go-sees to obtain jobs.",
      "Pose as directed, or strike suitable interpretive poses for promoting and selling merchandise or fashions during appearances, filming, or photo sessions."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "parts_salespersons",
    "onet_code": "41-2022.00",
    "title": "Parts Salespersons",
    "category": "Sales",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Coordination",
      "Persuasion"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Deductive Reasoning",
      "Inductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "sales",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 23389,
      "entry_max": 31186,
      "mid_min": 31186,
      "mid_max": 40541
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "41-2021.00",
      "43-5071.00",
      "41-2031.00"
    ],
    "training_paths": [],
    "description": "Sell spare and replacement parts and equipment in repair shop or parts store.",
    "dailyActivities": [
      "Receive payment or obtain credit authorization.",
      "Assist customers, such as responding to customer complaints and updating them about back-ordered parts.",
      "Fill customer orders from stock, and place orders when requested items are out of stock.",
      "Receive and fill telephone orders for parts.",
      "Locate and label parts, and maintain inventory of stock.",
      "Prepare sales slips or sales contracts."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "real_estate_sales_agents",
    "onet_code": "41-9022.00",
    "title": "Real Estate Sales Agents",
    "category": "Sales",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "sales",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 27517,
      "entry_max": 36690,
      "mid_min": 36690,
      "mid_max": 47697
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "41-9021.00",
      "11-9141.00",
      "13-2023.00"
    ],
    "training_paths": [],
    "description": "Rent, buy, or sell property for clients. Perform duties such as study property listings, interview prospective clients, accompany clients to property site, discuss conditions of sale, and draw up real estate contracts. Includes agents who represent buyer.",
    "dailyActivities": [
      "Prepare documents such as representation contracts, purchase agreements, closing statements, deeds, and leases.",
      "Present purchase offers to sellers for consideration.",
      "Act as an intermediary in negotiations between buyers and sellers, generally representing one or the other.",
      "Generate lists of properties that are compatible with buyers' needs and financial resources.",
      "Confer with escrow companies, lenders, home inspectors, and pest control operators to ensure that terms and conditions of purchase agreements are met before closing dates.",
      "Promote sales of properties through advertisements, open houses, and participation in multiple listing services."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "retail_salespersons",
    "onet_code": "41-2031.00",
    "title": "Retail Salespersons",
    "category": "Sales",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Social Perceptiveness",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "sales",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 23389,
      "entry_max": 31186,
      "mid_min": 31186,
      "mid_max": 40541
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "41-2021.00",
      "41-9091.00",
      "53-7065.00"
    ],
    "training_paths": [],
    "description": "Sell merchandise, such as furniture, motor vehicles, appliances, or apparel to consumers.",
    "dailyActivities": [
      "Greet customers and ascertain what each customer wants or needs.",
      "Recommend, select, and help locate or obtain merchandise based on customer needs and desires.",
      "Compute sales prices, total purchases, and receive and process cash or credit payment.",
      "Prepare merchandise for purchase or rental.",
      "Answer questions regarding the store and its merchandise.",
      "Maintain knowledge of current sales and promotions, policies regarding payment and exchanges, and security practices."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "sales_representatives_of_services_except_advertising_insurance_financial_services_and_travel",
    "onet_code": "41-3091.00",
    "title": "Sales Representatives of Services, Except Advertising, Insurance, Financial Services, and Travel",
    "category": "Sales",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "sales"
    ],
    "salary": {
      "entry_min": 23389,
      "entry_max": 31186,
      "mid_min": 31186,
      "mid_max": 40541
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-4051.00",
      "41-9041.00",
      "11-2022.00"
    ],
    "training_paths": [],
    "description": "Sell services to individuals or businesses. May describe options or resolve client problems.",
    "dailyActivities": [
      "Answer customers' questions about services, prices, availability, or credit terms.",
      "Attend sales or trade meetings or read related publications to obtain information about market conditions, business trends, regulations, or industry developments.",
      "Compute and compare costs of services.",
      "Consult with clients after sales or contract signings to resolve problems and provide ongoing support.",
      "Contact prospective or existing customers to discuss how services can meet their needs.",
      "Create forms or agreements to complete sales."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "sales_and_related_workers_all_other",
    "onet_code": "41-9099.00",
    "title": "Sales and Related Workers, All Other",
    "category": "Sales",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "sales"
    ],
    "salary": {
      "entry_min": 23389,
      "entry_max": 31186,
      "mid_min": 31186,
      "mid_max": 40541
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All sales and related workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "solar_sales_representatives_and_assessors",
    "onet_code": "41-4011.07",
    "title": "Solar Sales Representatives and Assessors",
    "category": "Sales",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "sales",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 27517,
      "entry_max": 36690,
      "mid_min": 36690,
      "mid_max": 47697
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "17-2199.11",
      "47-1011.03",
      "47-4011.01"
    ],
    "training_paths": [],
    "description": "Contact new or existing customers to determine their solar equipment needs, suggest systems or equipment, or estimate costs.",
    "dailyActivities": [
      "Prepare proposals, quotes, contracts, or presentations for potential solar customers.",
      "Select solar energy products, systems, or services for customers based on electrical energy requirements, site conditions, price, or other factors.",
      "Provide customers with information, such as quotes, orders, sales, shipping, warranties, credit, funding options, incentives, or tax rebates.",
      "Gather information from prospective customers to identify their solar energy needs.",
      "Calculate potential solar resources or solar array production for a particular site considering issues such as climate, shading, and roof orientation.",
      "Generate solar energy customer leads to develop new accounts."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "telemarketers",
    "onet_code": "41-9041.00",
    "title": "Telemarketers",
    "category": "Sales",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Social Perceptiveness",
      "Persuasion",
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Near Vision",
      "Speech Recognition"
    ],
    "keywords": [
      "customer_service",
      "sales",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 23389,
      "entry_max": 31186,
      "mid_min": 31186,
      "mid_max": 40541
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "41-3091.00",
      "43-4051.00",
      "41-3011.00"
    ],
    "training_paths": [],
    "description": "Solicit donations or orders for goods or services over the telephone.",
    "dailyActivities": [
      "Contact businesses or private individuals by telephone to solicit sales for goods or services, or to request donations for charitable causes.",
      "Obtain customer information such as name, address, and payment method, and enter orders into computers.",
      "Explain products or services and prices, and answer questions from customers.",
      "Record names, addresses, purchases, and reactions of prospects contacted.",
      "Maintain records of contacts, accounts, and orders.",
      "Answer telephone calls from potential customers who have been solicited through advertisements."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "travel_agents",
    "onet_code": "41-3041.00",
    "title": "Travel Agents",
    "category": "Sales",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Social Perceptiveness",
      "Persuasion"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "sales",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 27517,
      "entry_max": 36690,
      "mid_min": 36690,
      "mid_max": 47697
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-4181.00",
      "39-7012.00",
      "41-2021.00"
    ],
    "training_paths": [],
    "description": "Plan and sell transportation and accommodations for customers. Determine destination, modes of transportation, travel dates, costs, and accommodations required. May also describe, plan, and arrange itineraries and sell tour packages. May assist in resolving clients' travel problems.",
    "dailyActivities": [
      "Collect payment for transportation and accommodations from customer.",
      "Plan, describe, arrange, and sell itinerary tour packages and promotional travel incentives offered by various travel carriers.",
      "Converse with customer to determine destination, mode of transportation, travel dates, financial considerations, and accommodations required.",
      "Compute cost of travel and accommodations, using calculator, computer, carrier tariff books, and hotel rate books, or quote package tour's costs.",
      "Record and maintain information on clients, vendors, and travel packages.",
      "Book transportation and hotel reservations, using computer or telephone."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "agricultural_technicians",
    "onet_code": "19-4012.00",
    "title": "Agricultural Technicians",
    "category": "Science",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Science",
      "Critical Thinking",
      "Active Learning"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "science",
      "leadership"
    ],
    "salary": {
      "entry_min": 55965,
      "entry_max": 74620,
      "mid_min": 74620,
      "mid_max": 97006
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "17-2021.00",
      "19-4021.00",
      "11-9013.00"
    ],
    "training_paths": [],
    "description": "Work with agricultural scientists in plant, fiber, and animal research, or assist with animal breeding and nutrition. Set up or maintain laboratory equipment and collect samples from crops or animals. Prepare specimens or record data to assist scientists in biology or related life science experiments. Conduct tests and experiments to improve yield and quality of crops or to increase the resistance of plants and animals to disease or insects.",
    "dailyActivities": [
      "Prepare land for cultivated crops, orchards, or vineyards by plowing, discing, leveling, or contouring.",
      "Operate farm machinery, including tractors, plows, mowers, combines, balers, sprayers, earthmoving equipment, or trucks.",
      "Record data pertaining to experimentation, research, or animal care.",
      "Maintain or repair agricultural facilities, equipment, or tools to ensure operational readiness, safety, and cleanliness.",
      "Perform crop production duties, such as tilling, hoeing, pruning, weeding, or harvesting crops.",
      "Collect animal or crop samples."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "biological_scientists_all_other",
    "onet_code": "19-1029.00",
    "title": "Biological Scientists, All Other",
    "category": "Science",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "science"
    ],
    "salary": {
      "entry_min": 47570,
      "entry_max": 63427,
      "mid_min": 63427,
      "mid_max": 82455
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All biological scientists not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "chemical_technicians",
    "onet_code": "19-4031.00",
    "title": "Chemical Technicians",
    "category": "Science",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Science",
      "Critical Thinking",
      "Active Learning"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "science",
      "leadership"
    ],
    "salary": {
      "entry_min": 55965,
      "entry_max": 74620,
      "mid_min": 74620,
      "mid_max": 97006
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "19-2031.00",
      "17-3028.00",
      "17-2041.00"
    ],
    "training_paths": [],
    "description": "Conduct chemical and physical laboratory tests to assist scientists in making qualitative and quantitative analyses of solids, liquids, and gaseous materials for research and development of new products or processes, quality control, maintenance of environmental standards, and other work involving experimental, theoretical, or practical application of chemistry and related sciences.",
    "dailyActivities": [
      "Conduct chemical or physical laboratory tests to assist scientists in making qualitative or quantitative analyses of solids, liquids, or gaseous materials.",
      "Maintain, clean, or sterilize laboratory instruments or equipment.",
      "Monitor product quality to ensure compliance with standards and specifications.",
      "Set up and conduct chemical experiments, tests, and analyses, using techniques such as chromatography, spectroscopy, physical or chemical separation techniques, or microscopy.",
      "Prepare chemical solutions for products or processes, following standardized formulas, or create experimental formulas.",
      "Compile and interpret results of tests and analyses."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "food_science_technicians",
    "onet_code": "19-4013.00",
    "title": "Food Science Technicians",
    "category": "Science",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Science",
      "Critical Thinking",
      "Active Learning"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "science",
      "leadership"
    ],
    "salary": {
      "entry_min": 55965,
      "entry_max": 74620,
      "mid_min": 74620,
      "mid_max": 97006
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "19-1012.00",
      "19-4031.00",
      "19-4099.01"
    ],
    "training_paths": [],
    "description": "Work with food scientists or technologists to perform standardized qualitative and quantitative tests to determine physical or chemical properties of food or beverage products. Includes technicians who assist in research and development of production technology, quality control, packaging, processing, and use of foods.",
    "dailyActivities": [
      "Taste or smell foods or beverages to ensure that flavors meet specifications or to select samples with specific characteristics.",
      "Measure, test, or weigh bottles, cans, or other containers to ensure that hardness, strength, or dimensions meet specifications.",
      "Maintain records of testing results or other documents as required by state or other governing agencies.",
      "Monitor and control temperature of products.",
      "Analyze test results to classify products or compare results with standard tables.",
      "Record or compile test results or prepare graphs, charts, or reports."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "forensic_science_technicians",
    "onet_code": "19-4092.00",
    "title": "Forensic Science Technicians",
    "category": "Science",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Science",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "science",
      "leadership"
    ],
    "salary": {
      "entry_min": 55965,
      "entry_max": 74620,
      "mid_min": 74620,
      "mid_max": 97006
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "33-3021.02",
      "15-1299.06",
      "33-3021.00"
    ],
    "training_paths": [],
    "description": "Collect, identify, classify, and analyze physical evidence related to criminal investigations. Perform tests on weapons or substances, such as fiber, hair, and tissue to determine significance to investigation. May testify as expert witnesses on evidence or crime laboratory techniques. May serve as specialists in area of expertise, such as ballistics, fingerprinting, handwriting, or biochemistry.",
    "dailyActivities": [
      "Collect evidence from crime scenes, storing it in conditions that preserve its integrity.",
      "Keep records and prepare reports detailing findings, investigative methods, and laboratory techniques.",
      "Use photographic or video equipment to document evidence or crime scenes.",
      "Testify in court about investigative or analytical methods or findings.",
      "Use chemicals or other substances to examine latent fingerprint evidence and compare developed prints to those of known persons in databases.",
      "Measure and sketch crime scenes to document evidence."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "forest_and_conservation_technicians",
    "onet_code": "19-4071.00",
    "title": "Forest and Conservation Technicians",
    "category": "Science",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "science",
      "leadership"
    ],
    "salary": {
      "entry_min": 55965,
      "entry_max": 74620,
      "mid_min": 74620,
      "mid_max": 97006
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "19-1032.00",
      "19-1031.02",
      "45-4011.00"
    ],
    "training_paths": [],
    "description": "Provide technical assistance regarding the conservation of soil, water, forests, or related natural resources. May compile data pertaining to size, content, condition, and other characteristics of forest tracts under the direction of foresters, or train and lead forest workers in forest propagation and fire prevention and suppression. May assist conservation scientists in managing, improving, and protecting rangelands and wildlife habitats.",
    "dailyActivities": [
      "Thin and space trees and control weeds and undergrowth, using manual tools and chemicals, or supervise workers performing these tasks.",
      "Train and lead forest and conservation workers in seasonal activities, such as planting tree seedlings, putting out forest fires, and maintaining recreational facilities.",
      "Provide information about, and enforce, regulations, such as those concerning environmental protection, resource utilization, fire safety, and accident prevention.",
      "Patrol park or forest areas to protect resources and prevent damage.",
      "Map forest tract data using digital mapping systems.",
      "Keep records of the amount and condition of logs taken to mills."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "hydrologic_technicians",
    "onet_code": "19-4044.00",
    "title": "Hydrologic Technicians",
    "category": "Science",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "science"
    ],
    "salary": {
      "entry_min": 55965,
      "entry_max": 74620,
      "mid_min": 74620,
      "mid_max": 97006
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "19-2043.00",
      "17-2051.02",
      "19-4043.00"
    ],
    "training_paths": [],
    "description": "Collect and organize data concerning the distribution and circulation of ground and surface water, and data on its physical, chemical, and biological properties. Measure and report on flow rates and ground water levels, maintain field equipment, collect water samples, install and collect sampling equipment, and process samples for shipment to testing laboratories. May collect data on behalf of hydrologists, engineers, developers, government agencies, or agriculture.",
    "dailyActivities": [
      "Analyze ecological data about the impact of pollution, erosion, floods, and other environmental problems on bodies of water.",
      "Answer technical questions from hydrologists, policymakers, or other customers developing water conservation plans.",
      "Apply research findings to minimize the environmental impacts of pollution, waterborne diseases, erosion, or sedimentation.",
      "Assist in designing programs to ensure the proper sealing of abandoned wells.",
      "Collect water and soil samples to test for physical, chemical, or biological properties, such as pH, oxygen level, temperature, and pollution.",
      "Develop computer models for hydrologic predictions."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "life_scientists_all_other",
    "onet_code": "19-1099.00",
    "title": "Life Scientists, All Other",
    "category": "Science",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "science"
    ],
    "salary": {
      "entry_min": 47570,
      "entry_max": 63427,
      "mid_min": 63427,
      "mid_max": 82455
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All life scientists not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "life_physical_and_social_science_technicians_all_other",
    "onet_code": "19-4099.00",
    "title": "Life, Physical, and Social Science Technicians, All Other",
    "category": "Science",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "science"
    ],
    "salary": {
      "entry_min": 47570,
      "entry_max": 63427,
      "mid_min": 63427,
      "mid_max": 82455
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All life, physical, and social science technicians not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "nuclear_monitoring_technicians",
    "onet_code": "19-4051.02",
    "title": "Nuclear Monitoring Technicians",
    "category": "Science",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Science",
      "Critical Thinking",
      "Active Learning"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "science",
      "leadership"
    ],
    "salary": {
      "entry_min": 55965,
      "entry_max": 74620,
      "mid_min": 74620,
      "mid_max": 97006
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "19-4051.00",
      "17-2161.00",
      "19-4042.00"
    ],
    "training_paths": [],
    "description": "Collect and test samples to monitor results of nuclear experiments and contamination of humans, facilities, and environment.",
    "dailyActivities": [
      "Brief workers on radiation levels in work areas.",
      "Calculate safe radiation exposure times for personnel using plant contamination readings and prescribed safe levels of radiation.",
      "Monitor personnel to determine the amounts and intensities of radiation exposure.",
      "Inform supervisors when individual exposures or area radiation levels approach maximum permissible limits.",
      "Provide initial response to abnormal events or to alarms from radiation monitoring equipment.",
      "Determine intensities and types of radiation in work areas, equipment, or materials, using radiation detectors or other instruments."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "nuclear_technicians",
    "onet_code": "19-4051.00",
    "title": "Nuclear Technicians",
    "category": "Science",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "science",
      "leadership"
    ],
    "salary": {
      "entry_min": 55965,
      "entry_max": 74620,
      "mid_min": 74620,
      "mid_max": 97006
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-8011.00",
      "19-4051.02",
      "51-8013.00"
    ],
    "training_paths": [],
    "description": "Assist nuclear physicists, nuclear engineers, or other scientists in laboratory, power generation, or electricity production activities. May operate, maintain, or provide quality control for nuclear testing and research equipment. May monitor radiation.",
    "dailyActivities": [
      "Follow nuclear equipment operational policies and procedures that ensure environmental safety.",
      "Conduct surveillance testing to determine safety of nuclear equipment.",
      "Monitor nuclear reactor equipment performance to identify operational inefficiencies, hazards, or needs for maintenance or repair.",
      "Test plant equipment to ensure it is operating properly.",
      "Apply safety tags to equipment needing maintenance.",
      "Follow policies and procedures for radiation workers to ensure personnel safety."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "occupational_health_and_safety_technicians",
    "onet_code": "19-5012.00",
    "title": "Occupational Health and Safety Technicians",
    "category": "Science",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "science",
      "leadership"
    ],
    "salary": {
      "entry_min": 55965,
      "entry_max": 74620,
      "mid_min": 74620,
      "mid_max": 97006
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "17-2111.00",
      "19-5011.00",
      "13-1041.01"
    ],
    "training_paths": [],
    "description": "Collect data on work environments for analysis by occupational health and safety specialists. Implement and conduct evaluation of programs designed to limit chemical, physical, biological, and ergonomic risks to workers.",
    "dailyActivities": [
      "Evaluate situations or make determinations when a worker has refused to work on the grounds that danger or potential harm exists.",
      "Supply, operate, or maintain personal protective equipment.",
      "Train workers in safety procedures related to green jobs, such as the use of fall protection devices or maintenance of proper ventilation during wind turbine construction.",
      "Test workplaces for environmental hazards, such as exposure to radiation, chemical or biological hazards, or excessive noise.",
      "Maintain all required environmental records and documentation.",
      "Provide consultation to organizations or agencies on the workplace application of safety principles, practices, or techniques."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "physical_scientists_all_other",
    "onet_code": "19-2099.00",
    "title": "Physical Scientists, All Other",
    "category": "Science",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "science"
    ],
    "salary": {
      "entry_min": 47570,
      "entry_max": 63427,
      "mid_min": 63427,
      "mid_max": 82455
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All physical scientists not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "precision_agriculture_technicians",
    "onet_code": "19-4012.01",
    "title": "Precision Agriculture Technicians",
    "category": "Science",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "science",
      "leadership"
    ],
    "salary": {
      "entry_min": 55965,
      "entry_max": 74620,
      "mid_min": 74620,
      "mid_max": 97006
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "19-1013.00",
      "17-2021.00",
      "19-4012.00"
    ],
    "training_paths": [],
    "description": "Apply geospatial technologies, including geographic information systems (GIS) and Global Positioning System (GPS), to agricultural production or management activities, such as pest scouting, site-specific pesticide application, yield mapping, or variable-rate irrigation. May use computers to develop or analyze maps or remote sensing images to compare physical topography with data on soils, fertilizer, pests, or weather.",
    "dailyActivities": [
      "Document and maintain records of precision agriculture information.",
      "Collect information about soil or field attributes, yield data, or field boundaries, using field data recorders and basic geographic information systems (GIS).",
      "Use geospatial technology to develop soil sampling grids or identify sampling sites for testing characteristics such as nitrogen, phosphorus, or potassium content, pH, or micronutrients.",
      "Divide agricultural fields into georeferenced zones, based on soil characteristics and production potentials.",
      "Install, calibrate, or maintain sensors, mechanical controls, GPS-based vehicle guidance systems, or computer settings.",
      "Create, layer, and analyze maps showing precision agricultural data, such as crop yields, soil characteristics, input applications, terrain, drainage patterns, or field management history."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "psychologists_all_other",
    "onet_code": "19-3039.00",
    "title": "Psychologists, All Other",
    "category": "Science",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "science"
    ],
    "salary": {
      "entry_min": 47570,
      "entry_max": 63427,
      "mid_min": 63427,
      "mid_max": 82455
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All psychologists not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "quality_control_analysts",
    "onet_code": "19-4099.01",
    "title": "Quality Control Analysts",
    "category": "Science",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Originality"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "science",
      "leadership"
    ],
    "salary": {
      "entry_min": 55965,
      "entry_max": 74620,
      "mid_min": 74620,
      "mid_max": 97006
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "lifting"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "11-3051.01",
      "17-2112.02",
      "17-2112.00"
    ],
    "training_paths": [],
    "description": "Conduct tests to determine quality of raw materials, bulk intermediate and finished products. May conduct stability sample tests.",
    "dailyActivities": [
      "Conduct routine and non-routine analyses of in-process materials, raw materials, environmental samples, finished goods, or stability samples.",
      "Interpret test results, compare them to established specifications and control limits, and make recommendations on appropriateness of data for release.",
      "Calibrate, validate, or maintain laboratory equipment.",
      "Ensure that lab cleanliness and safety standards are maintained.",
      "Perform visual inspections of finished products.",
      "Complete documentation needed to support testing procedures, including data capture forms, equipment logbooks, or inventory forms."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "social_scientists_and_related_workers_all_other",
    "onet_code": "19-3099.00",
    "title": "Social Scientists and Related Workers, All Other",
    "category": "Science",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "science"
    ],
    "salary": {
      "entry_min": 47570,
      "entry_max": 63427,
      "mid_min": 63427,
      "mid_max": 82455
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All social scientists and related workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "community_and_social_service_specialists_all_other",
    "onet_code": "21-1099.00",
    "title": "Community and Social Service Specialists, All Other",
    "category": "Social Services",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "social_services"
    ],
    "salary": {
      "entry_min": 32123,
      "entry_max": 42831,
      "mid_min": 42831,
      "mid_max": 55680
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All community and social service specialists not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "counselors_all_other",
    "onet_code": "21-1019.00",
    "title": "Counselors, All Other",
    "category": "Social Services",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "social_services"
    ],
    "salary": {
      "entry_min": 32123,
      "entry_max": 42831,
      "mid_min": 42831,
      "mid_max": 55680
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All counselors not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "religious_workers_all_other",
    "onet_code": "21-2099.00",
    "title": "Religious Workers, All Other",
    "category": "Social Services",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "social_services"
    ],
    "salary": {
      "entry_min": 32123,
      "entry_max": 42831,
      "mid_min": 42831,
      "mid_max": 55680
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All religious workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "social_workers_all_other",
    "onet_code": "21-1029.00",
    "title": "Social Workers, All Other",
    "category": "Social Services",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "social_services"
    ],
    "salary": {
      "entry_min": 32123,
      "entry_max": 42831,
      "mid_min": 42831,
      "mid_max": 55680
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All social workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "air_traffic_controllers",
    "onet_code": "53-2021.00",
    "title": "Air Traffic Controllers",
    "category": "Transportation",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "problem_solving",
      "technical",
      "communication",
      "transportation",
      "leadership"
    ],
    "salary": {
      "entry_min": 30307,
      "entry_max": 40410,
      "mid_min": 40410,
      "mid_max": 52533
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-2022.00",
      "53-2012.00",
      "53-2011.00"
    ],
    "training_paths": [],
    "description": "Control air traffic on and within vicinity of airport, and movement of air traffic between altitude sectors and control centers, according to established procedures and policies. Authorize, regulate, and control commercial airline flights according to government or company regulations to expedite and ensure flight safety.",
    "dailyActivities": [
      "Inform pilots about nearby planes or potentially hazardous conditions, such as weather, speed and direction of wind, or visibility problems.",
      "Issue landing and take-off authorizations or instructions.",
      "Transfer control of departing flights to traffic control centers and accept control of arriving flights.",
      "Provide flight path changes or directions to emergency landing fields for pilots traveling in bad weather or in emergency situations.",
      "Alert airport emergency services in cases of emergency or when aircraft are experiencing difficulties.",
      "Monitor or direct the movement of aircraft within an assigned air space or on the ground at airports to minimize delays and maximize safety."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "aircraft_cargo_handling_supervisors",
    "onet_code": "53-1041.00",
    "title": "Aircraft Cargo Handling Supervisors",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Learning Strategies",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Fluency of Ideas",
      "Originality"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "transportation",
      "leadership"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-1043.00",
      "53-2022.00",
      "53-6051.00"
    ],
    "training_paths": [],
    "description": "Supervise and coordinate the activities of ground crew in the loading, unloading, securing, and staging of aircraft cargo or baggage. May determine the quantity and orientation of cargo and compute aircraft center of gravity. May accompany aircraft as member of flight crew and monitor and handle cargo in flight, and assist and brief passengers on safety and emergency procedures. Includes loadmasters.",
    "dailyActivities": [
      "Determine the quantity and orientation of cargo, and compute an aircraft's center of gravity.",
      "Direct ground crews in the loading, unloading, securing, or staging of aircraft cargo or baggage.",
      "Train new employees in areas such as safety procedures or equipment operation.",
      "Distribute cargo to maximize use of space.",
      "Calculate load weights for different aircraft compartments, using charts and computers.",
      "Accompany aircraft as a member of the flight crew to monitor and handle cargo in flight."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "aircraft_service_attendants",
    "onet_code": "53-6032.00",
    "title": "Aircraft Service Attendants",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "transportation"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-3011.00",
      "49-2091.00",
      "51-2011.00"
    ],
    "training_paths": [],
    "description": "Service aircraft with fuel. May de-ice aircraft, refill water and cooling agents, empty sewage tanks, service air and oxygen systems, or clean and polish exterior.",
    "dailyActivities": [
      "Apply de-icing fluid to aircraft from baskets lifted by truck-mounted cranes.",
      "Change aircraft oil, coolant, or other fluids.",
      "Clean aircraft interiors by picking up waste, wiping down windows, or vacuuming.",
      "Climb ladders to reach aircraft surfaces to be cleaned.",
      "Complete forms describing tasks completed.",
      "De-grease aircraft exteriors."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "airfield_operations_specialists",
    "onet_code": "53-2022.00",
    "title": "Airfield Operations Specialists",
    "category": "Transportation",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "transportation",
      "leadership"
    ],
    "salary": {
      "entry_min": 30307,
      "entry_max": 40410,
      "mid_min": 40410,
      "mid_max": 52533
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-2021.00",
      "53-1041.00",
      "53-1044.00"
    ],
    "training_paths": [],
    "description": "Ensure the safe takeoff and landing of commercial and military aircraft. Duties include coordination between air-traffic control and maintenance personnel, dispatching, using airfield landing and navigational aids, implementing airfield safety procedures, monitoring and maintaining flight records, and applying knowledge of weather information.",
    "dailyActivities": [
      "Inspect airfield conditions to ensure compliance with federal regulatory requirements.",
      "Implement airfield safety procedures to ensure a safe operating environment for personnel and aircraft operation.",
      "Conduct inspections of the airport property and perimeter to maintain controlled access to airfields.",
      "Assist in responding to aircraft and medical emergencies.",
      "Initiate or conduct airport-wide coordination of snow removal on runways and taxiways.",
      "Manage wildlife on and around airport grounds."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "ambulance_drivers_and_attendants_except_emergency_medical_technicians",
    "onet_code": "53-3011.00",
    "title": "Ambulance Drivers and Attendants, Except Emergency Medical Technicians",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Social Perceptiveness",
      "Coordination",
      "Instructing"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "communication",
      "transportation",
      "leadership"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "29-2042.00",
      "29-2043.00",
      "31-1132.00"
    ],
    "training_paths": [],
    "description": "Drive ambulance or assist ambulance driver in transporting sick, injured, or convalescent persons. Assist in lifting patients.",
    "dailyActivities": [
      "Remove and replace soiled linens or equipment to maintain sanitary conditions.",
      "Drive ambulances or assist ambulance drivers in transporting sick, injured, or convalescent persons.",
      "Report facts concerning accidents or emergencies to hospital personnel or law enforcement officials.",
      "Place patients on stretchers, and load stretchers into ambulances, usually with assistance from other attendants.",
      "Accompany and assist emergency medical technicians on calls.",
      "Replace supplies and disposable items on ambulances."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "automotive_and_watercraft_service_attendants",
    "onet_code": "53-6031.00",
    "title": "Automotive and Watercraft Service Attendants",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Visualization",
      "Arm-Hand Steadiness",
      "Manual Dexterity"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "analytical",
      "physical",
      "technical",
      "transportation",
      "communication"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-3023.00",
      "53-7072.00",
      "49-9043.00"
    ],
    "training_paths": [],
    "description": "Service automobiles, buses, trucks, boats, and other automotive or marine vehicles with fuel, lubricants, and accessories. Collect payment for services and supplies. May lubricate vehicle, change motor oil, refill antifreeze, or replace lights or other accessories, such as windshield wiper blades or fan belts. May repair or replace tires.",
    "dailyActivities": [
      "Collect cash payments from customers, and make change or charge purchases to customers' credit cards, providing customers with receipts.",
      "Check tire pressure and levels of fuel, motor oil, transmission, radiator, battery, or other fluids, adding air or fluids as required.",
      "Perform minor repairs, such as adjusting brakes, replacing spark plugs, or changing engine oil or filters.",
      "Clean parking areas, offices, restrooms, or equipment, and remove trash.",
      "Order stock, and price and shelve incoming goods.",
      "Sell and install accessories, such as batteries, windshield wiper blades, fan belts, bulbs, or headlamps."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "aviation_inspectors",
    "onet_code": "53-6051.01",
    "title": "Aviation Inspectors",
    "category": "Transportation",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Science",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "transportation",
      "leadership"
    ],
    "salary": {
      "entry_min": 30307,
      "entry_max": 40410,
      "mid_min": 40410,
      "mid_max": 52533
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-6051.07",
      "53-6051.00",
      "47-4011.00"
    ],
    "training_paths": [],
    "description": "Inspect aircraft, maintenance procedures, air navigational aids, air traffic controls, and communications equipment to ensure conformance with Federal safety regulations.",
    "dailyActivities": [
      "Inspect work of aircraft mechanics performing maintenance, modification, or repair and overhaul of aircraft and aircraft mechanical systems to ensure adherence to standards and procedures.",
      "Examine maintenance records and flight logs to determine if service and maintenance checks and overhauls were performed at prescribed intervals.",
      "Inspect new, repaired, or modified aircraft to identify damage or defects and to assess airworthiness and conformance to standards, using checklists, hand tools, and test instruments.",
      "Approve or deny issuance of certificates of airworthiness.",
      "Prepare and maintain detailed repair, inspection, investigation, and certification records and reports.",
      "Examine landing gear, tires, and exteriors of fuselage, wings, and engines for evidence of damage or corrosion and the need for repairs."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "bridge_and_lock_tenders",
    "onet_code": "53-6011.00",
    "title": "Bridge and Lock Tenders",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Critical Thinking",
      "Monitoring",
      "Coordination",
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Information Ordering",
      "Selective Attention",
      "Control Precision"
    ],
    "keywords": [
      "hands_on",
      "problem_solving",
      "communication",
      "transportation",
      "leadership"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-4022.00",
      "53-5022.00",
      "53-7041.00"
    ],
    "training_paths": [],
    "description": "Operate and tend bridges, canal locks, and lighthouses to permit marine passage on inland waterways, near shores, and at danger points in waterway passages. May supervise such operations. Includes drawbridge operators, lock operators, and slip bridge operators.",
    "dailyActivities": [
      "Control machinery to open and close canal locks and dams, railroad or highway drawbridges, or horizontally or vertically adjustable bridges.",
      "Direct movements of vessels in locks or bridge areas, using signals, telecommunication equipment, or loudspeakers.",
      "Observe position and progress of vessels to ensure best use of lock spaces or bridge opening spaces.",
      "Record names, types, and destinations of vessels passing through bridge openings or locks, and numbers of trains or vehicles crossing bridges.",
      "Observe approaching vessels to determine size and speed, and listen for whistle signals indicating desire to pass.",
      "Move levers to activate traffic signals, navigation lights, and alarms."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "bus_drivers_school",
    "onet_code": "53-3051.00",
    "title": "Bus Drivers, School",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Information Ordering"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "communication",
      "transportation",
      "leadership"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "33-9094.00",
      "53-3052.00",
      "53-3054.00"
    ],
    "training_paths": [],
    "description": "Drive a school bus to transport students. Ensure adherence to safety rules. May assist students in boarding or exiting.",
    "dailyActivities": [
      "Comply with traffic regulations to operate vehicles in a safe and courteous manner.",
      "Follow safety rules as students board and exit buses or cross streets near bus stops.",
      "Check the condition of a vehicle's tires, brakes, windshield wipers, lights, oil, fuel, water, and safety equipment to ensure that everything is in working order.",
      "Report any bus malfunctions or needed repairs.",
      "Pick up and drop off students at regularly scheduled neighborhood locations, following strict time schedules.",
      "Drive gasoline, diesel, or electrically powered multi-passenger vehicles to transport students between neighborhoods, schools, and school activities."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "bus_drivers_transit_and_intercity",
    "onet_code": "53-3052.00",
    "title": "Bus Drivers, Transit and Intercity",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Expression",
      "Problem Sensitivity",
      "Selective Attention",
      "Time Sharing",
      "Control Precision"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "physical",
      "communication",
      "transportation"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-3054.00",
      "53-3053.00",
      "53-4041.00"
    ],
    "training_paths": [],
    "description": "Drive bus or motor coach, including regular route operations, charters, and private carriage. May assist passengers with baggage. May collect fares or tickets.",
    "dailyActivities": [
      "Drive vehicles over specified routes or to specified destinations according to time schedules, complying with traffic regulations to ensure that passengers have a smooth and safe ride.",
      "Park vehicles at loading areas so that passengers can board.",
      "Inspect vehicles and check gas, oil, and water levels prior to departure.",
      "Announce stops to passengers.",
      "Assist passengers, such as elderly or individuals with disabilities, on and off bus, ensure they are seated properly, help carry baggage, and answer questions about bus schedules or routes.",
      "Collect tickets or cash fares from passengers."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "captains_mates_and_pilots_of_water_vessels",
    "onet_code": "53-5021.00",
    "title": "Captains, Mates, and Pilots of Water Vessels",
    "category": "Transportation",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "transportation",
      "leadership"
    ],
    "salary": {
      "entry_min": 30307,
      "entry_max": 40410,
      "mid_min": 40410,
      "mid_max": 52533
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-5011.00",
      "53-5022.00",
      "53-5031.00"
    ],
    "training_paths": [],
    "description": "Command or supervise operations of ships and water vessels, such as tugboats and ferryboats. Required to hold license issued by U.S. Coast Guard.",
    "dailyActivities": [
      "Direct courses and speeds of ships, based on specialized knowledge of local winds, weather, water depths, tides, currents, and hazards.",
      "Prevent ships under navigational control from engaging in unsafe operations.",
      "Serve as a vessel's docking master upon arrival at a port or at a berth.",
      "Consult maps, charts, weather reports, or navigation equipment to determine and direct ship movements.",
      "Steer and operate vessels, using radios, depth finders, radars, lights, buoys, or lighthouses.",
      "Operate ship-to-shore radios to exchange information needed for ship operations."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "cleaners_of_vehicles_and_equipment",
    "onet_code": "53-7061.00",
    "title": "Cleaners of Vehicles and Equipment",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Operations Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Manual Dexterity",
      "Control Precision",
      "Multilimb Coordination",
      "Trunk Strength"
    ],
    "keywords": [
      "communication",
      "hands_on",
      "physical",
      "transportation"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-6011.00",
      "51-9192.00",
      "37-2011.00"
    ],
    "training_paths": [],
    "description": "Wash or otherwise clean vehicles, machinery, and other equipment. Use such materials as water, cleaning agents, brushes, cloths, and hoses.",
    "dailyActivities": [
      "Rinse objects and place them on drying racks or use cloth, squeegees, or air compressors to dry surfaces.",
      "Apply paints, dyes, polishes, reconditioners, waxes, or masking materials to vehicles to preserve, protect, or restore color or condition.",
      "Clean and polish vehicle windows.",
      "Drive vehicles to or from workshops or customers' workplaces or homes.",
      "Scrub, scrape, or spray machine parts, equipment, or vehicles, using scrapers, brushes, clothes, cleaners, disinfectants, insecticides, acid, abrasives, vacuums, or hoses.",
      "Inspect parts, equipment, or vehicles for cleanliness, damage, and compliance with standards or regulations."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "commercial_pilots",
    "onet_code": "53-2012.00",
    "title": "Commercial Pilots",
    "category": "Transportation",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "technical",
      "problem_solving",
      "communication",
      "transportation",
      "leadership"
    ],
    "salary": {
      "entry_min": 30307,
      "entry_max": 40410,
      "mid_min": 40410,
      "mid_max": 52533
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-2011.00",
      "53-2021.00",
      "53-2022.00"
    ],
    "training_paths": [],
    "description": "Pilot and navigate the flight of fixed-wing aircraft on nonscheduled air carrier routes, or helicopters. Requires Commercial Pilot certificate. Includes charter pilots with similar certification, and air ambulance and air tour pilots. Excludes regional, national, and international airline pilots.",
    "dailyActivities": [
      "Check aircraft prior to flights to ensure that the engines, controls, instruments, and other systems are functioning properly.",
      "Co-pilot aircraft or perform captain's duties, as required.",
      "Consider airport altitudes, outside temperatures, plane weights, and wind speeds and directions to calculate the speed needed to become airborne.",
      "Use instrumentation to pilot aircraft when visibility is poor.",
      "Monitor engine operation, fuel consumption, and functioning of aircraft systems during flights.",
      "Order changes in fuel supplies, loads, routes, or schedules to ensure safety of flights."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "conveyor_operators_and_tenders",
    "onet_code": "53-7011.00",
    "title": "Conveyor Operators and Tenders",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "none"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 0,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Inductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "communication",
      "transportation"
    ],
    "salary": {
      "entry_min": 21215,
      "entry_max": 28287,
      "mid_min": 28287,
      "mid_max": 36773
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-7063.00",
      "53-7121.00",
      "53-7051.00"
    ],
    "training_paths": [],
    "description": "Control or tend conveyors or conveyor systems that move materials or products to and from stockpiles, processing stations, departments, or vehicles. May control speed and routing of materials or products.",
    "dailyActivities": [
      "Inform supervisors of equipment malfunctions that need to be addressed.",
      "Observe conveyor operations and monitor lights, dials, and gauges to maintain specified operating levels and to detect equipment malfunctions.",
      "Record production data such as weights, types, quantities, and storage locations of materials, as well as equipment performance problems and downtime.",
      "Load, unload, or adjust materials or products on conveyors by hand, by using lifts, hoists, and scoops, or by opening gates, chutes, or hoppers.",
      "Stop equipment or machinery and clear jams, using poles, bars, and hand tools, or remove damaged materials from conveyors.",
      "Distribute materials, supplies, and equipment to work stations, using lifts and trucks."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "crane_and_tower_operators",
    "onet_code": "53-7021.00",
    "title": "Crane and Tower Operators",
    "category": "Transportation",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Critical Thinking",
      "Monitoring",
      "Coordination",
      "Operations Monitoring",
      "Operation and Control",
      "Troubleshooting"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Deductive Reasoning",
      "Perceptual Speed",
      "Visualization"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "technical",
      "problem_solving",
      "communication",
      "transportation",
      "leadership"
    ],
    "salary": {
      "entry_min": 30307,
      "entry_max": 40410,
      "mid_min": 40410,
      "mid_max": 52533
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-7041.00",
      "53-7051.00",
      "49-3042.00"
    ],
    "training_paths": [],
    "description": "Operate mechanical boom and cable or tower and cable equipment to lift and move materials, machines, or products in many directions.",
    "dailyActivities": [
      "Determine load weights and check them against lifting capacities to prevent overload.",
      "Move levers, depress foot pedals, or turn dials to operate cranes, cherry pickers, electromagnets, or other moving equipment for lifting, moving, or placing loads.",
      "Inspect and adjust crane mechanisms or lifting accessories to prevent malfunctions or damage.",
      "Inspect cables or grappling devices for wear and install or replace cables, as needed.",
      "Direct helpers engaged in placing blocking or outrigging under cranes.",
      "Clean, lubricate, and maintain mechanisms such as cables, pulleys, or grappling devices, making repairs, as necessary."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "dredge_operators",
    "onet_code": "53-7031.00",
    "title": "Dredge Operators",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Coordination",
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Flexibility of Closure",
      "Perceptual Speed",
      "Selective Attention",
      "Arm-Hand Steadiness"
    ],
    "keywords": [
      "hands_on",
      "physical",
      "communication",
      "transportation",
      "leadership"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-7041.00",
      "47-2073.00",
      "47-5022.00"
    ],
    "training_paths": [],
    "description": "Operate dredge to remove sand, gravel, or other materials in order to excavate and maintain navigable channels in waterways.",
    "dailyActivities": [
      "Move levers to position dredges for excavation, to engage hydraulic pumps, to raise and lower suction booms, and to control rotation of cutterheads.",
      "Start and stop engines to operate equipment.",
      "Start power winches that draw in or let out cables to change positions of dredges, or pull in and let out cables manually.",
      "Pump water to clear machinery pipelines.",
      "Lower anchor poles to verify depths of excavations, using winches, or scan depth gauges to determine depths of excavations.",
      "Direct or assist workers placing shore anchors and cables, laying additional pipes from dredges to shore, and pumping water from pontoons."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "driver_sales_workers",
    "onet_code": "53-3031.00",
    "title": "Driver/Sales Workers",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Critical Thinking",
      "Persuasion",
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "communication",
      "transportation"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-3033.00",
      "43-5071.00",
      "41-9091.00"
    ],
    "training_paths": [],
    "description": "Drive truck or other vehicle over established routes or within an established territory and sell or deliver goods, such as food products, including restaurant take-out items, or pick up or deliver items such as commercial laundry. May also take orders, collect payment, or stock merchandise at point of delivery.",
    "dailyActivities": [
      "Drive trucks to deliver such items as food, medical supplies, or newspapers.",
      "Inform regular customers of new products or services and price changes.",
      "Record sales or delivery information on daily sales or delivery record.",
      "Listen to and resolve customers' complaints regarding products or services.",
      "Collect money from customers, make change, and record transactions on customer receipts.",
      "Maintain trucks and food-dispensing equipment and clean inside of machines that dispense food or beverages."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "first_line_supervisors_of_helpers_laborers_and_material_movers_hand",
    "onet_code": "53-1042.00",
    "title": "First-Line Supervisors of Helpers, Laborers, and Material Movers, Hand",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "transportation",
      "leadership"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-1011.00",
      "51-1011.00",
      "53-1043.00"
    ],
    "training_paths": [],
    "description": "Directly supervise and coordinate the activities of helpers, laborers, or material movers, hand.",
    "dailyActivities": [
      "Maintain a safe working environment by monitoring safety procedures and equipment.",
      "Collaborate with workers and managers to solve work-related problems.",
      "Review work throughout the work process and at completion to ensure that it has been performed properly.",
      "Inform designated employees or departments of items loaded or problems encountered.",
      "Inspect equipment for wear and for conformance to specifications.",
      "Prepare and maintain work records and reports of information such as employee time and wages, daily receipts, or inspection results."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "first_line_supervisors_of_material_moving_machine_and_vehicle_operators",
    "onet_code": "53-1043.00",
    "title": "First-Line Supervisors of Material-Moving Machine and Vehicle Operators",
    "category": "Transportation",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "transportation",
      "leadership"
    ],
    "salary": {
      "entry_min": 30307,
      "entry_max": 40410,
      "mid_min": 40410,
      "mid_max": 52533
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-1042.00",
      "49-1011.00",
      "51-1011.00"
    ],
    "training_paths": [],
    "description": "Directly supervise and coordinate activities of material-moving machine and vehicle operators and helpers.",
    "dailyActivities": [
      "Enforce safety rules and regulations.",
      "Interpret transportation or tariff regulations, shipping orders, safety regulations, or company policies and procedures for workers.",
      "Resolve worker problems or collaborate with employees to assist in problem resolution.",
      "Confer with customers, supervisors, contractors, or other personnel to exchange information or to resolve problems.",
      "Plan work assignments and equipment allocations to meet transportation, operations or production goals.",
      "Examine, measure, or weigh cargo or materials to determine specific handling requirements."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "first_line_supervisors_of_passenger_attendants",
    "onet_code": "53-1044.00",
    "title": "First-Line Supervisors of Passenger Attendants",
    "category": "Transportation",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "transportation"
    ],
    "salary": {
      "entry_min": 30307,
      "entry_max": 40410,
      "mid_min": 40410,
      "mid_max": 52533
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-1011.00",
      "43-1011.00",
      "53-1043.00"
    ],
    "training_paths": [],
    "description": "Supervise and coordinate activities of passenger attendants.",
    "dailyActivities": [
      "Analyze and record personnel or operational data and write related activity reports.",
      "Apply customer feedback to service improvement efforts.",
      "Compute or estimate cash, payroll, transportation, or personnel requirements.",
      "Confer with customers, supervisors, contractors, or other personnel to exchange information or to resolve problems.",
      "Direct or coordinate the activities of workers, such as flight or car attendants.",
      "Enforce safety rules and regulations."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "first_line_supervisors_of_transportation_workers_all_other",
    "onet_code": "53-1049.00",
    "title": "First-Line Supervisors of Transportation Workers, All Other",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "transportation"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All first-line supervisors of transportation workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "flight_attendants",
    "onet_code": "53-2031.00",
    "title": "Flight Attendants",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "transportation",
      "leadership"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-6061.00",
      "43-4181.00",
      "53-1044.00"
    ],
    "training_paths": [],
    "description": "Monitor safety of the aircraft cabin. Provide services to airline passengers, explain safety information, serve food and beverages, and respond to emergency incidents.",
    "dailyActivities": [
      "Verify that first aid kits and other emergency equipment, including fire extinguishers and oxygen bottles, are in working order.",
      "Announce and demonstrate safety and emergency procedures, such as the use of oxygen masks, seat belts, and life jackets.",
      "Monitor passenger behavior to identify threats to the safety of the crew and other passengers.",
      "Walk aisles of planes to verify that passengers have complied with federal regulations prior to takeoffs and landings.",
      "Direct and assist passengers in emergency procedures, such as evacuating a plane following an emergency landing.",
      "Prepare passengers and aircraft for landing, following procedures."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "gas_compressor_and_gas_pumping_station_operators",
    "onet_code": "53-7071.00",
    "title": "Gas Compressor and Gas Pumping Station Operators",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Complex Problem Solving",
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Inductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "physical",
      "technical",
      "problem_solving",
      "communication",
      "transportation"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-8092.00",
      "51-8093.00",
      "51-8021.00"
    ],
    "training_paths": [],
    "description": "Operate steam-, gas-, electric motor-, or internal combustion-engine driven compressors. Transmit, compress, or recover gases, such as butane, nitrogen, hydrogen, and natural gas.",
    "dailyActivities": [
      "Monitor meters and pressure gauges to determine consumption rate variations, temperatures, and pressures.",
      "Respond to problems by adjusting control room equipment or instructing other personnel to adjust equipment at problem locations or in other control areas.",
      "Record instrument readings and operational changes in operating logs.",
      "Adjust valves and equipment to obtain specified performance.",
      "Move controls and turn valves to start compressor engines, pumps, and auxiliary equipment.",
      "Operate power-driven pumps that transfer liquids, semi-liquids, gases, or powdered materials."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "heavy_and_tractor_trailer_truck_drivers",
    "onet_code": "53-3032.00",
    "title": "Heavy and Tractor-Trailer Truck Drivers",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control",
      "Time Management"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "communication",
      "transportation"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-7051.00",
      "53-3033.00",
      "53-7121.00"
    ],
    "training_paths": [],
    "description": "Drive a tractor-trailer combination or a truck with a capacity of at least 26,001 pounds Gross Vehicle Weight (GVW). May be required to unload truck. Requires commercial drivers' license. Includes tow truck drivers.",
    "dailyActivities": [
      "Check all load-related documentation for completeness and accuracy.",
      "Inspect loads to ensure that cargo is secure.",
      "Check vehicles to ensure that mechanical, safety, and emergency equipment is in good working order.",
      "Crank trailer landing gear up or down to safely secure vehicles.",
      "Obtain receipts or signatures for delivered goods and collect payment for services when required.",
      "Maintain logs of working hours or of vehicle service or repair status, following applicable state and federal regulations."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "military_mos_relevant": [
      "88M"
    ],
    "last_updated": new Date()
  },
  {
    "id": "hoist_and_winch_operators",
    "onet_code": "53-7041.00",
    "title": "Hoist and Winch Operators",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Coordination",
      "Operations Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Perceptual Speed",
      "Control Precision",
      "Multilimb Coordination",
      "Response Orientation"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "physical",
      "transportation",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "49-9096.00",
      "53-7051.00",
      "53-7021.00"
    ],
    "training_paths": [],
    "description": "Operate or tend hoists or winches to lift and pull loads using power-operated cable equipment.",
    "dailyActivities": [
      "Move levers, pedals, and throttles to stop, start, and regulate speeds of hoist or winch drums in response to hand, bell, buzzer, telephone, loud-speaker, or whistle signals, or by observing dial indicators or cable marks.",
      "Start engines of hoists or winches and use levers and pedals to wind or unwind cable on drums.",
      "Observe equipment gauges and indicators and hand signals of other workers to verify load positions or depths.",
      "Operate compressed air, diesel, electric, gasoline, or steam-driven hoists or winches to control movement of cableways, cages, derricks, draglines, loaders, railcars, or skips.",
      "Move or reposition hoists, winches, loads and materials, manually or using equipment and machines such as trucks, cars, and hand trucks.",
      "Select loads or materials according to weight and size specifications."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "industrial_truck_and_tractor_operators",
    "onet_code": "53-7051.00",
    "title": "Industrial Truck and Tractor Operators",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Coordination",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Perceptual Speed",
      "Spatial Orientation"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "technical",
      "transportation",
      "communication",
      "leadership"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-7041.00",
      "53-7021.00",
      "53-7121.00"
    ],
    "training_paths": [],
    "description": "Operate industrial trucks or tractors equipped to move materials around a warehouse, storage yard, factory, construction site, or similar location.",
    "dailyActivities": [
      "Move levers or controls that operate lifting devices, such as forklifts, lift beams with swivel-hooks, hoists, or elevating platforms, to load, unload, transport, or stack material.",
      "Move controls to drive gasoline- or electric-powered trucks, cars, or tractors and transport materials between loading, processing, and storage areas.",
      "Manually or mechanically load or unload materials from pallets, skids, platforms, cars, lifting devices, or other transport vehicles.",
      "Position lifting devices under, over, or around loaded pallets, skids, or boxes and secure material or products for transport to designated areas.",
      "Inspect product load for accuracy and safely move it around the warehouse or facility to ensure timely and complete delivery.",
      "Weigh materials or products and record weight or other production data on tags or labels."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "laborers_and_freight_stock_and_material_movers_hand",
    "onet_code": "53-7062.00",
    "title": "Laborers and Freight, Stock, and Material Movers, Hand",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Oral Comprehension",
      "Arm-Hand Steadiness",
      "Manual Dexterity",
      "Control Precision",
      "Multilimb Coordination"
    ],
    "keywords": [
      "communication",
      "physical",
      "transportation"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-7063.00",
      "53-7051.00",
      "53-7064.00"
    ],
    "training_paths": [],
    "description": "Manually move freight, stock, luggage, or other materials, or perform other general labor. Includes all manual laborers not elsewhere classified.",
    "dailyActivities": [
      "Maintain equipment storage areas to ensure that inventory is protected.",
      "Read work orders or receive oral instructions to determine work assignments or material or equipment needs.",
      "Move freight, stock, or other materials to and from storage or production areas, loading docks, delivery vehicles, ships, or containers, by hand or using trucks, tractors, or other equipment.",
      "Install protective devices, such as bracing, padding, or strapping, to prevent shifting or damage to items being transported.",
      "Sort cargo before loading and unloading.",
      "Attach identifying tags to containers or mark them with identifying information."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "light_truck_drivers",
    "onet_code": "53-3033.00",
    "title": "Light Truck Drivers",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Spatial Orientation",
      "Control Precision"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "communication",
      "transportation"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-3032.00",
      "53-3031.00",
      "43-5021.00"
    ],
    "training_paths": [],
    "description": "Drive a light vehicle, such as a truck or van, with a capacity of less than 26,001 pounds Gross Vehicle Weight (GVW), primarily to pick up merchandise or packages from a distribution center and deliver. May load and unload vehicle.",
    "dailyActivities": [
      "Obey traffic laws and follow established traffic and transportation procedures.",
      "Report any mechanical problems encountered with vehicles.",
      "Verify the contents of inventory loads against shipping papers.",
      "Inspect and maintain vehicle supplies and equipment, such as gas, oil, water, tires, lights, or brakes, to ensure that vehicles are in proper working condition.",
      "Read maps and follow written or verbal geographic directions.",
      "Load and unload trucks, vans, or automobiles."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "military_mos_relevant": [
      "88M"
    ],
    "last_updated": new Date()
  },
  {
    "id": "locomotive_engineers",
    "onet_code": "53-4011.00",
    "title": "Locomotive Engineers",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "communication",
      "transportation",
      "leadership"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-4022.00",
      "53-4031.00",
      "53-4013.00"
    ],
    "training_paths": [],
    "description": "Drive electric, diesel-electric, steam, or gas-turbine-electric locomotives to transport passengers or freight. Interpret train orders, electronic or manual signals, and railroad rules and regulations.",
    "dailyActivities": [
      "Interpret train orders, signals, or railroad rules and regulations that govern the operation of locomotives.",
      "Confer with conductors or traffic control center personnel via radiophones to issue or receive information concerning stops, delays, or oncoming trains.",
      "Receive starting signals from conductors and use controls such as throttles or air brakes to drive electric, diesel-electric, steam, or gas turbine-electric locomotives.",
      "Monitor gauges or meters that measure speed, amperage, battery charge, or air pressure in brake lines or in main reservoirs.",
      "Observe tracks to detect obstructions.",
      "Call out train signals to assistants to verify meanings."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "machine_feeders_and_offbearers",
    "onet_code": "53-7063.00",
    "title": "Machine Feeders and Offbearers",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Operations Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Perceptual Speed",
      "Arm-Hand Steadiness"
    ],
    "keywords": [
      "hands_on",
      "physical",
      "transportation"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9032.00",
      "51-9191.00",
      "51-9041.00"
    ],
    "training_paths": [],
    "description": "Feed materials into or remove materials from machines or equipment that is automatic or tended by other workers.",
    "dailyActivities": [
      "Inspect materials and products for defects, and to ensure conformance to specifications.",
      "Record production and operational data, such as amount of materials processed.",
      "Push dual control buttons and move controls to start, stop, or adjust machinery and equipment.",
      "Weigh or measure materials or products to ensure conformance to specifications.",
      "Identify and mark materials, products, and samples, following instructions.",
      "Clean and maintain machinery, equipment, and work areas to ensure proper functioning and safe working conditions."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "material_moving_workers_all_other",
    "onet_code": "53-7199.00",
    "title": "Material Moving Workers, All Other",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "transportation"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All material moving workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "motor_vehicle_operators_all_other",
    "onet_code": "53-3099.00",
    "title": "Motor Vehicle Operators, All Other",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "transportation"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All motor vehicle operators not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "motorboat_operators",
    "onet_code": "53-5022.00",
    "title": "Motorboat Operators",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Critical Thinking",
      "Monitoring",
      "Social Perceptiveness",
      "Coordination",
      "Service Orientation",
      "Complex Problem Solving",
      "Operations Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Inductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "communication",
      "transportation",
      "leadership"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-5021.00",
      "53-5011.00",
      "53-5031.00"
    ],
    "training_paths": [],
    "description": "Operate small motor-driven boats. May assist in navigational activities.",
    "dailyActivities": [
      "Operate engine throttles and steering mechanisms to guide boats on desired courses.",
      "Direct safety operations in emergency situations.",
      "Secure boats to docks with mooring lines, and cast off lines to enable departure.",
      "Maintain desired courses, using compasses or electronic navigational aids.",
      "Organize and direct the activities of crew members.",
      "Follow safety procedures to ensure the protection of passengers, cargo, and vessels."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "packers_and_packagers_hand",
    "onet_code": "53-7064.00",
    "title": "Packers and Packagers, Hand",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Oral Comprehension",
      "Manual Dexterity",
      "Static Strength",
      "Trunk Strength",
      "Near Vision"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "analytical",
      "physical",
      "transportation",
      "communication"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-9111.00",
      "53-7063.00",
      "45-2041.00"
    ],
    "training_paths": [],
    "description": "Pack or package by hand a wide variety of products and materials.",
    "dailyActivities": [
      "Examine and inspect containers, materials, or products to ensure that product quality and packing specifications are met.",
      "Measure, weigh, and count products and materials.",
      "Record product, packaging, and order information on specified forms and records.",
      "Seal containers or materials, using glues, fasteners, nails, and hand tools.",
      "Assemble, line, and pad cartons, crates, and containers, using hand tools.",
      "Obtain, move, and sort products, materials, containers, and orders, using hand tools."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "parking_attendants",
    "onet_code": "53-6021.00",
    "title": "Parking Attendants",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Oral Expression",
      "Flexibility of Closure",
      "Selective Attention",
      "Near Vision",
      "Far Vision"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "physical",
      "communication",
      "transportation"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-3053.00",
      "33-3041.00",
      "39-6011.00"
    ],
    "training_paths": [],
    "description": "Park vehicles or issue tickets for customers in a parking lot or garage. May park or tend vehicles in environments such as a car dealership or rental car facility. May collect fee.",
    "dailyActivities": [
      "Take numbered tags from customers, locate vehicles, and deliver vehicles, or provide customers with instructions for locating vehicles.",
      "Inspect vehicles to detect any damage.",
      "Greet customers and open their car doors.",
      "Issue ticket stubs or place numbered tags on windshields, log tags or attach tag to customers' keys, and give customers matching tags for locating parked vehicles.",
      "Perform cash handling tasks, such as making change, balancing and recording cash drawer, or distributing tips.",
      "Explain and calculate parking charges, collect fees from customers, and respond to customer complaints."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "passenger_attendants",
    "onet_code": "53-6061.00",
    "title": "Passenger Attendants",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Active Listening",
      "Critical Thinking",
      "Monitoring",
      "Social Perceptiveness",
      "Coordination",
      "Service Orientation"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Near Vision"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "problem_solving",
      "communication",
      "transportation",
      "leadership"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-2031.00",
      "39-6011.00",
      "43-4181.00"
    ],
    "training_paths": [],
    "description": "Provide services to ensure the safety of passengers aboard ships, buses, trains, or within the station or terminal. Perform duties such as explaining the use of safety equipment, serving meals or beverages, or answering questions related to travel.",
    "dailyActivities": [
      "Secure passengers for transportation by buckling seatbelts or fastening wheelchairs with tie-down straps.",
      "Provide boarding assistance to elderly, sick, or injured people.",
      "Respond to passengers' questions, requests, or complaints.",
      "Determine or facilitate seating arrangements.",
      "Provide customers with information on routes, gates, prices, timetables, terminals, or concourses.",
      "Perform equipment safety checks prior to departure."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "pump_operators_except_wellhead_pumpers",
    "onet_code": "53-7072.00",
    "title": "Pump Operators, Except Wellhead Pumpers",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Critical Thinking",
      "Monitoring",
      "Coordination",
      "Operations Monitoring",
      "Operation and Control",
      "Judgment and Decision Making"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "transportation",
      "leadership"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-7071.00",
      "51-8093.00",
      "53-7073.00"
    ],
    "training_paths": [],
    "description": "Tend, control, or operate power-driven, stationary, or portable pumps and manifold systems to transfer gases, oil, other liquids, slurries, or powdered materials to and from various vessels and processes.",
    "dailyActivities": [
      "Monitor gauges and flowmeters and inspect equipment to ensure that tank levels, temperatures, chemical amounts, and pressures are at specified levels, reporting abnormalities as necessary.",
      "Record operating data such as products and quantities pumped, stocks used, gauging results, and operating times.",
      "Plan movement of products through lines to processing, storage, and shipping units, using knowledge of interconnections and capacities of pipelines, valve manifolds, pumps, and tankage.",
      "Turn valves and start pumps to start or regulate flows of substances such as gases, liquids, slurries, or powdered materials.",
      "Communicate with other workers, using signals, radios, or telephones, to start and stop flows of materials or substances.",
      "Connect hoses and pipelines to pumps and vessels prior to material transfer, using hand tools."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "rail_transportation_workers_all_other",
    "onet_code": "53-4099.00",
    "title": "Rail Transportation Workers, All Other",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "transportation"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All rail transportation workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "rail_yard_engineers_dinkey_operators_and_hostlers",
    "onet_code": "53-4013.00",
    "title": "Rail Yard Engineers, Dinkey Operators, and Hostlers",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Coordination",
      "Complex Problem Solving",
      "Operations Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "physical",
      "technical",
      "problem_solving",
      "communication",
      "transportation",
      "leadership"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-4022.00",
      "53-4011.00",
      "53-4031.00"
    ],
    "training_paths": [],
    "description": "Drive switching or other locomotive or dinkey engines within railroad yard, industrial plant, quarry, construction project, or similar location.",
    "dailyActivities": [
      "Observe and respond to wayside and cab signals, including color light signals, position signals, torpedoes, flags, and hot box detectors.",
      "Inspect engines before and after use to ensure proper operation.",
      "Apply and release hand brakes.",
      "Signal crew members for movement of engines or trains, using lanterns, hand signals, radios, or telephones.",
      "Confer with conductors and other workers via radiotelephones or computers to exchange switching information.",
      "Inspect track for defects such as broken rails and switch malfunctions."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "railroad_brake_signal_and_switch_operators_and_locomotive_firers",
    "onet_code": "53-4022.00",
    "title": "Railroad Brake, Signal, and Switch Operators and Locomotive Firers",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Monitoring",
      "Coordination",
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "communication",
      "transportation",
      "leadership"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-4011.00",
      "53-4013.00",
      "53-4031.00"
    ],
    "training_paths": [],
    "description": "Operate or monitor railroad track switches or locomotive instruments. May couple or uncouple rolling stock to make up or break up trains. Watch for and relay traffic signals. May inspect couplings, air hoses, journal boxes, and hand brakes. May watch for dragging equipment or obstacles on rights-of-way.",
    "dailyActivities": [
      "Observe train signals along routes and verify their meanings for engineers.",
      "Signal locomotive engineers to start or stop trains when coupling or uncoupling cars, using hand signals, lanterns, or radio communication.",
      "Pull or push track switches to reroute cars.",
      "Observe signals from other crew members so that work activities can be coordinated.",
      "Monitor trains as they go around curves to detect dragging equipment and smoking journal boxes.",
      "Inspect couplings, air hoses, journal boxes, and handbrakes to ensure that they are securely fastened and functioning properly."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "railroad_conductors_and_yardmasters",
    "onet_code": "53-4031.00",
    "title": "Railroad Conductors and Yardmasters",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness",
      "Coordination"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "communication",
      "transportation",
      "leadership"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-4011.00",
      "53-4022.00",
      "53-4013.00"
    ],
    "training_paths": [],
    "description": "Coordinate activities of switch-engine crew within railroad yard, industrial plant, or similar location. Conductors coordinate activities of train crew on passenger or freight trains. Yardmasters review train schedules and switching orders and coordinate activities of workers engaged in railroad traffic operations, such as the makeup or breakup of trains and yard switching.",
    "dailyActivities": [
      "Signal engineers to begin train runs, stop trains, or change speed, using telecommunications equipment or hand signals.",
      "Confer with engineers regarding train routes, timetables, and cargoes, and to discuss alternative routes when there are rail defects or obstructions.",
      "Receive information regarding train or rail problems from dispatchers or from electronic monitoring devices.",
      "Receive instructions from dispatchers regarding trains' routes, timetables, and cargoes.",
      "Direct and instruct workers engaged in yard activities, such as switching tracks, coupling and uncoupling cars, and routing inbound and outbound traffic.",
      "Operate controls to activate track switches and traffic signals."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "recycling_coordinators",
    "onet_code": "53-1042.01",
    "title": "Recycling Coordinators",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Learning Strategies",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Problem Sensitivity"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "transportation",
      "leadership"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-7062.04",
      "53-1043.00",
      "53-1042.00"
    ],
    "training_paths": [],
    "description": "Supervise curbside and drop-off recycling programs for municipal governments or private firms.",
    "dailyActivities": [
      "Oversee recycling pick-up or drop-off programs to ensure compliance with community ordinances.",
      "Maintain logs of recycling materials received or shipped to processing companies.",
      "Supervise recycling technicians, community service workers, or other recycling operations employees or volunteers.",
      "Review customer requests for service to determine service needs and deploy appropriate resources to provide service.",
      "Provide training to recycling technicians or community service workers on topics such as safety, solid waste processing, or general recycling operations.",
      "Identify or investigate new opportunities for materials to be collected and recycled."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "recycling_and_reclamation_workers",
    "onet_code": "53-7062.04",
    "title": "Recycling and Reclamation Workers",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Category Flexibility",
      "Arm-Hand Steadiness",
      "Manual Dexterity",
      "Finger Dexterity",
      "Control Precision"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "physical",
      "communication",
      "transportation"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-1042.01",
      "47-4041.00",
      "53-7081.00"
    ],
    "training_paths": [],
    "description": "Prepare and sort materials or products for recycling. Identify and remove hazardous substances. Dismantle components of products such as appliances.",
    "dailyActivities": [
      "Sort materials, such as metals, glass, wood, paper or plastics, into appropriate containers for recycling.",
      "Clean recycling yard by sweeping, raking, picking up broken glass and loose paper debris, or moving barrels and bins.",
      "Operate forklifts, pallet jacks, power lifts, or front-end loaders to load bales, bundles, or other heavy items onto trucks for shipping to smelters or other recycled materials processing facilities.",
      "Sort metals to separate high-grade metals, such as copper, brass, and aluminum, for recycling.",
      "Clean, inspect, or lubricate recyclable collection equipment or perform routine maintenance or minor repairs on recycling equipment, such as star gears, finger sorters, destoners, belts, and grinders.",
      "Collect and sort recyclable construction materials, such as concrete, drywall, plastics, or wood, into containers."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "refuse_and_recyclable_material_collectors",
    "onet_code": "53-7081.00",
    "title": "Refuse and Recyclable Material Collectors",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [
      "Multilimb Coordination",
      "Reaction Time",
      "Static Strength",
      "Trunk Strength",
      "Far Vision"
    ],
    "keywords": [
      "communication",
      "hands_on",
      "physical",
      "transportation"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-7062.04",
      "47-4041.00",
      "53-3032.00"
    ],
    "training_paths": [],
    "description": "Collect and dump refuse or recyclable materials from containers into truck. May drive truck.",
    "dailyActivities": [
      "Inspect trucks prior to beginning routes to ensure safe operating condition.",
      "Drive trucks, following established routes, through residential streets or alleys or through business or industrial areas.",
      "Refuel trucks or add other fluids, such as oil or brake fluid.",
      "Dump refuse or recyclable materials at disposal sites.",
      "Fill out defective equipment reports.",
      "Operate automated or semi-automated hoisting devices that raise refuse bins and dump contents into openings in truck bodies."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "sailors_and_marine_oilers",
    "onet_code": "53-5011.00",
    "title": "Sailors and Marine Oilers",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Coordination",
      "Instructing",
      "Operations Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "transportation",
      "leadership"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-5021.00",
      "53-5031.00",
      "49-9096.00"
    ],
    "training_paths": [],
    "description": "Stand watch to look for obstructions in path of vessel, measure water depth, turn wheel on bridge, or use emergency equipment as directed by captain, mate, or pilot. Break out, rig, overhaul, and store cargo-handling gear, stationary rigging, and running gear. Perform a variety of maintenance tasks to preserve the painted surface of the ship and to maintain line and ship equipment. Must hold government-issued certification and tankerman certification when working aboard liquid-carrying vessels. Includes able seamen and ordinary seamen.",
    "dailyActivities": [
      "Tie barges together into tow units for tugboats to handle, inspecting barges periodically during voyages and disconnecting them when destinations are reached.",
      "Attach hoses and operate pumps to transfer substances to and from liquid cargo tanks.",
      "Handle lines to moor vessels to wharfs, to tie up vessels to other vessels, or to rig towing lines.",
      "Read pressure and temperature gauges or displays and record data in engineering logs.",
      "Stand watch in ships' bows or bridge wings to look for obstructions in a ship's path or to locate navigational aids, such as buoys or lighthouses.",
      "Maintain government-issued certifications, as required."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "ship_engineers",
    "onet_code": "53-5031.00",
    "title": "Ship Engineers",
    "category": "Transportation",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "detail_oriented",
      "hands_on",
      "analytical",
      "physical",
      "technical",
      "problem_solving",
      "communication",
      "transportation",
      "leadership"
    ],
    "salary": {
      "entry_min": 30307,
      "entry_max": 40410,
      "mid_min": 40410,
      "mid_max": 52533
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-8021.00",
      "17-2121.00",
      "49-9071.00"
    ],
    "training_paths": [],
    "description": "Supervise and coordinate activities of crew engaged in operating and maintaining engines, boilers, deck machinery, and electrical, sanitary, and refrigeration equipment aboard ship.",
    "dailyActivities": [
      "Monitor engine, machinery, or equipment indicators when vessels are underway, and report abnormalities to appropriate shipboard staff.",
      "Monitor the availability, use, or condition of lifesaving equipment or pollution preventatives to ensure that international regulations are followed.",
      "Monitor and test operations of engines or other equipment so that malfunctions and their causes can be identified.",
      "Start engines to propel ships, and regulate engines and power transmissions to control speeds of ships, according to directions from captains or bridge computers.",
      "Perform or participate in emergency drills, as required.",
      "Perform general marine vessel maintenance or repair work, such as repairing leaks, finishing interiors, refueling, or maintaining decks."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "shuttle_drivers_and_chauffeurs",
    "onet_code": "53-3053.00",
    "title": "Shuttle Drivers and Chauffeurs",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Monitoring",
      "Social Perceptiveness"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Spatial Orientation",
      "Time Sharing",
      "Control Precision"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "communication",
      "transportation",
      "leadership"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-3054.00",
      "53-3052.00",
      "53-3033.00"
    ],
    "training_paths": [],
    "description": "Drive a motor vehicle to transport passengers on a planned or scheduled basis. May collect a fare. Includes nonemergency medical transporters and hearse drivers.",
    "dailyActivities": [
      "Test vehicle equipment, such as lights, brakes, horns, or windshield wipers, to ensure proper operation.",
      "Check the condition of a vehicle's tires, brakes, windshield wipers, lights, oil, fuel, water, and safety equipment to ensure that everything is in working order.",
      "Comply with traffic regulations to operate vehicles in a safe and courteous manner.",
      "Follow relevant safety regulations and state laws governing vehicle operation, and ensure that passengers follow safety regulations.",
      "Operate vehicles with specialized equipment, such as wheelchair lifts, to transport and secure passengers with special needs.",
      "Report any vehicle malfunctions or needed repairs."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "stockers_and_order_fillers",
    "onet_code": "53-7065.00",
    "title": "Stockers and Order Fillers",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Oral Expression",
      "Multilimb Coordination",
      "Extent Flexibility",
      "Near Vision"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "physical",
      "communication",
      "transportation"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "43-5071.00",
      "41-2021.00",
      "43-5111.00"
    ],
    "training_paths": [],
    "description": "Receive, store, and issue merchandise, materials, equipment, and other items from stockroom, warehouse, or storage yard to fill shelves, racks, tables, or customers' orders. May operate power equipment to fill orders. May mark prices on merchandise and set up sales displays.",
    "dailyActivities": [
      "Complete order receipts.",
      "Answer customers' questions about merchandise and advise customers on merchandise selection.",
      "Issue or distribute materials, products, parts, and supplies to customers or coworkers, based on information from incoming requisitions.",
      "Keep records of out-going orders.",
      "Stock shelves, racks, cases, bins, and tables with new or transferred merchandise.",
      "Operate equipment such as forklifts."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "subway_and_streetcar_operators",
    "onet_code": "53-4041.00",
    "title": "Subway and Streetcar Operators",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Critical Thinking",
      "Active Learning",
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control",
      "Time Management"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "communication",
      "transportation"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-4011.00",
      "53-4031.00",
      "53-3052.00"
    ],
    "training_paths": [],
    "description": "Operate subway or elevated suburban trains with no separate locomotive, or electric-powered streetcar, to transport passengers. May handle fares.",
    "dailyActivities": [
      "Monitor lights indicating obstructions or other trains ahead and watch for car and truck traffic at crossings to stay alert to potential hazards.",
      "Operate controls to open and close transit vehicle doors.",
      "Drive and control rail-guided public transportation, such as subways, elevated trains, and electric-powered streetcars, trams, or trolleys, to transport passengers.",
      "Report delays, mechanical problems, and emergencies to supervisors or dispatchers, using radios.",
      "Regulate vehicle speed and the time spent at each stop to maintain schedules.",
      "Make announcements to passengers, such as notifications of upcoming stops or schedule delays."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "tank_car_truck_and_ship_loaders",
    "onet_code": "53-7121.00",
    "title": "Tank Car, Truck, and Ship Loaders",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Flexibility of Closure"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "communication",
      "transportation"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-7051.00",
      "53-7011.00",
      "53-7062.00"
    ],
    "training_paths": [],
    "description": "Load and unload chemicals and bulk solids, such as coal, sand, and grain, into or from tank cars, trucks, or ships, using material moving equipment. May perform a variety of other tasks relating to shipment of products. May gauge or sample shipping tanks and test them for leaks.",
    "dailyActivities": [
      "Seal outlet valves on tank cars, barges, and trucks.",
      "Verify tank car, barge, or truck load numbers to ensure car placement accuracy based on written or verbal instructions.",
      "Start pumps and adjust valves or cables to regulate the flow of products to vessels, using knowledge of loading procedures.",
      "Check conditions and weights of vessels to ensure cleanliness and compliance with loading procedures.",
      "Observe positions of cars passing loading spouts, and swing spouts into the correct positions at the appropriate times.",
      "Monitor product movement to and from storage tanks, coordinating activities with other workers to ensure constant product flow."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "taxi_drivers",
    "onet_code": "53-3054.00",
    "title": "Taxi Drivers",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "transportation"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-3053.00",
      "53-3052.00",
      "53-3033.00"
    ],
    "training_paths": [],
    "description": "Drive a motor vehicle to transport passengers on an unplanned basis and charge a fare, usually based on a meter.",
    "dailyActivities": [
      "Collect fares or vouchers from passengers, and make change or issue receipts as necessary.",
      "Communicate with dispatchers by radio, telephone, or computer to exchange information and receive requests for passenger service.",
      "Complete accident reports when necessary.",
      "Determine fares based on trip distances and times, using taximeters and fee schedules, and announce fares to passengers.",
      "Drive taxicabs or privately owned vehicles to transport passengers.",
      "Follow relevant safety regulations and state laws governing vehicle operation, and ensure that passengers follow safety regulations."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "traffic_technicians",
    "onet_code": "53-6041.00",
    "title": "Traffic Technicians",
    "category": "Transportation",
    "tier": "mid",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 1,
      "years_preferred": 2,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Active Listening",
      "Writing",
      "Speaking",
      "Mathematics",
      "Critical Thinking",
      "Active Learning",
      "Monitoring"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Written Expression",
      "Fluency of Ideas"
    ],
    "keywords": [
      "customer_service",
      "analytical",
      "hands_on",
      "physical",
      "problem_solving",
      "technical",
      "communication",
      "transportation",
      "leadership"
    ],
    "salary": {
      "entry_min": 30307,
      "entry_max": 40410,
      "mid_min": 40410,
      "mid_max": 52533
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "17-3022.00",
      "47-4011.00",
      "53-2021.00"
    ],
    "training_paths": [],
    "description": "Conduct field studies to determine traffic volume, speed, effectiveness of signals, adequacy of lighting, and other factors influencing traffic conditions, under direction of traffic engineer.",
    "dailyActivities": [
      "Study traffic delays by noting times of delays, the numbers of vehicles affected, and vehicle speed through the delay area.",
      "Interact with the public to answer traffic-related questions, respond to complaints or requests, or discuss traffic control ordinances, plans, policies, or procedures.",
      "Prepare graphs, charts, diagrams, or other aids to illustrate observations or conclusions.",
      "Analyze data related to traffic flow, accident rates, or proposed development to determine the most efficient methods to expedite traffic flow.",
      "Prepare work orders for repair, maintenance, or changes in traffic systems.",
      "Plan, design, and improve components of traffic control systems to accommodate current or projected traffic and to increase usability and efficiency."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "transportation_vehicle_equipment_and_systems_inspectors_except_aviation",
    "onet_code": "53-6051.07",
    "title": "Transportation Vehicle, Equipment and Systems Inspectors, Except Aviation",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Reading Comprehension",
      "Operations Monitoring",
      "Operation and Control",
      "Quality Control Analysis"
    ],
    "niceToHave": [
      "Oral Comprehension",
      "Written Comprehension",
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning"
    ],
    "keywords": [
      "detail_oriented",
      "analytical",
      "hands_on",
      "physical",
      "technical",
      "communication",
      "transportation"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "53-6051.01",
      "53-6051.00",
      "47-4011.00"
    ],
    "training_paths": [],
    "description": "Inspect and monitor transportation equipment, vehicles, or systems to ensure compliance with regulations and safety standards.",
    "dailyActivities": [
      "Inspect vehicles or other equipment for evidence of abuse, damage, or mechanical malfunction.",
      "Inspect vehicles or equipment to ensure compliance with rules, standards, or regulations.",
      "Inspect repairs to transportation vehicles or equipment to ensure that repair work was performed properly.",
      "Identify modifications to engines, fuel systems, emissions control equipment, or other vehicle systems to determine the impact of modifications on inspection procedures or conclusions.",
      "Conduct remote inspections of motor vehicles, using handheld controllers and remotely directed vehicle inspection devices.",
      "Prepare reports on investigations or inspections and actions taken."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "transportation_workers_all_other",
    "onet_code": "53-6099.00",
    "title": "Transportation Workers, All Other",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [],
    "niceToHave": [],
    "keywords": [
      "transportation"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [],
    "training_paths": [],
    "description": "All transportation workers not listed separately.",
    "dailyActivities": [],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  },
  {
    "id": "wellhead_pumpers",
    "onet_code": "53-7073.00",
    "title": "Wellhead Pumpers",
    "category": "Transportation",
    "tier": "entry",
    "education_required": {
      "minimum": "hs_diploma"
    },
    "certifications_required": [],
    "certifications_preferred": [],
    "experience_required": {
      "years_minimum": 0,
      "years_preferred": 1,
      "relevant_roles": []
    },
    "requiredSkills": [
      "Speaking",
      "Critical Thinking",
      "Monitoring",
      "Operations Monitoring",
      "Operation and Control",
      "Equipment Maintenance",
      "Troubleshooting",
      "Repairing"
    ],
    "niceToHave": [
      "Oral Expression",
      "Problem Sensitivity",
      "Deductive Reasoning",
      "Inductive Reasoning",
      "Information Ordering"
    ],
    "keywords": [
      "customer_service",
      "hands_on",
      "analytical",
      "physical",
      "technical",
      "problem_solving",
      "communication",
      "transportation"
    ],
    "salary": {
      "entry_min": 25761,
      "entry_max": 34348,
      "mid_min": 34348,
      "mid_max": 44652
    },
    "market_outlook": {
      "growth_rate": 5,
      "annual_openings": 10000,
      "competition_level": "medium"
    },
    "work_environment": {
      "remote_available": false,
      "hybrid_available": false,
      "physical_demands": [
        "standing",
        "lifting",
        "physical_stamina",
        "driving"
      ],
      "typical_schedule": "Full-time, standard hours"
    },
    "common_entry_points": [],
    "common_next_steps": [
      "51-8093.00",
      "53-7072.00",
      "51-8092.00"
    ],
    "training_paths": [],
    "description": "Operate power pumps and auxiliary equipment to produce flow of oil or gas from wells in oil field.",
    "dailyActivities": [
      "Monitor pumps and flow lines for gas and fluid leaks.",
      "Gauge oil and gas production.",
      "Start compressor engines and divert oil from storage tanks into compressor units and auxiliary equipment to recover natural gas from oil.",
      "Monitor control panels during pumping operations to ensure that materials are being pumped at the correct pressure, density, rate, and concentration.",
      "Operate engines and pumps to shut off wells according to production schedules, and to switch flow of oil into storage tanks.",
      "Repair gas and oil meters and gauges."
    ],
    "commonTransitionsFrom": [],
    "is_active": true,
    "last_updated": new Date()
  }
];

export default ONET_CAREERS;
